const AbstractPageModule = validate10;
function validate10(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.moduleType === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "moduleType"
        },
        message: "must have required property 'moduleType'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.moduleType !== void 0) {
      if (typeof data.moduleType !== "string") {
        const err1 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.heading !== void 0) {
      if (typeof data.heading !== "string") {
        const err2 = {
          instancePath: instancePath + "/heading",
          schemaPath: "#/properties/heading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.subHeading !== void 0) {
      if (typeof data.subHeading !== "string") {
        const err3 = {
          instancePath: instancePath + "/subHeading",
          schemaPath: "#/properties/subHeading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate10.errors = vErrors;
  return errors === 0;
}
const AbstractListModule = validate11;
const schema12 = {
  "$id": "AbstractListModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "layoutType": {
      "type": "string",
      "enum": ["CAROUSEL", "GRID"]
    },
    "density": {
      "type": "string",
      "enum": ["NORMAL", "DENSE", "DENSEST"]
    },
    "preferedGridSize": {
      "type": "object",
      "properties": {
        "columns": {
          "type": "number"
        },
        "rows": {
          "type": "number"
        }
      },
      "required": ["columns", "rows"]
    }
  },
  "required": ["density", "layoutType", "moduleType"],
  "description": "Most of what is shown in the app is a list of objects, so this abstract class captures that concept."
};
function validate11(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.density === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "density"
        },
        message: "must have required property 'density'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.layoutType === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "layoutType"
        },
        message: "must have required property 'layoutType'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.moduleType === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "moduleType"
        },
        message: "must have required property 'moduleType'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.moduleType !== void 0) {
      if (typeof data.moduleType !== "string") {
        const err3 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.heading !== void 0) {
      if (typeof data.heading !== "string") {
        const err4 = {
          instancePath: instancePath + "/heading",
          schemaPath: "#/properties/heading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.subHeading !== void 0) {
      if (typeof data.subHeading !== "string") {
        const err5 = {
          instancePath: instancePath + "/subHeading",
          schemaPath: "#/properties/subHeading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.layoutType !== void 0) {
      let data3 = data.layoutType;
      if (typeof data3 !== "string") {
        const err6 = {
          instancePath: instancePath + "/layoutType",
          schemaPath: "#/properties/layoutType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if (!(data3 === "CAROUSEL" || data3 === "GRID")) {
        const err7 = {
          instancePath: instancePath + "/layoutType",
          schemaPath: "#/properties/layoutType/enum",
          keyword: "enum",
          params: {
            allowedValues: schema12.properties.layoutType.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.density !== void 0) {
      let data4 = data.density;
      if (typeof data4 !== "string") {
        const err8 = {
          instancePath: instancePath + "/density",
          schemaPath: "#/properties/density/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
      if (!(data4 === "NORMAL" || data4 === "DENSE" || data4 === "DENSEST")) {
        const err9 = {
          instancePath: instancePath + "/density",
          schemaPath: "#/properties/density/enum",
          keyword: "enum",
          params: {
            allowedValues: schema12.properties.density.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.preferedGridSize !== void 0) {
      let data5 = data.preferedGridSize;
      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
        if (data5.columns === void 0) {
          const err10 = {
            instancePath: instancePath + "/preferedGridSize",
            schemaPath: "#/properties/preferedGridSize/required",
            keyword: "required",
            params: {
              missingProperty: "columns"
            },
            message: "must have required property 'columns'"
          };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
        if (data5.rows === void 0) {
          const err11 = {
            instancePath: instancePath + "/preferedGridSize",
            schemaPath: "#/properties/preferedGridSize/required",
            keyword: "required",
            params: {
              missingProperty: "rows"
            },
            message: "must have required property 'rows'"
          };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
        if (data5.columns !== void 0) {
          let data6 = data5.columns;
          if (!(typeof data6 == "number" && isFinite(data6))) {
            const err12 = {
              instancePath: instancePath + "/preferedGridSize/columns",
              schemaPath: "#/properties/preferedGridSize/properties/columns/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
        }
        if (data5.rows !== void 0) {
          let data7 = data5.rows;
          if (!(typeof data7 == "number" && isFinite(data7))) {
            const err13 = {
              instancePath: instancePath + "/preferedGridSize/rows",
              schemaPath: "#/properties/preferedGridSize/properties/rows/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
        }
      } else {
        const err14 = {
          instancePath: instancePath + "/preferedGridSize",
          schemaPath: "#/properties/preferedGridSize/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
  } else {
    const err15 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err15];
    } else {
      vErrors.push(err15);
    }
    errors++;
  }
  validate11.errors = vErrors;
  return errors === 0;
}
const InviteErrors = validate12;
const schema13 = {
  "$id": "InviteErrors",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["joymo-invites/invite-expired", "joymo-invites/invite-not-found", "joymo-invites/unauthorized", "joymo-invites/invalid-invite"]
};
function validate12(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (!(data === "joymo-invites/invite-expired" || data === "joymo-invites/invite-not-found" || data === "joymo-invites/unauthorized" || data === "joymo-invites/invalid-invite")) {
    const err1 = {
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema13.enum
      },
      message: "must be equal to one of the allowed values"
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate12.errors = vErrors;
  return errors === 0;
}
const AcceptUserInviteRequest = validate13;
function validate13(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.inviteId === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "inviteId"
        },
        message: "must have required property 'inviteId'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.token === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "token"
        },
        message: "must have required property 'token'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.inviteId !== void 0) {
      if (typeof data.inviteId !== "string") {
        const err2 = {
          instancePath: instancePath + "/inviteId",
          schemaPath: "#/properties/inviteId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.token !== void 0) {
      if (typeof data.token !== "string") {
        const err3 = {
          instancePath: instancePath + "/token",
          schemaPath: "#/properties/token/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.paymentMethodId !== void 0) {
      if (typeof data.paymentMethodId !== "string") {
        const err4 = {
          instancePath: instancePath + "/paymentMethodId",
          schemaPath: "#/properties/paymentMethodId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate13.errors = vErrors;
  return errors === 0;
}
const AcceptUserInviteResponse = validate14;
function validate14(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err1 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/anyOf/0/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (true !== data0) {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/anyOf/0/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.message !== void 0) {
      if (typeof data.message !== "string") {
        const err3 = {
          instancePath: instancePath + "/message",
          schemaPath: "#/anyOf/0/properties/message/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.subscriptionId !== void 0) {
      if (typeof data.subscriptionId !== "string") {
        const err4 = {
          instancePath: instancePath + "/subscriptionId",
          schemaPath: "#/anyOf/0/properties/subscriptionId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/anyOf/0/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs9 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.success === void 0) {
        const err6 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "success"
          },
          message: "must have required property 'success'"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if (data.message === void 0) {
        const err7 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "message"
          },
          message: "must have required property 'message'"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if (data.errorReason === void 0) {
        const err8 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "errorReason"
          },
          message: "must have required property 'errorReason'"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
      if (data.success !== void 0) {
        let data3 = data.success;
        if (typeof data3 !== "boolean") {
          const err9 = {
            instancePath: instancePath + "/success",
            schemaPath: "#/anyOf/1/properties/success/type",
            keyword: "type",
            params: {
              type: "boolean"
            },
            message: "must be boolean"
          };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
        if (false !== data3) {
          const err10 = {
            instancePath: instancePath + "/success",
            schemaPath: "#/anyOf/1/properties/success/const",
            keyword: "const",
            params: {
              allowedValue: false
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
      }
      if (data.message !== void 0) {
        if (typeof data.message !== "string") {
          const err11 = {
            instancePath: instancePath + "/message",
            schemaPath: "#/anyOf/1/properties/message/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
      }
      if (data.errorReason !== void 0) {
        let data5 = data.errorReason;
        if (typeof data5 !== "string") {
          const err12 = {
            instancePath: instancePath + "/errorReason",
            schemaPath: "InviteErrors/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err12];
          } else {
            vErrors.push(err12);
          }
          errors++;
        }
        if (!(data5 === "joymo-invites/invite-expired" || data5 === "joymo-invites/invite-not-found" || data5 === "joymo-invites/unauthorized" || data5 === "joymo-invites/invalid-invite")) {
          const err13 = {
            instancePath: instancePath + "/errorReason",
            schemaPath: "InviteErrors/enum",
            keyword: "enum",
            params: {
              allowedValues: schema13.enum
            },
            message: "must be equal to one of the allowed values"
          };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
      }
    } else {
      const err14 = {
        instancePath,
        schemaPath: "#/anyOf/1/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err14];
      } else {
        vErrors.push(err14);
      }
      errors++;
    }
    var _valid0 = _errs9 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err15 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err15];
    } else {
      vErrors.push(err15);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate14.errors = vErrors;
  return errors === 0;
}
const StaticSlideSource = validate15;
function validate15(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.type === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.slides === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "slides"
        },
        message: "must have required property 'slides'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.type !== void 0) {
      let data0 = data.type;
      if (typeof data0 !== "string") {
        const err2 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if ("STATIC" !== data0) {
        const err3 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/const",
          keyword: "const",
          params: {
            allowedValue: "STATIC"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.slides !== void 0) {
      let data1 = data.slides;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.internal === void 0) {
              const err4 = {
                instancePath: instancePath + "/slides/" + i0,
                schemaPath: "#/properties/slides/items/required",
                keyword: "required",
                params: {
                  missingProperty: "internal"
                },
                message: "must have required property 'internal'"
              };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
            if (data2.image === void 0) {
              const err5 = {
                instancePath: instancePath + "/slides/" + i0,
                schemaPath: "#/properties/slides/items/required",
                keyword: "required",
                params: {
                  missingProperty: "image"
                },
                message: "must have required property 'image'"
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if (data2.link !== void 0) {
              if (typeof data2.link !== "string") {
                const err6 = {
                  instancePath: instancePath + "/slides/" + i0 + "/link",
                  schemaPath: "#/properties/slides/items/properties/link/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            }
            if (data2.internal !== void 0) {
              if (typeof data2.internal !== "boolean") {
                const err7 = {
                  instancePath: instancePath + "/slides/" + i0 + "/internal",
                  schemaPath: "#/properties/slides/items/properties/internal/type",
                  keyword: "type",
                  params: {
                    type: "boolean"
                  },
                  message: "must be boolean"
                };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
            }
            if (data2.heading !== void 0) {
              if (typeof data2.heading !== "string") {
                const err8 = {
                  instancePath: instancePath + "/slides/" + i0 + "/heading",
                  schemaPath: "#/properties/slides/items/properties/heading/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
            }
            if (data2.subHeading !== void 0) {
              if (typeof data2.subHeading !== "string") {
                const err9 = {
                  instancePath: instancePath + "/slides/" + i0 + "/subHeading",
                  schemaPath: "#/properties/slides/items/properties/subHeading/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
            }
            if (data2.image !== void 0) {
              let data7 = data2.image;
              if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
                if (data7.largeViewport === void 0) {
                  const err10 = {
                    instancePath: instancePath + "/slides/" + i0 + "/image",
                    schemaPath: "#/properties/slides/items/properties/image/required",
                    keyword: "required",
                    params: {
                      missingProperty: "largeViewport"
                    },
                    message: "must have required property 'largeViewport'"
                  };
                  if (vErrors === null) {
                    vErrors = [err10];
                  } else {
                    vErrors.push(err10);
                  }
                  errors++;
                }
                if (data7.largeViewport !== void 0) {
                  if (typeof data7.largeViewport !== "string") {
                    const err11 = {
                      instancePath: instancePath + "/slides/" + i0 + "/image/largeViewport",
                      schemaPath: "#/properties/slides/items/properties/image/properties/largeViewport/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err11];
                    } else {
                      vErrors.push(err11);
                    }
                    errors++;
                  }
                }
                if (data7.smallViewport !== void 0) {
                  if (typeof data7.smallViewport !== "string") {
                    const err12 = {
                      instancePath: instancePath + "/slides/" + i0 + "/image/smallViewport",
                      schemaPath: "#/properties/slides/items/properties/image/properties/smallViewport/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err12];
                    } else {
                      vErrors.push(err12);
                    }
                    errors++;
                  }
                }
              } else {
                const err13 = {
                  instancePath: instancePath + "/slides/" + i0 + "/image",
                  schemaPath: "#/properties/slides/items/properties/image/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
            }
          } else {
            const err14 = {
              instancePath: instancePath + "/slides/" + i0,
              schemaPath: "#/properties/slides/items/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err14];
            } else {
              vErrors.push(err14);
            }
            errors++;
          }
        }
      } else {
        const err15 = {
          instancePath: instancePath + "/slides",
          schemaPath: "#/properties/slides/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
  } else {
    const err16 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err16];
    } else {
      vErrors.push(err16);
    }
    errors++;
  }
  validate15.errors = vErrors;
  return errors === 0;
}
const AdCarouselModule = validate16;
const schema18 = {
  "$id": "AdCarouselModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string",
      "const": "AD_CAROUSEL"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "hideFilter": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string",
          "enum": ["SUBSCRIBED", "REGISTERED"]
        }
      }, {
        "type": "null"
      }]
    },
    "displayStyle": {
      "type": "string",
      "const": "SLIDES"
    },
    "holdSeconds": {
      "type": "number"
    },
    "navigable": {
      "type": "boolean"
    },
    "slidesSource": {
      "$ref": "StaticSlideSource"
    }
  },
  "required": ["displayStyle", "hideFilter", "holdSeconds", "moduleType", "navigable", "slidesSource"],
  "description": 'Generalization of the simpler AD_SPACE module. Specifies a space that can display multiple "slides" and control the behavior and style of those slides. The end result is to promote and entice the user to click on one of the slides and can be used for "internal" linking or for external (ads, shopping).'
};
function validate16(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.displayStyle === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "displayStyle"
        },
        message: "must have required property 'displayStyle'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.hideFilter === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "hideFilter"
        },
        message: "must have required property 'hideFilter'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.holdSeconds === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "holdSeconds"
        },
        message: "must have required property 'holdSeconds'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.moduleType === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "moduleType"
        },
        message: "must have required property 'moduleType'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.navigable === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "navigable"
        },
        message: "must have required property 'navigable'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.slidesSource === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "slidesSource"
        },
        message: "must have required property 'slidesSource'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.moduleType !== void 0) {
      let data0 = data.moduleType;
      if (typeof data0 !== "string") {
        const err6 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if ("AD_CAROUSEL" !== data0) {
        const err7 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/const",
          keyword: "const",
          params: {
            allowedValue: "AD_CAROUSEL"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.heading !== void 0) {
      if (typeof data.heading !== "string") {
        const err8 = {
          instancePath: instancePath + "/heading",
          schemaPath: "#/properties/heading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.subHeading !== void 0) {
      if (typeof data.subHeading !== "string") {
        const err9 = {
          instancePath: instancePath + "/subHeading",
          schemaPath: "#/properties/subHeading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.hideFilter !== void 0) {
      let data3 = data.hideFilter;
      const _errs8 = errors;
      let valid1 = false;
      const _errs9 = errors;
      if (Array.isArray(data3)) {
        const len0 = data3.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data4 = data3[i0];
          if (typeof data4 !== "string") {
            const err10 = {
              instancePath: instancePath + "/hideFilter/" + i0,
              schemaPath: "#/properties/hideFilter/anyOf/0/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err10];
            } else {
              vErrors.push(err10);
            }
            errors++;
          }
          if (!(data4 === "SUBSCRIBED" || data4 === "REGISTERED")) {
            const err11 = {
              instancePath: instancePath + "/hideFilter/" + i0,
              schemaPath: "#/properties/hideFilter/anyOf/0/items/enum",
              keyword: "enum",
              params: {
                allowedValues: schema18.properties.hideFilter.anyOf[0].items.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err11];
            } else {
              vErrors.push(err11);
            }
            errors++;
          }
        }
      } else {
        const err12 = {
          instancePath: instancePath + "/hideFilter",
          schemaPath: "#/properties/hideFilter/anyOf/0/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
      var _valid0 = _errs9 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs13 = errors;
        if (data3 !== null) {
          const err13 = {
            instancePath: instancePath + "/hideFilter",
            schemaPath: "#/properties/hideFilter/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
        var _valid0 = _errs13 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err14 = {
          instancePath: instancePath + "/hideFilter",
          schemaPath: "#/properties/hideFilter/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      } else {
        errors = _errs8;
        if (vErrors !== null) {
          if (_errs8) {
            vErrors.length = _errs8;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.displayStyle !== void 0) {
      let data5 = data.displayStyle;
      if (typeof data5 !== "string") {
        const err15 = {
          instancePath: instancePath + "/displayStyle",
          schemaPath: "#/properties/displayStyle/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
      if ("SLIDES" !== data5) {
        const err16 = {
          instancePath: instancePath + "/displayStyle",
          schemaPath: "#/properties/displayStyle/const",
          keyword: "const",
          params: {
            allowedValue: "SLIDES"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.holdSeconds !== void 0) {
      let data6 = data.holdSeconds;
      if (!(typeof data6 == "number" && isFinite(data6))) {
        const err17 = {
          instancePath: instancePath + "/holdSeconds",
          schemaPath: "#/properties/holdSeconds/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.navigable !== void 0) {
      if (typeof data.navigable !== "boolean") {
        const err18 = {
          instancePath: instancePath + "/navigable",
          schemaPath: "#/properties/navigable/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
    if (data.slidesSource !== void 0) {
      let data8 = data.slidesSource;
      if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
        if (data8.type === void 0) {
          const err19 = {
            instancePath: instancePath + "/slidesSource",
            schemaPath: "StaticSlideSource/required",
            keyword: "required",
            params: {
              missingProperty: "type"
            },
            message: "must have required property 'type'"
          };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if (data8.slides === void 0) {
          const err20 = {
            instancePath: instancePath + "/slidesSource",
            schemaPath: "StaticSlideSource/required",
            keyword: "required",
            params: {
              missingProperty: "slides"
            },
            message: "must have required property 'slides'"
          };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
        if (data8.type !== void 0) {
          let data9 = data8.type;
          if (typeof data9 !== "string") {
            const err21 = {
              instancePath: instancePath + "/slidesSource/type",
              schemaPath: "StaticSlideSource/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
          if ("STATIC" !== data9) {
            const err22 = {
              instancePath: instancePath + "/slidesSource/type",
              schemaPath: "StaticSlideSource/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "STATIC"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err22];
            } else {
              vErrors.push(err22);
            }
            errors++;
          }
        }
        if (data8.slides !== void 0) {
          let data10 = data8.slides;
          if (Array.isArray(data10)) {
            const len1 = data10.length;
            for (let i1 = 0; i1 < len1; i1++) {
              let data11 = data10[i1];
              if (data11 && typeof data11 == "object" && !Array.isArray(data11)) {
                if (data11.internal === void 0) {
                  const err23 = {
                    instancePath: instancePath + "/slidesSource/slides/" + i1,
                    schemaPath: "StaticSlideSource/properties/slides/items/required",
                    keyword: "required",
                    params: {
                      missingProperty: "internal"
                    },
                    message: "must have required property 'internal'"
                  };
                  if (vErrors === null) {
                    vErrors = [err23];
                  } else {
                    vErrors.push(err23);
                  }
                  errors++;
                }
                if (data11.image === void 0) {
                  const err24 = {
                    instancePath: instancePath + "/slidesSource/slides/" + i1,
                    schemaPath: "StaticSlideSource/properties/slides/items/required",
                    keyword: "required",
                    params: {
                      missingProperty: "image"
                    },
                    message: "must have required property 'image'"
                  };
                  if (vErrors === null) {
                    vErrors = [err24];
                  } else {
                    vErrors.push(err24);
                  }
                  errors++;
                }
                if (data11.link !== void 0) {
                  if (typeof data11.link !== "string") {
                    const err25 = {
                      instancePath: instancePath + "/slidesSource/slides/" + i1 + "/link",
                      schemaPath: "StaticSlideSource/properties/slides/items/properties/link/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err25];
                    } else {
                      vErrors.push(err25);
                    }
                    errors++;
                  }
                }
                if (data11.internal !== void 0) {
                  if (typeof data11.internal !== "boolean") {
                    const err26 = {
                      instancePath: instancePath + "/slidesSource/slides/" + i1 + "/internal",
                      schemaPath: "StaticSlideSource/properties/slides/items/properties/internal/type",
                      keyword: "type",
                      params: {
                        type: "boolean"
                      },
                      message: "must be boolean"
                    };
                    if (vErrors === null) {
                      vErrors = [err26];
                    } else {
                      vErrors.push(err26);
                    }
                    errors++;
                  }
                }
                if (data11.heading !== void 0) {
                  if (typeof data11.heading !== "string") {
                    const err27 = {
                      instancePath: instancePath + "/slidesSource/slides/" + i1 + "/heading",
                      schemaPath: "StaticSlideSource/properties/slides/items/properties/heading/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err27];
                    } else {
                      vErrors.push(err27);
                    }
                    errors++;
                  }
                }
                if (data11.subHeading !== void 0) {
                  if (typeof data11.subHeading !== "string") {
                    const err28 = {
                      instancePath: instancePath + "/slidesSource/slides/" + i1 + "/subHeading",
                      schemaPath: "StaticSlideSource/properties/slides/items/properties/subHeading/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err28];
                    } else {
                      vErrors.push(err28);
                    }
                    errors++;
                  }
                }
                if (data11.image !== void 0) {
                  let data16 = data11.image;
                  if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
                    if (data16.largeViewport === void 0) {
                      const err29 = {
                        instancePath: instancePath + "/slidesSource/slides/" + i1 + "/image",
                        schemaPath: "StaticSlideSource/properties/slides/items/properties/image/required",
                        keyword: "required",
                        params: {
                          missingProperty: "largeViewport"
                        },
                        message: "must have required property 'largeViewport'"
                      };
                      if (vErrors === null) {
                        vErrors = [err29];
                      } else {
                        vErrors.push(err29);
                      }
                      errors++;
                    }
                    if (data16.largeViewport !== void 0) {
                      if (typeof data16.largeViewport !== "string") {
                        const err30 = {
                          instancePath: instancePath + "/slidesSource/slides/" + i1 + "/image/largeViewport",
                          schemaPath: "StaticSlideSource/properties/slides/items/properties/image/properties/largeViewport/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err30];
                        } else {
                          vErrors.push(err30);
                        }
                        errors++;
                      }
                    }
                    if (data16.smallViewport !== void 0) {
                      if (typeof data16.smallViewport !== "string") {
                        const err31 = {
                          instancePath: instancePath + "/slidesSource/slides/" + i1 + "/image/smallViewport",
                          schemaPath: "StaticSlideSource/properties/slides/items/properties/image/properties/smallViewport/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err31];
                        } else {
                          vErrors.push(err31);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err32 = {
                      instancePath: instancePath + "/slidesSource/slides/" + i1 + "/image",
                      schemaPath: "StaticSlideSource/properties/slides/items/properties/image/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err32];
                    } else {
                      vErrors.push(err32);
                    }
                    errors++;
                  }
                }
              } else {
                const err33 = {
                  instancePath: instancePath + "/slidesSource/slides/" + i1,
                  schemaPath: "StaticSlideSource/properties/slides/items/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err33];
                } else {
                  vErrors.push(err33);
                }
                errors++;
              }
            }
          } else {
            const err34 = {
              instancePath: instancePath + "/slidesSource/slides",
              schemaPath: "StaticSlideSource/properties/slides/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err34];
            } else {
              vErrors.push(err34);
            }
            errors++;
          }
        }
      } else {
        const err35 = {
          instancePath: instancePath + "/slidesSource",
          schemaPath: "StaticSlideSource/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err35];
        } else {
          vErrors.push(err35);
        }
        errors++;
      }
    }
  } else {
    const err36 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err36];
    } else {
      vErrors.push(err36);
    }
    errors++;
  }
  validate16.errors = vErrors;
  return errors === 0;
}
const AdSpaceModule = validate17;
const schema20 = {
  "$id": "AdSpaceModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string",
      "const": "AD_SPACE"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "hideFilter": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string",
          "enum": ["SUBSCRIBED", "REGISTERED"]
        }
      }, {
        "type": "null"
      }]
    },
    "link": {
      "type": "string"
    },
    "internal": {
      "type": "boolean"
    },
    "image": {
      "type": "object",
      "properties": {
        "largeViewport": {
          "type": "string"
        },
        "smallViewport": {
          "type": "string"
        }
      },
      "required": ["largeViewport"]
    }
  },
  "required": ["hideFilter", "image", "moduleType"],
  "description": "Specifies an Ad and the users it can be hidden from."
};
function validate17(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.hideFilter === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "hideFilter"
        },
        message: "must have required property 'hideFilter'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.image === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "image"
        },
        message: "must have required property 'image'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.moduleType === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "moduleType"
        },
        message: "must have required property 'moduleType'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.moduleType !== void 0) {
      let data0 = data.moduleType;
      if (typeof data0 !== "string") {
        const err3 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
      if ("AD_SPACE" !== data0) {
        const err4 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/const",
          keyword: "const",
          params: {
            allowedValue: "AD_SPACE"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.heading !== void 0) {
      if (typeof data.heading !== "string") {
        const err5 = {
          instancePath: instancePath + "/heading",
          schemaPath: "#/properties/heading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.subHeading !== void 0) {
      if (typeof data.subHeading !== "string") {
        const err6 = {
          instancePath: instancePath + "/subHeading",
          schemaPath: "#/properties/subHeading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.hideFilter !== void 0) {
      let data3 = data.hideFilter;
      const _errs8 = errors;
      let valid1 = false;
      const _errs9 = errors;
      if (Array.isArray(data3)) {
        const len0 = data3.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data4 = data3[i0];
          if (typeof data4 !== "string") {
            const err7 = {
              instancePath: instancePath + "/hideFilter/" + i0,
              schemaPath: "#/properties/hideFilter/anyOf/0/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
          }
          if (!(data4 === "SUBSCRIBED" || data4 === "REGISTERED")) {
            const err8 = {
              instancePath: instancePath + "/hideFilter/" + i0,
              schemaPath: "#/properties/hideFilter/anyOf/0/items/enum",
              keyword: "enum",
              params: {
                allowedValues: schema20.properties.hideFilter.anyOf[0].items.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err8];
            } else {
              vErrors.push(err8);
            }
            errors++;
          }
        }
      } else {
        const err9 = {
          instancePath: instancePath + "/hideFilter",
          schemaPath: "#/properties/hideFilter/anyOf/0/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      var _valid0 = _errs9 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs13 = errors;
        if (data3 !== null) {
          const err10 = {
            instancePath: instancePath + "/hideFilter",
            schemaPath: "#/properties/hideFilter/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
        var _valid0 = _errs13 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err11 = {
          instancePath: instancePath + "/hideFilter",
          schemaPath: "#/properties/hideFilter/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      } else {
        errors = _errs8;
        if (vErrors !== null) {
          if (_errs8) {
            vErrors.length = _errs8;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.link !== void 0) {
      if (typeof data.link !== "string") {
        const err12 = {
          instancePath: instancePath + "/link",
          schemaPath: "#/properties/link/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.internal !== void 0) {
      if (typeof data.internal !== "boolean") {
        const err13 = {
          instancePath: instancePath + "/internal",
          schemaPath: "#/properties/internal/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.image !== void 0) {
      let data7 = data.image;
      if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
        if (data7.largeViewport === void 0) {
          const err14 = {
            instancePath: instancePath + "/image",
            schemaPath: "#/properties/image/required",
            keyword: "required",
            params: {
              missingProperty: "largeViewport"
            },
            message: "must have required property 'largeViewport'"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
        if (data7.largeViewport !== void 0) {
          if (typeof data7.largeViewport !== "string") {
            const err15 = {
              instancePath: instancePath + "/image/largeViewport",
              schemaPath: "#/properties/image/properties/largeViewport/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
        if (data7.smallViewport !== void 0) {
          if (typeof data7.smallViewport !== "string") {
            const err16 = {
              instancePath: instancePath + "/image/smallViewport",
              schemaPath: "#/properties/image/properties/smallViewport/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err16];
            } else {
              vErrors.push(err16);
            }
            errors++;
          }
        }
      } else {
        const err17 = {
          instancePath: instancePath + "/image",
          schemaPath: "#/properties/image/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
  } else {
    const err18 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err18];
    } else {
      vErrors.push(err18);
    }
    errors++;
  }
  validate17.errors = vErrors;
  return errors === 0;
}
const BillingPeriodicity = validate18;
const schema21 = {
  "$id": "BillingPeriodicity",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["MONTHLY", "YEARLY"],
  "description": "Represents the duration of one billing cycle."
};
function validate18(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (!(data === "MONTHLY" || data === "YEARLY")) {
    const err1 = {
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema21.enum
      },
      message: "must be equal to one of the allowed values"
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate18.errors = vErrors;
  return errors === 0;
}
const PauseBehaviour = validate19;
const formats0 = require("ajv-formats/dist/formats").fullFormats["date-time"];
function validate19(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.periods === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "periods"
        },
        message: "must have required property 'periods'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.onceEvery === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "onceEvery"
        },
        message: "must have required property 'onceEvery'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.canUnpause === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "canUnpause"
        },
        message: "must have required property 'canUnpause'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.texts === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "texts"
        },
        message: "must have required property 'texts'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.periods !== void 0) {
      let data0 = data.periods;
      if (Array.isArray(data0)) {
        const len0 = data0.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data1 = data0[i0];
          if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
            if (data1.period === void 0) {
              const err4 = {
                instancePath: instancePath + "/periods/" + i0,
                schemaPath: "#/properties/periods/items/required",
                keyword: "required",
                params: {
                  missingProperty: "period"
                },
                message: "must have required property 'period'"
              };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
            if (data1.label === void 0) {
              const err5 = {
                instancePath: instancePath + "/periods/" + i0,
                schemaPath: "#/properties/periods/items/required",
                keyword: "required",
                params: {
                  missingProperty: "label"
                },
                message: "must have required property 'label'"
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if (data1.period !== void 0) {
              let data2 = data1.period;
              const _errs6 = errors;
              let valid4 = false;
              const _errs7 = errors;
              if (!(typeof data2 == "number" && isFinite(data2))) {
                const err6 = {
                  instancePath: instancePath + "/periods/" + i0 + "/period",
                  schemaPath: "#/properties/periods/items/properties/period/anyOf/0/type",
                  keyword: "type",
                  params: {
                    type: "number"
                  },
                  message: "must be number"
                };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
              var _valid0 = _errs7 === errors;
              valid4 = valid4 || _valid0;
              if (!valid4) {
                const _errs9 = errors;
                if (!(data2 && typeof data2 == "object" && !Array.isArray(data2))) {
                  const err7 = {
                    instancePath: instancePath + "/periods/" + i0 + "/period",
                    schemaPath: "#/properties/periods/items/properties/period/anyOf/1/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  };
                  if (vErrors === null) {
                    vErrors = [err7];
                  } else {
                    vErrors.push(err7);
                  }
                  errors++;
                }
                if (typeof data2 === "string") {
                  if (!formats0(data2)) {
                    const err8 = {
                      instancePath: instancePath + "/periods/" + i0 + "/period",
                      schemaPath: "#/properties/periods/items/properties/period/anyOf/1/format",
                      keyword: "format",
                      params: {
                        format: "date-time"
                      },
                      message: 'must match format "date-time"'
                    };
                    if (vErrors === null) {
                      vErrors = [err8];
                    } else {
                      vErrors.push(err8);
                    }
                    errors++;
                  }
                }
                var _valid0 = _errs9 === errors;
                valid4 = valid4 || _valid0;
              }
              if (!valid4) {
                const err9 = {
                  instancePath: instancePath + "/periods/" + i0 + "/period",
                  schemaPath: "#/properties/periods/items/properties/period/anyOf",
                  keyword: "anyOf",
                  params: {},
                  message: "must match a schema in anyOf"
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              } else {
                errors = _errs6;
                if (vErrors !== null) {
                  if (_errs6) {
                    vErrors.length = _errs6;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data1.label !== void 0) {
              if (typeof data1.label !== "string") {
                const err10 = {
                  instancePath: instancePath + "/periods/" + i0 + "/label",
                  schemaPath: "#/properties/periods/items/properties/label/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
            }
          } else {
            const err11 = {
              instancePath: instancePath + "/periods/" + i0,
              schemaPath: "#/properties/periods/items/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err11];
            } else {
              vErrors.push(err11);
            }
            errors++;
          }
        }
      } else {
        const err12 = {
          instancePath: instancePath + "/periods",
          schemaPath: "#/properties/periods/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.onceEvery !== void 0) {
      let data4 = data.onceEvery;
      if (!(typeof data4 == "number" && isFinite(data4))) {
        const err13 = {
          instancePath: instancePath + "/onceEvery",
          schemaPath: "#/properties/onceEvery/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.canUnpause !== void 0) {
      if (typeof data.canUnpause !== "boolean") {
        const err14 = {
          instancePath: instancePath + "/canUnpause",
          schemaPath: "#/properties/canUnpause/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.texts !== void 0) {
      let data6 = data.texts;
      if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
        if (data6.header === void 0) {
          const err15 = {
            instancePath: instancePath + "/texts",
            schemaPath: "#/properties/texts/required",
            keyword: "required",
            params: {
              missingProperty: "header"
            },
            message: "must have required property 'header'"
          };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if (data6.pros === void 0) {
          const err16 = {
            instancePath: instancePath + "/texts",
            schemaPath: "#/properties/texts/required",
            keyword: "required",
            params: {
              missingProperty: "pros"
            },
            message: "must have required property 'pros'"
          };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
        if (data6.header !== void 0) {
          if (typeof data6.header !== "string") {
            const err17 = {
              instancePath: instancePath + "/texts/header",
              schemaPath: "#/properties/texts/properties/header/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err17];
            } else {
              vErrors.push(err17);
            }
            errors++;
          }
        }
        if (data6.pros !== void 0) {
          let data8 = data6.pros;
          if (Array.isArray(data8)) {
            const len1 = data8.length;
            for (let i1 = 0; i1 < len1; i1++) {
              if (typeof data8[i1] !== "string") {
                const err18 = {
                  instancePath: instancePath + "/texts/pros/" + i1,
                  schemaPath: "#/properties/texts/properties/pros/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
            }
          } else {
            const err19 = {
              instancePath: instancePath + "/texts/pros",
              schemaPath: "#/properties/texts/properties/pros/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err19];
            } else {
              vErrors.push(err19);
            }
            errors++;
          }
        }
        if (data6.promoBlock !== void 0) {
          let data10 = data6.promoBlock;
          if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
            if (data10.title === void 0) {
              const err20 = {
                instancePath: instancePath + "/texts/promoBlock",
                schemaPath: "#/properties/texts/properties/promoBlock/required",
                keyword: "required",
                params: {
                  missingProperty: "title"
                },
                message: "must have required property 'title'"
              };
              if (vErrors === null) {
                vErrors = [err20];
              } else {
                vErrors.push(err20);
              }
              errors++;
            }
            if (data10.description === void 0) {
              const err21 = {
                instancePath: instancePath + "/texts/promoBlock",
                schemaPath: "#/properties/texts/properties/promoBlock/required",
                keyword: "required",
                params: {
                  missingProperty: "description"
                },
                message: "must have required property 'description'"
              };
              if (vErrors === null) {
                vErrors = [err21];
              } else {
                vErrors.push(err21);
              }
              errors++;
            }
            if (data10.imageUrl !== void 0) {
              if (typeof data10.imageUrl !== "string") {
                const err22 = {
                  instancePath: instancePath + "/texts/promoBlock/imageUrl",
                  schemaPath: "#/properties/texts/properties/promoBlock/properties/imageUrl/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err22];
                } else {
                  vErrors.push(err22);
                }
                errors++;
              }
            }
            if (data10.title !== void 0) {
              if (typeof data10.title !== "string") {
                const err23 = {
                  instancePath: instancePath + "/texts/promoBlock/title",
                  schemaPath: "#/properties/texts/properties/promoBlock/properties/title/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
            }
            if (data10.description !== void 0) {
              if (typeof data10.description !== "string") {
                const err24 = {
                  instancePath: instancePath + "/texts/promoBlock/description",
                  schemaPath: "#/properties/texts/properties/promoBlock/properties/description/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err24];
                } else {
                  vErrors.push(err24);
                }
                errors++;
              }
            }
          } else {
            const err25 = {
              instancePath: instancePath + "/texts/promoBlock",
              schemaPath: "#/properties/texts/properties/promoBlock/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err25];
            } else {
              vErrors.push(err25);
            }
            errors++;
          }
        }
      } else {
        const err26 = {
          instancePath: instancePath + "/texts",
          schemaPath: "#/properties/texts/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err26];
        } else {
          vErrors.push(err26);
        }
        errors++;
      }
    }
  } else {
    const err27 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err27];
    } else {
      vErrors.push(err27);
    }
    errors++;
  }
  validate19.errors = vErrors;
  return errors === 0;
}
const PlanInstallments = validate20;
function validate20(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.bindingCycles === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "bindingCycles"
        },
        message: "must have required property 'bindingCycles'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.price === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "price"
        },
        message: "must have required property 'price'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.period === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "period"
        },
        message: "must have required property 'period'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.bindingCycles !== void 0) {
      let data0 = data.bindingCycles;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err3 = {
          instancePath: instancePath + "/bindingCycles",
          schemaPath: "#/properties/bindingCycles/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.price !== void 0) {
      let data1 = data.price;
      if (!(typeof data1 == "number" && isFinite(data1))) {
        const err4 = {
          instancePath: instancePath + "/price",
          schemaPath: "#/properties/price/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.period !== void 0) {
      let data2 = data.period;
      if (typeof data2 !== "string") {
        const err5 = {
          instancePath: instancePath + "/period",
          schemaPath: "BillingPeriodicity/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if (!(data2 === "MONTHLY" || data2 === "YEARLY")) {
        const err6 = {
          instancePath: instancePath + "/period",
          schemaPath: "BillingPeriodicity/enum",
          keyword: "enum",
          params: {
            allowedValues: schema21.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.label !== void 0) {
      if (typeof data.label !== "string") {
        const err7 = {
          instancePath: instancePath + "/label",
          schemaPath: "#/properties/label/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.details !== void 0) {
      if (typeof data.details !== "string") {
        const err8 = {
          instancePath: instancePath + "/details",
          schemaPath: "#/properties/details/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.icon !== void 0) {
      if (typeof data.icon !== "string") {
        const err9 = {
          instancePath: instancePath + "/icon",
          schemaPath: "#/properties/icon/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
  } else {
    const err10 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
  }
  validate20.errors = vErrors;
  return errors === 0;
}
const PriceBlock = validate21;
function validate21(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.discountTag !== void 0) {
      if (typeof data.discountTag !== "string") {
        const err0 = {
          instancePath: instancePath + "/discountTag",
          schemaPath: "#/properties/discountTag/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.label !== void 0) {
      if (typeof data.label !== "string") {
        const err1 = {
          instancePath: instancePath + "/label",
          schemaPath: "#/properties/label/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.details !== void 0) {
      if (typeof data.details !== "string") {
        const err2 = {
          instancePath: instancePath + "/details",
          schemaPath: "#/properties/details/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.action !== void 0) {
      let data3 = data.action;
      const _errs8 = errors;
      let valid1 = false;
      const _errs9 = errors;
      if (typeof data3 !== "string") {
        const err3 = {
          instancePath: instancePath + "/action",
          schemaPath: "#/properties/action/anyOf/0/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
      var _valid0 = _errs9 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs11 = errors;
        if (Array.isArray(data3)) {
          if (data3.length > 2) {
            const err4 = {
              instancePath: instancePath + "/action",
              schemaPath: "#/properties/action/anyOf/1/maxItems",
              keyword: "maxItems",
              params: {
                limit: 2
              },
              message: "must NOT have more than 2 items"
            };
            if (vErrors === null) {
              vErrors = [err4];
            } else {
              vErrors.push(err4);
            }
            errors++;
          }
          if (data3.length < 2) {
            const err5 = {
              instancePath: instancePath + "/action",
              schemaPath: "#/properties/action/anyOf/1/minItems",
              keyword: "minItems",
              params: {
                limit: 2
              },
              message: "must NOT have fewer than 2 items"
            };
            if (vErrors === null) {
              vErrors = [err5];
            } else {
              vErrors.push(err5);
            }
            errors++;
          }
          const len0 = data3.length;
          if (len0 > 0) {
            if (typeof data3[0] !== "string") {
              const err6 = {
                instancePath: instancePath + "/action/0",
                schemaPath: "#/properties/action/anyOf/1/items/0/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
          }
          if (len0 > 1) {
            let data5 = data3[1];
            if (!(typeof data5 == "number" && isFinite(data5))) {
              const err7 = {
                instancePath: instancePath + "/action/1",
                schemaPath: "#/properties/action/anyOf/1/items/1/type",
                keyword: "type",
                params: {
                  type: "number"
                },
                message: "must be number"
              };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
          }
        } else {
          const err8 = {
            instancePath: instancePath + "/action",
            schemaPath: "#/properties/action/anyOf/1/type",
            keyword: "type",
            params: {
              type: "array"
            },
            message: "must be array"
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
        var _valid0 = _errs11 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err9 = {
          instancePath: instancePath + "/action",
          schemaPath: "#/properties/action/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      } else {
        errors = _errs8;
        if (vErrors !== null) {
          if (_errs8) {
            vErrors.length = _errs8;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err10 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
  }
  validate21.errors = vErrors;
  return errors === 0;
}
const BillingPeriodConfiguration = validate22;
const schema26 = {
  "$id": "BillingPeriodConfiguration",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "highlighted": {
      "type": "boolean"
    },
    "period": {
      "$ref": "BillingPeriodicity"
    },
    "basePrice": {
      "type": "number"
    },
    "trialDays": {
      "type": ["null", "number"]
    },
    "discountLabel": {
      "type": ["string", "null"]
    },
    "discountDescription": {
      "type": "string"
    },
    "priceBlock": {
      "$ref": "PriceBlock"
    },
    "initialPhaseDiscount": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "discount": {
            "anyOf": [{
              "type": "object",
              "properties": {
                "percentOff": {
                  "type": "number"
                }
              },
              "required": ["percentOff"]
            }, {
              "type": "object",
              "properties": {
                "amountOff": {
                  "type": "number"
                }
              },
              "required": ["amountOff"]
            }]
          },
          "cycles": {
            "anyOf": [{
              "type": "number"
            }, {
              "type": "object",
              "format": "date-time"
            }]
          },
          "offerEndDate": {
            "anyOf": [{
              "type": "object",
              "format": "date-time"
            }, {
              "type": "null"
            }]
          },
          "title": {
            "type": "string"
          },
          "shortDescription": {
            "type": "string"
          },
          "overrides": {
            "type": "object",
            "properties": {
              "discountLabel": {
                "type": "string"
              },
              "discountDescription": {
                "type": "string"
              },
              "priceBlock": {
                "$ref": "PriceBlock"
              }
            }
          },
          "allowedForInstallments": {
            "type": "boolean",
            "const": false
          }
        },
        "required": ["discount", "cycles", "offerEndDate", "title", "shortDescription"]
      }, {
        "type": "null"
      }]
    },
    "allowPromoCodes": {
      "type": "boolean"
    },
    "pauseBehaviour": {
      "$ref": "PauseBehaviour"
    },
    "installments": {
      "$ref": "PlanInstallments"
    }
  },
  "required": ["highlighted", "period", "basePrice", "trialDays", "discountLabel", "discountDescription", "initialPhaseDiscount", "allowPromoCodes"],
  "description": "Represents the configuration for a given billing period. Currently supported cycles:  - MONTHLY: every month  - YEARLY: every year"
};
function validate22(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.highlighted === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "highlighted"
        },
        message: "must have required property 'highlighted'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.period === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "period"
        },
        message: "must have required property 'period'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.basePrice === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "basePrice"
        },
        message: "must have required property 'basePrice'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.trialDays === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "trialDays"
        },
        message: "must have required property 'trialDays'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.discountLabel === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "discountLabel"
        },
        message: "must have required property 'discountLabel'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.discountDescription === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "discountDescription"
        },
        message: "must have required property 'discountDescription'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.initialPhaseDiscount === void 0) {
      const err6 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "initialPhaseDiscount"
        },
        message: "must have required property 'initialPhaseDiscount'"
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.allowPromoCodes === void 0) {
      const err7 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "allowPromoCodes"
        },
        message: "must have required property 'allowPromoCodes'"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.highlighted !== void 0) {
      if (typeof data.highlighted !== "boolean") {
        const err8 = {
          instancePath: instancePath + "/highlighted",
          schemaPath: "#/properties/highlighted/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.period !== void 0) {
      let data1 = data.period;
      if (typeof data1 !== "string") {
        const err9 = {
          instancePath: instancePath + "/period",
          schemaPath: "BillingPeriodicity/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if (!(data1 === "MONTHLY" || data1 === "YEARLY")) {
        const err10 = {
          instancePath: instancePath + "/period",
          schemaPath: "BillingPeriodicity/enum",
          keyword: "enum",
          params: {
            allowedValues: schema21.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.basePrice !== void 0) {
      let data2 = data.basePrice;
      if (!(typeof data2 == "number" && isFinite(data2))) {
        const err11 = {
          instancePath: instancePath + "/basePrice",
          schemaPath: "#/properties/basePrice/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.trialDays !== void 0) {
      let data3 = data.trialDays;
      if (data3 !== null && !(typeof data3 == "number" && isFinite(data3))) {
        const err12 = {
          instancePath: instancePath + "/trialDays",
          schemaPath: "#/properties/trialDays/type",
          keyword: "type",
          params: {
            type: schema26.properties.trialDays.type
          },
          message: "must be null,number"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.discountLabel !== void 0) {
      let data4 = data.discountLabel;
      if (typeof data4 !== "string" && data4 !== null) {
        const err13 = {
          instancePath: instancePath + "/discountLabel",
          schemaPath: "#/properties/discountLabel/type",
          keyword: "type",
          params: {
            type: schema26.properties.discountLabel.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.discountDescription !== void 0) {
      if (typeof data.discountDescription !== "string") {
        const err14 = {
          instancePath: instancePath + "/discountDescription",
          schemaPath: "#/properties/discountDescription/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.priceBlock !== void 0) {
      let data6 = data.priceBlock;
      if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
        if (data6.discountTag !== void 0) {
          if (typeof data6.discountTag !== "string") {
            const err15 = {
              instancePath: instancePath + "/priceBlock/discountTag",
              schemaPath: "PriceBlock/properties/discountTag/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
        if (data6.label !== void 0) {
          if (typeof data6.label !== "string") {
            const err16 = {
              instancePath: instancePath + "/priceBlock/label",
              schemaPath: "PriceBlock/properties/label/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err16];
            } else {
              vErrors.push(err16);
            }
            errors++;
          }
        }
        if (data6.details !== void 0) {
          if (typeof data6.details !== "string") {
            const err17 = {
              instancePath: instancePath + "/priceBlock/details",
              schemaPath: "PriceBlock/properties/details/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err17];
            } else {
              vErrors.push(err17);
            }
            errors++;
          }
        }
        if (data6.action !== void 0) {
          let data10 = data6.action;
          const _errs24 = errors;
          let valid4 = false;
          const _errs25 = errors;
          if (typeof data10 !== "string") {
            const err18 = {
              instancePath: instancePath + "/priceBlock/action",
              schemaPath: "PriceBlock/properties/action/anyOf/0/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err18];
            } else {
              vErrors.push(err18);
            }
            errors++;
          }
          var _valid0 = _errs25 === errors;
          valid4 = valid4 || _valid0;
          if (!valid4) {
            const _errs27 = errors;
            if (Array.isArray(data10)) {
              if (data10.length > 2) {
                const err19 = {
                  instancePath: instancePath + "/priceBlock/action",
                  schemaPath: "PriceBlock/properties/action/anyOf/1/maxItems",
                  keyword: "maxItems",
                  params: {
                    limit: 2
                  },
                  message: "must NOT have more than 2 items"
                };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
              if (data10.length < 2) {
                const err20 = {
                  instancePath: instancePath + "/priceBlock/action",
                  schemaPath: "PriceBlock/properties/action/anyOf/1/minItems",
                  keyword: "minItems",
                  params: {
                    limit: 2
                  },
                  message: "must NOT have fewer than 2 items"
                };
                if (vErrors === null) {
                  vErrors = [err20];
                } else {
                  vErrors.push(err20);
                }
                errors++;
              }
              const len0 = data10.length;
              if (len0 > 0) {
                if (typeof data10[0] !== "string") {
                  const err21 = {
                    instancePath: instancePath + "/priceBlock/action/0",
                    schemaPath: "PriceBlock/properties/action/anyOf/1/items/0/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err21];
                  } else {
                    vErrors.push(err21);
                  }
                  errors++;
                }
              }
              if (len0 > 1) {
                let data12 = data10[1];
                if (!(typeof data12 == "number" && isFinite(data12))) {
                  const err22 = {
                    instancePath: instancePath + "/priceBlock/action/1",
                    schemaPath: "PriceBlock/properties/action/anyOf/1/items/1/type",
                    keyword: "type",
                    params: {
                      type: "number"
                    },
                    message: "must be number"
                  };
                  if (vErrors === null) {
                    vErrors = [err22];
                  } else {
                    vErrors.push(err22);
                  }
                  errors++;
                }
              }
            } else {
              const err23 = {
                instancePath: instancePath + "/priceBlock/action",
                schemaPath: "PriceBlock/properties/action/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "array"
                },
                message: "must be array"
              };
              if (vErrors === null) {
                vErrors = [err23];
              } else {
                vErrors.push(err23);
              }
              errors++;
            }
            var _valid0 = _errs27 === errors;
            valid4 = valid4 || _valid0;
          }
          if (!valid4) {
            const err24 = {
              instancePath: instancePath + "/priceBlock/action",
              schemaPath: "PriceBlock/properties/action/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          } else {
            errors = _errs24;
            if (vErrors !== null) {
              if (_errs24) {
                vErrors.length = _errs24;
              } else {
                vErrors = null;
              }
            }
          }
        }
      } else {
        const err25 = {
          instancePath: instancePath + "/priceBlock",
          schemaPath: "PriceBlock/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err25];
        } else {
          vErrors.push(err25);
        }
        errors++;
      }
    }
    if (data.initialPhaseDiscount !== void 0) {
      let data13 = data.initialPhaseDiscount;
      const _errs34 = errors;
      let valid6 = false;
      const _errs35 = errors;
      if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
        if (data13.discount === void 0) {
          const err26 = {
            instancePath: instancePath + "/initialPhaseDiscount",
            schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "discount"
            },
            message: "must have required property 'discount'"
          };
          if (vErrors === null) {
            vErrors = [err26];
          } else {
            vErrors.push(err26);
          }
          errors++;
        }
        if (data13.cycles === void 0) {
          const err27 = {
            instancePath: instancePath + "/initialPhaseDiscount",
            schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "cycles"
            },
            message: "must have required property 'cycles'"
          };
          if (vErrors === null) {
            vErrors = [err27];
          } else {
            vErrors.push(err27);
          }
          errors++;
        }
        if (data13.offerEndDate === void 0) {
          const err28 = {
            instancePath: instancePath + "/initialPhaseDiscount",
            schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "offerEndDate"
            },
            message: "must have required property 'offerEndDate'"
          };
          if (vErrors === null) {
            vErrors = [err28];
          } else {
            vErrors.push(err28);
          }
          errors++;
        }
        if (data13.title === void 0) {
          const err29 = {
            instancePath: instancePath + "/initialPhaseDiscount",
            schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "title"
            },
            message: "must have required property 'title'"
          };
          if (vErrors === null) {
            vErrors = [err29];
          } else {
            vErrors.push(err29);
          }
          errors++;
        }
        if (data13.shortDescription === void 0) {
          const err30 = {
            instancePath: instancePath + "/initialPhaseDiscount",
            schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "shortDescription"
            },
            message: "must have required property 'shortDescription'"
          };
          if (vErrors === null) {
            vErrors = [err30];
          } else {
            vErrors.push(err30);
          }
          errors++;
        }
        if (data13.discount !== void 0) {
          let data14 = data13.discount;
          const _errs38 = errors;
          let valid8 = false;
          const _errs39 = errors;
          if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
            if (data14.percentOff === void 0) {
              const err31 = {
                instancePath: instancePath + "/initialPhaseDiscount/discount",
                schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/discount/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "percentOff"
                },
                message: "must have required property 'percentOff'"
              };
              if (vErrors === null) {
                vErrors = [err31];
              } else {
                vErrors.push(err31);
              }
              errors++;
            }
            if (data14.percentOff !== void 0) {
              let data15 = data14.percentOff;
              if (!(typeof data15 == "number" && isFinite(data15))) {
                const err32 = {
                  instancePath: instancePath + "/initialPhaseDiscount/discount/percentOff",
                  schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/discount/anyOf/0/properties/percentOff/type",
                  keyword: "type",
                  params: {
                    type: "number"
                  },
                  message: "must be number"
                };
                if (vErrors === null) {
                  vErrors = [err32];
                } else {
                  vErrors.push(err32);
                }
                errors++;
              }
            }
          } else {
            const err33 = {
              instancePath: instancePath + "/initialPhaseDiscount/discount",
              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/discount/anyOf/0/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err33];
            } else {
              vErrors.push(err33);
            }
            errors++;
          }
          var _valid2 = _errs39 === errors;
          valid8 = valid8 || _valid2;
          if (!valid8) {
            const _errs43 = errors;
            if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
              if (data14.amountOff === void 0) {
                const err34 = {
                  instancePath: instancePath + "/initialPhaseDiscount/discount",
                  schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/discount/anyOf/1/required",
                  keyword: "required",
                  params: {
                    missingProperty: "amountOff"
                  },
                  message: "must have required property 'amountOff'"
                };
                if (vErrors === null) {
                  vErrors = [err34];
                } else {
                  vErrors.push(err34);
                }
                errors++;
              }
              if (data14.amountOff !== void 0) {
                let data16 = data14.amountOff;
                if (!(typeof data16 == "number" && isFinite(data16))) {
                  const err35 = {
                    instancePath: instancePath + "/initialPhaseDiscount/discount/amountOff",
                    schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/discount/anyOf/1/properties/amountOff/type",
                    keyword: "type",
                    params: {
                      type: "number"
                    },
                    message: "must be number"
                  };
                  if (vErrors === null) {
                    vErrors = [err35];
                  } else {
                    vErrors.push(err35);
                  }
                  errors++;
                }
              }
            } else {
              const err36 = {
                instancePath: instancePath + "/initialPhaseDiscount/discount",
                schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/discount/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              };
              if (vErrors === null) {
                vErrors = [err36];
              } else {
                vErrors.push(err36);
              }
              errors++;
            }
            var _valid2 = _errs43 === errors;
            valid8 = valid8 || _valid2;
          }
          if (!valid8) {
            const err37 = {
              instancePath: instancePath + "/initialPhaseDiscount/discount",
              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/discount/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err37];
            } else {
              vErrors.push(err37);
            }
            errors++;
          } else {
            errors = _errs38;
            if (vErrors !== null) {
              if (_errs38) {
                vErrors.length = _errs38;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data13.cycles !== void 0) {
          let data17 = data13.cycles;
          const _errs48 = errors;
          let valid11 = false;
          const _errs49 = errors;
          if (!(typeof data17 == "number" && isFinite(data17))) {
            const err38 = {
              instancePath: instancePath + "/initialPhaseDiscount/cycles",
              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/cycles/anyOf/0/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err38];
            } else {
              vErrors.push(err38);
            }
            errors++;
          }
          var _valid3 = _errs49 === errors;
          valid11 = valid11 || _valid3;
          if (!valid11) {
            const _errs51 = errors;
            if (!(data17 && typeof data17 == "object" && !Array.isArray(data17))) {
              const err39 = {
                instancePath: instancePath + "/initialPhaseDiscount/cycles",
                schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/cycles/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              };
              if (vErrors === null) {
                vErrors = [err39];
              } else {
                vErrors.push(err39);
              }
              errors++;
            }
            if (typeof data17 === "string") {
              if (!formats0(data17)) {
                const err40 = {
                  instancePath: instancePath + "/initialPhaseDiscount/cycles",
                  schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/cycles/anyOf/1/format",
                  keyword: "format",
                  params: {
                    format: "date-time"
                  },
                  message: 'must match format "date-time"'
                };
                if (vErrors === null) {
                  vErrors = [err40];
                } else {
                  vErrors.push(err40);
                }
                errors++;
              }
            }
            var _valid3 = _errs51 === errors;
            valid11 = valid11 || _valid3;
          }
          if (!valid11) {
            const err41 = {
              instancePath: instancePath + "/initialPhaseDiscount/cycles",
              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/cycles/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err41];
            } else {
              vErrors.push(err41);
            }
            errors++;
          } else {
            errors = _errs48;
            if (vErrors !== null) {
              if (_errs48) {
                vErrors.length = _errs48;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data13.offerEndDate !== void 0) {
          let data18 = data13.offerEndDate;
          const _errs54 = errors;
          let valid12 = false;
          const _errs55 = errors;
          if (!(data18 && typeof data18 == "object" && !Array.isArray(data18))) {
            const err42 = {
              instancePath: instancePath + "/initialPhaseDiscount/offerEndDate",
              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/offerEndDate/anyOf/0/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err42];
            } else {
              vErrors.push(err42);
            }
            errors++;
          }
          if (typeof data18 === "string") {
            if (!formats0(data18)) {
              const err43 = {
                instancePath: instancePath + "/initialPhaseDiscount/offerEndDate",
                schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/offerEndDate/anyOf/0/format",
                keyword: "format",
                params: {
                  format: "date-time"
                },
                message: 'must match format "date-time"'
              };
              if (vErrors === null) {
                vErrors = [err43];
              } else {
                vErrors.push(err43);
              }
              errors++;
            }
          }
          var _valid4 = _errs55 === errors;
          valid12 = valid12 || _valid4;
          if (!valid12) {
            const _errs57 = errors;
            if (data18 !== null) {
              const err44 = {
                instancePath: instancePath + "/initialPhaseDiscount/offerEndDate",
                schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/offerEndDate/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err44];
              } else {
                vErrors.push(err44);
              }
              errors++;
            }
            var _valid4 = _errs57 === errors;
            valid12 = valid12 || _valid4;
          }
          if (!valid12) {
            const err45 = {
              instancePath: instancePath + "/initialPhaseDiscount/offerEndDate",
              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/offerEndDate/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err45];
            } else {
              vErrors.push(err45);
            }
            errors++;
          } else {
            errors = _errs54;
            if (vErrors !== null) {
              if (_errs54) {
                vErrors.length = _errs54;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data13.title !== void 0) {
          if (typeof data13.title !== "string") {
            const err46 = {
              instancePath: instancePath + "/initialPhaseDiscount/title",
              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/title/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err46];
            } else {
              vErrors.push(err46);
            }
            errors++;
          }
        }
        if (data13.shortDescription !== void 0) {
          if (typeof data13.shortDescription !== "string") {
            const err47 = {
              instancePath: instancePath + "/initialPhaseDiscount/shortDescription",
              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/shortDescription/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err47];
            } else {
              vErrors.push(err47);
            }
            errors++;
          }
        }
        if (data13.overrides !== void 0) {
          let data21 = data13.overrides;
          if (data21 && typeof data21 == "object" && !Array.isArray(data21)) {
            if (data21.discountLabel !== void 0) {
              if (typeof data21.discountLabel !== "string") {
                const err48 = {
                  instancePath: instancePath + "/initialPhaseDiscount/overrides/discountLabel",
                  schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/overrides/properties/discountLabel/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err48];
                } else {
                  vErrors.push(err48);
                }
                errors++;
              }
            }
            if (data21.discountDescription !== void 0) {
              if (typeof data21.discountDescription !== "string") {
                const err49 = {
                  instancePath: instancePath + "/initialPhaseDiscount/overrides/discountDescription",
                  schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/overrides/properties/discountDescription/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err49];
                } else {
                  vErrors.push(err49);
                }
                errors++;
              }
            }
            if (data21.priceBlock !== void 0) {
              let data24 = data21.priceBlock;
              if (data24 && typeof data24 == "object" && !Array.isArray(data24)) {
                if (data24.discountTag !== void 0) {
                  if (typeof data24.discountTag !== "string") {
                    const err50 = {
                      instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/discountTag",
                      schemaPath: "PriceBlock/properties/discountTag/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err50];
                    } else {
                      vErrors.push(err50);
                    }
                    errors++;
                  }
                }
                if (data24.label !== void 0) {
                  if (typeof data24.label !== "string") {
                    const err51 = {
                      instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/label",
                      schemaPath: "PriceBlock/properties/label/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err51];
                    } else {
                      vErrors.push(err51);
                    }
                    errors++;
                  }
                }
                if (data24.details !== void 0) {
                  if (typeof data24.details !== "string") {
                    const err52 = {
                      instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/details",
                      schemaPath: "PriceBlock/properties/details/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err52];
                    } else {
                      vErrors.push(err52);
                    }
                    errors++;
                  }
                }
                if (data24.action !== void 0) {
                  let data28 = data24.action;
                  const _errs79 = errors;
                  let valid16 = false;
                  const _errs80 = errors;
                  if (typeof data28 !== "string") {
                    const err53 = {
                      instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/action",
                      schemaPath: "PriceBlock/properties/action/anyOf/0/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err53];
                    } else {
                      vErrors.push(err53);
                    }
                    errors++;
                  }
                  var _valid5 = _errs80 === errors;
                  valid16 = valid16 || _valid5;
                  if (!valid16) {
                    const _errs82 = errors;
                    if (Array.isArray(data28)) {
                      if (data28.length > 2) {
                        const err54 = {
                          instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/action",
                          schemaPath: "PriceBlock/properties/action/anyOf/1/maxItems",
                          keyword: "maxItems",
                          params: {
                            limit: 2
                          },
                          message: "must NOT have more than 2 items"
                        };
                        if (vErrors === null) {
                          vErrors = [err54];
                        } else {
                          vErrors.push(err54);
                        }
                        errors++;
                      }
                      if (data28.length < 2) {
                        const err55 = {
                          instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/action",
                          schemaPath: "PriceBlock/properties/action/anyOf/1/minItems",
                          keyword: "minItems",
                          params: {
                            limit: 2
                          },
                          message: "must NOT have fewer than 2 items"
                        };
                        if (vErrors === null) {
                          vErrors = [err55];
                        } else {
                          vErrors.push(err55);
                        }
                        errors++;
                      }
                      const len1 = data28.length;
                      if (len1 > 0) {
                        if (typeof data28[0] !== "string") {
                          const err56 = {
                            instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/action/0",
                            schemaPath: "PriceBlock/properties/action/anyOf/1/items/0/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err56];
                          } else {
                            vErrors.push(err56);
                          }
                          errors++;
                        }
                      }
                      if (len1 > 1) {
                        let data30 = data28[1];
                        if (!(typeof data30 == "number" && isFinite(data30))) {
                          const err57 = {
                            instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/action/1",
                            schemaPath: "PriceBlock/properties/action/anyOf/1/items/1/type",
                            keyword: "type",
                            params: {
                              type: "number"
                            },
                            message: "must be number"
                          };
                          if (vErrors === null) {
                            vErrors = [err57];
                          } else {
                            vErrors.push(err57);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err58 = {
                        instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/action",
                        schemaPath: "PriceBlock/properties/action/anyOf/1/type",
                        keyword: "type",
                        params: {
                          type: "array"
                        },
                        message: "must be array"
                      };
                      if (vErrors === null) {
                        vErrors = [err58];
                      } else {
                        vErrors.push(err58);
                      }
                      errors++;
                    }
                    var _valid5 = _errs82 === errors;
                    valid16 = valid16 || _valid5;
                  }
                  if (!valid16) {
                    const err59 = {
                      instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock/action",
                      schemaPath: "PriceBlock/properties/action/anyOf",
                      keyword: "anyOf",
                      params: {},
                      message: "must match a schema in anyOf"
                    };
                    if (vErrors === null) {
                      vErrors = [err59];
                    } else {
                      vErrors.push(err59);
                    }
                    errors++;
                  } else {
                    errors = _errs79;
                    if (vErrors !== null) {
                      if (_errs79) {
                        vErrors.length = _errs79;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                }
              } else {
                const err60 = {
                  instancePath: instancePath + "/initialPhaseDiscount/overrides/priceBlock",
                  schemaPath: "PriceBlock/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err60];
                } else {
                  vErrors.push(err60);
                }
                errors++;
              }
            }
          } else {
            const err61 = {
              instancePath: instancePath + "/initialPhaseDiscount/overrides",
              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/overrides/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err61];
            } else {
              vErrors.push(err61);
            }
            errors++;
          }
        }
        if (data13.allowedForInstallments !== void 0) {
          let data31 = data13.allowedForInstallments;
          if (typeof data31 !== "boolean") {
            const err62 = {
              instancePath: instancePath + "/initialPhaseDiscount/allowedForInstallments",
              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/allowedForInstallments/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err62];
            } else {
              vErrors.push(err62);
            }
            errors++;
          }
          if (false !== data31) {
            const err63 = {
              instancePath: instancePath + "/initialPhaseDiscount/allowedForInstallments",
              schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/properties/allowedForInstallments/const",
              keyword: "const",
              params: {
                allowedValue: false
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err63];
            } else {
              vErrors.push(err63);
            }
            errors++;
          }
        }
      } else {
        const err64 = {
          instancePath: instancePath + "/initialPhaseDiscount",
          schemaPath: "#/properties/initialPhaseDiscount/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err64];
        } else {
          vErrors.push(err64);
        }
        errors++;
      }
      var _valid1 = _errs35 === errors;
      valid6 = valid6 || _valid1;
      if (!valid6) {
        const _errs90 = errors;
        if (data13 !== null) {
          const err65 = {
            instancePath: instancePath + "/initialPhaseDiscount",
            schemaPath: "#/properties/initialPhaseDiscount/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err65];
          } else {
            vErrors.push(err65);
          }
          errors++;
        }
        var _valid1 = _errs90 === errors;
        valid6 = valid6 || _valid1;
      }
      if (!valid6) {
        const err66 = {
          instancePath: instancePath + "/initialPhaseDiscount",
          schemaPath: "#/properties/initialPhaseDiscount/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err66];
        } else {
          vErrors.push(err66);
        }
        errors++;
      } else {
        errors = _errs34;
        if (vErrors !== null) {
          if (_errs34) {
            vErrors.length = _errs34;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.allowPromoCodes !== void 0) {
      if (typeof data.allowPromoCodes !== "boolean") {
        const err67 = {
          instancePath: instancePath + "/allowPromoCodes",
          schemaPath: "#/properties/allowPromoCodes/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err67];
        } else {
          vErrors.push(err67);
        }
        errors++;
      }
    }
    if (data.pauseBehaviour !== void 0) {
      let data33 = data.pauseBehaviour;
      if (data33 && typeof data33 == "object" && !Array.isArray(data33)) {
        if (data33.periods === void 0) {
          const err68 = {
            instancePath: instancePath + "/pauseBehaviour",
            schemaPath: "PauseBehaviour/required",
            keyword: "required",
            params: {
              missingProperty: "periods"
            },
            message: "must have required property 'periods'"
          };
          if (vErrors === null) {
            vErrors = [err68];
          } else {
            vErrors.push(err68);
          }
          errors++;
        }
        if (data33.onceEvery === void 0) {
          const err69 = {
            instancePath: instancePath + "/pauseBehaviour",
            schemaPath: "PauseBehaviour/required",
            keyword: "required",
            params: {
              missingProperty: "onceEvery"
            },
            message: "must have required property 'onceEvery'"
          };
          if (vErrors === null) {
            vErrors = [err69];
          } else {
            vErrors.push(err69);
          }
          errors++;
        }
        if (data33.canUnpause === void 0) {
          const err70 = {
            instancePath: instancePath + "/pauseBehaviour",
            schemaPath: "PauseBehaviour/required",
            keyword: "required",
            params: {
              missingProperty: "canUnpause"
            },
            message: "must have required property 'canUnpause'"
          };
          if (vErrors === null) {
            vErrors = [err70];
          } else {
            vErrors.push(err70);
          }
          errors++;
        }
        if (data33.texts === void 0) {
          const err71 = {
            instancePath: instancePath + "/pauseBehaviour",
            schemaPath: "PauseBehaviour/required",
            keyword: "required",
            params: {
              missingProperty: "texts"
            },
            message: "must have required property 'texts'"
          };
          if (vErrors === null) {
            vErrors = [err71];
          } else {
            vErrors.push(err71);
          }
          errors++;
        }
        if (data33.periods !== void 0) {
          let data34 = data33.periods;
          if (Array.isArray(data34)) {
            const len2 = data34.length;
            for (let i0 = 0; i0 < len2; i0++) {
              let data35 = data34[i0];
              if (data35 && typeof data35 == "object" && !Array.isArray(data35)) {
                if (data35.period === void 0) {
                  const err72 = {
                    instancePath: instancePath + "/pauseBehaviour/periods/" + i0,
                    schemaPath: "PauseBehaviour/properties/periods/items/required",
                    keyword: "required",
                    params: {
                      missingProperty: "period"
                    },
                    message: "must have required property 'period'"
                  };
                  if (vErrors === null) {
                    vErrors = [err72];
                  } else {
                    vErrors.push(err72);
                  }
                  errors++;
                }
                if (data35.label === void 0) {
                  const err73 = {
                    instancePath: instancePath + "/pauseBehaviour/periods/" + i0,
                    schemaPath: "PauseBehaviour/properties/periods/items/required",
                    keyword: "required",
                    params: {
                      missingProperty: "label"
                    },
                    message: "must have required property 'label'"
                  };
                  if (vErrors === null) {
                    vErrors = [err73];
                  } else {
                    vErrors.push(err73);
                  }
                  errors++;
                }
                if (data35.period !== void 0) {
                  let data36 = data35.period;
                  const _errs102 = errors;
                  let valid23 = false;
                  const _errs103 = errors;
                  if (!(typeof data36 == "number" && isFinite(data36))) {
                    const err74 = {
                      instancePath: instancePath + "/pauseBehaviour/periods/" + i0 + "/period",
                      schemaPath: "PauseBehaviour/properties/periods/items/properties/period/anyOf/0/type",
                      keyword: "type",
                      params: {
                        type: "number"
                      },
                      message: "must be number"
                    };
                    if (vErrors === null) {
                      vErrors = [err74];
                    } else {
                      vErrors.push(err74);
                    }
                    errors++;
                  }
                  var _valid6 = _errs103 === errors;
                  valid23 = valid23 || _valid6;
                  if (!valid23) {
                    const _errs105 = errors;
                    if (!(data36 && typeof data36 == "object" && !Array.isArray(data36))) {
                      const err75 = {
                        instancePath: instancePath + "/pauseBehaviour/periods/" + i0 + "/period",
                        schemaPath: "PauseBehaviour/properties/periods/items/properties/period/anyOf/1/type",
                        keyword: "type",
                        params: {
                          type: "object"
                        },
                        message: "must be object"
                      };
                      if (vErrors === null) {
                        vErrors = [err75];
                      } else {
                        vErrors.push(err75);
                      }
                      errors++;
                    }
                    if (typeof data36 === "string") {
                      if (!formats0(data36)) {
                        const err76 = {
                          instancePath: instancePath + "/pauseBehaviour/periods/" + i0 + "/period",
                          schemaPath: "PauseBehaviour/properties/periods/items/properties/period/anyOf/1/format",
                          keyword: "format",
                          params: {
                            format: "date-time"
                          },
                          message: 'must match format "date-time"'
                        };
                        if (vErrors === null) {
                          vErrors = [err76];
                        } else {
                          vErrors.push(err76);
                        }
                        errors++;
                      }
                    }
                    var _valid6 = _errs105 === errors;
                    valid23 = valid23 || _valid6;
                  }
                  if (!valid23) {
                    const err77 = {
                      instancePath: instancePath + "/pauseBehaviour/periods/" + i0 + "/period",
                      schemaPath: "PauseBehaviour/properties/periods/items/properties/period/anyOf",
                      keyword: "anyOf",
                      params: {},
                      message: "must match a schema in anyOf"
                    };
                    if (vErrors === null) {
                      vErrors = [err77];
                    } else {
                      vErrors.push(err77);
                    }
                    errors++;
                  } else {
                    errors = _errs102;
                    if (vErrors !== null) {
                      if (_errs102) {
                        vErrors.length = _errs102;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                }
                if (data35.label !== void 0) {
                  if (typeof data35.label !== "string") {
                    const err78 = {
                      instancePath: instancePath + "/pauseBehaviour/periods/" + i0 + "/label",
                      schemaPath: "PauseBehaviour/properties/periods/items/properties/label/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err78];
                    } else {
                      vErrors.push(err78);
                    }
                    errors++;
                  }
                }
              } else {
                const err79 = {
                  instancePath: instancePath + "/pauseBehaviour/periods/" + i0,
                  schemaPath: "PauseBehaviour/properties/periods/items/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err79];
                } else {
                  vErrors.push(err79);
                }
                errors++;
              }
            }
          } else {
            const err80 = {
              instancePath: instancePath + "/pauseBehaviour/periods",
              schemaPath: "PauseBehaviour/properties/periods/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err80];
            } else {
              vErrors.push(err80);
            }
            errors++;
          }
        }
        if (data33.onceEvery !== void 0) {
          let data38 = data33.onceEvery;
          if (!(typeof data38 == "number" && isFinite(data38))) {
            const err81 = {
              instancePath: instancePath + "/pauseBehaviour/onceEvery",
              schemaPath: "PauseBehaviour/properties/onceEvery/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err81];
            } else {
              vErrors.push(err81);
            }
            errors++;
          }
        }
        if (data33.canUnpause !== void 0) {
          if (typeof data33.canUnpause !== "boolean") {
            const err82 = {
              instancePath: instancePath + "/pauseBehaviour/canUnpause",
              schemaPath: "PauseBehaviour/properties/canUnpause/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err82];
            } else {
              vErrors.push(err82);
            }
            errors++;
          }
        }
        if (data33.texts !== void 0) {
          let data40 = data33.texts;
          if (data40 && typeof data40 == "object" && !Array.isArray(data40)) {
            if (data40.header === void 0) {
              const err83 = {
                instancePath: instancePath + "/pauseBehaviour/texts",
                schemaPath: "PauseBehaviour/properties/texts/required",
                keyword: "required",
                params: {
                  missingProperty: "header"
                },
                message: "must have required property 'header'"
              };
              if (vErrors === null) {
                vErrors = [err83];
              } else {
                vErrors.push(err83);
              }
              errors++;
            }
            if (data40.pros === void 0) {
              const err84 = {
                instancePath: instancePath + "/pauseBehaviour/texts",
                schemaPath: "PauseBehaviour/properties/texts/required",
                keyword: "required",
                params: {
                  missingProperty: "pros"
                },
                message: "must have required property 'pros'"
              };
              if (vErrors === null) {
                vErrors = [err84];
              } else {
                vErrors.push(err84);
              }
              errors++;
            }
            if (data40.header !== void 0) {
              if (typeof data40.header !== "string") {
                const err85 = {
                  instancePath: instancePath + "/pauseBehaviour/texts/header",
                  schemaPath: "PauseBehaviour/properties/texts/properties/header/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err85];
                } else {
                  vErrors.push(err85);
                }
                errors++;
              }
            }
            if (data40.pros !== void 0) {
              let data42 = data40.pros;
              if (Array.isArray(data42)) {
                const len3 = data42.length;
                for (let i1 = 0; i1 < len3; i1++) {
                  if (typeof data42[i1] !== "string") {
                    const err86 = {
                      instancePath: instancePath + "/pauseBehaviour/texts/pros/" + i1,
                      schemaPath: "PauseBehaviour/properties/texts/properties/pros/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err86];
                    } else {
                      vErrors.push(err86);
                    }
                    errors++;
                  }
                }
              } else {
                const err87 = {
                  instancePath: instancePath + "/pauseBehaviour/texts/pros",
                  schemaPath: "PauseBehaviour/properties/texts/properties/pros/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err87];
                } else {
                  vErrors.push(err87);
                }
                errors++;
              }
            }
            if (data40.promoBlock !== void 0) {
              let data44 = data40.promoBlock;
              if (data44 && typeof data44 == "object" && !Array.isArray(data44)) {
                if (data44.title === void 0) {
                  const err88 = {
                    instancePath: instancePath + "/pauseBehaviour/texts/promoBlock",
                    schemaPath: "PauseBehaviour/properties/texts/properties/promoBlock/required",
                    keyword: "required",
                    params: {
                      missingProperty: "title"
                    },
                    message: "must have required property 'title'"
                  };
                  if (vErrors === null) {
                    vErrors = [err88];
                  } else {
                    vErrors.push(err88);
                  }
                  errors++;
                }
                if (data44.description === void 0) {
                  const err89 = {
                    instancePath: instancePath + "/pauseBehaviour/texts/promoBlock",
                    schemaPath: "PauseBehaviour/properties/texts/properties/promoBlock/required",
                    keyword: "required",
                    params: {
                      missingProperty: "description"
                    },
                    message: "must have required property 'description'"
                  };
                  if (vErrors === null) {
                    vErrors = [err89];
                  } else {
                    vErrors.push(err89);
                  }
                  errors++;
                }
                if (data44.imageUrl !== void 0) {
                  if (typeof data44.imageUrl !== "string") {
                    const err90 = {
                      instancePath: instancePath + "/pauseBehaviour/texts/promoBlock/imageUrl",
                      schemaPath: "PauseBehaviour/properties/texts/properties/promoBlock/properties/imageUrl/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err90];
                    } else {
                      vErrors.push(err90);
                    }
                    errors++;
                  }
                }
                if (data44.title !== void 0) {
                  if (typeof data44.title !== "string") {
                    const err91 = {
                      instancePath: instancePath + "/pauseBehaviour/texts/promoBlock/title",
                      schemaPath: "PauseBehaviour/properties/texts/properties/promoBlock/properties/title/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err91];
                    } else {
                      vErrors.push(err91);
                    }
                    errors++;
                  }
                }
                if (data44.description !== void 0) {
                  if (typeof data44.description !== "string") {
                    const err92 = {
                      instancePath: instancePath + "/pauseBehaviour/texts/promoBlock/description",
                      schemaPath: "PauseBehaviour/properties/texts/properties/promoBlock/properties/description/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err92];
                    } else {
                      vErrors.push(err92);
                    }
                    errors++;
                  }
                }
              } else {
                const err93 = {
                  instancePath: instancePath + "/pauseBehaviour/texts/promoBlock",
                  schemaPath: "PauseBehaviour/properties/texts/properties/promoBlock/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err93];
                } else {
                  vErrors.push(err93);
                }
                errors++;
              }
            }
          } else {
            const err94 = {
              instancePath: instancePath + "/pauseBehaviour/texts",
              schemaPath: "PauseBehaviour/properties/texts/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err94];
            } else {
              vErrors.push(err94);
            }
            errors++;
          }
        }
      } else {
        const err95 = {
          instancePath: instancePath + "/pauseBehaviour",
          schemaPath: "PauseBehaviour/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err95];
        } else {
          vErrors.push(err95);
        }
        errors++;
      }
    }
    if (data.installments !== void 0) {
      if (!validate20(data.installments, {
        instancePath: instancePath + "/installments",
        parentData: data,
        parentDataProperty: "installments",
        rootData
      })) {
        vErrors = vErrors === null ? validate20.errors : vErrors.concat(validate20.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err96 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err96];
    } else {
      vErrors.push(err96);
    }
    errors++;
  }
  validate22.errors = vErrors;
  return errors === 0;
}
const PlanPrice = validate24;
function validate24(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.currency === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "currency"
        },
        message: "must have required property 'currency'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.billingPeriods === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "billingPeriods"
        },
        message: "must have required property 'billingPeriods'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.currency !== void 0) {
      if (typeof data.currency !== "string") {
        const err2 = {
          instancePath: instancePath + "/currency",
          schemaPath: "#/properties/currency/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.billingPeriods !== void 0) {
      let data1 = data.billingPeriods;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (!validate22(data1[i0], {
            instancePath: instancePath + "/billingPeriods/" + i0,
            parentData: data1,
            parentDataProperty: i0,
            rootData
          })) {
            vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err3 = {
          instancePath: instancePath + "/billingPeriods",
          schemaPath: "#/properties/billingPeriods/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate24.errors = vErrors;
  return errors === 0;
}
const ApplyCouponRequest = validate26;
function validate26(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.code === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "code"
        },
        message: "must have required property 'code'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.channelId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.planId === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "planId"
        },
        message: "must have required property 'planId'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.selectedPeriodicity === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "selectedPeriodicity"
        },
        message: "must have required property 'selectedPeriodicity'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.code !== void 0) {
      if (typeof data.code !== "string") {
        const err4 = {
          instancePath: instancePath + "/code",
          schemaPath: "#/properties/code/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err5 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.planId !== void 0) {
      if (typeof data.planId !== "string") {
        const err6 = {
          instancePath: instancePath + "/planId",
          schemaPath: "#/properties/planId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.selectedCurrency !== void 0) {
      if (typeof data.selectedCurrency !== "string") {
        const err7 = {
          instancePath: instancePath + "/selectedCurrency",
          schemaPath: "#/properties/selectedCurrency/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.selectedPeriodicity !== void 0) {
      let data4 = data.selectedPeriodicity;
      if (typeof data4 !== "string") {
        const err8 = {
          instancePath: instancePath + "/selectedPeriodicity",
          schemaPath: "BillingPeriodicity/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
      if (!(data4 === "MONTHLY" || data4 === "YEARLY")) {
        const err9 = {
          instancePath: instancePath + "/selectedPeriodicity",
          schemaPath: "BillingPeriodicity/enum",
          keyword: "enum",
          params: {
            allowedValues: schema21.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
  } else {
    const err10 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
  }
  validate26.errors = vErrors;
  return errors === 0;
}
const ApplyCouponSuccessfulResponse = validate27;
function validate27(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.totalDue === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "totalDue"
        },
        message: "must have required property 'totalDue'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.amountOff === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "amountOff"
        },
        message: "must have required property 'amountOff'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.couponText === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "couponText"
        },
        message: "must have required property 'couponText'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err4 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if (true !== data0) {
        const err5 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.totalDue !== void 0) {
      let data1 = data.totalDue;
      if (!(typeof data1 == "number" && isFinite(data1))) {
        const err6 = {
          instancePath: instancePath + "/totalDue",
          schemaPath: "#/properties/totalDue/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.amountOff !== void 0) {
      let data2 = data.amountOff;
      if (!(typeof data2 == "number" && isFinite(data2))) {
        const err7 = {
          instancePath: instancePath + "/amountOff",
          schemaPath: "#/properties/amountOff/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.couponText !== void 0) {
      if (typeof data.couponText !== "string") {
        const err8 = {
          instancePath: instancePath + "/couponText",
          schemaPath: "#/properties/couponText/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
  } else {
    const err9 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err9];
    } else {
      vErrors.push(err9);
    }
    errors++;
  }
  validate27.errors = vErrors;
  return errors === 0;
}
const ApplyCouponErrorResponse = validate28;
function validate28(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.errorReason === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "errorReason"
        },
        message: "must have required property 'errorReason'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (false !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: false
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.errorReason !== void 0) {
      if (typeof data.errorReason !== "string") {
        const err4 = {
          instancePath: instancePath + "/errorReason",
          schemaPath: "#/properties/errorReason/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate28.errors = vErrors;
  return errors === 0;
}
const ApplyCouponResponse = validate29;
function validate29(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "ApplyCouponSuccessfulResponse/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.totalDue === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "ApplyCouponSuccessfulResponse/required",
        keyword: "required",
        params: {
          missingProperty: "totalDue"
        },
        message: "must have required property 'totalDue'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.amountOff === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "ApplyCouponSuccessfulResponse/required",
        keyword: "required",
        params: {
          missingProperty: "amountOff"
        },
        message: "must have required property 'amountOff'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.couponText === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "ApplyCouponSuccessfulResponse/required",
        keyword: "required",
        params: {
          missingProperty: "couponText"
        },
        message: "must have required property 'couponText'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err4 = {
          instancePath: instancePath + "/success",
          schemaPath: "ApplyCouponSuccessfulResponse/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if (true !== data0) {
        const err5 = {
          instancePath: instancePath + "/success",
          schemaPath: "ApplyCouponSuccessfulResponse/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.totalDue !== void 0) {
      let data1 = data.totalDue;
      if (!(typeof data1 == "number" && isFinite(data1))) {
        const err6 = {
          instancePath: instancePath + "/totalDue",
          schemaPath: "ApplyCouponSuccessfulResponse/properties/totalDue/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.amountOff !== void 0) {
      let data2 = data.amountOff;
      if (!(typeof data2 == "number" && isFinite(data2))) {
        const err7 = {
          instancePath: instancePath + "/amountOff",
          schemaPath: "ApplyCouponSuccessfulResponse/properties/amountOff/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.couponText !== void 0) {
      if (typeof data.couponText !== "string") {
        const err8 = {
          instancePath: instancePath + "/couponText",
          schemaPath: "ApplyCouponSuccessfulResponse/properties/couponText/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
  } else {
    const err9 = {
      instancePath,
      schemaPath: "ApplyCouponSuccessfulResponse/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err9];
    } else {
      vErrors.push(err9);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs12 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.success === void 0) {
        const err10 = {
          instancePath,
          schemaPath: "ApplyCouponErrorResponse/required",
          keyword: "required",
          params: {
            missingProperty: "success"
          },
          message: "must have required property 'success'"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
      if (data.errorReason === void 0) {
        const err11 = {
          instancePath,
          schemaPath: "ApplyCouponErrorResponse/required",
          keyword: "required",
          params: {
            missingProperty: "errorReason"
          },
          message: "must have required property 'errorReason'"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if (data.success !== void 0) {
        let data4 = data.success;
        if (typeof data4 !== "boolean") {
          const err12 = {
            instancePath: instancePath + "/success",
            schemaPath: "ApplyCouponErrorResponse/properties/success/type",
            keyword: "type",
            params: {
              type: "boolean"
            },
            message: "must be boolean"
          };
          if (vErrors === null) {
            vErrors = [err12];
          } else {
            vErrors.push(err12);
          }
          errors++;
        }
        if (false !== data4) {
          const err13 = {
            instancePath: instancePath + "/success",
            schemaPath: "ApplyCouponErrorResponse/properties/success/const",
            keyword: "const",
            params: {
              allowedValue: false
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
      }
      if (data.errorReason !== void 0) {
        if (typeof data.errorReason !== "string") {
          const err14 = {
            instancePath: instancePath + "/errorReason",
            schemaPath: "ApplyCouponErrorResponse/properties/errorReason/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
      }
    } else {
      const err15 = {
        instancePath,
        schemaPath: "ApplyCouponErrorResponse/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err15];
      } else {
        vErrors.push(err15);
      }
      errors++;
    }
    var _valid0 = _errs12 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err16 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err16];
    } else {
      vErrors.push(err16);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate29.errors = vErrors;
  return errors === 0;
}
const ArenaAuthRequest = validate30;
function validate30(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.action === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "action"
        },
        message: "must have required property 'action'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.platform === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "platform"
        },
        message: "must have required property 'platform'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.token === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "token"
        },
        message: "must have required property 'token'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.uid === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "uid"
        },
        message: "must have required property 'uid'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.platform !== void 0) {
      let data0 = data.platform;
      if (typeof data0 !== "string") {
        const err4 = {
          instancePath: instancePath + "/platform",
          schemaPath: "#/anyOf/0/properties/platform/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if ("ARENA" !== data0) {
        const err5 = {
          instancePath: instancePath + "/platform",
          schemaPath: "#/anyOf/0/properties/platform/const",
          keyword: "const",
          params: {
            allowedValue: "ARENA"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.action !== void 0) {
      let data1 = data.action;
      if (typeof data1 !== "string") {
        const err6 = {
          instancePath: instancePath + "/action",
          schemaPath: "#/anyOf/0/properties/action/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if ("login" !== data1) {
        const err7 = {
          instancePath: instancePath + "/action",
          schemaPath: "#/anyOf/0/properties/action/const",
          keyword: "const",
          params: {
            allowedValue: "login"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.token !== void 0) {
      if (typeof data.token !== "string") {
        const err8 = {
          instancePath: instancePath + "/token",
          schemaPath: "#/anyOf/0/properties/token/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.uid !== void 0) {
      if (typeof data.uid !== "string") {
        const err9 = {
          instancePath: instancePath + "/uid",
          schemaPath: "#/anyOf/0/properties/uid/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
  } else {
    const err10 = {
      instancePath,
      schemaPath: "#/anyOf/0/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs11 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.action === void 0) {
        const err11 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "action"
          },
          message: "must have required property 'action'"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if (data.platform === void 0) {
        const err12 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "platform"
          },
          message: "must have required property 'platform'"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
      if (data.platform !== void 0) {
        let data4 = data.platform;
        if (typeof data4 !== "string") {
          const err13 = {
            instancePath: instancePath + "/platform",
            schemaPath: "#/anyOf/1/properties/platform/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
        if ("ARENA" !== data4) {
          const err14 = {
            instancePath: instancePath + "/platform",
            schemaPath: "#/anyOf/1/properties/platform/const",
            keyword: "const",
            params: {
              allowedValue: "ARENA"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
      }
      if (data.action !== void 0) {
        let data5 = data.action;
        if (typeof data5 !== "string") {
          const err15 = {
            instancePath: instancePath + "/action",
            schemaPath: "#/anyOf/1/properties/action/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if ("logout" !== data5) {
          const err16 = {
            instancePath: instancePath + "/action",
            schemaPath: "#/anyOf/1/properties/action/const",
            keyword: "const",
            params: {
              allowedValue: "logout"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
      }
    } else {
      const err17 = {
        instancePath,
        schemaPath: "#/anyOf/1/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err17];
      } else {
        vErrors.push(err17);
      }
      errors++;
    }
    var _valid0 = _errs11 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs17 = errors;
      if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.action === void 0) {
          const err18 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "action"
            },
            message: "must have required property 'action'"
          };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        if (data.platform === void 0) {
          const err19 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "platform"
            },
            message: "must have required property 'platform'"
          };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if (data.platform !== void 0) {
          let data6 = data.platform;
          if (typeof data6 !== "string") {
            const err20 = {
              instancePath: instancePath + "/platform",
              schemaPath: "#/anyOf/2/properties/platform/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err20];
            } else {
              vErrors.push(err20);
            }
            errors++;
          }
          if ("ARENA" !== data6) {
            const err21 = {
              instancePath: instancePath + "/platform",
              schemaPath: "#/anyOf/2/properties/platform/const",
              keyword: "const",
              params: {
                allowedValue: "ARENA"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
        }
        if (data.action !== void 0) {
          let data7 = data.action;
          if (typeof data7 !== "string") {
            const err22 = {
              instancePath: instancePath + "/action",
              schemaPath: "#/anyOf/2/properties/action/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err22];
            } else {
              vErrors.push(err22);
            }
            errors++;
          }
          if ("status" !== data7) {
            const err23 = {
              instancePath: instancePath + "/action",
              schemaPath: "#/anyOf/2/properties/action/const",
              keyword: "const",
              params: {
                allowedValue: "status"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
        }
      } else {
        const err24 = {
          instancePath,
          schemaPath: "#/anyOf/2/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err24];
        } else {
          vErrors.push(err24);
        }
        errors++;
      }
      var _valid0 = _errs17 === errors;
      valid0 = valid0 || _valid0;
    }
  }
  if (!valid0) {
    const err25 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err25];
    } else {
      vErrors.push(err25);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate30.errors = vErrors;
  return errors === 0;
}
const TvAuthRequest = validate31;
function validate31(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.action === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "action"
        },
        message: "must have required property 'action'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.channelId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.idToken === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "idToken"
        },
        message: "must have required property 'idToken'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.platform === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "platform"
        },
        message: "must have required property 'platform'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.redirectUrl === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "redirectUrl"
        },
        message: "must have required property 'redirectUrl'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.platform !== void 0) {
      let data0 = data.platform;
      if (typeof data0 !== "string") {
        const err5 = {
          instancePath: instancePath + "/platform",
          schemaPath: "#/anyOf/0/properties/platform/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if ("TV" !== data0) {
        const err6 = {
          instancePath: instancePath + "/platform",
          schemaPath: "#/anyOf/0/properties/platform/const",
          keyword: "const",
          params: {
            allowedValue: "TV"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.action !== void 0) {
      let data1 = data.action;
      if (typeof data1 !== "string") {
        const err7 = {
          instancePath: instancePath + "/action",
          schemaPath: "#/anyOf/0/properties/action/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if ("GET_SIGNIN_URL" !== data1) {
        const err8 = {
          instancePath: instancePath + "/action",
          schemaPath: "#/anyOf/0/properties/action/const",
          keyword: "const",
          params: {
            allowedValue: "GET_SIGNIN_URL"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err9 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/anyOf/0/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.idToken !== void 0) {
      if (typeof data.idToken !== "string") {
        const err10 = {
          instancePath: instancePath + "/idToken",
          schemaPath: "#/anyOf/0/properties/idToken/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.redirectUrl !== void 0) {
      if (typeof data.redirectUrl !== "string") {
        const err11 = {
          instancePath: instancePath + "/redirectUrl",
          schemaPath: "#/anyOf/0/properties/redirectUrl/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
  } else {
    const err12 = {
      instancePath,
      schemaPath: "#/anyOf/0/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err12];
    } else {
      vErrors.push(err12);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs13 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.action === void 0) {
        const err13 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "action"
          },
          message: "must have required property 'action'"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
      if (data.channelId === void 0) {
        const err14 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "channelId"
          },
          message: "must have required property 'channelId'"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
      if (data.email === void 0) {
        const err15 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "email"
          },
          message: "must have required property 'email'"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
      if (data.platform === void 0) {
        const err16 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "platform"
          },
          message: "must have required property 'platform'"
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
      if (data.platform !== void 0) {
        let data5 = data.platform;
        if (typeof data5 !== "string") {
          const err17 = {
            instancePath: instancePath + "/platform",
            schemaPath: "#/anyOf/1/properties/platform/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
        if ("TV" !== data5) {
          const err18 = {
            instancePath: instancePath + "/platform",
            schemaPath: "#/anyOf/1/properties/platform/const",
            keyword: "const",
            params: {
              allowedValue: "TV"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
      }
      if (data.action !== void 0) {
        let data6 = data.action;
        if (typeof data6 !== "string") {
          const err19 = {
            instancePath: instancePath + "/action",
            schemaPath: "#/anyOf/1/properties/action/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if ("REQUEST_PASSWORD_RESET" !== data6) {
          const err20 = {
            instancePath: instancePath + "/action",
            schemaPath: "#/anyOf/1/properties/action/const",
            keyword: "const",
            params: {
              allowedValue: "REQUEST_PASSWORD_RESET"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
      }
      if (data.channelId !== void 0) {
        if (typeof data.channelId !== "string") {
          const err21 = {
            instancePath: instancePath + "/channelId",
            schemaPath: "#/anyOf/1/properties/channelId/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
      }
      if (data.email !== void 0) {
        if (typeof data.email !== "string") {
          const err22 = {
            instancePath: instancePath + "/email",
            schemaPath: "#/anyOf/1/properties/email/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
      }
    } else {
      const err23 = {
        instancePath,
        schemaPath: "#/anyOf/1/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err23];
      } else {
        vErrors.push(err23);
      }
      errors++;
    }
    var _valid0 = _errs13 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs23 = errors;
      if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.action === void 0) {
          const err24 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "action"
            },
            message: "must have required property 'action'"
          };
          if (vErrors === null) {
            vErrors = [err24];
          } else {
            vErrors.push(err24);
          }
          errors++;
        }
        if (data.channelId === void 0) {
          const err25 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "channelId"
            },
            message: "must have required property 'channelId'"
          };
          if (vErrors === null) {
            vErrors = [err25];
          } else {
            vErrors.push(err25);
          }
          errors++;
        }
        if (data.email === void 0) {
          const err26 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "email"
            },
            message: "must have required property 'email'"
          };
          if (vErrors === null) {
            vErrors = [err26];
          } else {
            vErrors.push(err26);
          }
          errors++;
        }
        if (data.platform === void 0) {
          const err27 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "platform"
            },
            message: "must have required property 'platform'"
          };
          if (vErrors === null) {
            vErrors = [err27];
          } else {
            vErrors.push(err27);
          }
          errors++;
        }
        if (data.platform !== void 0) {
          let data9 = data.platform;
          if (typeof data9 !== "string") {
            const err28 = {
              instancePath: instancePath + "/platform",
              schemaPath: "#/anyOf/2/properties/platform/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err28];
            } else {
              vErrors.push(err28);
            }
            errors++;
          }
          if ("TV" !== data9) {
            const err29 = {
              instancePath: instancePath + "/platform",
              schemaPath: "#/anyOf/2/properties/platform/const",
              keyword: "const",
              params: {
                allowedValue: "TV"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err29];
            } else {
              vErrors.push(err29);
            }
            errors++;
          }
        }
        if (data.action !== void 0) {
          let data10 = data.action;
          if (typeof data10 !== "string") {
            const err30 = {
              instancePath: instancePath + "/action",
              schemaPath: "#/anyOf/2/properties/action/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err30];
            } else {
              vErrors.push(err30);
            }
            errors++;
          }
          if ("REQUEST_EMAIL_VERIFICATION" !== data10) {
            const err31 = {
              instancePath: instancePath + "/action",
              schemaPath: "#/anyOf/2/properties/action/const",
              keyword: "const",
              params: {
                allowedValue: "REQUEST_EMAIL_VERIFICATION"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
        }
        if (data.channelId !== void 0) {
          if (typeof data.channelId !== "string") {
            const err32 = {
              instancePath: instancePath + "/channelId",
              schemaPath: "#/anyOf/2/properties/channelId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err32];
            } else {
              vErrors.push(err32);
            }
            errors++;
          }
        }
        if (data.email !== void 0) {
          if (typeof data.email !== "string") {
            const err33 = {
              instancePath: instancePath + "/email",
              schemaPath: "#/anyOf/2/properties/email/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err33];
            } else {
              vErrors.push(err33);
            }
            errors++;
          }
        }
      } else {
        const err34 = {
          instancePath,
          schemaPath: "#/anyOf/2/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err34];
        } else {
          vErrors.push(err34);
        }
        errors++;
      }
      var _valid0 = _errs23 === errors;
      valid0 = valid0 || _valid0;
    }
  }
  if (!valid0) {
    const err35 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err35];
    } else {
      vErrors.push(err35);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate31.errors = vErrors;
  return errors === 0;
}
const StudioAuthRequest = validate32;
function validate32(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.action === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "action"
        },
        message: "must have required property 'action'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.idToken === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "idToken"
        },
        message: "must have required property 'idToken'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.platform === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "platform"
        },
        message: "must have required property 'platform'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.redirectUrl === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "redirectUrl"
        },
        message: "must have required property 'redirectUrl'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.platform !== void 0) {
      let data0 = data.platform;
      if (typeof data0 !== "string") {
        const err4 = {
          instancePath: instancePath + "/platform",
          schemaPath: "#/anyOf/0/properties/platform/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if ("STUDIO" !== data0) {
        const err5 = {
          instancePath: instancePath + "/platform",
          schemaPath: "#/anyOf/0/properties/platform/const",
          keyword: "const",
          params: {
            allowedValue: "STUDIO"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.action !== void 0) {
      let data1 = data.action;
      if (typeof data1 !== "string") {
        const err6 = {
          instancePath: instancePath + "/action",
          schemaPath: "#/anyOf/0/properties/action/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if ("GET_SIGNIN_URL" !== data1) {
        const err7 = {
          instancePath: instancePath + "/action",
          schemaPath: "#/anyOf/0/properties/action/const",
          keyword: "const",
          params: {
            allowedValue: "GET_SIGNIN_URL"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.idToken !== void 0) {
      if (typeof data.idToken !== "string") {
        const err8 = {
          instancePath: instancePath + "/idToken",
          schemaPath: "#/anyOf/0/properties/idToken/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.redirectUrl !== void 0) {
      if (typeof data.redirectUrl !== "string") {
        const err9 = {
          instancePath: instancePath + "/redirectUrl",
          schemaPath: "#/anyOf/0/properties/redirectUrl/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
  } else {
    const err10 = {
      instancePath,
      schemaPath: "#/anyOf/0/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs11 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.action === void 0) {
        const err11 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "action"
          },
          message: "must have required property 'action'"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if (data.email === void 0) {
        const err12 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "email"
          },
          message: "must have required property 'email'"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
      if (data.platform === void 0) {
        const err13 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "platform"
          },
          message: "must have required property 'platform'"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
      if (data.platform !== void 0) {
        let data4 = data.platform;
        if (typeof data4 !== "string") {
          const err14 = {
            instancePath: instancePath + "/platform",
            schemaPath: "#/anyOf/1/properties/platform/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
        if ("STUDIO" !== data4) {
          const err15 = {
            instancePath: instancePath + "/platform",
            schemaPath: "#/anyOf/1/properties/platform/const",
            keyword: "const",
            params: {
              allowedValue: "STUDIO"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
      }
      if (data.action !== void 0) {
        let data5 = data.action;
        if (typeof data5 !== "string") {
          const err16 = {
            instancePath: instancePath + "/action",
            schemaPath: "#/anyOf/1/properties/action/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
        if ("REQUEST_PASSWORD_RESET" !== data5) {
          const err17 = {
            instancePath: instancePath + "/action",
            schemaPath: "#/anyOf/1/properties/action/const",
            keyword: "const",
            params: {
              allowedValue: "REQUEST_PASSWORD_RESET"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
      }
      if (data.email !== void 0) {
        if (typeof data.email !== "string") {
          const err18 = {
            instancePath: instancePath + "/email",
            schemaPath: "#/anyOf/1/properties/email/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
      }
    } else {
      const err19 = {
        instancePath,
        schemaPath: "#/anyOf/1/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err19];
      } else {
        vErrors.push(err19);
      }
      errors++;
    }
    var _valid0 = _errs11 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs19 = errors;
      if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.action === void 0) {
          const err20 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "action"
            },
            message: "must have required property 'action'"
          };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
        if (data.email === void 0) {
          const err21 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "email"
            },
            message: "must have required property 'email'"
          };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
        if (data.platform === void 0) {
          const err22 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "platform"
            },
            message: "must have required property 'platform'"
          };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
        if (data.platform !== void 0) {
          let data7 = data.platform;
          if (typeof data7 !== "string") {
            const err23 = {
              instancePath: instancePath + "/platform",
              schemaPath: "#/anyOf/2/properties/platform/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
          if ("STUDIO" !== data7) {
            const err24 = {
              instancePath: instancePath + "/platform",
              schemaPath: "#/anyOf/2/properties/platform/const",
              keyword: "const",
              params: {
                allowedValue: "STUDIO"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          }
        }
        if (data.action !== void 0) {
          let data8 = data.action;
          if (typeof data8 !== "string") {
            const err25 = {
              instancePath: instancePath + "/action",
              schemaPath: "#/anyOf/2/properties/action/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err25];
            } else {
              vErrors.push(err25);
            }
            errors++;
          }
          if ("REQUEST_EMAIL_VERIFICATION" !== data8) {
            const err26 = {
              instancePath: instancePath + "/action",
              schemaPath: "#/anyOf/2/properties/action/const",
              keyword: "const",
              params: {
                allowedValue: "REQUEST_EMAIL_VERIFICATION"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err26];
            } else {
              vErrors.push(err26);
            }
            errors++;
          }
        }
        if (data.email !== void 0) {
          if (typeof data.email !== "string") {
            const err27 = {
              instancePath: instancePath + "/email",
              schemaPath: "#/anyOf/2/properties/email/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err27];
            } else {
              vErrors.push(err27);
            }
            errors++;
          }
        }
      } else {
        const err28 = {
          instancePath,
          schemaPath: "#/anyOf/2/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err28];
        } else {
          vErrors.push(err28);
        }
        errors++;
      }
      var _valid0 = _errs19 === errors;
      valid0 = valid0 || _valid0;
    }
  }
  if (!valid0) {
    const err29 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err29];
    } else {
      vErrors.push(err29);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate32.errors = vErrors;
  return errors === 0;
}
const AuthRequest = validate33;
function validate33(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  const _errs3 = errors;
  let valid2 = false;
  const _errs4 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.action === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "ArenaAuthRequest/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "action"
        },
        message: "must have required property 'action'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.platform === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "ArenaAuthRequest/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "platform"
        },
        message: "must have required property 'platform'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.token === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "ArenaAuthRequest/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "token"
        },
        message: "must have required property 'token'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.uid === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "ArenaAuthRequest/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "uid"
        },
        message: "must have required property 'uid'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.platform !== void 0) {
      let data0 = data.platform;
      if (typeof data0 !== "string") {
        const err4 = {
          instancePath: instancePath + "/platform",
          schemaPath: "ArenaAuthRequest/anyOf/0/properties/platform/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if ("ARENA" !== data0) {
        const err5 = {
          instancePath: instancePath + "/platform",
          schemaPath: "ArenaAuthRequest/anyOf/0/properties/platform/const",
          keyword: "const",
          params: {
            allowedValue: "ARENA"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.action !== void 0) {
      let data1 = data.action;
      if (typeof data1 !== "string") {
        const err6 = {
          instancePath: instancePath + "/action",
          schemaPath: "ArenaAuthRequest/anyOf/0/properties/action/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if ("login" !== data1) {
        const err7 = {
          instancePath: instancePath + "/action",
          schemaPath: "ArenaAuthRequest/anyOf/0/properties/action/const",
          keyword: "const",
          params: {
            allowedValue: "login"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.token !== void 0) {
      if (typeof data.token !== "string") {
        const err8 = {
          instancePath: instancePath + "/token",
          schemaPath: "ArenaAuthRequest/anyOf/0/properties/token/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.uid !== void 0) {
      if (typeof data.uid !== "string") {
        const err9 = {
          instancePath: instancePath + "/uid",
          schemaPath: "ArenaAuthRequest/anyOf/0/properties/uid/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
  } else {
    const err10 = {
      instancePath,
      schemaPath: "ArenaAuthRequest/anyOf/0/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
  }
  var _valid1 = _errs4 === errors;
  valid2 = valid2 || _valid1;
  if (!valid2) {
    const _errs14 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.action === void 0) {
        const err11 = {
          instancePath,
          schemaPath: "ArenaAuthRequest/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "action"
          },
          message: "must have required property 'action'"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if (data.platform === void 0) {
        const err12 = {
          instancePath,
          schemaPath: "ArenaAuthRequest/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "platform"
          },
          message: "must have required property 'platform'"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
      if (data.platform !== void 0) {
        let data4 = data.platform;
        if (typeof data4 !== "string") {
          const err13 = {
            instancePath: instancePath + "/platform",
            schemaPath: "ArenaAuthRequest/anyOf/1/properties/platform/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
        if ("ARENA" !== data4) {
          const err14 = {
            instancePath: instancePath + "/platform",
            schemaPath: "ArenaAuthRequest/anyOf/1/properties/platform/const",
            keyword: "const",
            params: {
              allowedValue: "ARENA"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
      }
      if (data.action !== void 0) {
        let data5 = data.action;
        if (typeof data5 !== "string") {
          const err15 = {
            instancePath: instancePath + "/action",
            schemaPath: "ArenaAuthRequest/anyOf/1/properties/action/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if ("logout" !== data5) {
          const err16 = {
            instancePath: instancePath + "/action",
            schemaPath: "ArenaAuthRequest/anyOf/1/properties/action/const",
            keyword: "const",
            params: {
              allowedValue: "logout"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
      }
    } else {
      const err17 = {
        instancePath,
        schemaPath: "ArenaAuthRequest/anyOf/1/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err17];
      } else {
        vErrors.push(err17);
      }
      errors++;
    }
    var _valid1 = _errs14 === errors;
    valid2 = valid2 || _valid1;
    if (!valid2) {
      const _errs20 = errors;
      if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.action === void 0) {
          const err18 = {
            instancePath,
            schemaPath: "ArenaAuthRequest/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "action"
            },
            message: "must have required property 'action'"
          };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        if (data.platform === void 0) {
          const err19 = {
            instancePath,
            schemaPath: "ArenaAuthRequest/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "platform"
            },
            message: "must have required property 'platform'"
          };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if (data.platform !== void 0) {
          let data6 = data.platform;
          if (typeof data6 !== "string") {
            const err20 = {
              instancePath: instancePath + "/platform",
              schemaPath: "ArenaAuthRequest/anyOf/2/properties/platform/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err20];
            } else {
              vErrors.push(err20);
            }
            errors++;
          }
          if ("ARENA" !== data6) {
            const err21 = {
              instancePath: instancePath + "/platform",
              schemaPath: "ArenaAuthRequest/anyOf/2/properties/platform/const",
              keyword: "const",
              params: {
                allowedValue: "ARENA"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
        }
        if (data.action !== void 0) {
          let data7 = data.action;
          if (typeof data7 !== "string") {
            const err22 = {
              instancePath: instancePath + "/action",
              schemaPath: "ArenaAuthRequest/anyOf/2/properties/action/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err22];
            } else {
              vErrors.push(err22);
            }
            errors++;
          }
          if ("status" !== data7) {
            const err23 = {
              instancePath: instancePath + "/action",
              schemaPath: "ArenaAuthRequest/anyOf/2/properties/action/const",
              keyword: "const",
              params: {
                allowedValue: "status"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
        }
      } else {
        const err24 = {
          instancePath,
          schemaPath: "ArenaAuthRequest/anyOf/2/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err24];
        } else {
          vErrors.push(err24);
        }
        errors++;
      }
      var _valid1 = _errs20 === errors;
      valid2 = valid2 || _valid1;
    }
  }
  if (!valid2) {
    const err25 = {
      instancePath,
      schemaPath: "ArenaAuthRequest/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err25];
    } else {
      vErrors.push(err25);
    }
    errors++;
  } else {
    errors = _errs3;
    if (vErrors !== null) {
      if (_errs3) {
        vErrors.length = _errs3;
      } else {
        vErrors = null;
      }
    }
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs26 = errors;
    const _errs28 = errors;
    let valid7 = false;
    const _errs29 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.action === void 0) {
        const err26 = {
          instancePath,
          schemaPath: "TvAuthRequest/anyOf/0/required",
          keyword: "required",
          params: {
            missingProperty: "action"
          },
          message: "must have required property 'action'"
        };
        if (vErrors === null) {
          vErrors = [err26];
        } else {
          vErrors.push(err26);
        }
        errors++;
      }
      if (data.channelId === void 0) {
        const err27 = {
          instancePath,
          schemaPath: "TvAuthRequest/anyOf/0/required",
          keyword: "required",
          params: {
            missingProperty: "channelId"
          },
          message: "must have required property 'channelId'"
        };
        if (vErrors === null) {
          vErrors = [err27];
        } else {
          vErrors.push(err27);
        }
        errors++;
      }
      if (data.idToken === void 0) {
        const err28 = {
          instancePath,
          schemaPath: "TvAuthRequest/anyOf/0/required",
          keyword: "required",
          params: {
            missingProperty: "idToken"
          },
          message: "must have required property 'idToken'"
        };
        if (vErrors === null) {
          vErrors = [err28];
        } else {
          vErrors.push(err28);
        }
        errors++;
      }
      if (data.platform === void 0) {
        const err29 = {
          instancePath,
          schemaPath: "TvAuthRequest/anyOf/0/required",
          keyword: "required",
          params: {
            missingProperty: "platform"
          },
          message: "must have required property 'platform'"
        };
        if (vErrors === null) {
          vErrors = [err29];
        } else {
          vErrors.push(err29);
        }
        errors++;
      }
      if (data.redirectUrl === void 0) {
        const err30 = {
          instancePath,
          schemaPath: "TvAuthRequest/anyOf/0/required",
          keyword: "required",
          params: {
            missingProperty: "redirectUrl"
          },
          message: "must have required property 'redirectUrl'"
        };
        if (vErrors === null) {
          vErrors = [err30];
        } else {
          vErrors.push(err30);
        }
        errors++;
      }
      if (data.platform !== void 0) {
        let data8 = data.platform;
        if (typeof data8 !== "string") {
          const err31 = {
            instancePath: instancePath + "/platform",
            schemaPath: "TvAuthRequest/anyOf/0/properties/platform/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err31];
          } else {
            vErrors.push(err31);
          }
          errors++;
        }
        if ("TV" !== data8) {
          const err32 = {
            instancePath: instancePath + "/platform",
            schemaPath: "TvAuthRequest/anyOf/0/properties/platform/const",
            keyword: "const",
            params: {
              allowedValue: "TV"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err32];
          } else {
            vErrors.push(err32);
          }
          errors++;
        }
      }
      if (data.action !== void 0) {
        let data9 = data.action;
        if (typeof data9 !== "string") {
          const err33 = {
            instancePath: instancePath + "/action",
            schemaPath: "TvAuthRequest/anyOf/0/properties/action/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err33];
          } else {
            vErrors.push(err33);
          }
          errors++;
        }
        if ("GET_SIGNIN_URL" !== data9) {
          const err34 = {
            instancePath: instancePath + "/action",
            schemaPath: "TvAuthRequest/anyOf/0/properties/action/const",
            keyword: "const",
            params: {
              allowedValue: "GET_SIGNIN_URL"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err34];
          } else {
            vErrors.push(err34);
          }
          errors++;
        }
      }
      if (data.channelId !== void 0) {
        if (typeof data.channelId !== "string") {
          const err35 = {
            instancePath: instancePath + "/channelId",
            schemaPath: "TvAuthRequest/anyOf/0/properties/channelId/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err35];
          } else {
            vErrors.push(err35);
          }
          errors++;
        }
      }
      if (data.idToken !== void 0) {
        if (typeof data.idToken !== "string") {
          const err36 = {
            instancePath: instancePath + "/idToken",
            schemaPath: "TvAuthRequest/anyOf/0/properties/idToken/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err36];
          } else {
            vErrors.push(err36);
          }
          errors++;
        }
      }
      if (data.redirectUrl !== void 0) {
        if (typeof data.redirectUrl !== "string") {
          const err37 = {
            instancePath: instancePath + "/redirectUrl",
            schemaPath: "TvAuthRequest/anyOf/0/properties/redirectUrl/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err37];
          } else {
            vErrors.push(err37);
          }
          errors++;
        }
      }
    } else {
      const err38 = {
        instancePath,
        schemaPath: "TvAuthRequest/anyOf/0/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err38];
      } else {
        vErrors.push(err38);
      }
      errors++;
    }
    var _valid2 = _errs29 === errors;
    valid7 = valid7 || _valid2;
    if (!valid7) {
      const _errs41 = errors;
      if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.action === void 0) {
          const err39 = {
            instancePath,
            schemaPath: "TvAuthRequest/anyOf/1/required",
            keyword: "required",
            params: {
              missingProperty: "action"
            },
            message: "must have required property 'action'"
          };
          if (vErrors === null) {
            vErrors = [err39];
          } else {
            vErrors.push(err39);
          }
          errors++;
        }
        if (data.channelId === void 0) {
          const err40 = {
            instancePath,
            schemaPath: "TvAuthRequest/anyOf/1/required",
            keyword: "required",
            params: {
              missingProperty: "channelId"
            },
            message: "must have required property 'channelId'"
          };
          if (vErrors === null) {
            vErrors = [err40];
          } else {
            vErrors.push(err40);
          }
          errors++;
        }
        if (data.email === void 0) {
          const err41 = {
            instancePath,
            schemaPath: "TvAuthRequest/anyOf/1/required",
            keyword: "required",
            params: {
              missingProperty: "email"
            },
            message: "must have required property 'email'"
          };
          if (vErrors === null) {
            vErrors = [err41];
          } else {
            vErrors.push(err41);
          }
          errors++;
        }
        if (data.platform === void 0) {
          const err42 = {
            instancePath,
            schemaPath: "TvAuthRequest/anyOf/1/required",
            keyword: "required",
            params: {
              missingProperty: "platform"
            },
            message: "must have required property 'platform'"
          };
          if (vErrors === null) {
            vErrors = [err42];
          } else {
            vErrors.push(err42);
          }
          errors++;
        }
        if (data.platform !== void 0) {
          let data13 = data.platform;
          if (typeof data13 !== "string") {
            const err43 = {
              instancePath: instancePath + "/platform",
              schemaPath: "TvAuthRequest/anyOf/1/properties/platform/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err43];
            } else {
              vErrors.push(err43);
            }
            errors++;
          }
          if ("TV" !== data13) {
            const err44 = {
              instancePath: instancePath + "/platform",
              schemaPath: "TvAuthRequest/anyOf/1/properties/platform/const",
              keyword: "const",
              params: {
                allowedValue: "TV"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err44];
            } else {
              vErrors.push(err44);
            }
            errors++;
          }
        }
        if (data.action !== void 0) {
          let data14 = data.action;
          if (typeof data14 !== "string") {
            const err45 = {
              instancePath: instancePath + "/action",
              schemaPath: "TvAuthRequest/anyOf/1/properties/action/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err45];
            } else {
              vErrors.push(err45);
            }
            errors++;
          }
          if ("REQUEST_PASSWORD_RESET" !== data14) {
            const err46 = {
              instancePath: instancePath + "/action",
              schemaPath: "TvAuthRequest/anyOf/1/properties/action/const",
              keyword: "const",
              params: {
                allowedValue: "REQUEST_PASSWORD_RESET"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err46];
            } else {
              vErrors.push(err46);
            }
            errors++;
          }
        }
        if (data.channelId !== void 0) {
          if (typeof data.channelId !== "string") {
            const err47 = {
              instancePath: instancePath + "/channelId",
              schemaPath: "TvAuthRequest/anyOf/1/properties/channelId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err47];
            } else {
              vErrors.push(err47);
            }
            errors++;
          }
        }
        if (data.email !== void 0) {
          if (typeof data.email !== "string") {
            const err48 = {
              instancePath: instancePath + "/email",
              schemaPath: "TvAuthRequest/anyOf/1/properties/email/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err48];
            } else {
              vErrors.push(err48);
            }
            errors++;
          }
        }
      } else {
        const err49 = {
          instancePath,
          schemaPath: "TvAuthRequest/anyOf/1/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err49];
        } else {
          vErrors.push(err49);
        }
        errors++;
      }
      var _valid2 = _errs41 === errors;
      valid7 = valid7 || _valid2;
      if (!valid7) {
        const _errs51 = errors;
        if (data && typeof data == "object" && !Array.isArray(data)) {
          if (data.action === void 0) {
            const err50 = {
              instancePath,
              schemaPath: "TvAuthRequest/anyOf/2/required",
              keyword: "required",
              params: {
                missingProperty: "action"
              },
              message: "must have required property 'action'"
            };
            if (vErrors === null) {
              vErrors = [err50];
            } else {
              vErrors.push(err50);
            }
            errors++;
          }
          if (data.channelId === void 0) {
            const err51 = {
              instancePath,
              schemaPath: "TvAuthRequest/anyOf/2/required",
              keyword: "required",
              params: {
                missingProperty: "channelId"
              },
              message: "must have required property 'channelId'"
            };
            if (vErrors === null) {
              vErrors = [err51];
            } else {
              vErrors.push(err51);
            }
            errors++;
          }
          if (data.email === void 0) {
            const err52 = {
              instancePath,
              schemaPath: "TvAuthRequest/anyOf/2/required",
              keyword: "required",
              params: {
                missingProperty: "email"
              },
              message: "must have required property 'email'"
            };
            if (vErrors === null) {
              vErrors = [err52];
            } else {
              vErrors.push(err52);
            }
            errors++;
          }
          if (data.platform === void 0) {
            const err53 = {
              instancePath,
              schemaPath: "TvAuthRequest/anyOf/2/required",
              keyword: "required",
              params: {
                missingProperty: "platform"
              },
              message: "must have required property 'platform'"
            };
            if (vErrors === null) {
              vErrors = [err53];
            } else {
              vErrors.push(err53);
            }
            errors++;
          }
          if (data.platform !== void 0) {
            let data17 = data.platform;
            if (typeof data17 !== "string") {
              const err54 = {
                instancePath: instancePath + "/platform",
                schemaPath: "TvAuthRequest/anyOf/2/properties/platform/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err54];
              } else {
                vErrors.push(err54);
              }
              errors++;
            }
            if ("TV" !== data17) {
              const err55 = {
                instancePath: instancePath + "/platform",
                schemaPath: "TvAuthRequest/anyOf/2/properties/platform/const",
                keyword: "const",
                params: {
                  allowedValue: "TV"
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err55];
              } else {
                vErrors.push(err55);
              }
              errors++;
            }
          }
          if (data.action !== void 0) {
            let data18 = data.action;
            if (typeof data18 !== "string") {
              const err56 = {
                instancePath: instancePath + "/action",
                schemaPath: "TvAuthRequest/anyOf/2/properties/action/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err56];
              } else {
                vErrors.push(err56);
              }
              errors++;
            }
            if ("REQUEST_EMAIL_VERIFICATION" !== data18) {
              const err57 = {
                instancePath: instancePath + "/action",
                schemaPath: "TvAuthRequest/anyOf/2/properties/action/const",
                keyword: "const",
                params: {
                  allowedValue: "REQUEST_EMAIL_VERIFICATION"
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err57];
              } else {
                vErrors.push(err57);
              }
              errors++;
            }
          }
          if (data.channelId !== void 0) {
            if (typeof data.channelId !== "string") {
              const err58 = {
                instancePath: instancePath + "/channelId",
                schemaPath: "TvAuthRequest/anyOf/2/properties/channelId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err58];
              } else {
                vErrors.push(err58);
              }
              errors++;
            }
          }
          if (data.email !== void 0) {
            if (typeof data.email !== "string") {
              const err59 = {
                instancePath: instancePath + "/email",
                schemaPath: "TvAuthRequest/anyOf/2/properties/email/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err59];
              } else {
                vErrors.push(err59);
              }
              errors++;
            }
          }
        } else {
          const err60 = {
            instancePath,
            schemaPath: "TvAuthRequest/anyOf/2/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err60];
          } else {
            vErrors.push(err60);
          }
          errors++;
        }
        var _valid2 = _errs51 === errors;
        valid7 = valid7 || _valid2;
      }
    }
    if (!valid7) {
      const err61 = {
        instancePath,
        schemaPath: "TvAuthRequest/anyOf",
        keyword: "anyOf",
        params: {},
        message: "must match a schema in anyOf"
      };
      if (vErrors === null) {
        vErrors = [err61];
      } else {
        vErrors.push(err61);
      }
      errors++;
    } else {
      errors = _errs28;
      if (vErrors !== null) {
        if (_errs28) {
          vErrors.length = _errs28;
        } else {
          vErrors = null;
        }
      }
    }
    var _valid0 = _errs26 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs61 = errors;
      const _errs63 = errors;
      let valid12 = false;
      const _errs64 = errors;
      if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.action === void 0) {
          const err62 = {
            instancePath,
            schemaPath: "StudioAuthRequest/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "action"
            },
            message: "must have required property 'action'"
          };
          if (vErrors === null) {
            vErrors = [err62];
          } else {
            vErrors.push(err62);
          }
          errors++;
        }
        if (data.idToken === void 0) {
          const err63 = {
            instancePath,
            schemaPath: "StudioAuthRequest/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "idToken"
            },
            message: "must have required property 'idToken'"
          };
          if (vErrors === null) {
            vErrors = [err63];
          } else {
            vErrors.push(err63);
          }
          errors++;
        }
        if (data.platform === void 0) {
          const err64 = {
            instancePath,
            schemaPath: "StudioAuthRequest/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "platform"
            },
            message: "must have required property 'platform'"
          };
          if (vErrors === null) {
            vErrors = [err64];
          } else {
            vErrors.push(err64);
          }
          errors++;
        }
        if (data.redirectUrl === void 0) {
          const err65 = {
            instancePath,
            schemaPath: "StudioAuthRequest/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "redirectUrl"
            },
            message: "must have required property 'redirectUrl'"
          };
          if (vErrors === null) {
            vErrors = [err65];
          } else {
            vErrors.push(err65);
          }
          errors++;
        }
        if (data.platform !== void 0) {
          let data21 = data.platform;
          if (typeof data21 !== "string") {
            const err66 = {
              instancePath: instancePath + "/platform",
              schemaPath: "StudioAuthRequest/anyOf/0/properties/platform/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err66];
            } else {
              vErrors.push(err66);
            }
            errors++;
          }
          if ("STUDIO" !== data21) {
            const err67 = {
              instancePath: instancePath + "/platform",
              schemaPath: "StudioAuthRequest/anyOf/0/properties/platform/const",
              keyword: "const",
              params: {
                allowedValue: "STUDIO"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err67];
            } else {
              vErrors.push(err67);
            }
            errors++;
          }
        }
        if (data.action !== void 0) {
          let data22 = data.action;
          if (typeof data22 !== "string") {
            const err68 = {
              instancePath: instancePath + "/action",
              schemaPath: "StudioAuthRequest/anyOf/0/properties/action/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err68];
            } else {
              vErrors.push(err68);
            }
            errors++;
          }
          if ("GET_SIGNIN_URL" !== data22) {
            const err69 = {
              instancePath: instancePath + "/action",
              schemaPath: "StudioAuthRequest/anyOf/0/properties/action/const",
              keyword: "const",
              params: {
                allowedValue: "GET_SIGNIN_URL"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err69];
            } else {
              vErrors.push(err69);
            }
            errors++;
          }
        }
        if (data.idToken !== void 0) {
          if (typeof data.idToken !== "string") {
            const err70 = {
              instancePath: instancePath + "/idToken",
              schemaPath: "StudioAuthRequest/anyOf/0/properties/idToken/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err70];
            } else {
              vErrors.push(err70);
            }
            errors++;
          }
        }
        if (data.redirectUrl !== void 0) {
          if (typeof data.redirectUrl !== "string") {
            const err71 = {
              instancePath: instancePath + "/redirectUrl",
              schemaPath: "StudioAuthRequest/anyOf/0/properties/redirectUrl/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err71];
            } else {
              vErrors.push(err71);
            }
            errors++;
          }
        }
      } else {
        const err72 = {
          instancePath,
          schemaPath: "StudioAuthRequest/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err72];
        } else {
          vErrors.push(err72);
        }
        errors++;
      }
      var _valid3 = _errs64 === errors;
      valid12 = valid12 || _valid3;
      if (!valid12) {
        const _errs74 = errors;
        if (data && typeof data == "object" && !Array.isArray(data)) {
          if (data.action === void 0) {
            const err73 = {
              instancePath,
              schemaPath: "StudioAuthRequest/anyOf/1/required",
              keyword: "required",
              params: {
                missingProperty: "action"
              },
              message: "must have required property 'action'"
            };
            if (vErrors === null) {
              vErrors = [err73];
            } else {
              vErrors.push(err73);
            }
            errors++;
          }
          if (data.email === void 0) {
            const err74 = {
              instancePath,
              schemaPath: "StudioAuthRequest/anyOf/1/required",
              keyword: "required",
              params: {
                missingProperty: "email"
              },
              message: "must have required property 'email'"
            };
            if (vErrors === null) {
              vErrors = [err74];
            } else {
              vErrors.push(err74);
            }
            errors++;
          }
          if (data.platform === void 0) {
            const err75 = {
              instancePath,
              schemaPath: "StudioAuthRequest/anyOf/1/required",
              keyword: "required",
              params: {
                missingProperty: "platform"
              },
              message: "must have required property 'platform'"
            };
            if (vErrors === null) {
              vErrors = [err75];
            } else {
              vErrors.push(err75);
            }
            errors++;
          }
          if (data.platform !== void 0) {
            let data25 = data.platform;
            if (typeof data25 !== "string") {
              const err76 = {
                instancePath: instancePath + "/platform",
                schemaPath: "StudioAuthRequest/anyOf/1/properties/platform/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err76];
              } else {
                vErrors.push(err76);
              }
              errors++;
            }
            if ("STUDIO" !== data25) {
              const err77 = {
                instancePath: instancePath + "/platform",
                schemaPath: "StudioAuthRequest/anyOf/1/properties/platform/const",
                keyword: "const",
                params: {
                  allowedValue: "STUDIO"
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err77];
              } else {
                vErrors.push(err77);
              }
              errors++;
            }
          }
          if (data.action !== void 0) {
            let data26 = data.action;
            if (typeof data26 !== "string") {
              const err78 = {
                instancePath: instancePath + "/action",
                schemaPath: "StudioAuthRequest/anyOf/1/properties/action/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err78];
              } else {
                vErrors.push(err78);
              }
              errors++;
            }
            if ("REQUEST_PASSWORD_RESET" !== data26) {
              const err79 = {
                instancePath: instancePath + "/action",
                schemaPath: "StudioAuthRequest/anyOf/1/properties/action/const",
                keyword: "const",
                params: {
                  allowedValue: "REQUEST_PASSWORD_RESET"
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err79];
              } else {
                vErrors.push(err79);
              }
              errors++;
            }
          }
          if (data.email !== void 0) {
            if (typeof data.email !== "string") {
              const err80 = {
                instancePath: instancePath + "/email",
                schemaPath: "StudioAuthRequest/anyOf/1/properties/email/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err80];
              } else {
                vErrors.push(err80);
              }
              errors++;
            }
          }
        } else {
          const err81 = {
            instancePath,
            schemaPath: "StudioAuthRequest/anyOf/1/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err81];
          } else {
            vErrors.push(err81);
          }
          errors++;
        }
        var _valid3 = _errs74 === errors;
        valid12 = valid12 || _valid3;
        if (!valid12) {
          const _errs82 = errors;
          if (data && typeof data == "object" && !Array.isArray(data)) {
            if (data.action === void 0) {
              const err82 = {
                instancePath,
                schemaPath: "StudioAuthRequest/anyOf/2/required",
                keyword: "required",
                params: {
                  missingProperty: "action"
                },
                message: "must have required property 'action'"
              };
              if (vErrors === null) {
                vErrors = [err82];
              } else {
                vErrors.push(err82);
              }
              errors++;
            }
            if (data.email === void 0) {
              const err83 = {
                instancePath,
                schemaPath: "StudioAuthRequest/anyOf/2/required",
                keyword: "required",
                params: {
                  missingProperty: "email"
                },
                message: "must have required property 'email'"
              };
              if (vErrors === null) {
                vErrors = [err83];
              } else {
                vErrors.push(err83);
              }
              errors++;
            }
            if (data.platform === void 0) {
              const err84 = {
                instancePath,
                schemaPath: "StudioAuthRequest/anyOf/2/required",
                keyword: "required",
                params: {
                  missingProperty: "platform"
                },
                message: "must have required property 'platform'"
              };
              if (vErrors === null) {
                vErrors = [err84];
              } else {
                vErrors.push(err84);
              }
              errors++;
            }
            if (data.platform !== void 0) {
              let data28 = data.platform;
              if (typeof data28 !== "string") {
                const err85 = {
                  instancePath: instancePath + "/platform",
                  schemaPath: "StudioAuthRequest/anyOf/2/properties/platform/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err85];
                } else {
                  vErrors.push(err85);
                }
                errors++;
              }
              if ("STUDIO" !== data28) {
                const err86 = {
                  instancePath: instancePath + "/platform",
                  schemaPath: "StudioAuthRequest/anyOf/2/properties/platform/const",
                  keyword: "const",
                  params: {
                    allowedValue: "STUDIO"
                  },
                  message: "must be equal to constant"
                };
                if (vErrors === null) {
                  vErrors = [err86];
                } else {
                  vErrors.push(err86);
                }
                errors++;
              }
            }
            if (data.action !== void 0) {
              let data29 = data.action;
              if (typeof data29 !== "string") {
                const err87 = {
                  instancePath: instancePath + "/action",
                  schemaPath: "StudioAuthRequest/anyOf/2/properties/action/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err87];
                } else {
                  vErrors.push(err87);
                }
                errors++;
              }
              if ("REQUEST_EMAIL_VERIFICATION" !== data29) {
                const err88 = {
                  instancePath: instancePath + "/action",
                  schemaPath: "StudioAuthRequest/anyOf/2/properties/action/const",
                  keyword: "const",
                  params: {
                    allowedValue: "REQUEST_EMAIL_VERIFICATION"
                  },
                  message: "must be equal to constant"
                };
                if (vErrors === null) {
                  vErrors = [err88];
                } else {
                  vErrors.push(err88);
                }
                errors++;
              }
            }
            if (data.email !== void 0) {
              if (typeof data.email !== "string") {
                const err89 = {
                  instancePath: instancePath + "/email",
                  schemaPath: "StudioAuthRequest/anyOf/2/properties/email/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err89];
                } else {
                  vErrors.push(err89);
                }
                errors++;
              }
            }
          } else {
            const err90 = {
              instancePath,
              schemaPath: "StudioAuthRequest/anyOf/2/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err90];
            } else {
              vErrors.push(err90);
            }
            errors++;
          }
          var _valid3 = _errs82 === errors;
          valid12 = valid12 || _valid3;
        }
      }
      if (!valid12) {
        const err91 = {
          instancePath,
          schemaPath: "StudioAuthRequest/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err91];
        } else {
          vErrors.push(err91);
        }
        errors++;
      } else {
        errors = _errs63;
        if (vErrors !== null) {
          if (_errs63) {
            vErrors.length = _errs63;
          } else {
            vErrors = null;
          }
        }
      }
      var _valid0 = _errs61 === errors;
      valid0 = valid0 || _valid0;
    }
  }
  if (!valid0) {
    const err92 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err92];
    } else {
      vErrors.push(err92);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate33.errors = vErrors;
  return errors === 0;
}
const AuthResponse = validate34;
function validate34(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.code === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "code"
        },
        message: "must have required property 'code'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.result === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "result"
        },
        message: "must have required property 'result'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.code !== void 0) {
      let data0 = data.code;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = {
          instancePath: instancePath + "/code",
          schemaPath: "#/properties/code/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.result !== void 0) {
      if (typeof data.result !== "string") {
        const err3 = {
          instancePath: instancePath + "/result",
          schemaPath: "#/properties/result/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate34.errors = vErrors;
  return errors === 0;
}
const AuthErrors = validate35;
const schema47 = {
  "$id": "AuthErrors",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["joymo-auth/wrong-params", "joymo-auth/wrong-channel", "joymo-auth/no-domain-match", "joymo-auth/bad-protocol", "joymo-auth/unauthorized"]
};
function validate35(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (!(data === "joymo-auth/wrong-params" || data === "joymo-auth/wrong-channel" || data === "joymo-auth/no-domain-match" || data === "joymo-auth/bad-protocol" || data === "joymo-auth/unauthorized")) {
    const err1 = {
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema47.enum
      },
      message: "must be equal to one of the allowed values"
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate35.errors = vErrors;
  return errors === 0;
}
const Branding = validate36;
const schema48 = {
  "$id": "Branding",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "accentColor": {
      "type": "string"
    },
    "backgroundColor": {
      "type": "string"
    },
    "themeStyle": {
      "type": "string",
      "enum": ["rounded", "hard"]
    },
    "bannerImages": {
      "type": "object",
      "properties": {
        "3/1": {
          "type": "string"
        },
        "3/4": {
          "type": "string"
        },
        "16/9": {
          "type": "string"
        }
      },
      "required": ["3/1", "3/4", "16/9"]
    },
    "logoImage": {
      "type": "string"
    },
    "contactInformation": {
      "type": "object",
      "properties": {
        "socialMediaLinks": {
          "anyOf": [{
            "type": "array",
            "items": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "url": {
                  "type": "string"
                }
              },
              "required": ["type", "url"]
            }
          }, {
            "type": "null"
          }]
        },
        "contactAddressLines": {
          "anyOf": [{
            "type": "array",
            "items": {
              "type": "string"
            }
          }, {
            "type": "null"
          }]
        },
        "contactPhone": {
          "type": ["string", "null"]
        },
        "contactEmail": {
          "type": ["string", "null"]
        },
        "streamHelpText": {
          "type": ["string", "null"]
        },
        "supportEmail": {
          "type": ["string", "null"]
        },
        "faqLink": {
          "type": ["string", "null"]
        },
        "copyrightNotice": {
          "type": ["string", "null"]
        },
        "privacyPolicy": {
          "anyOf": [{
            "type": "array",
            "items": {
              "type": "string"
            }
          }, {
            "type": "null"
          }]
        },
        "logoImage": {
          "type": ["string", "null"]
        }
      },
      "required": ["socialMediaLinks", "contactAddressLines", "contactPhone", "contactEmail", "supportEmail", "copyrightNotice"]
    }
  },
  "required": ["accentColor", "backgroundColor", "themeStyle", "bannerImages", "logoImage"],
  "description": "Holds the information about the branding of a given entity (channel) and will affect the rendering of the elements on pages associated with it."
};
function validate36(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.accentColor === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "accentColor"
        },
        message: "must have required property 'accentColor'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.backgroundColor === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "backgroundColor"
        },
        message: "must have required property 'backgroundColor'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.themeStyle === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "themeStyle"
        },
        message: "must have required property 'themeStyle'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.bannerImages === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "bannerImages"
        },
        message: "must have required property 'bannerImages'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.logoImage === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "logoImage"
        },
        message: "must have required property 'logoImage'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.accentColor !== void 0) {
      if (typeof data.accentColor !== "string") {
        const err5 = {
          instancePath: instancePath + "/accentColor",
          schemaPath: "#/properties/accentColor/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.backgroundColor !== void 0) {
      if (typeof data.backgroundColor !== "string") {
        const err6 = {
          instancePath: instancePath + "/backgroundColor",
          schemaPath: "#/properties/backgroundColor/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.themeStyle !== void 0) {
      let data2 = data.themeStyle;
      if (typeof data2 !== "string") {
        const err7 = {
          instancePath: instancePath + "/themeStyle",
          schemaPath: "#/properties/themeStyle/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if (!(data2 === "rounded" || data2 === "hard")) {
        const err8 = {
          instancePath: instancePath + "/themeStyle",
          schemaPath: "#/properties/themeStyle/enum",
          keyword: "enum",
          params: {
            allowedValues: schema48.properties.themeStyle.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.bannerImages !== void 0) {
      let data3 = data.bannerImages;
      if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
        if (data3["3/1"] === void 0) {
          const err9 = {
            instancePath: instancePath + "/bannerImages",
            schemaPath: "#/properties/bannerImages/required",
            keyword: "required",
            params: {
              missingProperty: "3/1"
            },
            message: "must have required property '3/1'"
          };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
        if (data3["3/4"] === void 0) {
          const err10 = {
            instancePath: instancePath + "/bannerImages",
            schemaPath: "#/properties/bannerImages/required",
            keyword: "required",
            params: {
              missingProperty: "3/4"
            },
            message: "must have required property '3/4'"
          };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
        if (data3["16/9"] === void 0) {
          const err11 = {
            instancePath: instancePath + "/bannerImages",
            schemaPath: "#/properties/bannerImages/required",
            keyword: "required",
            params: {
              missingProperty: "16/9"
            },
            message: "must have required property '16/9'"
          };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
        if (data3["3/1"] !== void 0) {
          if (typeof data3["3/1"] !== "string") {
            const err12 = {
              instancePath: instancePath + "/bannerImages/3~11",
              schemaPath: "#/properties/bannerImages/properties/3~11/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
        }
        if (data3["3/4"] !== void 0) {
          if (typeof data3["3/4"] !== "string") {
            const err13 = {
              instancePath: instancePath + "/bannerImages/3~14",
              schemaPath: "#/properties/bannerImages/properties/3~14/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
        }
        if (data3["16/9"] !== void 0) {
          if (typeof data3["16/9"] !== "string") {
            const err14 = {
              instancePath: instancePath + "/bannerImages/16~19",
              schemaPath: "#/properties/bannerImages/properties/16~19/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err14];
            } else {
              vErrors.push(err14);
            }
            errors++;
          }
        }
      } else {
        const err15 = {
          instancePath: instancePath + "/bannerImages",
          schemaPath: "#/properties/bannerImages/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
    if (data.logoImage !== void 0) {
      if (typeof data.logoImage !== "string") {
        const err16 = {
          instancePath: instancePath + "/logoImage",
          schemaPath: "#/properties/logoImage/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.contactInformation !== void 0) {
      let data8 = data.contactInformation;
      if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
        if (data8.socialMediaLinks === void 0) {
          const err17 = {
            instancePath: instancePath + "/contactInformation",
            schemaPath: "#/properties/contactInformation/required",
            keyword: "required",
            params: {
              missingProperty: "socialMediaLinks"
            },
            message: "must have required property 'socialMediaLinks'"
          };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
        if (data8.contactAddressLines === void 0) {
          const err18 = {
            instancePath: instancePath + "/contactInformation",
            schemaPath: "#/properties/contactInformation/required",
            keyword: "required",
            params: {
              missingProperty: "contactAddressLines"
            },
            message: "must have required property 'contactAddressLines'"
          };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        if (data8.contactPhone === void 0) {
          const err19 = {
            instancePath: instancePath + "/contactInformation",
            schemaPath: "#/properties/contactInformation/required",
            keyword: "required",
            params: {
              missingProperty: "contactPhone"
            },
            message: "must have required property 'contactPhone'"
          };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if (data8.contactEmail === void 0) {
          const err20 = {
            instancePath: instancePath + "/contactInformation",
            schemaPath: "#/properties/contactInformation/required",
            keyword: "required",
            params: {
              missingProperty: "contactEmail"
            },
            message: "must have required property 'contactEmail'"
          };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
        if (data8.supportEmail === void 0) {
          const err21 = {
            instancePath: instancePath + "/contactInformation",
            schemaPath: "#/properties/contactInformation/required",
            keyword: "required",
            params: {
              missingProperty: "supportEmail"
            },
            message: "must have required property 'supportEmail'"
          };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
        if (data8.copyrightNotice === void 0) {
          const err22 = {
            instancePath: instancePath + "/contactInformation",
            schemaPath: "#/properties/contactInformation/required",
            keyword: "required",
            params: {
              missingProperty: "copyrightNotice"
            },
            message: "must have required property 'copyrightNotice'"
          };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
        if (data8.socialMediaLinks !== void 0) {
          let data9 = data8.socialMediaLinks;
          const _errs20 = errors;
          let valid3 = false;
          const _errs21 = errors;
          if (Array.isArray(data9)) {
            const len0 = data9.length;
            for (let i0 = 0; i0 < len0; i0++) {
              let data10 = data9[i0];
              if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                if (data10.type === void 0) {
                  const err23 = {
                    instancePath: instancePath + "/contactInformation/socialMediaLinks/" + i0,
                    schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/required",
                    keyword: "required",
                    params: {
                      missingProperty: "type"
                    },
                    message: "must have required property 'type'"
                  };
                  if (vErrors === null) {
                    vErrors = [err23];
                  } else {
                    vErrors.push(err23);
                  }
                  errors++;
                }
                if (data10.url === void 0) {
                  const err24 = {
                    instancePath: instancePath + "/contactInformation/socialMediaLinks/" + i0,
                    schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/required",
                    keyword: "required",
                    params: {
                      missingProperty: "url"
                    },
                    message: "must have required property 'url'"
                  };
                  if (vErrors === null) {
                    vErrors = [err24];
                  } else {
                    vErrors.push(err24);
                  }
                  errors++;
                }
                if (data10.type !== void 0) {
                  if (typeof data10.type !== "string") {
                    const err25 = {
                      instancePath: instancePath + "/contactInformation/socialMediaLinks/" + i0 + "/type",
                      schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/properties/type/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err25];
                    } else {
                      vErrors.push(err25);
                    }
                    errors++;
                  }
                }
                if (data10.url !== void 0) {
                  if (typeof data10.url !== "string") {
                    const err26 = {
                      instancePath: instancePath + "/contactInformation/socialMediaLinks/" + i0 + "/url",
                      schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/properties/url/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err26];
                    } else {
                      vErrors.push(err26);
                    }
                    errors++;
                  }
                }
              } else {
                const err27 = {
                  instancePath: instancePath + "/contactInformation/socialMediaLinks/" + i0,
                  schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err27];
                } else {
                  vErrors.push(err27);
                }
                errors++;
              }
            }
          } else {
            const err28 = {
              instancePath: instancePath + "/contactInformation/socialMediaLinks",
              schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf/0/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err28];
            } else {
              vErrors.push(err28);
            }
            errors++;
          }
          var _valid0 = _errs21 === errors;
          valid3 = valid3 || _valid0;
          if (!valid3) {
            const _errs29 = errors;
            if (data9 !== null) {
              const err29 = {
                instancePath: instancePath + "/contactInformation/socialMediaLinks",
                schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err29];
              } else {
                vErrors.push(err29);
              }
              errors++;
            }
            var _valid0 = _errs29 === errors;
            valid3 = valid3 || _valid0;
          }
          if (!valid3) {
            const err30 = {
              instancePath: instancePath + "/contactInformation/socialMediaLinks",
              schemaPath: "#/properties/contactInformation/properties/socialMediaLinks/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err30];
            } else {
              vErrors.push(err30);
            }
            errors++;
          } else {
            errors = _errs20;
            if (vErrors !== null) {
              if (_errs20) {
                vErrors.length = _errs20;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data8.contactAddressLines !== void 0) {
          let data13 = data8.contactAddressLines;
          const _errs32 = errors;
          let valid7 = false;
          const _errs33 = errors;
          if (Array.isArray(data13)) {
            const len1 = data13.length;
            for (let i1 = 0; i1 < len1; i1++) {
              if (typeof data13[i1] !== "string") {
                const err31 = {
                  instancePath: instancePath + "/contactInformation/contactAddressLines/" + i1,
                  schemaPath: "#/properties/contactInformation/properties/contactAddressLines/anyOf/0/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err31];
                } else {
                  vErrors.push(err31);
                }
                errors++;
              }
            }
          } else {
            const err32 = {
              instancePath: instancePath + "/contactInformation/contactAddressLines",
              schemaPath: "#/properties/contactInformation/properties/contactAddressLines/anyOf/0/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err32];
            } else {
              vErrors.push(err32);
            }
            errors++;
          }
          var _valid1 = _errs33 === errors;
          valid7 = valid7 || _valid1;
          if (!valid7) {
            const _errs37 = errors;
            if (data13 !== null) {
              const err33 = {
                instancePath: instancePath + "/contactInformation/contactAddressLines",
                schemaPath: "#/properties/contactInformation/properties/contactAddressLines/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err33];
              } else {
                vErrors.push(err33);
              }
              errors++;
            }
            var _valid1 = _errs37 === errors;
            valid7 = valid7 || _valid1;
          }
          if (!valid7) {
            const err34 = {
              instancePath: instancePath + "/contactInformation/contactAddressLines",
              schemaPath: "#/properties/contactInformation/properties/contactAddressLines/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err34];
            } else {
              vErrors.push(err34);
            }
            errors++;
          } else {
            errors = _errs32;
            if (vErrors !== null) {
              if (_errs32) {
                vErrors.length = _errs32;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data8.contactPhone !== void 0) {
          let data15 = data8.contactPhone;
          if (typeof data15 !== "string" && data15 !== null) {
            const err35 = {
              instancePath: instancePath + "/contactInformation/contactPhone",
              schemaPath: "#/properties/contactInformation/properties/contactPhone/type",
              keyword: "type",
              params: {
                type: schema48.properties.contactInformation.properties.contactPhone.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err35];
            } else {
              vErrors.push(err35);
            }
            errors++;
          }
        }
        if (data8.contactEmail !== void 0) {
          let data16 = data8.contactEmail;
          if (typeof data16 !== "string" && data16 !== null) {
            const err36 = {
              instancePath: instancePath + "/contactInformation/contactEmail",
              schemaPath: "#/properties/contactInformation/properties/contactEmail/type",
              keyword: "type",
              params: {
                type: schema48.properties.contactInformation.properties.contactEmail.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err36];
            } else {
              vErrors.push(err36);
            }
            errors++;
          }
        }
        if (data8.streamHelpText !== void 0) {
          let data17 = data8.streamHelpText;
          if (typeof data17 !== "string" && data17 !== null) {
            const err37 = {
              instancePath: instancePath + "/contactInformation/streamHelpText",
              schemaPath: "#/properties/contactInformation/properties/streamHelpText/type",
              keyword: "type",
              params: {
                type: schema48.properties.contactInformation.properties.streamHelpText.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err37];
            } else {
              vErrors.push(err37);
            }
            errors++;
          }
        }
        if (data8.supportEmail !== void 0) {
          let data18 = data8.supportEmail;
          if (typeof data18 !== "string" && data18 !== null) {
            const err38 = {
              instancePath: instancePath + "/contactInformation/supportEmail",
              schemaPath: "#/properties/contactInformation/properties/supportEmail/type",
              keyword: "type",
              params: {
                type: schema48.properties.contactInformation.properties.supportEmail.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err38];
            } else {
              vErrors.push(err38);
            }
            errors++;
          }
        }
        if (data8.faqLink !== void 0) {
          let data19 = data8.faqLink;
          if (typeof data19 !== "string" && data19 !== null) {
            const err39 = {
              instancePath: instancePath + "/contactInformation/faqLink",
              schemaPath: "#/properties/contactInformation/properties/faqLink/type",
              keyword: "type",
              params: {
                type: schema48.properties.contactInformation.properties.faqLink.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err39];
            } else {
              vErrors.push(err39);
            }
            errors++;
          }
        }
        if (data8.copyrightNotice !== void 0) {
          let data20 = data8.copyrightNotice;
          if (typeof data20 !== "string" && data20 !== null) {
            const err40 = {
              instancePath: instancePath + "/contactInformation/copyrightNotice",
              schemaPath: "#/properties/contactInformation/properties/copyrightNotice/type",
              keyword: "type",
              params: {
                type: schema48.properties.contactInformation.properties.copyrightNotice.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err40];
            } else {
              vErrors.push(err40);
            }
            errors++;
          }
        }
        if (data8.privacyPolicy !== void 0) {
          let data21 = data8.privacyPolicy;
          const _errs52 = errors;
          let valid10 = false;
          const _errs53 = errors;
          if (Array.isArray(data21)) {
            const len2 = data21.length;
            for (let i2 = 0; i2 < len2; i2++) {
              if (typeof data21[i2] !== "string") {
                const err41 = {
                  instancePath: instancePath + "/contactInformation/privacyPolicy/" + i2,
                  schemaPath: "#/properties/contactInformation/properties/privacyPolicy/anyOf/0/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err41];
                } else {
                  vErrors.push(err41);
                }
                errors++;
              }
            }
          } else {
            const err42 = {
              instancePath: instancePath + "/contactInformation/privacyPolicy",
              schemaPath: "#/properties/contactInformation/properties/privacyPolicy/anyOf/0/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err42];
            } else {
              vErrors.push(err42);
            }
            errors++;
          }
          var _valid2 = _errs53 === errors;
          valid10 = valid10 || _valid2;
          if (!valid10) {
            const _errs57 = errors;
            if (data21 !== null) {
              const err43 = {
                instancePath: instancePath + "/contactInformation/privacyPolicy",
                schemaPath: "#/properties/contactInformation/properties/privacyPolicy/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err43];
              } else {
                vErrors.push(err43);
              }
              errors++;
            }
            var _valid2 = _errs57 === errors;
            valid10 = valid10 || _valid2;
          }
          if (!valid10) {
            const err44 = {
              instancePath: instancePath + "/contactInformation/privacyPolicy",
              schemaPath: "#/properties/contactInformation/properties/privacyPolicy/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err44];
            } else {
              vErrors.push(err44);
            }
            errors++;
          } else {
            errors = _errs52;
            if (vErrors !== null) {
              if (_errs52) {
                vErrors.length = _errs52;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data8.logoImage !== void 0) {
          let data23 = data8.logoImage;
          if (typeof data23 !== "string" && data23 !== null) {
            const err45 = {
              instancePath: instancePath + "/contactInformation/logoImage",
              schemaPath: "#/properties/contactInformation/properties/logoImage/type",
              keyword: "type",
              params: {
                type: schema48.properties.contactInformation.properties.logoImage.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err45];
            } else {
              vErrors.push(err45);
            }
            errors++;
          }
        }
      } else {
        const err46 = {
          instancePath: instancePath + "/contactInformation",
          schemaPath: "#/properties/contactInformation/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err46];
        } else {
          vErrors.push(err46);
        }
        errors++;
      }
    }
  } else {
    const err47 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err47];
    } else {
      vErrors.push(err47);
    }
    errors++;
  }
  validate36.errors = vErrors;
  return errors === 0;
}
const BuySubscriptionRequest = validate37;
const schema49 = {
  "$id": "BuySubscriptionRequest",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "channelId": {
      "type": "string"
    },
    "planId": {
      "type": "string"
    },
    "selectedCurrency": {
      "type": "string"
    },
    "periodicity": {
      "$ref": "BillingPeriodicity"
    },
    "installments": {
      "type": ["boolean", "null"]
    },
    "paymentMethodId": {
      "type": "string"
    },
    "coupon": {
      "type": "string"
    }
  },
  "required": ["channelId", "planId", "selectedCurrency", "periodicity", "paymentMethodId"]
};
function validate37(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.channelId === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.planId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "planId"
        },
        message: "must have required property 'planId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.selectedCurrency === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "selectedCurrency"
        },
        message: "must have required property 'selectedCurrency'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.periodicity === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "periodicity"
        },
        message: "must have required property 'periodicity'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.paymentMethodId === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "paymentMethodId"
        },
        message: "must have required property 'paymentMethodId'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err5 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.planId !== void 0) {
      if (typeof data.planId !== "string") {
        const err6 = {
          instancePath: instancePath + "/planId",
          schemaPath: "#/properties/planId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.selectedCurrency !== void 0) {
      if (typeof data.selectedCurrency !== "string") {
        const err7 = {
          instancePath: instancePath + "/selectedCurrency",
          schemaPath: "#/properties/selectedCurrency/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.periodicity !== void 0) {
      let data3 = data.periodicity;
      if (typeof data3 !== "string") {
        const err8 = {
          instancePath: instancePath + "/periodicity",
          schemaPath: "BillingPeriodicity/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
      if (!(data3 === "MONTHLY" || data3 === "YEARLY")) {
        const err9 = {
          instancePath: instancePath + "/periodicity",
          schemaPath: "BillingPeriodicity/enum",
          keyword: "enum",
          params: {
            allowedValues: schema21.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.installments !== void 0) {
      let data4 = data.installments;
      if (typeof data4 !== "boolean" && data4 !== null) {
        const err10 = {
          instancePath: instancePath + "/installments",
          schemaPath: "#/properties/installments/type",
          keyword: "type",
          params: {
            type: schema49.properties.installments.type
          },
          message: "must be boolean,null"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.paymentMethodId !== void 0) {
      if (typeof data.paymentMethodId !== "string") {
        const err11 = {
          instancePath: instancePath + "/paymentMethodId",
          schemaPath: "#/properties/paymentMethodId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.coupon !== void 0) {
      if (typeof data.coupon !== "string") {
        const err12 = {
          instancePath: instancePath + "/coupon",
          schemaPath: "#/properties/coupon/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
  } else {
    const err13 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err13];
    } else {
      vErrors.push(err13);
    }
    errors++;
  }
  validate37.errors = vErrors;
  return errors === 0;
}
const BuySubscriptionSuccessfulResponse = validate38;
function validate38(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.subscriptionId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "subscriptionId"
        },
        message: "must have required property 'subscriptionId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (true !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.subscriptionId !== void 0) {
      if (typeof data.subscriptionId !== "string") {
        const err4 = {
          instancePath: instancePath + "/subscriptionId",
          schemaPath: "#/properties/subscriptionId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate38.errors = vErrors;
  return errors === 0;
}
const BuySubscriptionErrorResponse = validate39;
function validate39(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.error === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "error"
        },
        message: "must have required property 'error'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (false !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: false
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.error !== void 0) {
      if (typeof data.error !== "string") {
        const err4 = {
          instancePath: instancePath + "/error",
          schemaPath: "#/properties/error/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate39.errors = vErrors;
  return errors === 0;
}
const BuySubscriptionResponse = validate40;
function validate40(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "BuySubscriptionSuccessfulResponse/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.subscriptionId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "BuySubscriptionSuccessfulResponse/required",
        keyword: "required",
        params: {
          missingProperty: "subscriptionId"
        },
        message: "must have required property 'subscriptionId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "BuySubscriptionSuccessfulResponse/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (true !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "BuySubscriptionSuccessfulResponse/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.subscriptionId !== void 0) {
      if (typeof data.subscriptionId !== "string") {
        const err4 = {
          instancePath: instancePath + "/subscriptionId",
          schemaPath: "BuySubscriptionSuccessfulResponse/properties/subscriptionId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "BuySubscriptionSuccessfulResponse/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs8 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.success === void 0) {
        const err6 = {
          instancePath,
          schemaPath: "BuySubscriptionErrorResponse/required",
          keyword: "required",
          params: {
            missingProperty: "success"
          },
          message: "must have required property 'success'"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if (data.error === void 0) {
        const err7 = {
          instancePath,
          schemaPath: "BuySubscriptionErrorResponse/required",
          keyword: "required",
          params: {
            missingProperty: "error"
          },
          message: "must have required property 'error'"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if (data.success !== void 0) {
        let data2 = data.success;
        if (typeof data2 !== "boolean") {
          const err8 = {
            instancePath: instancePath + "/success",
            schemaPath: "BuySubscriptionErrorResponse/properties/success/type",
            keyword: "type",
            params: {
              type: "boolean"
            },
            message: "must be boolean"
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
        if (false !== data2) {
          const err9 = {
            instancePath: instancePath + "/success",
            schemaPath: "BuySubscriptionErrorResponse/properties/success/const",
            keyword: "const",
            params: {
              allowedValue: false
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
      }
      if (data.error !== void 0) {
        if (typeof data.error !== "string") {
          const err10 = {
            instancePath: instancePath + "/error",
            schemaPath: "BuySubscriptionErrorResponse/properties/error/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
      }
    } else {
      const err11 = {
        instancePath,
        schemaPath: "BuySubscriptionErrorResponse/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err11];
      } else {
        vErrors.push(err11);
      }
      errors++;
    }
    var _valid0 = _errs8 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err12 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err12];
    } else {
      vErrors.push(err12);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate40.errors = vErrors;
  return errors === 0;
}
const UserLocation = validate41;
const schema56 = {
  "$id": "UserLocation",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "IP": {
      "type": ["string", "null"]
    },
    "latlng": {
      "type": ["string", "null"]
    },
    "city": {
      "type": ["string", "null"]
    },
    "country": {
      "type": ["string", "null"]
    },
    "region": {
      "type": ["string", "null"]
    }
  },
  "required": ["IP", "latlng", "city", "country", "region"],
  "description": "Stores information about the user location. Usually extracted from a call to a firebase function."
};
function validate41(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.IP === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "IP"
        },
        message: "must have required property 'IP'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.latlng === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "latlng"
        },
        message: "must have required property 'latlng'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.city === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "city"
        },
        message: "must have required property 'city'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.country === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "country"
        },
        message: "must have required property 'country'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.region === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "region"
        },
        message: "must have required property 'region'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.IP !== void 0) {
      let data0 = data.IP;
      if (typeof data0 !== "string" && data0 !== null) {
        const err5 = {
          instancePath: instancePath + "/IP",
          schemaPath: "#/properties/IP/type",
          keyword: "type",
          params: {
            type: schema56.properties.IP.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.latlng !== void 0) {
      let data1 = data.latlng;
      if (typeof data1 !== "string" && data1 !== null) {
        const err6 = {
          instancePath: instancePath + "/latlng",
          schemaPath: "#/properties/latlng/type",
          keyword: "type",
          params: {
            type: schema56.properties.latlng.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.city !== void 0) {
      let data2 = data.city;
      if (typeof data2 !== "string" && data2 !== null) {
        const err7 = {
          instancePath: instancePath + "/city",
          schemaPath: "#/properties/city/type",
          keyword: "type",
          params: {
            type: schema56.properties.city.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.country !== void 0) {
      let data3 = data.country;
      if (typeof data3 !== "string" && data3 !== null) {
        const err8 = {
          instancePath: instancePath + "/country",
          schemaPath: "#/properties/country/type",
          keyword: "type",
          params: {
            type: schema56.properties.country.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.region !== void 0) {
      let data4 = data.region;
      if (typeof data4 !== "string" && data4 !== null) {
        const err9 = {
          instancePath: instancePath + "/region",
          schemaPath: "#/properties/region/type",
          keyword: "type",
          params: {
            type: schema56.properties.region.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
  } else {
    const err10 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
  }
  validate41.errors = vErrors;
  return errors === 0;
}
const SoldTicket = validate42;
const schema57 = {
  "$id": "SoldTicket",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "status": {
      "type": "string",
      "enum": ["PENDING", "ACTIVE", "REFUNDED"]
    },
    "paymentId": {
      "type": "string"
    },
    "userId": {
      "type": "string"
    },
    "eventId": {
      "type": "string"
    },
    "channelId": {
      "type": "string"
    },
    "organizationId": {
      "type": ["string", "null"]
    },
    "selectedConfig": {
      "type": "object",
      "properties": {
        "price": {
          "type": "number"
        },
        "currency": {
          "type": "string"
        }
      },
      "required": ["price", "currency"]
    },
    "ticketId": {
      "type": "string"
    },
    "eventTicketId": {
      "type": "string"
    },
    "transactionTime": {
      "type": "object",
      "format": "date-time"
    },
    "redemptionTime": {
      "anyOf": [{
        "type": "object",
        "format": "date-time"
      }, {
        "type": "null"
      }]
    },
    "videoIdsAccessed": {
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "location": {
      "anyOf": [{
        "$ref": "UserLocation"
      }, {
        "type": "null"
      }]
    }
  },
  "required": ["status", "paymentId", "userId", "eventId", "channelId", "organizationId", "selectedConfig", "ticketId", "eventTicketId", "transactionTime", "redemptionTime", "videoIdsAccessed", "location"],
  "description": "An instance of this object is saved when a user completes a payment for a given ticket (for an event). It also stores the list of videos that have been accessed using this ticket."
};
function validate42(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.status === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "status"
        },
        message: "must have required property 'status'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.paymentId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "paymentId"
        },
        message: "must have required property 'paymentId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.userId === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "userId"
        },
        message: "must have required property 'userId'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.eventId === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "eventId"
        },
        message: "must have required property 'eventId'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.channelId === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.organizationId === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "organizationId"
        },
        message: "must have required property 'organizationId'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.selectedConfig === void 0) {
      const err6 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "selectedConfig"
        },
        message: "must have required property 'selectedConfig'"
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.ticketId === void 0) {
      const err7 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "ticketId"
        },
        message: "must have required property 'ticketId'"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.eventTicketId === void 0) {
      const err8 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "eventTicketId"
        },
        message: "must have required property 'eventTicketId'"
      };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    if (data.transactionTime === void 0) {
      const err9 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "transactionTime"
        },
        message: "must have required property 'transactionTime'"
      };
      if (vErrors === null) {
        vErrors = [err9];
      } else {
        vErrors.push(err9);
      }
      errors++;
    }
    if (data.redemptionTime === void 0) {
      const err10 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "redemptionTime"
        },
        message: "must have required property 'redemptionTime'"
      };
      if (vErrors === null) {
        vErrors = [err10];
      } else {
        vErrors.push(err10);
      }
      errors++;
    }
    if (data.videoIdsAccessed === void 0) {
      const err11 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "videoIdsAccessed"
        },
        message: "must have required property 'videoIdsAccessed'"
      };
      if (vErrors === null) {
        vErrors = [err11];
      } else {
        vErrors.push(err11);
      }
      errors++;
    }
    if (data.location === void 0) {
      const err12 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "location"
        },
        message: "must have required property 'location'"
      };
      if (vErrors === null) {
        vErrors = [err12];
      } else {
        vErrors.push(err12);
      }
      errors++;
    }
    if (data.status !== void 0) {
      let data0 = data.status;
      if (typeof data0 !== "string") {
        const err13 = {
          instancePath: instancePath + "/status",
          schemaPath: "#/properties/status/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
      if (!(data0 === "PENDING" || data0 === "ACTIVE" || data0 === "REFUNDED")) {
        const err14 = {
          instancePath: instancePath + "/status",
          schemaPath: "#/properties/status/enum",
          keyword: "enum",
          params: {
            allowedValues: schema57.properties.status.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.paymentId !== void 0) {
      if (typeof data.paymentId !== "string") {
        const err15 = {
          instancePath: instancePath + "/paymentId",
          schemaPath: "#/properties/paymentId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
    if (data.userId !== void 0) {
      if (typeof data.userId !== "string") {
        const err16 = {
          instancePath: instancePath + "/userId",
          schemaPath: "#/properties/userId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.eventId !== void 0) {
      if (typeof data.eventId !== "string") {
        const err17 = {
          instancePath: instancePath + "/eventId",
          schemaPath: "#/properties/eventId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err18 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
    if (data.organizationId !== void 0) {
      let data5 = data.organizationId;
      if (typeof data5 !== "string" && data5 !== null) {
        const err19 = {
          instancePath: instancePath + "/organizationId",
          schemaPath: "#/properties/organizationId/type",
          keyword: "type",
          params: {
            type: schema57.properties.organizationId.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      }
    }
    if (data.selectedConfig !== void 0) {
      let data6 = data.selectedConfig;
      if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
        if (data6.price === void 0) {
          const err20 = {
            instancePath: instancePath + "/selectedConfig",
            schemaPath: "#/properties/selectedConfig/required",
            keyword: "required",
            params: {
              missingProperty: "price"
            },
            message: "must have required property 'price'"
          };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
        if (data6.currency === void 0) {
          const err21 = {
            instancePath: instancePath + "/selectedConfig",
            schemaPath: "#/properties/selectedConfig/required",
            keyword: "required",
            params: {
              missingProperty: "currency"
            },
            message: "must have required property 'currency'"
          };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
        if (data6.price !== void 0) {
          let data7 = data6.price;
          if (!(typeof data7 == "number" && isFinite(data7))) {
            const err22 = {
              instancePath: instancePath + "/selectedConfig/price",
              schemaPath: "#/properties/selectedConfig/properties/price/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err22];
            } else {
              vErrors.push(err22);
            }
            errors++;
          }
        }
        if (data6.currency !== void 0) {
          if (typeof data6.currency !== "string") {
            const err23 = {
              instancePath: instancePath + "/selectedConfig/currency",
              schemaPath: "#/properties/selectedConfig/properties/currency/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
        }
      } else {
        const err24 = {
          instancePath: instancePath + "/selectedConfig",
          schemaPath: "#/properties/selectedConfig/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err24];
        } else {
          vErrors.push(err24);
        }
        errors++;
      }
    }
    if (data.ticketId !== void 0) {
      if (typeof data.ticketId !== "string") {
        const err25 = {
          instancePath: instancePath + "/ticketId",
          schemaPath: "#/properties/ticketId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err25];
        } else {
          vErrors.push(err25);
        }
        errors++;
      }
    }
    if (data.eventTicketId !== void 0) {
      if (typeof data.eventTicketId !== "string") {
        const err26 = {
          instancePath: instancePath + "/eventTicketId",
          schemaPath: "#/properties/eventTicketId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err26];
        } else {
          vErrors.push(err26);
        }
        errors++;
      }
    }
    if (data.transactionTime !== void 0) {
      let data11 = data.transactionTime;
      if (!(data11 && typeof data11 == "object" && !Array.isArray(data11))) {
        const err27 = {
          instancePath: instancePath + "/transactionTime",
          schemaPath: "#/properties/transactionTime/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err27];
        } else {
          vErrors.push(err27);
        }
        errors++;
      }
      if (typeof data11 === "string") {
        if (!formats0(data11)) {
          const err28 = {
            instancePath: instancePath + "/transactionTime",
            schemaPath: "#/properties/transactionTime/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err28];
          } else {
            vErrors.push(err28);
          }
          errors++;
        }
      }
    }
    if (data.redemptionTime !== void 0) {
      let data12 = data.redemptionTime;
      const _errs26 = errors;
      let valid2 = false;
      const _errs27 = errors;
      if (!(data12 && typeof data12 == "object" && !Array.isArray(data12))) {
        const err29 = {
          instancePath: instancePath + "/redemptionTime",
          schemaPath: "#/properties/redemptionTime/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err29];
        } else {
          vErrors.push(err29);
        }
        errors++;
      }
      if (typeof data12 === "string") {
        if (!formats0(data12)) {
          const err30 = {
            instancePath: instancePath + "/redemptionTime",
            schemaPath: "#/properties/redemptionTime/anyOf/0/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err30];
          } else {
            vErrors.push(err30);
          }
          errors++;
        }
      }
      var _valid0 = _errs27 === errors;
      valid2 = valid2 || _valid0;
      if (!valid2) {
        const _errs29 = errors;
        if (data12 !== null) {
          const err31 = {
            instancePath: instancePath + "/redemptionTime",
            schemaPath: "#/properties/redemptionTime/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err31];
          } else {
            vErrors.push(err31);
          }
          errors++;
        }
        var _valid0 = _errs29 === errors;
        valid2 = valid2 || _valid0;
      }
      if (!valid2) {
        const err32 = {
          instancePath: instancePath + "/redemptionTime",
          schemaPath: "#/properties/redemptionTime/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err32];
        } else {
          vErrors.push(err32);
        }
        errors++;
      } else {
        errors = _errs26;
        if (vErrors !== null) {
          if (_errs26) {
            vErrors.length = _errs26;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.videoIdsAccessed !== void 0) {
      let data13 = data.videoIdsAccessed;
      if (Array.isArray(data13)) {
        const len0 = data13.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (typeof data13[i0] !== "string") {
            const err33 = {
              instancePath: instancePath + "/videoIdsAccessed/" + i0,
              schemaPath: "#/properties/videoIdsAccessed/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err33];
            } else {
              vErrors.push(err33);
            }
            errors++;
          }
        }
      } else {
        const err34 = {
          instancePath: instancePath + "/videoIdsAccessed",
          schemaPath: "#/properties/videoIdsAccessed/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err34];
        } else {
          vErrors.push(err34);
        }
        errors++;
      }
    }
    if (data.location !== void 0) {
      let data15 = data.location;
      const _errs36 = errors;
      let valid5 = false;
      const _errs37 = errors;
      if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
        if (data15.IP === void 0) {
          const err35 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "IP"
            },
            message: "must have required property 'IP'"
          };
          if (vErrors === null) {
            vErrors = [err35];
          } else {
            vErrors.push(err35);
          }
          errors++;
        }
        if (data15.latlng === void 0) {
          const err36 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "latlng"
            },
            message: "must have required property 'latlng'"
          };
          if (vErrors === null) {
            vErrors = [err36];
          } else {
            vErrors.push(err36);
          }
          errors++;
        }
        if (data15.city === void 0) {
          const err37 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "city"
            },
            message: "must have required property 'city'"
          };
          if (vErrors === null) {
            vErrors = [err37];
          } else {
            vErrors.push(err37);
          }
          errors++;
        }
        if (data15.country === void 0) {
          const err38 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "country"
            },
            message: "must have required property 'country'"
          };
          if (vErrors === null) {
            vErrors = [err38];
          } else {
            vErrors.push(err38);
          }
          errors++;
        }
        if (data15.region === void 0) {
          const err39 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "region"
            },
            message: "must have required property 'region'"
          };
          if (vErrors === null) {
            vErrors = [err39];
          } else {
            vErrors.push(err39);
          }
          errors++;
        }
        if (data15.IP !== void 0) {
          let data16 = data15.IP;
          if (typeof data16 !== "string" && data16 !== null) {
            const err40 = {
              instancePath: instancePath + "/location/IP",
              schemaPath: "UserLocation/properties/IP/type",
              keyword: "type",
              params: {
                type: schema56.properties.IP.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err40];
            } else {
              vErrors.push(err40);
            }
            errors++;
          }
        }
        if (data15.latlng !== void 0) {
          let data17 = data15.latlng;
          if (typeof data17 !== "string" && data17 !== null) {
            const err41 = {
              instancePath: instancePath + "/location/latlng",
              schemaPath: "UserLocation/properties/latlng/type",
              keyword: "type",
              params: {
                type: schema56.properties.latlng.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err41];
            } else {
              vErrors.push(err41);
            }
            errors++;
          }
        }
        if (data15.city !== void 0) {
          let data18 = data15.city;
          if (typeof data18 !== "string" && data18 !== null) {
            const err42 = {
              instancePath: instancePath + "/location/city",
              schemaPath: "UserLocation/properties/city/type",
              keyword: "type",
              params: {
                type: schema56.properties.city.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err42];
            } else {
              vErrors.push(err42);
            }
            errors++;
          }
        }
        if (data15.country !== void 0) {
          let data19 = data15.country;
          if (typeof data19 !== "string" && data19 !== null) {
            const err43 = {
              instancePath: instancePath + "/location/country",
              schemaPath: "UserLocation/properties/country/type",
              keyword: "type",
              params: {
                type: schema56.properties.country.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err43];
            } else {
              vErrors.push(err43);
            }
            errors++;
          }
        }
        if (data15.region !== void 0) {
          let data20 = data15.region;
          if (typeof data20 !== "string" && data20 !== null) {
            const err44 = {
              instancePath: instancePath + "/location/region",
              schemaPath: "UserLocation/properties/region/type",
              keyword: "type",
              params: {
                type: schema56.properties.region.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err44];
            } else {
              vErrors.push(err44);
            }
            errors++;
          }
        }
      } else {
        const err45 = {
          instancePath: instancePath + "/location",
          schemaPath: "UserLocation/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err45];
        } else {
          vErrors.push(err45);
        }
        errors++;
      }
      var _valid1 = _errs37 === errors;
      valid5 = valid5 || _valid1;
      if (!valid5) {
        const _errs50 = errors;
        if (data15 !== null) {
          const err46 = {
            instancePath: instancePath + "/location",
            schemaPath: "#/properties/location/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err46];
          } else {
            vErrors.push(err46);
          }
          errors++;
        }
        var _valid1 = _errs50 === errors;
        valid5 = valid5 || _valid1;
      }
      if (!valid5) {
        const err47 = {
          instancePath: instancePath + "/location",
          schemaPath: "#/properties/location/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err47];
        } else {
          vErrors.push(err47);
        }
        errors++;
      } else {
        errors = _errs36;
        if (vErrors !== null) {
          if (_errs36) {
            vErrors.length = _errs36;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err48 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err48];
    } else {
      vErrors.push(err48);
    }
    errors++;
  }
  validate42.errors = vErrors;
  return errors === 0;
}
const StripeSavedPaymentMethods = validate43;
function validate43(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.paymentMethodId === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "paymentMethodId"
        },
        message: "must have required property 'paymentMethodId'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.type === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.description === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "description"
        },
        message: "must have required property 'description'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.paymentMethodId !== void 0) {
      if (typeof data.paymentMethodId !== "string") {
        const err3 = {
          instancePath: instancePath + "/paymentMethodId",
          schemaPath: "#/properties/paymentMethodId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.type !== void 0) {
      if (typeof data.type !== "string") {
        const err4 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.description !== void 0) {
      if (typeof data.description !== "string") {
        const err5 = {
          instancePath: instancePath + "/description",
          schemaPath: "#/properties/description/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
  } else {
    const err6 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err6];
    } else {
      vErrors.push(err6);
    }
    errors++;
  }
  validate43.errors = vErrors;
  return errors === 0;
}
const StripePaymentSystemOpaque = validate44;
function validate44(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.provider === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "provider"
        },
        message: "must have required property 'provider'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.transactionClientSecret === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "transactionClientSecret"
        },
        message: "must have required property 'transactionClientSecret'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.stripePublicKey === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "stripePublicKey"
        },
        message: "must have required property 'stripePublicKey'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.provider !== void 0) {
      let data0 = data.provider;
      if (typeof data0 !== "string") {
        const err3 = {
          instancePath: instancePath + "/provider",
          schemaPath: "#/properties/provider/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
      if ("STRIPE" !== data0) {
        const err4 = {
          instancePath: instancePath + "/provider",
          schemaPath: "#/properties/provider/const",
          keyword: "const",
          params: {
            allowedValue: "STRIPE"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.transactionClientSecret !== void 0) {
      if (typeof data.transactionClientSecret !== "string") {
        const err5 = {
          instancePath: instancePath + "/transactionClientSecret",
          schemaPath: "#/properties/transactionClientSecret/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.stripePublicKey !== void 0) {
      if (typeof data.stripePublicKey !== "string") {
        const err6 = {
          instancePath: instancePath + "/stripePublicKey",
          schemaPath: "#/properties/stripePublicKey/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
  } else {
    const err7 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err7];
    } else {
      vErrors.push(err7);
    }
    errors++;
  }
  validate44.errors = vErrors;
  return errors === 0;
}
const StripePaymentOptionsForUser = validate45;
function validate45(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.newMethodIntent === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "newMethodIntent"
        },
        message: "must have required property 'newMethodIntent'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.environmentId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "environmentId"
        },
        message: "must have required property 'environmentId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.savedMethods !== void 0) {
      let data0 = data.savedMethods;
      if (Array.isArray(data0)) {
        const len0 = data0.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data1 = data0[i0];
          if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
            if (data1.paymentMethodId === void 0) {
              const err2 = {
                instancePath: instancePath + "/savedMethods/" + i0,
                schemaPath: "StripeSavedPaymentMethods/required",
                keyword: "required",
                params: {
                  missingProperty: "paymentMethodId"
                },
                message: "must have required property 'paymentMethodId'"
              };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            if (data1.type === void 0) {
              const err3 = {
                instancePath: instancePath + "/savedMethods/" + i0,
                schemaPath: "StripeSavedPaymentMethods/required",
                keyword: "required",
                params: {
                  missingProperty: "type"
                },
                message: "must have required property 'type'"
              };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
            }
            if (data1.description === void 0) {
              const err4 = {
                instancePath: instancePath + "/savedMethods/" + i0,
                schemaPath: "StripeSavedPaymentMethods/required",
                keyword: "required",
                params: {
                  missingProperty: "description"
                },
                message: "must have required property 'description'"
              };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
            if (data1.paymentMethodId !== void 0) {
              if (typeof data1.paymentMethodId !== "string") {
                const err5 = {
                  instancePath: instancePath + "/savedMethods/" + i0 + "/paymentMethodId",
                  schemaPath: "StripeSavedPaymentMethods/properties/paymentMethodId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
              }
            }
            if (data1.type !== void 0) {
              if (typeof data1.type !== "string") {
                const err6 = {
                  instancePath: instancePath + "/savedMethods/" + i0 + "/type",
                  schemaPath: "StripeSavedPaymentMethods/properties/type/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            }
            if (data1.description !== void 0) {
              if (typeof data1.description !== "string") {
                const err7 = {
                  instancePath: instancePath + "/savedMethods/" + i0 + "/description",
                  schemaPath: "StripeSavedPaymentMethods/properties/description/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
            }
          } else {
            const err8 = {
              instancePath: instancePath + "/savedMethods/" + i0,
              schemaPath: "StripeSavedPaymentMethods/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err8];
            } else {
              vErrors.push(err8);
            }
            errors++;
          }
        }
      } else {
        const err9 = {
          instancePath: instancePath + "/savedMethods",
          schemaPath: "#/properties/savedMethods/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.newMethodIntent !== void 0) {
      let data5 = data.newMethodIntent;
      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
        if (data5.clientSecret === void 0) {
          const err10 = {
            instancePath: instancePath + "/newMethodIntent",
            schemaPath: "#/properties/newMethodIntent/required",
            keyword: "required",
            params: {
              missingProperty: "clientSecret"
            },
            message: "must have required property 'clientSecret'"
          };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
        if (data5.publicKey === void 0) {
          const err11 = {
            instancePath: instancePath + "/newMethodIntent",
            schemaPath: "#/properties/newMethodIntent/required",
            keyword: "required",
            params: {
              missingProperty: "publicKey"
            },
            message: "must have required property 'publicKey'"
          };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
        if (data5.clientSecret !== void 0) {
          if (typeof data5.clientSecret !== "string") {
            const err12 = {
              instancePath: instancePath + "/newMethodIntent/clientSecret",
              schemaPath: "#/properties/newMethodIntent/properties/clientSecret/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
        }
        if (data5.publicKey !== void 0) {
          if (typeof data5.publicKey !== "string") {
            const err13 = {
              instancePath: instancePath + "/newMethodIntent/publicKey",
              schemaPath: "#/properties/newMethodIntent/properties/publicKey/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
        }
      } else {
        const err14 = {
          instancePath: instancePath + "/newMethodIntent",
          schemaPath: "#/properties/newMethodIntent/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.environmentId !== void 0) {
      if (typeof data.environmentId !== "string") {
        const err15 = {
          instancePath: instancePath + "/environmentId",
          schemaPath: "#/properties/environmentId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
  } else {
    const err16 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err16];
    } else {
      vErrors.push(err16);
    }
    errors++;
  }
  validate45.errors = vErrors;
  return errors === 0;
}
const StripeTicketMetaData = validate46;
function validate46(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.videoId === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "videoId"
        },
        message: "must have required property 'videoId'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.eventId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "eventId"
        },
        message: "must have required property 'eventId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.channelId === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.organizationId === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "organizationId"
        },
        message: "must have required property 'organizationId'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.ticketEntryId === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "ticketEntryId"
        },
        message: "must have required property 'ticketEntryId'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.userId === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "userId"
        },
        message: "must have required property 'userId'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.videoId !== void 0) {
      if (typeof data.videoId !== "string") {
        const err6 = {
          instancePath: instancePath + "/videoId",
          schemaPath: "#/properties/videoId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.videoTitleDescription !== void 0) {
      if (typeof data.videoTitleDescription !== "string") {
        const err7 = {
          instancePath: instancePath + "/videoTitleDescription",
          schemaPath: "#/properties/videoTitleDescription/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.eventId !== void 0) {
      if (typeof data.eventId !== "string") {
        const err8 = {
          instancePath: instancePath + "/eventId",
          schemaPath: "#/properties/eventId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.eventName !== void 0) {
      if (typeof data.eventName !== "string") {
        const err9 = {
          instancePath: instancePath + "/eventName",
          schemaPath: "#/properties/eventName/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err10 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.organizationId !== void 0) {
      if (typeof data.organizationId !== "string") {
        const err11 = {
          instancePath: instancePath + "/organizationId",
          schemaPath: "#/properties/organizationId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.ticketEntryId !== void 0) {
      if (typeof data.ticketEntryId !== "string") {
        const err12 = {
          instancePath: instancePath + "/ticketEntryId",
          schemaPath: "#/properties/ticketEntryId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.userId !== void 0) {
      if (typeof data.userId !== "string") {
        const err13 = {
          instancePath: instancePath + "/userId",
          schemaPath: "#/properties/userId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
  } else {
    const err14 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err14];
    } else {
      vErrors.push(err14);
    }
    errors++;
  }
  validate46.errors = vErrors;
  return errors === 0;
}
const StripeSubscriptionMetadata = validate47;
function validate47(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.channelId === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.organizationId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "organizationId"
        },
        message: "must have required property 'organizationId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.planId === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "planId"
        },
        message: "must have required property 'planId'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.userId === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "userId"
        },
        message: "must have required property 'userId'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.subscriptionId === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "subscriptionId"
        },
        message: "must have required property 'subscriptionId'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err5 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.organizationId !== void 0) {
      if (typeof data.organizationId !== "string") {
        const err6 = {
          instancePath: instancePath + "/organizationId",
          schemaPath: "#/properties/organizationId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.planId !== void 0) {
      if (typeof data.planId !== "string") {
        const err7 = {
          instancePath: instancePath + "/planId",
          schemaPath: "#/properties/planId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.userId !== void 0) {
      if (typeof data.userId !== "string") {
        const err8 = {
          instancePath: instancePath + "/userId",
          schemaPath: "#/properties/userId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.subscriptionId !== void 0) {
      if (typeof data.subscriptionId !== "string") {
        const err9 = {
          instancePath: instancePath + "/subscriptionId",
          schemaPath: "#/properties/subscriptionId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.app_canceled !== void 0) {
      if (typeof data.app_canceled !== "string") {
        const err10 = {
          instancePath: instancePath + "/app_canceled",
          schemaPath: "#/properties/app_canceled/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.proxy_promo_code !== void 0) {
      if (typeof data.proxy_promo_code !== "string") {
        const err11 = {
          instancePath: instancePath + "/proxy_promo_code",
          schemaPath: "#/properties/proxy_promo_code/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.initial_discount_phase !== void 0) {
      if (typeof data.initial_discount_phase !== "string") {
        const err12 = {
          instancePath: instancePath + "/initial_discount_phase",
          schemaPath: "#/properties/initial_discount_phase/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.initial_discount_renewal_price !== void 0) {
      if (typeof data.initial_discount_renewal_price !== "string") {
        const err13 = {
          instancePath: instancePath + "/initial_discount_renewal_price",
          schemaPath: "#/properties/initial_discount_renewal_price/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.initial_discount_price !== void 0) {
      if (typeof data.initial_discount_price !== "string") {
        const err14 = {
          instancePath: instancePath + "/initial_discount_price",
          schemaPath: "#/properties/initial_discount_price/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.initial_discount_phase_is_until !== void 0) {
      if (typeof data.initial_discount_phase_is_until !== "string") {
        const err15 = {
          instancePath: instancePath + "/initial_discount_phase_is_until",
          schemaPath: "#/properties/initial_discount_phase_is_until/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
  } else {
    const err16 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err16];
    } else {
      vErrors.push(err16);
    }
    errors++;
  }
  validate47.errors = vErrors;
  return errors === 0;
}
const StripeCouponMetadata = validate48;
function validate48(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.planId !== void 0) {
      if (typeof data.planId !== "string") {
        const err0 = {
          instancePath: instancePath + "/planId",
          schemaPath: "#/properties/planId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err1 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.organizationId !== void 0) {
      if (typeof data.organizationId !== "string") {
        const err2 = {
          instancePath: instancePath + "/organizationId",
          schemaPath: "#/properties/organizationId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.periodicity !== void 0) {
      if (typeof data.periodicity !== "string") {
        const err3 = {
          instancePath: instancePath + "/periodicity",
          schemaPath: "#/properties/periodicity/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate48.errors = vErrors;
  return errors === 0;
}
const BuyTicketRequest = validate49;
function validate49(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.channelId === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.eventId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "eventId"
        },
        message: "must have required property 'eventId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.ticketId === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "ticketId"
        },
        message: "must have required property 'ticketId'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.paymentMethodId === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "paymentMethodId"
        },
        message: "must have required property 'paymentMethodId'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err4 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.eventId !== void 0) {
      if (typeof data.eventId !== "string") {
        const err5 = {
          instancePath: instancePath + "/eventId",
          schemaPath: "#/properties/eventId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.ticketId !== void 0) {
      if (typeof data.ticketId !== "string") {
        const err6 = {
          instancePath: instancePath + "/ticketId",
          schemaPath: "#/properties/ticketId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.videoId !== void 0) {
      if (typeof data.videoId !== "string") {
        const err7 = {
          instancePath: instancePath + "/videoId",
          schemaPath: "#/properties/videoId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.selectedCurrency !== void 0) {
      if (typeof data.selectedCurrency !== "string") {
        const err8 = {
          instancePath: instancePath + "/selectedCurrency",
          schemaPath: "#/properties/selectedCurrency/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.paymentMethodId !== void 0) {
      if (typeof data.paymentMethodId !== "string") {
        const err9 = {
          instancePath: instancePath + "/paymentMethodId",
          schemaPath: "#/properties/paymentMethodId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
  } else {
    const err10 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
  }
  validate49.errors = vErrors;
  return errors === 0;
}
const BuyTicketSuccessfulResponse = validate50;
function validate50(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.ticketEntryId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "ticketEntryId"
        },
        message: "must have required property 'ticketEntryId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.ticketEntry === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "ticketEntry"
        },
        message: "must have required property 'ticketEntry'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.paymentSystemOpaque === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "paymentSystemOpaque"
        },
        message: "must have required property 'paymentSystemOpaque'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err4 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if (true !== data0) {
        const err5 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.ticketEntryId !== void 0) {
      if (typeof data.ticketEntryId !== "string") {
        const err6 = {
          instancePath: instancePath + "/ticketEntryId",
          schemaPath: "#/properties/ticketEntryId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.ticketEntry !== void 0) {
      if (!validate42(data.ticketEntry, {
        instancePath: instancePath + "/ticketEntry",
        parentData: data,
        parentDataProperty: "ticketEntry",
        rootData
      })) {
        vErrors = vErrors === null ? validate42.errors : vErrors.concat(validate42.errors);
        errors = vErrors.length;
      }
    }
    if (data.paymentSystemOpaque !== void 0) {
      let data3 = data.paymentSystemOpaque;
      if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
        if (data3.provider === void 0) {
          const err7 = {
            instancePath: instancePath + "/paymentSystemOpaque",
            schemaPath: "StripePaymentSystemOpaque/required",
            keyword: "required",
            params: {
              missingProperty: "provider"
            },
            message: "must have required property 'provider'"
          };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
        if (data3.transactionClientSecret === void 0) {
          const err8 = {
            instancePath: instancePath + "/paymentSystemOpaque",
            schemaPath: "StripePaymentSystemOpaque/required",
            keyword: "required",
            params: {
              missingProperty: "transactionClientSecret"
            },
            message: "must have required property 'transactionClientSecret'"
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
        if (data3.stripePublicKey === void 0) {
          const err9 = {
            instancePath: instancePath + "/paymentSystemOpaque",
            schemaPath: "StripePaymentSystemOpaque/required",
            keyword: "required",
            params: {
              missingProperty: "stripePublicKey"
            },
            message: "must have required property 'stripePublicKey'"
          };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
        if (data3.provider !== void 0) {
          let data4 = data3.provider;
          if (typeof data4 !== "string") {
            const err10 = {
              instancePath: instancePath + "/paymentSystemOpaque/provider",
              schemaPath: "StripePaymentSystemOpaque/properties/provider/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err10];
            } else {
              vErrors.push(err10);
            }
            errors++;
          }
          if ("STRIPE" !== data4) {
            const err11 = {
              instancePath: instancePath + "/paymentSystemOpaque/provider",
              schemaPath: "StripePaymentSystemOpaque/properties/provider/const",
              keyword: "const",
              params: {
                allowedValue: "STRIPE"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err11];
            } else {
              vErrors.push(err11);
            }
            errors++;
          }
        }
        if (data3.transactionClientSecret !== void 0) {
          if (typeof data3.transactionClientSecret !== "string") {
            const err12 = {
              instancePath: instancePath + "/paymentSystemOpaque/transactionClientSecret",
              schemaPath: "StripePaymentSystemOpaque/properties/transactionClientSecret/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
        }
        if (data3.stripePublicKey !== void 0) {
          if (typeof data3.stripePublicKey !== "string") {
            const err13 = {
              instancePath: instancePath + "/paymentSystemOpaque/stripePublicKey",
              schemaPath: "StripePaymentSystemOpaque/properties/stripePublicKey/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
        }
      } else {
        const err14 = {
          instancePath: instancePath + "/paymentSystemOpaque",
          schemaPath: "StripePaymentSystemOpaque/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
  } else {
    const err15 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err15];
    } else {
      vErrors.push(err15);
    }
    errors++;
  }
  validate50.errors = vErrors;
  return errors === 0;
}
const BuyTicketErrorResponse = validate52;
function validate52(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.errorReason === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "errorReason"
        },
        message: "must have required property 'errorReason'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (false !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: false
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.errorReason !== void 0) {
      if (typeof data.errorReason !== "string") {
        const err4 = {
          instancePath: instancePath + "/errorReason",
          schemaPath: "#/properties/errorReason/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate52.errors = vErrors;
  return errors === 0;
}
const BuyTicketResponse = validate53;
function validate53(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (!validate50(data, {
    instancePath,
    parentData,
    parentDataProperty,
    rootData
  })) {
    vErrors = vErrors === null ? validate50.errors : vErrors.concat(validate50.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs2 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.success === void 0) {
        const err0 = {
          instancePath,
          schemaPath: "BuyTicketErrorResponse/required",
          keyword: "required",
          params: {
            missingProperty: "success"
          },
          message: "must have required property 'success'"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
      if (data.errorReason === void 0) {
        const err1 = {
          instancePath,
          schemaPath: "BuyTicketErrorResponse/required",
          keyword: "required",
          params: {
            missingProperty: "errorReason"
          },
          message: "must have required property 'errorReason'"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (data.success !== void 0) {
        let data0 = data.success;
        if (typeof data0 !== "boolean") {
          const err2 = {
            instancePath: instancePath + "/success",
            schemaPath: "BuyTicketErrorResponse/properties/success/type",
            keyword: "type",
            params: {
              type: "boolean"
            },
            message: "must be boolean"
          };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (false !== data0) {
          const err3 = {
            instancePath: instancePath + "/success",
            schemaPath: "BuyTicketErrorResponse/properties/success/const",
            keyword: "const",
            params: {
              allowedValue: false
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      }
      if (data.errorReason !== void 0) {
        if (typeof data.errorReason !== "string") {
          const err4 = {
            instancePath: instancePath + "/errorReason",
            schemaPath: "BuyTicketErrorResponse/properties/errorReason/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
      }
    } else {
      const err5 = {
        instancePath,
        schemaPath: "BuyTicketErrorResponse/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    var _valid0 = _errs2 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err6 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err6];
    } else {
      vErrors.push(err6);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate53.errors = vErrors;
  return errors === 0;
}
const EventListSource = validate55;
const schema72 = {
  "$id": "EventListSource",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "eventIds": {
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "onlyState": {
      "type": "string",
      "enum": ["UPCOMING", "ACTIVE", "PASSED", "ACTIVE_AND_UPCOMING", "PASSED_AND_ACTIVE"]
    }
  }
};
function validate55(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.eventIds !== void 0) {
      let data0 = data.eventIds;
      if (Array.isArray(data0)) {
        const len0 = data0.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (typeof data0[i0] !== "string") {
            const err0 = {
              instancePath: instancePath + "/eventIds/" + i0,
              schemaPath: "#/properties/eventIds/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          }
        }
      } else {
        const err1 = {
          instancePath: instancePath + "/eventIds",
          schemaPath: "#/properties/eventIds/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.onlyState !== void 0) {
      let data2 = data.onlyState;
      if (typeof data2 !== "string") {
        const err2 = {
          instancePath: instancePath + "/onlyState",
          schemaPath: "#/properties/onlyState/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data2 === "UPCOMING" || data2 === "ACTIVE" || data2 === "PASSED" || data2 === "ACTIVE_AND_UPCOMING" || data2 === "PASSED_AND_ACTIVE")) {
        const err3 = {
          instancePath: instancePath + "/onlyState",
          schemaPath: "#/properties/onlyState/enum",
          keyword: "enum",
          params: {
            allowedValues: schema72.properties.onlyState.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate55.errors = vErrors;
  return errors === 0;
}
const EventListModule = validate56;
const schema73 = {
  "$id": "EventListModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string",
      "const": "EVENTS_LIST"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "layoutType": {
      "type": "string",
      "enum": ["CAROUSEL", "GRID"]
    },
    "density": {
      "type": "string",
      "enum": ["NORMAL", "DENSE", "DENSEST"]
    },
    "preferedGridSize": {
      "type": "object",
      "properties": {
        "columns": {
          "type": "number"
        },
        "rows": {
          "type": "number"
        }
      },
      "required": ["columns", "rows"]
    },
    "listSource": {
      "$ref": "EventListSource"
    },
    "sort": {
      "type": "string",
      "const": "DATE"
    },
    "order": {
      "type": "string",
      "enum": ["ASC", "DESC"]
    },
    "size": {
      "type": "number"
    }
  },
  "required": ["density", "layoutType", "listSource", "moduleType", "size"],
  "description": "Specifies a list of events to be shown in cards. The list can be static, or dynamic"
};
function validate56(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.density === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "density"
        },
        message: "must have required property 'density'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.layoutType === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "layoutType"
        },
        message: "must have required property 'layoutType'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.listSource === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "listSource"
        },
        message: "must have required property 'listSource'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.moduleType === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "moduleType"
        },
        message: "must have required property 'moduleType'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.size === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "size"
        },
        message: "must have required property 'size'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.moduleType !== void 0) {
      let data0 = data.moduleType;
      if (typeof data0 !== "string") {
        const err5 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if ("EVENTS_LIST" !== data0) {
        const err6 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/const",
          keyword: "const",
          params: {
            allowedValue: "EVENTS_LIST"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.heading !== void 0) {
      if (typeof data.heading !== "string") {
        const err7 = {
          instancePath: instancePath + "/heading",
          schemaPath: "#/properties/heading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.subHeading !== void 0) {
      if (typeof data.subHeading !== "string") {
        const err8 = {
          instancePath: instancePath + "/subHeading",
          schemaPath: "#/properties/subHeading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.layoutType !== void 0) {
      let data3 = data.layoutType;
      if (typeof data3 !== "string") {
        const err9 = {
          instancePath: instancePath + "/layoutType",
          schemaPath: "#/properties/layoutType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if (!(data3 === "CAROUSEL" || data3 === "GRID")) {
        const err10 = {
          instancePath: instancePath + "/layoutType",
          schemaPath: "#/properties/layoutType/enum",
          keyword: "enum",
          params: {
            allowedValues: schema73.properties.layoutType.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.density !== void 0) {
      let data4 = data.density;
      if (typeof data4 !== "string") {
        const err11 = {
          instancePath: instancePath + "/density",
          schemaPath: "#/properties/density/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if (!(data4 === "NORMAL" || data4 === "DENSE" || data4 === "DENSEST")) {
        const err12 = {
          instancePath: instancePath + "/density",
          schemaPath: "#/properties/density/enum",
          keyword: "enum",
          params: {
            allowedValues: schema73.properties.density.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.preferedGridSize !== void 0) {
      let data5 = data.preferedGridSize;
      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
        if (data5.columns === void 0) {
          const err13 = {
            instancePath: instancePath + "/preferedGridSize",
            schemaPath: "#/properties/preferedGridSize/required",
            keyword: "required",
            params: {
              missingProperty: "columns"
            },
            message: "must have required property 'columns'"
          };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
        if (data5.rows === void 0) {
          const err14 = {
            instancePath: instancePath + "/preferedGridSize",
            schemaPath: "#/properties/preferedGridSize/required",
            keyword: "required",
            params: {
              missingProperty: "rows"
            },
            message: "must have required property 'rows'"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
        if (data5.columns !== void 0) {
          let data6 = data5.columns;
          if (!(typeof data6 == "number" && isFinite(data6))) {
            const err15 = {
              instancePath: instancePath + "/preferedGridSize/columns",
              schemaPath: "#/properties/preferedGridSize/properties/columns/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
        if (data5.rows !== void 0) {
          let data7 = data5.rows;
          if (!(typeof data7 == "number" && isFinite(data7))) {
            const err16 = {
              instancePath: instancePath + "/preferedGridSize/rows",
              schemaPath: "#/properties/preferedGridSize/properties/rows/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err16];
            } else {
              vErrors.push(err16);
            }
            errors++;
          }
        }
      } else {
        const err17 = {
          instancePath: instancePath + "/preferedGridSize",
          schemaPath: "#/properties/preferedGridSize/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.listSource !== void 0) {
      let data8 = data.listSource;
      if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
        if (data8.eventIds !== void 0) {
          let data9 = data8.eventIds;
          if (Array.isArray(data9)) {
            const len0 = data9.length;
            for (let i0 = 0; i0 < len0; i0++) {
              if (typeof data9[i0] !== "string") {
                const err18 = {
                  instancePath: instancePath + "/listSource/eventIds/" + i0,
                  schemaPath: "EventListSource/properties/eventIds/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
            }
          } else {
            const err19 = {
              instancePath: instancePath + "/listSource/eventIds",
              schemaPath: "EventListSource/properties/eventIds/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err19];
            } else {
              vErrors.push(err19);
            }
            errors++;
          }
        }
        if (data8.onlyState !== void 0) {
          let data11 = data8.onlyState;
          if (typeof data11 !== "string") {
            const err20 = {
              instancePath: instancePath + "/listSource/onlyState",
              schemaPath: "EventListSource/properties/onlyState/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err20];
            } else {
              vErrors.push(err20);
            }
            errors++;
          }
          if (!(data11 === "UPCOMING" || data11 === "ACTIVE" || data11 === "PASSED" || data11 === "ACTIVE_AND_UPCOMING" || data11 === "PASSED_AND_ACTIVE")) {
            const err21 = {
              instancePath: instancePath + "/listSource/onlyState",
              schemaPath: "EventListSource/properties/onlyState/enum",
              keyword: "enum",
              params: {
                allowedValues: schema72.properties.onlyState.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
        }
      } else {
        const err22 = {
          instancePath: instancePath + "/listSource",
          schemaPath: "EventListSource/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err22];
        } else {
          vErrors.push(err22);
        }
        errors++;
      }
    }
    if (data.sort !== void 0) {
      let data12 = data.sort;
      if (typeof data12 !== "string") {
        const err23 = {
          instancePath: instancePath + "/sort",
          schemaPath: "#/properties/sort/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err23];
        } else {
          vErrors.push(err23);
        }
        errors++;
      }
      if ("DATE" !== data12) {
        const err24 = {
          instancePath: instancePath + "/sort",
          schemaPath: "#/properties/sort/const",
          keyword: "const",
          params: {
            allowedValue: "DATE"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err24];
        } else {
          vErrors.push(err24);
        }
        errors++;
      }
    }
    if (data.order !== void 0) {
      let data13 = data.order;
      if (typeof data13 !== "string") {
        const err25 = {
          instancePath: instancePath + "/order",
          schemaPath: "#/properties/order/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err25];
        } else {
          vErrors.push(err25);
        }
        errors++;
      }
      if (!(data13 === "ASC" || data13 === "DESC")) {
        const err26 = {
          instancePath: instancePath + "/order",
          schemaPath: "#/properties/order/enum",
          keyword: "enum",
          params: {
            allowedValues: schema73.properties.order.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err26];
        } else {
          vErrors.push(err26);
        }
        errors++;
      }
    }
    if (data.size !== void 0) {
      let data14 = data.size;
      if (!(typeof data14 == "number" && isFinite(data14))) {
        const err27 = {
          instancePath: instancePath + "/size",
          schemaPath: "#/properties/size/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err27];
        } else {
          vErrors.push(err27);
        }
        errors++;
      }
    }
  } else {
    const err28 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err28];
    } else {
      vErrors.push(err28);
    }
    errors++;
  }
  validate56.errors = vErrors;
  return errors === 0;
}
const PromoButtonAction = validate57;
const schema76 = {
  "$id": "SingleOptionLink",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "type": {
      "type": "string",
      "enum": ["URL", "EVENT_TICKET", "PLAN"]
    },
    "id": {
      "type": "string"
    },
    "openInNewContext": {
      "type": "boolean"
    }
  },
  "required": ["type", "id"],
  "description": "Links to a specific product or page"
};
function validate57(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.text === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "text"
        },
        message: "must have required property 'text'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.linkTo === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "linkTo"
        },
        message: "must have required property 'linkTo'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.text !== void 0) {
      if (typeof data.text !== "string") {
        const err2 = {
          instancePath: instancePath + "/text",
          schemaPath: "#/properties/text/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.linkTo !== void 0) {
      let data1 = data.linkTo;
      const _errs4 = errors;
      let valid1 = false;
      const _errs5 = errors;
      if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
        if (data1.type === void 0) {
          const err3 = {
            instancePath: instancePath + "/linkTo",
            schemaPath: "SingleOptionLink/required",
            keyword: "required",
            params: {
              missingProperty: "type"
            },
            message: "must have required property 'type'"
          };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
        if (data1.id === void 0) {
          const err4 = {
            instancePath: instancePath + "/linkTo",
            schemaPath: "SingleOptionLink/required",
            keyword: "required",
            params: {
              missingProperty: "id"
            },
            message: "must have required property 'id'"
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
        if (data1.type !== void 0) {
          let data2 = data1.type;
          if (typeof data2 !== "string") {
            const err5 = {
              instancePath: instancePath + "/linkTo/type",
              schemaPath: "SingleOptionLink/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err5];
            } else {
              vErrors.push(err5);
            }
            errors++;
          }
          if (!(data2 === "URL" || data2 === "EVENT_TICKET" || data2 === "PLAN")) {
            const err6 = {
              instancePath: instancePath + "/linkTo/type",
              schemaPath: "SingleOptionLink/properties/type/enum",
              keyword: "enum",
              params: {
                allowedValues: schema76.properties.type.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err6];
            } else {
              vErrors.push(err6);
            }
            errors++;
          }
        }
        if (data1.id !== void 0) {
          if (typeof data1.id !== "string") {
            const err7 = {
              instancePath: instancePath + "/linkTo/id",
              schemaPath: "SingleOptionLink/properties/id/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
          }
        }
        if (data1.openInNewContext !== void 0) {
          if (typeof data1.openInNewContext !== "boolean") {
            const err8 = {
              instancePath: instancePath + "/linkTo/openInNewContext",
              schemaPath: "SingleOptionLink/properties/openInNewContext/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err8];
            } else {
              vErrors.push(err8);
            }
            errors++;
          }
        }
      } else {
        const err9 = {
          instancePath: instancePath + "/linkTo",
          schemaPath: "SingleOptionLink/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      var _valid0 = _errs5 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs14 = errors;
        if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
          if (data1.type === void 0) {
            const err10 = {
              instancePath: instancePath + "/linkTo",
              schemaPath: "OptionsListLink/required",
              keyword: "required",
              params: {
                missingProperty: "type"
              },
              message: "must have required property 'type'"
            };
            if (vErrors === null) {
              vErrors = [err10];
            } else {
              vErrors.push(err10);
            }
            errors++;
          }
          if (data1.sections === void 0) {
            const err11 = {
              instancePath: instancePath + "/linkTo",
              schemaPath: "OptionsListLink/required",
              keyword: "required",
              params: {
                missingProperty: "sections"
              },
              message: "must have required property 'sections'"
            };
            if (vErrors === null) {
              vErrors = [err11];
            } else {
              vErrors.push(err11);
            }
            errors++;
          }
          if (data1.type !== void 0) {
            let data5 = data1.type;
            if (typeof data5 !== "string") {
              const err12 = {
                instancePath: instancePath + "/linkTo/type",
                schemaPath: "OptionsListLink/properties/type/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            if ("LIST_OPTIONS" !== data5) {
              const err13 = {
                instancePath: instancePath + "/linkTo/type",
                schemaPath: "OptionsListLink/properties/type/const",
                keyword: "const",
                params: {
                  allowedValue: "LIST_OPTIONS"
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err13];
              } else {
                vErrors.push(err13);
              }
              errors++;
            }
          }
          if (data1.dialogTitle !== void 0) {
            if (typeof data1.dialogTitle !== "string") {
              const err14 = {
                instancePath: instancePath + "/linkTo/dialogTitle",
                schemaPath: "OptionsListLink/properties/dialogTitle/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err14];
              } else {
                vErrors.push(err14);
              }
              errors++;
            }
          }
          if (data1.sections !== void 0) {
            let data7 = data1.sections;
            if (Array.isArray(data7)) {
              const len0 = data7.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data8 = data7[i0];
                if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                  if (data8.title === void 0) {
                    const err15 = {
                      instancePath: instancePath + "/linkTo/sections/" + i0,
                      schemaPath: "OptionsListLink/properties/sections/items/required",
                      keyword: "required",
                      params: {
                        missingProperty: "title"
                      },
                      message: "must have required property 'title'"
                    };
                    if (vErrors === null) {
                      vErrors = [err15];
                    } else {
                      vErrors.push(err15);
                    }
                    errors++;
                  }
                  if (data8.ids === void 0) {
                    const err16 = {
                      instancePath: instancePath + "/linkTo/sections/" + i0,
                      schemaPath: "OptionsListLink/properties/sections/items/required",
                      keyword: "required",
                      params: {
                        missingProperty: "ids"
                      },
                      message: "must have required property 'ids'"
                    };
                    if (vErrors === null) {
                      vErrors = [err16];
                    } else {
                      vErrors.push(err16);
                    }
                    errors++;
                  }
                  if (data8.title !== void 0) {
                    if (typeof data8.title !== "string") {
                      const err17 = {
                        instancePath: instancePath + "/linkTo/sections/" + i0 + "/title",
                        schemaPath: "OptionsListLink/properties/sections/items/properties/title/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err17];
                      } else {
                        vErrors.push(err17);
                      }
                      errors++;
                    }
                  }
                  if (data8.ids !== void 0) {
                    let data10 = data8.ids;
                    if (Array.isArray(data10)) {
                      const len1 = data10.length;
                      for (let i1 = 0; i1 < len1; i1++) {
                        if (typeof data10[i1] !== "string") {
                          const err18 = {
                            instancePath: instancePath + "/linkTo/sections/" + i0 + "/ids/" + i1,
                            schemaPath: "OptionsListLink/properties/sections/items/properties/ids/items/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err18];
                          } else {
                            vErrors.push(err18);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err19 = {
                        instancePath: instancePath + "/linkTo/sections/" + i0 + "/ids",
                        schemaPath: "OptionsListLink/properties/sections/items/properties/ids/type",
                        keyword: "type",
                        params: {
                          type: "array"
                        },
                        message: "must be array"
                      };
                      if (vErrors === null) {
                        vErrors = [err19];
                      } else {
                        vErrors.push(err19);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err20 = {
                    instancePath: instancePath + "/linkTo/sections/" + i0,
                    schemaPath: "OptionsListLink/properties/sections/items/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  };
                  if (vErrors === null) {
                    vErrors = [err20];
                  } else {
                    vErrors.push(err20);
                  }
                  errors++;
                }
              }
            } else {
              const err21 = {
                instancePath: instancePath + "/linkTo/sections",
                schemaPath: "OptionsListLink/properties/sections/type",
                keyword: "type",
                params: {
                  type: "array"
                },
                message: "must be array"
              };
              if (vErrors === null) {
                vErrors = [err21];
              } else {
                vErrors.push(err21);
              }
              errors++;
            }
          }
          if (data1.hideUnavailableOptions !== void 0) {
            if (typeof data1.hideUnavailableOptions !== "boolean") {
              const err22 = {
                instancePath: instancePath + "/linkTo/hideUnavailableOptions",
                schemaPath: "OptionsListLink/properties/hideUnavailableOptions/type",
                keyword: "type",
                params: {
                  type: "boolean"
                },
                message: "must be boolean"
              };
              if (vErrors === null) {
                vErrors = [err22];
              } else {
                vErrors.push(err22);
              }
              errors++;
            }
          }
        } else {
          const err23 = {
            instancePath: instancePath + "/linkTo",
            schemaPath: "OptionsListLink/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err23];
          } else {
            vErrors.push(err23);
          }
          errors++;
        }
        var _valid0 = _errs14 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err24 = {
          instancePath: instancePath + "/linkTo",
          schemaPath: "#/properties/linkTo/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err24];
        } else {
          vErrors.push(err24);
        }
        errors++;
      } else {
        errors = _errs4;
        if (vErrors !== null) {
          if (_errs4) {
            vErrors.length = _errs4;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err25 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err25];
    } else {
      vErrors.push(err25);
    }
    errors++;
  }
  validate57.errors = vErrors;
  return errors === 0;
}
const SingleOptionLink = validate58;
function validate58(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.type === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.id === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "id"
        },
        message: "must have required property 'id'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.type !== void 0) {
      let data0 = data.type;
      if (typeof data0 !== "string") {
        const err2 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (!(data0 === "URL" || data0 === "EVENT_TICKET" || data0 === "PLAN")) {
        const err3 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/enum",
          keyword: "enum",
          params: {
            allowedValues: schema76.properties.type.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      if (typeof data.id !== "string") {
        const err4 = {
          instancePath: instancePath + "/id",
          schemaPath: "#/properties/id/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.openInNewContext !== void 0) {
      if (typeof data.openInNewContext !== "boolean") {
        const err5 = {
          instancePath: instancePath + "/openInNewContext",
          schemaPath: "#/properties/openInNewContext/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
  } else {
    const err6 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err6];
    } else {
      vErrors.push(err6);
    }
    errors++;
  }
  validate58.errors = vErrors;
  return errors === 0;
}
const OptionsListLink = validate59;
function validate59(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.type === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.sections === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "sections"
        },
        message: "must have required property 'sections'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.type !== void 0) {
      let data0 = data.type;
      if (typeof data0 !== "string") {
        const err2 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if ("LIST_OPTIONS" !== data0) {
        const err3 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/const",
          keyword: "const",
          params: {
            allowedValue: "LIST_OPTIONS"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.dialogTitle !== void 0) {
      if (typeof data.dialogTitle !== "string") {
        const err4 = {
          instancePath: instancePath + "/dialogTitle",
          schemaPath: "#/properties/dialogTitle/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.sections !== void 0) {
      let data2 = data.sections;
      if (Array.isArray(data2)) {
        const len0 = data2.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data3 = data2[i0];
          if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
            if (data3.title === void 0) {
              const err5 = {
                instancePath: instancePath + "/sections/" + i0,
                schemaPath: "#/properties/sections/items/required",
                keyword: "required",
                params: {
                  missingProperty: "title"
                },
                message: "must have required property 'title'"
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if (data3.ids === void 0) {
              const err6 = {
                instancePath: instancePath + "/sections/" + i0,
                schemaPath: "#/properties/sections/items/required",
                keyword: "required",
                params: {
                  missingProperty: "ids"
                },
                message: "must have required property 'ids'"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            if (data3.title !== void 0) {
              if (typeof data3.title !== "string") {
                const err7 = {
                  instancePath: instancePath + "/sections/" + i0 + "/title",
                  schemaPath: "#/properties/sections/items/properties/title/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
            }
            if (data3.ids !== void 0) {
              let data5 = data3.ids;
              if (Array.isArray(data5)) {
                const len1 = data5.length;
                for (let i1 = 0; i1 < len1; i1++) {
                  if (typeof data5[i1] !== "string") {
                    const err8 = {
                      instancePath: instancePath + "/sections/" + i0 + "/ids/" + i1,
                      schemaPath: "#/properties/sections/items/properties/ids/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err8];
                    } else {
                      vErrors.push(err8);
                    }
                    errors++;
                  }
                }
              } else {
                const err9 = {
                  instancePath: instancePath + "/sections/" + i0 + "/ids",
                  schemaPath: "#/properties/sections/items/properties/ids/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
            }
          } else {
            const err10 = {
              instancePath: instancePath + "/sections/" + i0,
              schemaPath: "#/properties/sections/items/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err10];
            } else {
              vErrors.push(err10);
            }
            errors++;
          }
        }
      } else {
        const err11 = {
          instancePath: instancePath + "/sections",
          schemaPath: "#/properties/sections/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.hideUnavailableOptions !== void 0) {
      if (typeof data.hideUnavailableOptions !== "boolean") {
        const err12 = {
          instancePath: instancePath + "/hideUnavailableOptions",
          schemaPath: "#/properties/hideUnavailableOptions/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
  } else {
    const err13 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err13];
    } else {
      vErrors.push(err13);
    }
    errors++;
  }
  validate59.errors = vErrors;
  return errors === 0;
}
const PromotionalBlock = validate60;
function validate61(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.condition === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "condition"
        },
        message: "must have required property 'condition'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.type === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.label === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "label"
        },
        message: "must have required property 'label'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.details === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "details"
        },
        message: "must have required property 'details'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.action === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "action"
        },
        message: "must have required property 'action'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.condition !== void 0) {
      if (data.condition !== null) {
        const err5 = {
          instancePath: instancePath + "/condition",
          schemaPath: "#/properties/condition/type",
          keyword: "type",
          params: {
            type: "null"
          },
          message: "must be null"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.type !== void 0) {
      let data1 = data.type;
      if (typeof data1 !== "string") {
        const err6 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if ("BUTTON" !== data1) {
        const err7 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/const",
          keyword: "const",
          params: {
            allowedValue: "BUTTON"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.label !== void 0) {
      if (typeof data.label !== "string") {
        const err8 = {
          instancePath: instancePath + "/label",
          schemaPath: "#/properties/label/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.details !== void 0) {
      if (typeof data.details !== "string") {
        const err9 = {
          instancePath: instancePath + "/details",
          schemaPath: "#/properties/details/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.action !== void 0) {
      if (!validate57(data.action, {
        instancePath: instancePath + "/action",
        parentData: data,
        parentDataProperty: "action",
        rootData
      })) {
        vErrors = vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
        errors = vErrors.length;
      }
    }
    if (data.hideIfNoValidAction !== void 0) {
      if (typeof data.hideIfNoValidAction !== "boolean") {
        const err10 = {
          instancePath: instancePath + "/hideIfNoValidAction",
          schemaPath: "#/properties/hideIfNoValidAction/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
  } else {
    const err11 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err11];
    } else {
      vErrors.push(err11);
    }
    errors++;
  }
  validate61.errors = vErrors;
  return errors === 0;
}
function validate64(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.condition === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "condition"
        },
        message: "must have required property 'condition'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.type === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.title === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "title"
        },
        message: "must have required property 'title'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.promoBlock === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "promoBlock"
        },
        message: "must have required property 'promoBlock'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.actionBlocks === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "actionBlocks"
        },
        message: "must have required property 'actionBlocks'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.infoText === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "infoText"
        },
        message: "must have required property 'infoText'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.condition !== void 0) {
      if (data.condition !== null) {
        const err6 = {
          instancePath: instancePath + "/condition",
          schemaPath: "#/properties/condition/type",
          keyword: "type",
          params: {
            type: "null"
          },
          message: "must be null"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.type !== void 0) {
      let data1 = data.type;
      if (typeof data1 !== "string") {
        const err7 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if ("CARD" !== data1) {
        const err8 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/const",
          keyword: "const",
          params: {
            allowedValue: "CARD"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.title !== void 0) {
      if (typeof data.title !== "string") {
        const err9 = {
          instancePath: instancePath + "/title",
          schemaPath: "#/properties/title/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.promoBlock !== void 0) {
      let data3 = data.promoBlock;
      const _errs8 = errors;
      let valid1 = false;
      const _errs9 = errors;
      if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
        if (data3.title === void 0) {
          const err10 = {
            instancePath: instancePath + "/promoBlock",
            schemaPath: "#/properties/promoBlock/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "title"
            },
            message: "must have required property 'title'"
          };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
        if (data3.description === void 0) {
          const err11 = {
            instancePath: instancePath + "/promoBlock",
            schemaPath: "#/properties/promoBlock/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "description"
            },
            message: "must have required property 'description'"
          };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
        if (data3.title !== void 0) {
          if (typeof data3.title !== "string") {
            const err12 = {
              instancePath: instancePath + "/promoBlock/title",
              schemaPath: "#/properties/promoBlock/anyOf/0/properties/title/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
        }
        if (data3.description !== void 0) {
          if (typeof data3.description !== "string") {
            const err13 = {
              instancePath: instancePath + "/promoBlock/description",
              schemaPath: "#/properties/promoBlock/anyOf/0/properties/description/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
        }
      } else {
        const err14 = {
          instancePath: instancePath + "/promoBlock",
          schemaPath: "#/properties/promoBlock/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
      var _valid0 = _errs9 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs15 = errors;
        if (data3 !== null) {
          const err15 = {
            instancePath: instancePath + "/promoBlock",
            schemaPath: "#/properties/promoBlock/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        var _valid0 = _errs15 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err16 = {
          instancePath: instancePath + "/promoBlock",
          schemaPath: "#/properties/promoBlock/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      } else {
        errors = _errs8;
        if (vErrors !== null) {
          if (_errs8) {
            vErrors.length = _errs8;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.actionBlocks !== void 0) {
      let data6 = data.actionBlocks;
      if (Array.isArray(data6)) {
        const len0 = data6.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data7 = data6[i0];
          if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
            if (data7.discountTag === void 0) {
              const err17 = {
                instancePath: instancePath + "/actionBlocks/" + i0,
                schemaPath: "#/properties/actionBlocks/items/required",
                keyword: "required",
                params: {
                  missingProperty: "discountTag"
                },
                message: "must have required property 'discountTag'"
              };
              if (vErrors === null) {
                vErrors = [err17];
              } else {
                vErrors.push(err17);
              }
              errors++;
            }
            if (data7.label === void 0) {
              const err18 = {
                instancePath: instancePath + "/actionBlocks/" + i0,
                schemaPath: "#/properties/actionBlocks/items/required",
                keyword: "required",
                params: {
                  missingProperty: "label"
                },
                message: "must have required property 'label'"
              };
              if (vErrors === null) {
                vErrors = [err18];
              } else {
                vErrors.push(err18);
              }
              errors++;
            }
            if (data7.details === void 0) {
              const err19 = {
                instancePath: instancePath + "/actionBlocks/" + i0,
                schemaPath: "#/properties/actionBlocks/items/required",
                keyword: "required",
                params: {
                  missingProperty: "details"
                },
                message: "must have required property 'details'"
              };
              if (vErrors === null) {
                vErrors = [err19];
              } else {
                vErrors.push(err19);
              }
              errors++;
            }
            if (data7.action === void 0) {
              const err20 = {
                instancePath: instancePath + "/actionBlocks/" + i0,
                schemaPath: "#/properties/actionBlocks/items/required",
                keyword: "required",
                params: {
                  missingProperty: "action"
                },
                message: "must have required property 'action'"
              };
              if (vErrors === null) {
                vErrors = [err20];
              } else {
                vErrors.push(err20);
              }
              errors++;
            }
            if (data7.discountTag !== void 0) {
              if (typeof data7.discountTag !== "string") {
                const err21 = {
                  instancePath: instancePath + "/actionBlocks/" + i0 + "/discountTag",
                  schemaPath: "#/properties/actionBlocks/items/properties/discountTag/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err21];
                } else {
                  vErrors.push(err21);
                }
                errors++;
              }
            }
            if (data7.label !== void 0) {
              if (typeof data7.label !== "string") {
                const err22 = {
                  instancePath: instancePath + "/actionBlocks/" + i0 + "/label",
                  schemaPath: "#/properties/actionBlocks/items/properties/label/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err22];
                } else {
                  vErrors.push(err22);
                }
                errors++;
              }
            }
            if (data7.details !== void 0) {
              if (typeof data7.details !== "string") {
                const err23 = {
                  instancePath: instancePath + "/actionBlocks/" + i0 + "/details",
                  schemaPath: "#/properties/actionBlocks/items/properties/details/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
            }
            if (data7.action !== void 0) {
              if (!validate57(data7.action, {
                instancePath: instancePath + "/actionBlocks/" + i0 + "/action",
                parentData: data7,
                parentDataProperty: "action",
                rootData
              })) {
                vErrors = vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
                errors = vErrors.length;
              }
            }
          } else {
            const err24 = {
              instancePath: instancePath + "/actionBlocks/" + i0,
              schemaPath: "#/properties/actionBlocks/items/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          }
        }
      } else {
        const err25 = {
          instancePath: instancePath + "/actionBlocks",
          schemaPath: "#/properties/actionBlocks/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err25];
        } else {
          vErrors.push(err25);
        }
        errors++;
      }
    }
    if (data.infoText !== void 0) {
      if (typeof data.infoText !== "string") {
        const err26 = {
          instancePath: instancePath + "/infoText",
          schemaPath: "#/properties/infoText/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err26];
        } else {
          vErrors.push(err26);
        }
        errors++;
      }
    }
    if (data.hideIfNoValidAction !== void 0) {
      if (typeof data.hideIfNoValidAction !== "boolean") {
        const err27 = {
          instancePath: instancePath + "/hideIfNoValidAction",
          schemaPath: "#/properties/hideIfNoValidAction/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err27];
        } else {
          vErrors.push(err27);
        }
        errors++;
      }
    }
  } else {
    const err28 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err28];
    } else {
      vErrors.push(err28);
    }
    errors++;
  }
  validate64.errors = vErrors;
  return errors === 0;
}
function validate60(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (!validate61(data, {
    instancePath,
    parentData,
    parentDataProperty,
    rootData
  })) {
    vErrors = vErrors === null ? validate61.errors : vErrors.concat(validate61.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs2 = errors;
    if (!validate64(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData
    })) {
      vErrors = vErrors === null ? validate64.errors : vErrors.concat(validate64.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs2 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err0 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate60.errors = vErrors;
  return errors === 0;
}
const ButtonPromotionalBlock = validate61;
const CardPromotionalBlock = validate64;
const HeaderModule = validate67;
function validate68(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.text === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "text"
        },
        message: "must have required property 'text'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.subText === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "subText"
        },
        message: "must have required property 'subText'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.bannerImages === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "bannerImages"
        },
        message: "must have required property 'bannerImages'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.logoImage !== void 0) {
      if (typeof data.logoImage !== "string") {
        const err3 = {
          instancePath: instancePath + "/logoImage",
          schemaPath: "#/properties/logoImage/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.text !== void 0) {
      if (typeof data.text !== "string") {
        const err4 = {
          instancePath: instancePath + "/text",
          schemaPath: "#/properties/text/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.subText !== void 0) {
      if (typeof data.subText !== "string") {
        const err5 = {
          instancePath: instancePath + "/subText",
          schemaPath: "#/properties/subText/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.bannerImages !== void 0) {
      let data3 = data.bannerImages;
      const _errs8 = errors;
      let valid1 = false;
      const _errs9 = errors;
      if (typeof data3 !== "string") {
        const err6 = {
          instancePath: instancePath + "/bannerImages",
          schemaPath: "#/properties/bannerImages/anyOf/0/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if ("NONE" !== data3) {
        const err7 = {
          instancePath: instancePath + "/bannerImages",
          schemaPath: "#/properties/bannerImages/anyOf/0/const",
          keyword: "const",
          params: {
            allowedValue: "NONE"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      var _valid0 = _errs9 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs11 = errors;
        if (typeof data3 !== "string") {
          const err8 = {
            instancePath: instancePath + "/bannerImages",
            schemaPath: "#/properties/bannerImages/anyOf/1/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
        if ("INHERIT" !== data3) {
          const err9 = {
            instancePath: instancePath + "/bannerImages",
            schemaPath: "#/properties/bannerImages/anyOf/1/const",
            keyword: "const",
            params: {
              allowedValue: "INHERIT"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
        var _valid0 = _errs11 === errors;
        valid1 = valid1 || _valid0;
        if (!valid1) {
          const _errs13 = errors;
          if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
            if (data3["3/1"] === void 0) {
              const err10 = {
                instancePath: instancePath + "/bannerImages",
                schemaPath: "#/properties/bannerImages/anyOf/2/required",
                keyword: "required",
                params: {
                  missingProperty: "3/1"
                },
                message: "must have required property '3/1'"
              };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            if (data3["3/4"] === void 0) {
              const err11 = {
                instancePath: instancePath + "/bannerImages",
                schemaPath: "#/properties/bannerImages/anyOf/2/required",
                keyword: "required",
                params: {
                  missingProperty: "3/4"
                },
                message: "must have required property '3/4'"
              };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            if (data3["16/9"] === void 0) {
              const err12 = {
                instancePath: instancePath + "/bannerImages",
                schemaPath: "#/properties/bannerImages/anyOf/2/required",
                keyword: "required",
                params: {
                  missingProperty: "16/9"
                },
                message: "must have required property '16/9'"
              };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            if (data3["3/1"] !== void 0) {
              if (typeof data3["3/1"] !== "string") {
                const err13 = {
                  instancePath: instancePath + "/bannerImages/3~11",
                  schemaPath: "#/properties/bannerImages/anyOf/2/properties/3~11/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
            }
            if (data3["3/4"] !== void 0) {
              if (typeof data3["3/4"] !== "string") {
                const err14 = {
                  instancePath: instancePath + "/bannerImages/3~14",
                  schemaPath: "#/properties/bannerImages/anyOf/2/properties/3~14/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
            if (data3["16/9"] !== void 0) {
              if (typeof data3["16/9"] !== "string") {
                const err15 = {
                  instancePath: instancePath + "/bannerImages/16~19",
                  schemaPath: "#/properties/bannerImages/anyOf/2/properties/16~19/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
              }
            }
          } else {
            const err16 = {
              instancePath: instancePath + "/bannerImages",
              schemaPath: "#/properties/bannerImages/anyOf/2/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err16];
            } else {
              vErrors.push(err16);
            }
            errors++;
          }
          var _valid0 = _errs13 === errors;
          valid1 = valid1 || _valid0;
        }
      }
      if (!valid1) {
        const err17 = {
          instancePath: instancePath + "/bannerImages",
          schemaPath: "#/properties/bannerImages/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      } else {
        errors = _errs8;
        if (vErrors !== null) {
          if (_errs8) {
            vErrors.length = _errs8;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.promoBlocks !== void 0) {
      let data7 = data.promoBlocks;
      if (Array.isArray(data7)) {
        const len0 = data7.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (!validate60(data7[i0], {
            instancePath: instancePath + "/promoBlocks/" + i0,
            parentData: data7,
            parentDataProperty: i0,
            rootData
          })) {
            vErrors = vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err18 = {
          instancePath: instancePath + "/promoBlocks",
          schemaPath: "#/properties/promoBlocks/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
  } else {
    const err19 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err19];
    } else {
      vErrors.push(err19);
    }
    errors++;
  }
  validate68.errors = vErrors;
  return errors === 0;
}
function validate67(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (!validate68(data, {
    instancePath,
    parentData,
    parentDataProperty,
    rootData
  })) {
    vErrors = vErrors === null ? validate68.errors : vErrors.concat(validate68.errors);
    errors = vErrors.length;
  }
  validate67.errors = vErrors;
  return errors === 0;
}
const ClassicHeaderModule = validate68;
const LiveAndUpcomingListModule = validate71;
const schema85 = {
  "$id": "LiveAndUpcomingListModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string",
      "const": "LIVE_AND_UPCOMING_LIST"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "layoutType": {
      "type": "string",
      "enum": ["CAROUSEL", "GRID"]
    },
    "density": {
      "type": "string",
      "enum": ["NORMAL", "DENSE", "DENSEST"]
    },
    "preferedGridSize": {
      "type": "object",
      "properties": {
        "columns": {
          "type": "number"
        },
        "rows": {
          "type": "number"
        }
      },
      "required": ["columns", "rows"]
    },
    "listSource": {
      "type": "object",
      "properties": {
        "tags": {
          "type": "object",
          "properties": {
            "kind": {
              "type": "string",
              "enum": ["ALL", "SOME"]
            },
            "list": {
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          },
          "required": ["kind", "list"]
        },
        "eventId": {
          "type": "string"
        }
      }
    },
    "size": {
      "type": "number"
    },
    "dateRange": {
      "type": "array",
      "items": {
        "anyOf": [{
          "type": "string",
          "const": "NOW"
        }, {
          "type": "object",
          "format": "date-time"
        }, {
          "type": "null"
        }]
      },
      "minItems": 2,
      "maxItems": 2
    }
  },
  "required": ["density", "layoutType", "listSource", "moduleType", "size"],
  "description": "Loads a list of streams that are either live or upcoming. This only loads videos of type STREAM and with a state other than 'PASSED'."
};
function validate71(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.density === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "density"
        },
        message: "must have required property 'density'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.layoutType === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "layoutType"
        },
        message: "must have required property 'layoutType'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.listSource === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "listSource"
        },
        message: "must have required property 'listSource'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.moduleType === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "moduleType"
        },
        message: "must have required property 'moduleType'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.size === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "size"
        },
        message: "must have required property 'size'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.moduleType !== void 0) {
      let data0 = data.moduleType;
      if (typeof data0 !== "string") {
        const err5 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if ("LIVE_AND_UPCOMING_LIST" !== data0) {
        const err6 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/const",
          keyword: "const",
          params: {
            allowedValue: "LIVE_AND_UPCOMING_LIST"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.heading !== void 0) {
      if (typeof data.heading !== "string") {
        const err7 = {
          instancePath: instancePath + "/heading",
          schemaPath: "#/properties/heading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.subHeading !== void 0) {
      if (typeof data.subHeading !== "string") {
        const err8 = {
          instancePath: instancePath + "/subHeading",
          schemaPath: "#/properties/subHeading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.layoutType !== void 0) {
      let data3 = data.layoutType;
      if (typeof data3 !== "string") {
        const err9 = {
          instancePath: instancePath + "/layoutType",
          schemaPath: "#/properties/layoutType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if (!(data3 === "CAROUSEL" || data3 === "GRID")) {
        const err10 = {
          instancePath: instancePath + "/layoutType",
          schemaPath: "#/properties/layoutType/enum",
          keyword: "enum",
          params: {
            allowedValues: schema85.properties.layoutType.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.density !== void 0) {
      let data4 = data.density;
      if (typeof data4 !== "string") {
        const err11 = {
          instancePath: instancePath + "/density",
          schemaPath: "#/properties/density/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if (!(data4 === "NORMAL" || data4 === "DENSE" || data4 === "DENSEST")) {
        const err12 = {
          instancePath: instancePath + "/density",
          schemaPath: "#/properties/density/enum",
          keyword: "enum",
          params: {
            allowedValues: schema85.properties.density.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.preferedGridSize !== void 0) {
      let data5 = data.preferedGridSize;
      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
        if (data5.columns === void 0) {
          const err13 = {
            instancePath: instancePath + "/preferedGridSize",
            schemaPath: "#/properties/preferedGridSize/required",
            keyword: "required",
            params: {
              missingProperty: "columns"
            },
            message: "must have required property 'columns'"
          };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
        if (data5.rows === void 0) {
          const err14 = {
            instancePath: instancePath + "/preferedGridSize",
            schemaPath: "#/properties/preferedGridSize/required",
            keyword: "required",
            params: {
              missingProperty: "rows"
            },
            message: "must have required property 'rows'"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
        if (data5.columns !== void 0) {
          let data6 = data5.columns;
          if (!(typeof data6 == "number" && isFinite(data6))) {
            const err15 = {
              instancePath: instancePath + "/preferedGridSize/columns",
              schemaPath: "#/properties/preferedGridSize/properties/columns/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
        if (data5.rows !== void 0) {
          let data7 = data5.rows;
          if (!(typeof data7 == "number" && isFinite(data7))) {
            const err16 = {
              instancePath: instancePath + "/preferedGridSize/rows",
              schemaPath: "#/properties/preferedGridSize/properties/rows/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err16];
            } else {
              vErrors.push(err16);
            }
            errors++;
          }
        }
      } else {
        const err17 = {
          instancePath: instancePath + "/preferedGridSize",
          schemaPath: "#/properties/preferedGridSize/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.listSource !== void 0) {
      let data8 = data.listSource;
      if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
        if (data8.tags !== void 0) {
          let data9 = data8.tags;
          if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
            if (data9.kind === void 0) {
              const err18 = {
                instancePath: instancePath + "/listSource/tags",
                schemaPath: "#/properties/listSource/properties/tags/required",
                keyword: "required",
                params: {
                  missingProperty: "kind"
                },
                message: "must have required property 'kind'"
              };
              if (vErrors === null) {
                vErrors = [err18];
              } else {
                vErrors.push(err18);
              }
              errors++;
            }
            if (data9.list === void 0) {
              const err19 = {
                instancePath: instancePath + "/listSource/tags",
                schemaPath: "#/properties/listSource/properties/tags/required",
                keyword: "required",
                params: {
                  missingProperty: "list"
                },
                message: "must have required property 'list'"
              };
              if (vErrors === null) {
                vErrors = [err19];
              } else {
                vErrors.push(err19);
              }
              errors++;
            }
            if (data9.kind !== void 0) {
              let data10 = data9.kind;
              if (typeof data10 !== "string") {
                const err20 = {
                  instancePath: instancePath + "/listSource/tags/kind",
                  schemaPath: "#/properties/listSource/properties/tags/properties/kind/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err20];
                } else {
                  vErrors.push(err20);
                }
                errors++;
              }
              if (!(data10 === "ALL" || data10 === "SOME")) {
                const err21 = {
                  instancePath: instancePath + "/listSource/tags/kind",
                  schemaPath: "#/properties/listSource/properties/tags/properties/kind/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema85.properties.listSource.properties.tags.properties.kind.enum
                  },
                  message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) {
                  vErrors = [err21];
                } else {
                  vErrors.push(err21);
                }
                errors++;
              }
            }
            if (data9.list !== void 0) {
              let data11 = data9.list;
              if (Array.isArray(data11)) {
                const len0 = data11.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  if (typeof data11[i0] !== "string") {
                    const err22 = {
                      instancePath: instancePath + "/listSource/tags/list/" + i0,
                      schemaPath: "#/properties/listSource/properties/tags/properties/list/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err22];
                    } else {
                      vErrors.push(err22);
                    }
                    errors++;
                  }
                }
              } else {
                const err23 = {
                  instancePath: instancePath + "/listSource/tags/list",
                  schemaPath: "#/properties/listSource/properties/tags/properties/list/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
            }
          } else {
            const err24 = {
              instancePath: instancePath + "/listSource/tags",
              schemaPath: "#/properties/listSource/properties/tags/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          }
        }
        if (data8.eventId !== void 0) {
          if (typeof data8.eventId !== "string") {
            const err25 = {
              instancePath: instancePath + "/listSource/eventId",
              schemaPath: "#/properties/listSource/properties/eventId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err25];
            } else {
              vErrors.push(err25);
            }
            errors++;
          }
        }
      } else {
        const err26 = {
          instancePath: instancePath + "/listSource",
          schemaPath: "#/properties/listSource/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err26];
        } else {
          vErrors.push(err26);
        }
        errors++;
      }
    }
    if (data.size !== void 0) {
      let data14 = data.size;
      if (!(typeof data14 == "number" && isFinite(data14))) {
        const err27 = {
          instancePath: instancePath + "/size",
          schemaPath: "#/properties/size/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err27];
        } else {
          vErrors.push(err27);
        }
        errors++;
      }
    }
    if (data.dateRange !== void 0) {
      let data15 = data.dateRange;
      if (Array.isArray(data15)) {
        if (data15.length > 2) {
          const err28 = {
            instancePath: instancePath + "/dateRange",
            schemaPath: "#/properties/dateRange/maxItems",
            keyword: "maxItems",
            params: {
              limit: 2
            },
            message: "must NOT have more than 2 items"
          };
          if (vErrors === null) {
            vErrors = [err28];
          } else {
            vErrors.push(err28);
          }
          errors++;
        }
        if (data15.length < 2) {
          const err29 = {
            instancePath: instancePath + "/dateRange",
            schemaPath: "#/properties/dateRange/minItems",
            keyword: "minItems",
            params: {
              limit: 2
            },
            message: "must NOT have fewer than 2 items"
          };
          if (vErrors === null) {
            vErrors = [err29];
          } else {
            vErrors.push(err29);
          }
          errors++;
        }
        const len1 = data15.length;
        for (let i1 = 0; i1 < len1; i1++) {
          let data16 = data15[i1];
          const _errs34 = errors;
          let valid8 = false;
          const _errs35 = errors;
          if (typeof data16 !== "string") {
            const err30 = {
              instancePath: instancePath + "/dateRange/" + i1,
              schemaPath: "#/properties/dateRange/items/anyOf/0/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err30];
            } else {
              vErrors.push(err30);
            }
            errors++;
          }
          if ("NOW" !== data16) {
            const err31 = {
              instancePath: instancePath + "/dateRange/" + i1,
              schemaPath: "#/properties/dateRange/items/anyOf/0/const",
              keyword: "const",
              params: {
                allowedValue: "NOW"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
          var _valid0 = _errs35 === errors;
          valid8 = valid8 || _valid0;
          if (!valid8) {
            const _errs37 = errors;
            if (!(data16 && typeof data16 == "object" && !Array.isArray(data16))) {
              const err32 = {
                instancePath: instancePath + "/dateRange/" + i1,
                schemaPath: "#/properties/dateRange/items/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              };
              if (vErrors === null) {
                vErrors = [err32];
              } else {
                vErrors.push(err32);
              }
              errors++;
            }
            if (typeof data16 === "string") {
              if (!formats0(data16)) {
                const err33 = {
                  instancePath: instancePath + "/dateRange/" + i1,
                  schemaPath: "#/properties/dateRange/items/anyOf/1/format",
                  keyword: "format",
                  params: {
                    format: "date-time"
                  },
                  message: 'must match format "date-time"'
                };
                if (vErrors === null) {
                  vErrors = [err33];
                } else {
                  vErrors.push(err33);
                }
                errors++;
              }
            }
            var _valid0 = _errs37 === errors;
            valid8 = valid8 || _valid0;
            if (!valid8) {
              const _errs39 = errors;
              if (data16 !== null) {
                const err34 = {
                  instancePath: instancePath + "/dateRange/" + i1,
                  schemaPath: "#/properties/dateRange/items/anyOf/2/type",
                  keyword: "type",
                  params: {
                    type: "null"
                  },
                  message: "must be null"
                };
                if (vErrors === null) {
                  vErrors = [err34];
                } else {
                  vErrors.push(err34);
                }
                errors++;
              }
              var _valid0 = _errs39 === errors;
              valid8 = valid8 || _valid0;
            }
          }
          if (!valid8) {
            const err35 = {
              instancePath: instancePath + "/dateRange/" + i1,
              schemaPath: "#/properties/dateRange/items/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err35];
            } else {
              vErrors.push(err35);
            }
            errors++;
          } else {
            errors = _errs34;
            if (vErrors !== null) {
              if (_errs34) {
                vErrors.length = _errs34;
              } else {
                vErrors = null;
              }
            }
          }
        }
      } else {
        const err36 = {
          instancePath: instancePath + "/dateRange",
          schemaPath: "#/properties/dateRange/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err36];
        } else {
          vErrors.push(err36);
        }
        errors++;
      }
    }
  } else {
    const err37 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err37];
    } else {
      vErrors.push(err37);
    }
    errors++;
  }
  validate71.errors = vErrors;
  return errors === 0;
}
const StaticNamedTagListSource = validate72;
function validate72(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.tagIds === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "tagIds"
        },
        message: "must have required property 'tagIds'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.tagIds !== void 0) {
      let data0 = data.tagIds;
      if (Array.isArray(data0)) {
        const len0 = data0.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (typeof data0[i0] !== "string") {
            const err1 = {
              instancePath: instancePath + "/tagIds/" + i0,
              schemaPath: "#/properties/tagIds/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
        }
      } else {
        const err2 = {
          instancePath: instancePath + "/tagIds",
          schemaPath: "#/properties/tagIds/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate72.errors = vErrors;
  return errors === 0;
}
const DynamicNamedTagListSource = validate73;
const schema87 = {
  "$id": "DynamicNamedTagListSource",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "type": {
      "type": "string",
      "enum": ["EVENT", "ATHLETE", "PLACE", "TOURNAMENT", "TEAM", "SEASON"]
    }
  },
  "required": ["type"]
};
function validate73(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.type === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.type !== void 0) {
      let data0 = data.type;
      if (typeof data0 !== "string") {
        const err1 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === "EVENT" || data0 === "ATHLETE" || data0 === "PLACE" || data0 === "TOURNAMENT" || data0 === "TEAM" || data0 === "SEASON")) {
        const err2 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/enum",
          keyword: "enum",
          params: {
            allowedValues: schema87.properties.type.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate73.errors = vErrors;
  return errors === 0;
}
const NamedTagListSource = validate74;
function validate74(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.tagIds === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "StaticNamedTagListSource/required",
        keyword: "required",
        params: {
          missingProperty: "tagIds"
        },
        message: "must have required property 'tagIds'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.tagIds !== void 0) {
      let data0 = data.tagIds;
      if (Array.isArray(data0)) {
        const len0 = data0.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (typeof data0[i0] !== "string") {
            const err1 = {
              instancePath: instancePath + "/tagIds/" + i0,
              schemaPath: "StaticNamedTagListSource/properties/tagIds/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
        }
      } else {
        const err2 = {
          instancePath: instancePath + "/tagIds",
          schemaPath: "StaticNamedTagListSource/properties/tagIds/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: "StaticNamedTagListSource/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs8 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.type === void 0) {
        const err4 = {
          instancePath,
          schemaPath: "DynamicNamedTagListSource/required",
          keyword: "required",
          params: {
            missingProperty: "type"
          },
          message: "must have required property 'type'"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if (data.type !== void 0) {
        let data2 = data.type;
        if (typeof data2 !== "string") {
          const err5 = {
            instancePath: instancePath + "/type",
            schemaPath: "DynamicNamedTagListSource/properties/type/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
        if (!(data2 === "EVENT" || data2 === "ATHLETE" || data2 === "PLACE" || data2 === "TOURNAMENT" || data2 === "TEAM" || data2 === "SEASON")) {
          const err6 = {
            instancePath: instancePath + "/type",
            schemaPath: "DynamicNamedTagListSource/properties/type/enum",
            keyword: "enum",
            params: {
              allowedValues: schema87.properties.type.enum
            },
            message: "must be equal to one of the allowed values"
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
      }
    } else {
      const err7 = {
        instancePath,
        schemaPath: "DynamicNamedTagListSource/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    var _valid0 = _errs8 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err8 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err8];
    } else {
      vErrors.push(err8);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate74.errors = vErrors;
  return errors === 0;
}
const NamedTagsListModule = validate75;
const schema91 = {
  "$id": "NamedTagsListModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string",
      "const": "NAMED_TAGS_LIST"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "layoutType": {
      "type": "string",
      "enum": ["CAROUSEL", "GRID"]
    },
    "density": {
      "type": "string",
      "enum": ["NORMAL", "DENSE", "DENSEST"]
    },
    "preferedGridSize": {
      "type": "object",
      "properties": {
        "columns": {
          "type": "number"
        },
        "rows": {
          "type": "number"
        }
      },
      "required": ["columns", "rows"]
    },
    "listSource": {
      "$ref": "NamedTagListSource"
    },
    "size": {
      "type": "number"
    }
  },
  "required": ["density", "layoutType", "listSource", "moduleType", "size"]
};
function validate75(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.density === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "density"
        },
        message: "must have required property 'density'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.layoutType === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "layoutType"
        },
        message: "must have required property 'layoutType'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.listSource === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "listSource"
        },
        message: "must have required property 'listSource'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.moduleType === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "moduleType"
        },
        message: "must have required property 'moduleType'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.size === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "size"
        },
        message: "must have required property 'size'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.moduleType !== void 0) {
      let data0 = data.moduleType;
      if (typeof data0 !== "string") {
        const err5 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if ("NAMED_TAGS_LIST" !== data0) {
        const err6 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/const",
          keyword: "const",
          params: {
            allowedValue: "NAMED_TAGS_LIST"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.heading !== void 0) {
      if (typeof data.heading !== "string") {
        const err7 = {
          instancePath: instancePath + "/heading",
          schemaPath: "#/properties/heading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.subHeading !== void 0) {
      if (typeof data.subHeading !== "string") {
        const err8 = {
          instancePath: instancePath + "/subHeading",
          schemaPath: "#/properties/subHeading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.layoutType !== void 0) {
      let data3 = data.layoutType;
      if (typeof data3 !== "string") {
        const err9 = {
          instancePath: instancePath + "/layoutType",
          schemaPath: "#/properties/layoutType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if (!(data3 === "CAROUSEL" || data3 === "GRID")) {
        const err10 = {
          instancePath: instancePath + "/layoutType",
          schemaPath: "#/properties/layoutType/enum",
          keyword: "enum",
          params: {
            allowedValues: schema91.properties.layoutType.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.density !== void 0) {
      let data4 = data.density;
      if (typeof data4 !== "string") {
        const err11 = {
          instancePath: instancePath + "/density",
          schemaPath: "#/properties/density/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if (!(data4 === "NORMAL" || data4 === "DENSE" || data4 === "DENSEST")) {
        const err12 = {
          instancePath: instancePath + "/density",
          schemaPath: "#/properties/density/enum",
          keyword: "enum",
          params: {
            allowedValues: schema91.properties.density.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.preferedGridSize !== void 0) {
      let data5 = data.preferedGridSize;
      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
        if (data5.columns === void 0) {
          const err13 = {
            instancePath: instancePath + "/preferedGridSize",
            schemaPath: "#/properties/preferedGridSize/required",
            keyword: "required",
            params: {
              missingProperty: "columns"
            },
            message: "must have required property 'columns'"
          };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
        if (data5.rows === void 0) {
          const err14 = {
            instancePath: instancePath + "/preferedGridSize",
            schemaPath: "#/properties/preferedGridSize/required",
            keyword: "required",
            params: {
              missingProperty: "rows"
            },
            message: "must have required property 'rows'"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
        if (data5.columns !== void 0) {
          let data6 = data5.columns;
          if (!(typeof data6 == "number" && isFinite(data6))) {
            const err15 = {
              instancePath: instancePath + "/preferedGridSize/columns",
              schemaPath: "#/properties/preferedGridSize/properties/columns/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
        if (data5.rows !== void 0) {
          let data7 = data5.rows;
          if (!(typeof data7 == "number" && isFinite(data7))) {
            const err16 = {
              instancePath: instancePath + "/preferedGridSize/rows",
              schemaPath: "#/properties/preferedGridSize/properties/rows/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err16];
            } else {
              vErrors.push(err16);
            }
            errors++;
          }
        }
      } else {
        const err17 = {
          instancePath: instancePath + "/preferedGridSize",
          schemaPath: "#/properties/preferedGridSize/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.listSource !== void 0) {
      if (!validate74(data.listSource, {
        instancePath: instancePath + "/listSource",
        parentData: data,
        parentDataProperty: "listSource",
        rootData
      })) {
        vErrors = vErrors === null ? validate74.errors : vErrors.concat(validate74.errors);
        errors = vErrors.length;
      }
    }
    if (data.size !== void 0) {
      let data9 = data.size;
      if (!(typeof data9 == "number" && isFinite(data9))) {
        const err18 = {
          instancePath: instancePath + "/size",
          schemaPath: "#/properties/size/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
  } else {
    const err19 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err19];
    } else {
      vErrors.push(err19);
    }
    errors++;
  }
  validate75.errors = vErrors;
  return errors === 0;
}
const TagsListModule = validate77;
function validate77(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.moduleType === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "moduleType"
        },
        message: "must have required property 'moduleType'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.tags === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "tags"
        },
        message: "must have required property 'tags'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.moduleType !== void 0) {
      let data0 = data.moduleType;
      if (typeof data0 !== "string") {
        const err2 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if ("TAGS_LIST" !== data0) {
        const err3 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/const",
          keyword: "const",
          params: {
            allowedValue: "TAGS_LIST"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.heading !== void 0) {
      if (typeof data.heading !== "string") {
        const err4 = {
          instancePath: instancePath + "/heading",
          schemaPath: "#/properties/heading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.subHeading !== void 0) {
      if (typeof data.subHeading !== "string") {
        const err5 = {
          instancePath: instancePath + "/subHeading",
          schemaPath: "#/properties/subHeading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.tags !== void 0) {
      let data3 = data.tags;
      if (Array.isArray(data3)) {
        const len0 = data3.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (typeof data3[i0] !== "string") {
            const err6 = {
              instancePath: instancePath + "/tags/" + i0,
              schemaPath: "#/properties/tags/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err6];
            } else {
              vErrors.push(err6);
            }
            errors++;
          }
        }
      } else {
        const err7 = {
          instancePath: instancePath + "/tags",
          schemaPath: "#/properties/tags/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
  } else {
    const err8 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err8];
    } else {
      vErrors.push(err8);
    }
    errors++;
  }
  validate77.errors = vErrors;
  return errors === 0;
}
const AttributeKey = validate78;
const schema93 = {
  "$id": "AttributeKey",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["attr0", "attr1", "attr2", "attr3"]
};
function validate78(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (!(data === "attr0" || data === "attr1" || data === "attr2" || data === "attr3")) {
    const err1 = {
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema93.enum
      },
      message: "must be equal to one of the allowed values"
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate78.errors = vErrors;
  return errors === 0;
}
const CustomAttributes = validate79;
function validate79(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.attr0 !== void 0) {
      if (typeof data.attr0 !== "string") {
        const err0 = {
          instancePath: instancePath + "/attr0",
          schemaPath: "#/properties/attr0/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.attr1 !== void 0) {
      if (typeof data.attr1 !== "string") {
        const err1 = {
          instancePath: instancePath + "/attr1",
          schemaPath: "#/properties/attr1/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.attr2 !== void 0) {
      if (typeof data.attr2 !== "string") {
        const err2 = {
          instancePath: instancePath + "/attr2",
          schemaPath: "#/properties/attr2/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.attr3 !== void 0) {
      if (typeof data.attr3 !== "string") {
        const err3 = {
          instancePath: instancePath + "/attr3",
          schemaPath: "#/properties/attr3/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate79.errors = vErrors;
  return errors === 0;
}
const FiltersAttributeDefinition = validate80;
const schema95 = {
  "$id": "FiltersAttributeDefinition",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "anyOf": [{
    "type": "object",
    "properties": {
      "source": {
        "type": "string",
        "enum": ["tag", "event", "date"]
      }
    },
    "required": ["source"]
  }, {
    "$ref": "AttributeSource"
  }]
};
function validate81(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.source === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "source"
        },
        message: "must have required property 'source'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.source !== void 0) {
      let data0 = data.source;
      if (typeof data0 !== "string") {
        const err1 = {
          instancePath: instancePath + "/source",
          schemaPath: "AttributeKey/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === "attr0" || data0 === "attr1" || data0 === "attr2" || data0 === "attr3")) {
        const err2 = {
          instancePath: instancePath + "/source",
          schemaPath: "AttributeKey/enum",
          keyword: "enum",
          params: {
            allowedValues: schema93.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: "#/anyOf/0/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs6 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.source === void 0) {
        const err4 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "source"
          },
          message: "must have required property 'source'"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if (data.groups === void 0) {
        const err5 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "groups"
          },
          message: "must have required property 'groups'"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if (data.source !== void 0) {
        let data1 = data.source;
        if (typeof data1 !== "string") {
          const err6 = {
            instancePath: instancePath + "/source",
            schemaPath: "AttributeKey/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
        if (!(data1 === "attr0" || data1 === "attr1" || data1 === "attr2" || data1 === "attr3")) {
          const err7 = {
            instancePath: instancePath + "/source",
            schemaPath: "AttributeKey/enum",
            keyword: "enum",
            params: {
              allowedValues: schema93.enum
            },
            message: "must be equal to one of the allowed values"
          };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
      }
      if (data.groups !== void 0) {
        let data2 = data.groups;
        if (Array.isArray(data2)) {
          const len0 = data2.length;
          for (let i0 = 0; i0 < len0; i0++) {
            if (typeof data2[i0] !== "string") {
              const err8 = {
                instancePath: instancePath + "/groups/" + i0,
                schemaPath: "#/anyOf/1/properties/groups/items/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
          }
        } else {
          const err9 = {
            instancePath: instancePath + "/groups",
            schemaPath: "#/anyOf/1/properties/groups/type",
            keyword: "type",
            params: {
              type: "array"
            },
            message: "must be array"
          };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
      }
    } else {
      const err10 = {
        instancePath,
        schemaPath: "#/anyOf/1/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err10];
      } else {
        vErrors.push(err10);
      }
      errors++;
    }
    var _valid0 = _errs6 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs15 = errors;
      if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.source === void 0) {
          const err11 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "source"
            },
            message: "must have required property 'source'"
          };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
        if (data.values === void 0) {
          const err12 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "values"
            },
            message: "must have required property 'values'"
          };
          if (vErrors === null) {
            vErrors = [err12];
          } else {
            vErrors.push(err12);
          }
          errors++;
        }
        if (data.source !== void 0) {
          let data4 = data.source;
          if (typeof data4 !== "string") {
            const err13 = {
              instancePath: instancePath + "/source",
              schemaPath: "AttributeKey/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
          if (!(data4 === "attr0" || data4 === "attr1" || data4 === "attr2" || data4 === "attr3")) {
            const err14 = {
              instancePath: instancePath + "/source",
              schemaPath: "AttributeKey/enum",
              keyword: "enum",
              params: {
                allowedValues: schema93.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err14];
            } else {
              vErrors.push(err14);
            }
            errors++;
          }
        }
        if (data.values !== void 0) {
          let data5 = data.values;
          if (Array.isArray(data5)) {
            const len1 = data5.length;
            for (let i1 = 0; i1 < len1; i1++) {
              if (typeof data5[i1] !== "string") {
                const err15 = {
                  instancePath: instancePath + "/values/" + i1,
                  schemaPath: "#/anyOf/2/properties/values/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
              }
            }
          } else {
            const err16 = {
              instancePath: instancePath + "/values",
              schemaPath: "#/anyOf/2/properties/values/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err16];
            } else {
              vErrors.push(err16);
            }
            errors++;
          }
        }
      } else {
        const err17 = {
          instancePath,
          schemaPath: "#/anyOf/2/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
      var _valid0 = _errs15 === errors;
      valid0 = valid0 || _valid0;
    }
  }
  if (!valid0) {
    const err18 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err18];
    } else {
      vErrors.push(err18);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate81.errors = vErrors;
  return errors === 0;
}
function validate80(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.source === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "source"
        },
        message: "must have required property 'source'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.source !== void 0) {
      let data0 = data.source;
      if (typeof data0 !== "string") {
        const err1 = {
          instancePath: instancePath + "/source",
          schemaPath: "#/anyOf/0/properties/source/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === "tag" || data0 === "event" || data0 === "date")) {
        const err2 = {
          instancePath: instancePath + "/source",
          schemaPath: "#/anyOf/0/properties/source/enum",
          keyword: "enum",
          params: {
            allowedValues: schema95.anyOf[0].properties.source.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: "#/anyOf/0/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs5 = errors;
    if (!validate81(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData
    })) {
      vErrors = vErrors === null ? validate81.errors : vErrors.concat(validate81.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs5 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err4 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate80.errors = vErrors;
  return errors === 0;
}
const AttributeSource = validate81;
const DynamicVideoListSource = validate83;
const schema100 = {
  "$id": "DynamicVideoListSource",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "tags": {
      "type": "object",
      "properties": {
        "kind": {
          "type": "string",
          "enum": ["ALL", "SOME"]
        },
        "list": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["kind", "list"]
    },
    "eventId": {
      "type": "string"
    },
    "type": {
      "type": "string",
      "enum": ["SHORT", "STREAM", "UPLOAD"]
    },
    "streamState": {
      "type": "string",
      "enum": ["LIVE", "SCHEDULED", "FINISHED"]
    },
    "attributes": {
      "$ref": "CustomAttributes"
    },
    "paged": {
      "type": "boolean"
    }
  },
  "description": "A source referencing a dynamic list of videos that need to be loaded at runtime"
};
function validate83(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.tags !== void 0) {
      let data0 = data.tags;
      if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
        if (data0.kind === void 0) {
          const err0 = {
            instancePath: instancePath + "/tags",
            schemaPath: "#/properties/tags/required",
            keyword: "required",
            params: {
              missingProperty: "kind"
            },
            message: "must have required property 'kind'"
          };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        if (data0.list === void 0) {
          const err1 = {
            instancePath: instancePath + "/tags",
            schemaPath: "#/properties/tags/required",
            keyword: "required",
            params: {
              missingProperty: "list"
            },
            message: "must have required property 'list'"
          };
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        }
        if (data0.kind !== void 0) {
          let data1 = data0.kind;
          if (typeof data1 !== "string") {
            const err2 = {
              instancePath: instancePath + "/tags/kind",
              schemaPath: "#/properties/tags/properties/kind/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          if (!(data1 === "ALL" || data1 === "SOME")) {
            const err3 = {
              instancePath: instancePath + "/tags/kind",
              schemaPath: "#/properties/tags/properties/kind/enum",
              keyword: "enum",
              params: {
                allowedValues: schema100.properties.tags.properties.kind.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err3];
            } else {
              vErrors.push(err3);
            }
            errors++;
          }
        }
        if (data0.list !== void 0) {
          let data2 = data0.list;
          if (Array.isArray(data2)) {
            const len0 = data2.length;
            for (let i0 = 0; i0 < len0; i0++) {
              if (typeof data2[i0] !== "string") {
                const err4 = {
                  instancePath: instancePath + "/tags/list/" + i0,
                  schemaPath: "#/properties/tags/properties/list/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err4];
                } else {
                  vErrors.push(err4);
                }
                errors++;
              }
            }
          } else {
            const err5 = {
              instancePath: instancePath + "/tags/list",
              schemaPath: "#/properties/tags/properties/list/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err5];
            } else {
              vErrors.push(err5);
            }
            errors++;
          }
        }
      } else {
        const err6 = {
          instancePath: instancePath + "/tags",
          schemaPath: "#/properties/tags/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.eventId !== void 0) {
      if (typeof data.eventId !== "string") {
        const err7 = {
          instancePath: instancePath + "/eventId",
          schemaPath: "#/properties/eventId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.type !== void 0) {
      let data5 = data.type;
      if (typeof data5 !== "string") {
        const err8 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
      if (!(data5 === "SHORT" || data5 === "STREAM" || data5 === "UPLOAD")) {
        const err9 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/enum",
          keyword: "enum",
          params: {
            allowedValues: schema100.properties.type.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.streamState !== void 0) {
      let data6 = data.streamState;
      if (typeof data6 !== "string") {
        const err10 = {
          instancePath: instancePath + "/streamState",
          schemaPath: "#/properties/streamState/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
      if (!(data6 === "LIVE" || data6 === "SCHEDULED" || data6 === "FINISHED")) {
        const err11 = {
          instancePath: instancePath + "/streamState",
          schemaPath: "#/properties/streamState/enum",
          keyword: "enum",
          params: {
            allowedValues: schema100.properties.streamState.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.attributes !== void 0) {
      let data7 = data.attributes;
      if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
        if (data7.attr0 !== void 0) {
          if (typeof data7.attr0 !== "string") {
            const err12 = {
              instancePath: instancePath + "/attributes/attr0",
              schemaPath: "CustomAttributes/properties/attr0/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
        }
        if (data7.attr1 !== void 0) {
          if (typeof data7.attr1 !== "string") {
            const err13 = {
              instancePath: instancePath + "/attributes/attr1",
              schemaPath: "CustomAttributes/properties/attr1/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
        }
        if (data7.attr2 !== void 0) {
          if (typeof data7.attr2 !== "string") {
            const err14 = {
              instancePath: instancePath + "/attributes/attr2",
              schemaPath: "CustomAttributes/properties/attr2/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err14];
            } else {
              vErrors.push(err14);
            }
            errors++;
          }
        }
        if (data7.attr3 !== void 0) {
          if (typeof data7.attr3 !== "string") {
            const err15 = {
              instancePath: instancePath + "/attributes/attr3",
              schemaPath: "CustomAttributes/properties/attr3/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
      } else {
        const err16 = {
          instancePath: instancePath + "/attributes",
          schemaPath: "CustomAttributes/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.paged !== void 0) {
      if (typeof data.paged !== "boolean") {
        const err17 = {
          instancePath: instancePath + "/paged",
          schemaPath: "#/properties/paged/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
  } else {
    const err18 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err18];
    } else {
      vErrors.push(err18);
    }
    errors++;
  }
  validate83.errors = vErrors;
  return errors === 0;
}
const StaticVideoListSource = validate84;
function validate84(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.videoIds === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "videoIds"
        },
        message: "must have required property 'videoIds'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.videoIds !== void 0) {
      let data0 = data.videoIds;
      if (Array.isArray(data0)) {
        const len0 = data0.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (typeof data0[i0] !== "string") {
            const err1 = {
              instancePath: instancePath + "/videoIds/" + i0,
              schemaPath: "#/properties/videoIds/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
        }
      } else {
        const err2 = {
          instancePath: instancePath + "/videoIds",
          schemaPath: "#/properties/videoIds/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate84.errors = vErrors;
  return errors === 0;
}
const VideoListSource = validate85;
function validate85(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.videoIds === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "StaticVideoListSource/required",
        keyword: "required",
        params: {
          missingProperty: "videoIds"
        },
        message: "must have required property 'videoIds'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.videoIds !== void 0) {
      let data0 = data.videoIds;
      if (Array.isArray(data0)) {
        const len0 = data0.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (typeof data0[i0] !== "string") {
            const err1 = {
              instancePath: instancePath + "/videoIds/" + i0,
              schemaPath: "StaticVideoListSource/properties/videoIds/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
        }
      } else {
        const err2 = {
          instancePath: instancePath + "/videoIds",
          schemaPath: "StaticVideoListSource/properties/videoIds/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: "StaticVideoListSource/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs8 = errors;
    if (!validate83(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData
    })) {
      vErrors = vErrors === null ? validate83.errors : vErrors.concat(validate83.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs8 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err4 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate85.errors = vErrors;
  return errors === 0;
}
const VideoListModuleBase = validate87;
const schema105 = {
  "$id": "VideoListModuleBase",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "layoutType": {
      "type": "string",
      "enum": ["CAROUSEL", "GRID"]
    },
    "density": {
      "type": "string",
      "enum": ["NORMAL", "DENSE", "DENSEST"]
    },
    "preferedGridSize": {
      "type": "object",
      "properties": {
        "columns": {
          "type": "number"
        },
        "rows": {
          "type": "number"
        }
      },
      "required": ["columns", "rows"]
    },
    "sort": {
      "type": "string",
      "enum": ["DATE", "DATE_TRIMMED"]
    },
    "order": {
      "type": "string",
      "enum": ["ASC", "DESC"]
    },
    "size": {
      "type": "number"
    },
    "dateRange": {
      "type": "array",
      "items": {
        "anyOf": [{
          "type": "string",
          "const": "NOW"
        }, {
          "type": "object",
          "format": "date-time"
        }, {
          "type": "null"
        }]
      },
      "minItems": 2,
      "maxItems": 2
    }
  },
  "required": ["density", "layoutType", "moduleType", "size"]
};
function validate87(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.density === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "density"
        },
        message: "must have required property 'density'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.layoutType === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "layoutType"
        },
        message: "must have required property 'layoutType'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.moduleType === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "moduleType"
        },
        message: "must have required property 'moduleType'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.size === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "size"
        },
        message: "must have required property 'size'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.moduleType !== void 0) {
      if (typeof data.moduleType !== "string") {
        const err4 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.heading !== void 0) {
      if (typeof data.heading !== "string") {
        const err5 = {
          instancePath: instancePath + "/heading",
          schemaPath: "#/properties/heading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.subHeading !== void 0) {
      if (typeof data.subHeading !== "string") {
        const err6 = {
          instancePath: instancePath + "/subHeading",
          schemaPath: "#/properties/subHeading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.layoutType !== void 0) {
      let data3 = data.layoutType;
      if (typeof data3 !== "string") {
        const err7 = {
          instancePath: instancePath + "/layoutType",
          schemaPath: "#/properties/layoutType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if (!(data3 === "CAROUSEL" || data3 === "GRID")) {
        const err8 = {
          instancePath: instancePath + "/layoutType",
          schemaPath: "#/properties/layoutType/enum",
          keyword: "enum",
          params: {
            allowedValues: schema105.properties.layoutType.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.density !== void 0) {
      let data4 = data.density;
      if (typeof data4 !== "string") {
        const err9 = {
          instancePath: instancePath + "/density",
          schemaPath: "#/properties/density/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if (!(data4 === "NORMAL" || data4 === "DENSE" || data4 === "DENSEST")) {
        const err10 = {
          instancePath: instancePath + "/density",
          schemaPath: "#/properties/density/enum",
          keyword: "enum",
          params: {
            allowedValues: schema105.properties.density.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.preferedGridSize !== void 0) {
      let data5 = data.preferedGridSize;
      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
        if (data5.columns === void 0) {
          const err11 = {
            instancePath: instancePath + "/preferedGridSize",
            schemaPath: "#/properties/preferedGridSize/required",
            keyword: "required",
            params: {
              missingProperty: "columns"
            },
            message: "must have required property 'columns'"
          };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
        if (data5.rows === void 0) {
          const err12 = {
            instancePath: instancePath + "/preferedGridSize",
            schemaPath: "#/properties/preferedGridSize/required",
            keyword: "required",
            params: {
              missingProperty: "rows"
            },
            message: "must have required property 'rows'"
          };
          if (vErrors === null) {
            vErrors = [err12];
          } else {
            vErrors.push(err12);
          }
          errors++;
        }
        if (data5.columns !== void 0) {
          let data6 = data5.columns;
          if (!(typeof data6 == "number" && isFinite(data6))) {
            const err13 = {
              instancePath: instancePath + "/preferedGridSize/columns",
              schemaPath: "#/properties/preferedGridSize/properties/columns/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
        }
        if (data5.rows !== void 0) {
          let data7 = data5.rows;
          if (!(typeof data7 == "number" && isFinite(data7))) {
            const err14 = {
              instancePath: instancePath + "/preferedGridSize/rows",
              schemaPath: "#/properties/preferedGridSize/properties/rows/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err14];
            } else {
              vErrors.push(err14);
            }
            errors++;
          }
        }
      } else {
        const err15 = {
          instancePath: instancePath + "/preferedGridSize",
          schemaPath: "#/properties/preferedGridSize/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
    if (data.sort !== void 0) {
      let data8 = data.sort;
      if (typeof data8 !== "string") {
        const err16 = {
          instancePath: instancePath + "/sort",
          schemaPath: "#/properties/sort/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
      if (!(data8 === "DATE" || data8 === "DATE_TRIMMED")) {
        const err17 = {
          instancePath: instancePath + "/sort",
          schemaPath: "#/properties/sort/enum",
          keyword: "enum",
          params: {
            allowedValues: schema105.properties.sort.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.order !== void 0) {
      let data9 = data.order;
      if (typeof data9 !== "string") {
        const err18 = {
          instancePath: instancePath + "/order",
          schemaPath: "#/properties/order/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
      if (!(data9 === "ASC" || data9 === "DESC")) {
        const err19 = {
          instancePath: instancePath + "/order",
          schemaPath: "#/properties/order/enum",
          keyword: "enum",
          params: {
            allowedValues: schema105.properties.order.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      }
    }
    if (data.size !== void 0) {
      let data10 = data.size;
      if (!(typeof data10 == "number" && isFinite(data10))) {
        const err20 = {
          instancePath: instancePath + "/size",
          schemaPath: "#/properties/size/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
    }
    if (data.dateRange !== void 0) {
      let data11 = data.dateRange;
      if (Array.isArray(data11)) {
        if (data11.length > 2) {
          const err21 = {
            instancePath: instancePath + "/dateRange",
            schemaPath: "#/properties/dateRange/maxItems",
            keyword: "maxItems",
            params: {
              limit: 2
            },
            message: "must NOT have more than 2 items"
          };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
        if (data11.length < 2) {
          const err22 = {
            instancePath: instancePath + "/dateRange",
            schemaPath: "#/properties/dateRange/minItems",
            keyword: "minItems",
            params: {
              limit: 2
            },
            message: "must NOT have fewer than 2 items"
          };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
        const len0 = data11.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data12 = data11[i0];
          const _errs26 = errors;
          let valid4 = false;
          const _errs27 = errors;
          if (typeof data12 !== "string") {
            const err23 = {
              instancePath: instancePath + "/dateRange/" + i0,
              schemaPath: "#/properties/dateRange/items/anyOf/0/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
          if ("NOW" !== data12) {
            const err24 = {
              instancePath: instancePath + "/dateRange/" + i0,
              schemaPath: "#/properties/dateRange/items/anyOf/0/const",
              keyword: "const",
              params: {
                allowedValue: "NOW"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          }
          var _valid0 = _errs27 === errors;
          valid4 = valid4 || _valid0;
          if (!valid4) {
            const _errs29 = errors;
            if (!(data12 && typeof data12 == "object" && !Array.isArray(data12))) {
              const err25 = {
                instancePath: instancePath + "/dateRange/" + i0,
                schemaPath: "#/properties/dateRange/items/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              };
              if (vErrors === null) {
                vErrors = [err25];
              } else {
                vErrors.push(err25);
              }
              errors++;
            }
            if (typeof data12 === "string") {
              if (!formats0(data12)) {
                const err26 = {
                  instancePath: instancePath + "/dateRange/" + i0,
                  schemaPath: "#/properties/dateRange/items/anyOf/1/format",
                  keyword: "format",
                  params: {
                    format: "date-time"
                  },
                  message: 'must match format "date-time"'
                };
                if (vErrors === null) {
                  vErrors = [err26];
                } else {
                  vErrors.push(err26);
                }
                errors++;
              }
            }
            var _valid0 = _errs29 === errors;
            valid4 = valid4 || _valid0;
            if (!valid4) {
              const _errs31 = errors;
              if (data12 !== null) {
                const err27 = {
                  instancePath: instancePath + "/dateRange/" + i0,
                  schemaPath: "#/properties/dateRange/items/anyOf/2/type",
                  keyword: "type",
                  params: {
                    type: "null"
                  },
                  message: "must be null"
                };
                if (vErrors === null) {
                  vErrors = [err27];
                } else {
                  vErrors.push(err27);
                }
                errors++;
              }
              var _valid0 = _errs31 === errors;
              valid4 = valid4 || _valid0;
            }
          }
          if (!valid4) {
            const err28 = {
              instancePath: instancePath + "/dateRange/" + i0,
              schemaPath: "#/properties/dateRange/items/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err28];
            } else {
              vErrors.push(err28);
            }
            errors++;
          } else {
            errors = _errs26;
            if (vErrors !== null) {
              if (_errs26) {
                vErrors.length = _errs26;
              } else {
                vErrors = null;
              }
            }
          }
        }
      } else {
        const err29 = {
          instancePath: instancePath + "/dateRange",
          schemaPath: "#/properties/dateRange/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err29];
        } else {
          vErrors.push(err29);
        }
        errors++;
      }
    }
  } else {
    const err30 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err30];
    } else {
      vErrors.push(err30);
    }
    errors++;
  }
  validate87.errors = vErrors;
  return errors === 0;
}
const VideoListModule = validate88;
const schema106 = {
  "$id": "VideoListModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string",
      "const": "VIDEOS_LIST"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "layoutType": {
      "type": "string",
      "enum": ["CAROUSEL", "GRID"]
    },
    "density": {
      "type": "string",
      "enum": ["NORMAL", "DENSE", "DENSEST"]
    },
    "preferedGridSize": {
      "type": "object",
      "properties": {
        "columns": {
          "type": "number"
        },
        "rows": {
          "type": "number"
        }
      },
      "required": ["columns", "rows"]
    },
    "sort": {
      "type": "string",
      "enum": ["DATE", "DATE_TRIMMED"]
    },
    "order": {
      "type": "string",
      "enum": ["ASC", "DESC"]
    },
    "size": {
      "type": "number"
    },
    "dateRange": {
      "type": "array",
      "items": {
        "anyOf": [{
          "type": "string",
          "const": "NOW"
        }, {
          "type": "object",
          "format": "date-time"
        }, {
          "type": "null"
        }]
      },
      "minItems": 2,
      "maxItems": 2
    },
    "listSource": {
      "$ref": "VideoListSource"
    }
  },
  "required": ["density", "layoutType", "listSource", "moduleType", "size"],
  "description": "Specifies a list of videos that satisfies certain criteria using listSource and also defines the way the data should be sorted and presented."
};
function validate88(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.density === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "density"
        },
        message: "must have required property 'density'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.layoutType === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "layoutType"
        },
        message: "must have required property 'layoutType'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.listSource === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "listSource"
        },
        message: "must have required property 'listSource'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.moduleType === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "moduleType"
        },
        message: "must have required property 'moduleType'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.size === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "size"
        },
        message: "must have required property 'size'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.moduleType !== void 0) {
      let data0 = data.moduleType;
      if (typeof data0 !== "string") {
        const err5 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if ("VIDEOS_LIST" !== data0) {
        const err6 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/const",
          keyword: "const",
          params: {
            allowedValue: "VIDEOS_LIST"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.heading !== void 0) {
      if (typeof data.heading !== "string") {
        const err7 = {
          instancePath: instancePath + "/heading",
          schemaPath: "#/properties/heading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.subHeading !== void 0) {
      if (typeof data.subHeading !== "string") {
        const err8 = {
          instancePath: instancePath + "/subHeading",
          schemaPath: "#/properties/subHeading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.layoutType !== void 0) {
      let data3 = data.layoutType;
      if (typeof data3 !== "string") {
        const err9 = {
          instancePath: instancePath + "/layoutType",
          schemaPath: "#/properties/layoutType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if (!(data3 === "CAROUSEL" || data3 === "GRID")) {
        const err10 = {
          instancePath: instancePath + "/layoutType",
          schemaPath: "#/properties/layoutType/enum",
          keyword: "enum",
          params: {
            allowedValues: schema106.properties.layoutType.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.density !== void 0) {
      let data4 = data.density;
      if (typeof data4 !== "string") {
        const err11 = {
          instancePath: instancePath + "/density",
          schemaPath: "#/properties/density/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if (!(data4 === "NORMAL" || data4 === "DENSE" || data4 === "DENSEST")) {
        const err12 = {
          instancePath: instancePath + "/density",
          schemaPath: "#/properties/density/enum",
          keyword: "enum",
          params: {
            allowedValues: schema106.properties.density.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.preferedGridSize !== void 0) {
      let data5 = data.preferedGridSize;
      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
        if (data5.columns === void 0) {
          const err13 = {
            instancePath: instancePath + "/preferedGridSize",
            schemaPath: "#/properties/preferedGridSize/required",
            keyword: "required",
            params: {
              missingProperty: "columns"
            },
            message: "must have required property 'columns'"
          };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
        if (data5.rows === void 0) {
          const err14 = {
            instancePath: instancePath + "/preferedGridSize",
            schemaPath: "#/properties/preferedGridSize/required",
            keyword: "required",
            params: {
              missingProperty: "rows"
            },
            message: "must have required property 'rows'"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
        if (data5.columns !== void 0) {
          let data6 = data5.columns;
          if (!(typeof data6 == "number" && isFinite(data6))) {
            const err15 = {
              instancePath: instancePath + "/preferedGridSize/columns",
              schemaPath: "#/properties/preferedGridSize/properties/columns/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
        if (data5.rows !== void 0) {
          let data7 = data5.rows;
          if (!(typeof data7 == "number" && isFinite(data7))) {
            const err16 = {
              instancePath: instancePath + "/preferedGridSize/rows",
              schemaPath: "#/properties/preferedGridSize/properties/rows/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err16];
            } else {
              vErrors.push(err16);
            }
            errors++;
          }
        }
      } else {
        const err17 = {
          instancePath: instancePath + "/preferedGridSize",
          schemaPath: "#/properties/preferedGridSize/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.sort !== void 0) {
      let data8 = data.sort;
      if (typeof data8 !== "string") {
        const err18 = {
          instancePath: instancePath + "/sort",
          schemaPath: "#/properties/sort/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
      if (!(data8 === "DATE" || data8 === "DATE_TRIMMED")) {
        const err19 = {
          instancePath: instancePath + "/sort",
          schemaPath: "#/properties/sort/enum",
          keyword: "enum",
          params: {
            allowedValues: schema106.properties.sort.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      }
    }
    if (data.order !== void 0) {
      let data9 = data.order;
      if (typeof data9 !== "string") {
        const err20 = {
          instancePath: instancePath + "/order",
          schemaPath: "#/properties/order/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
      if (!(data9 === "ASC" || data9 === "DESC")) {
        const err21 = {
          instancePath: instancePath + "/order",
          schemaPath: "#/properties/order/enum",
          keyword: "enum",
          params: {
            allowedValues: schema106.properties.order.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err21];
        } else {
          vErrors.push(err21);
        }
        errors++;
      }
    }
    if (data.size !== void 0) {
      let data10 = data.size;
      if (!(typeof data10 == "number" && isFinite(data10))) {
        const err22 = {
          instancePath: instancePath + "/size",
          schemaPath: "#/properties/size/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err22];
        } else {
          vErrors.push(err22);
        }
        errors++;
      }
    }
    if (data.dateRange !== void 0) {
      let data11 = data.dateRange;
      if (Array.isArray(data11)) {
        if (data11.length > 2) {
          const err23 = {
            instancePath: instancePath + "/dateRange",
            schemaPath: "#/properties/dateRange/maxItems",
            keyword: "maxItems",
            params: {
              limit: 2
            },
            message: "must NOT have more than 2 items"
          };
          if (vErrors === null) {
            vErrors = [err23];
          } else {
            vErrors.push(err23);
          }
          errors++;
        }
        if (data11.length < 2) {
          const err24 = {
            instancePath: instancePath + "/dateRange",
            schemaPath: "#/properties/dateRange/minItems",
            keyword: "minItems",
            params: {
              limit: 2
            },
            message: "must NOT have fewer than 2 items"
          };
          if (vErrors === null) {
            vErrors = [err24];
          } else {
            vErrors.push(err24);
          }
          errors++;
        }
        const len0 = data11.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data12 = data11[i0];
          const _errs26 = errors;
          let valid4 = false;
          const _errs27 = errors;
          if (typeof data12 !== "string") {
            const err25 = {
              instancePath: instancePath + "/dateRange/" + i0,
              schemaPath: "#/properties/dateRange/items/anyOf/0/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err25];
            } else {
              vErrors.push(err25);
            }
            errors++;
          }
          if ("NOW" !== data12) {
            const err26 = {
              instancePath: instancePath + "/dateRange/" + i0,
              schemaPath: "#/properties/dateRange/items/anyOf/0/const",
              keyword: "const",
              params: {
                allowedValue: "NOW"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err26];
            } else {
              vErrors.push(err26);
            }
            errors++;
          }
          var _valid0 = _errs27 === errors;
          valid4 = valid4 || _valid0;
          if (!valid4) {
            const _errs29 = errors;
            if (!(data12 && typeof data12 == "object" && !Array.isArray(data12))) {
              const err27 = {
                instancePath: instancePath + "/dateRange/" + i0,
                schemaPath: "#/properties/dateRange/items/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              };
              if (vErrors === null) {
                vErrors = [err27];
              } else {
                vErrors.push(err27);
              }
              errors++;
            }
            if (typeof data12 === "string") {
              if (!formats0(data12)) {
                const err28 = {
                  instancePath: instancePath + "/dateRange/" + i0,
                  schemaPath: "#/properties/dateRange/items/anyOf/1/format",
                  keyword: "format",
                  params: {
                    format: "date-time"
                  },
                  message: 'must match format "date-time"'
                };
                if (vErrors === null) {
                  vErrors = [err28];
                } else {
                  vErrors.push(err28);
                }
                errors++;
              }
            }
            var _valid0 = _errs29 === errors;
            valid4 = valid4 || _valid0;
            if (!valid4) {
              const _errs31 = errors;
              if (data12 !== null) {
                const err29 = {
                  instancePath: instancePath + "/dateRange/" + i0,
                  schemaPath: "#/properties/dateRange/items/anyOf/2/type",
                  keyword: "type",
                  params: {
                    type: "null"
                  },
                  message: "must be null"
                };
                if (vErrors === null) {
                  vErrors = [err29];
                } else {
                  vErrors.push(err29);
                }
                errors++;
              }
              var _valid0 = _errs31 === errors;
              valid4 = valid4 || _valid0;
            }
          }
          if (!valid4) {
            const err30 = {
              instancePath: instancePath + "/dateRange/" + i0,
              schemaPath: "#/properties/dateRange/items/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err30];
            } else {
              vErrors.push(err30);
            }
            errors++;
          } else {
            errors = _errs26;
            if (vErrors !== null) {
              if (_errs26) {
                vErrors.length = _errs26;
              } else {
                vErrors = null;
              }
            }
          }
        }
      } else {
        const err31 = {
          instancePath: instancePath + "/dateRange",
          schemaPath: "#/properties/dateRange/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err31];
        } else {
          vErrors.push(err31);
        }
        errors++;
      }
    }
    if (data.listSource !== void 0) {
      if (!validate85(data.listSource, {
        instancePath: instancePath + "/listSource",
        parentData: data,
        parentDataProperty: "listSource",
        rootData
      })) {
        vErrors = vErrors === null ? validate85.errors : vErrors.concat(validate85.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err32 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err32];
    } else {
      vErrors.push(err32);
    }
    errors++;
  }
  validate88.errors = vErrors;
  return errors === 0;
}
const FilteredVideoListModule = validate90;
const schema107 = {
  "$id": "FilteredVideoListModule",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "moduleType": {
      "type": "string",
      "const": "FILTERED_VIDEOS_LIST"
    },
    "heading": {
      "type": "string"
    },
    "subHeading": {
      "type": "string"
    },
    "layoutType": {
      "type": "string",
      "enum": ["CAROUSEL", "GRID"]
    },
    "density": {
      "type": "string",
      "enum": ["NORMAL", "DENSE", "DENSEST"]
    },
    "preferedGridSize": {
      "type": "object",
      "properties": {
        "columns": {
          "type": "number"
        },
        "rows": {
          "type": "number"
        }
      },
      "required": ["columns", "rows"]
    },
    "sort": {
      "type": "string",
      "enum": ["DATE", "DATE_TRIMMED"]
    },
    "order": {
      "type": "string",
      "enum": ["ASC", "DESC"]
    },
    "size": {
      "type": "number"
    },
    "dateRange": {
      "type": "array",
      "items": {
        "anyOf": [{
          "type": "string",
          "const": "NOW"
        }, {
          "type": "object",
          "format": "date-time"
        }, {
          "type": "null"
        }]
      },
      "minItems": 2,
      "maxItems": 2
    },
    "listSource": {
      "$ref": "DynamicVideoListSource"
    },
    "filters": {
      "anyOf": [{
        "type": "string",
        "const": "DEFAULT"
      }, {
        "type": "array",
        "items": {
          "$ref": "FiltersAttributeDefinition"
        }
      }]
    }
  },
  "required": ["density", "filters", "layoutType", "listSource", "moduleType", "size"],
  "description": "A variation of the VideoListModule that show filtering options to the user. The attributes selected by the user will override any attributes specified in the listSource."
};
function validate90(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.density === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "density"
        },
        message: "must have required property 'density'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.filters === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "filters"
        },
        message: "must have required property 'filters'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.layoutType === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "layoutType"
        },
        message: "must have required property 'layoutType'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.listSource === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "listSource"
        },
        message: "must have required property 'listSource'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.moduleType === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "moduleType"
        },
        message: "must have required property 'moduleType'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.size === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "size"
        },
        message: "must have required property 'size'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.moduleType !== void 0) {
      let data0 = data.moduleType;
      if (typeof data0 !== "string") {
        const err6 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if ("FILTERED_VIDEOS_LIST" !== data0) {
        const err7 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/const",
          keyword: "const",
          params: {
            allowedValue: "FILTERED_VIDEOS_LIST"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.heading !== void 0) {
      if (typeof data.heading !== "string") {
        const err8 = {
          instancePath: instancePath + "/heading",
          schemaPath: "#/properties/heading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.subHeading !== void 0) {
      if (typeof data.subHeading !== "string") {
        const err9 = {
          instancePath: instancePath + "/subHeading",
          schemaPath: "#/properties/subHeading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.layoutType !== void 0) {
      let data3 = data.layoutType;
      if (typeof data3 !== "string") {
        const err10 = {
          instancePath: instancePath + "/layoutType",
          schemaPath: "#/properties/layoutType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
      if (!(data3 === "CAROUSEL" || data3 === "GRID")) {
        const err11 = {
          instancePath: instancePath + "/layoutType",
          schemaPath: "#/properties/layoutType/enum",
          keyword: "enum",
          params: {
            allowedValues: schema107.properties.layoutType.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.density !== void 0) {
      let data4 = data.density;
      if (typeof data4 !== "string") {
        const err12 = {
          instancePath: instancePath + "/density",
          schemaPath: "#/properties/density/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
      if (!(data4 === "NORMAL" || data4 === "DENSE" || data4 === "DENSEST")) {
        const err13 = {
          instancePath: instancePath + "/density",
          schemaPath: "#/properties/density/enum",
          keyword: "enum",
          params: {
            allowedValues: schema107.properties.density.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.preferedGridSize !== void 0) {
      let data5 = data.preferedGridSize;
      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
        if (data5.columns === void 0) {
          const err14 = {
            instancePath: instancePath + "/preferedGridSize",
            schemaPath: "#/properties/preferedGridSize/required",
            keyword: "required",
            params: {
              missingProperty: "columns"
            },
            message: "must have required property 'columns'"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
        if (data5.rows === void 0) {
          const err15 = {
            instancePath: instancePath + "/preferedGridSize",
            schemaPath: "#/properties/preferedGridSize/required",
            keyword: "required",
            params: {
              missingProperty: "rows"
            },
            message: "must have required property 'rows'"
          };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if (data5.columns !== void 0) {
          let data6 = data5.columns;
          if (!(typeof data6 == "number" && isFinite(data6))) {
            const err16 = {
              instancePath: instancePath + "/preferedGridSize/columns",
              schemaPath: "#/properties/preferedGridSize/properties/columns/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err16];
            } else {
              vErrors.push(err16);
            }
            errors++;
          }
        }
        if (data5.rows !== void 0) {
          let data7 = data5.rows;
          if (!(typeof data7 == "number" && isFinite(data7))) {
            const err17 = {
              instancePath: instancePath + "/preferedGridSize/rows",
              schemaPath: "#/properties/preferedGridSize/properties/rows/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err17];
            } else {
              vErrors.push(err17);
            }
            errors++;
          }
        }
      } else {
        const err18 = {
          instancePath: instancePath + "/preferedGridSize",
          schemaPath: "#/properties/preferedGridSize/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
    if (data.sort !== void 0) {
      let data8 = data.sort;
      if (typeof data8 !== "string") {
        const err19 = {
          instancePath: instancePath + "/sort",
          schemaPath: "#/properties/sort/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      }
      if (!(data8 === "DATE" || data8 === "DATE_TRIMMED")) {
        const err20 = {
          instancePath: instancePath + "/sort",
          schemaPath: "#/properties/sort/enum",
          keyword: "enum",
          params: {
            allowedValues: schema107.properties.sort.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
    }
    if (data.order !== void 0) {
      let data9 = data.order;
      if (typeof data9 !== "string") {
        const err21 = {
          instancePath: instancePath + "/order",
          schemaPath: "#/properties/order/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err21];
        } else {
          vErrors.push(err21);
        }
        errors++;
      }
      if (!(data9 === "ASC" || data9 === "DESC")) {
        const err22 = {
          instancePath: instancePath + "/order",
          schemaPath: "#/properties/order/enum",
          keyword: "enum",
          params: {
            allowedValues: schema107.properties.order.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err22];
        } else {
          vErrors.push(err22);
        }
        errors++;
      }
    }
    if (data.size !== void 0) {
      let data10 = data.size;
      if (!(typeof data10 == "number" && isFinite(data10))) {
        const err23 = {
          instancePath: instancePath + "/size",
          schemaPath: "#/properties/size/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err23];
        } else {
          vErrors.push(err23);
        }
        errors++;
      }
    }
    if (data.dateRange !== void 0) {
      let data11 = data.dateRange;
      if (Array.isArray(data11)) {
        if (data11.length > 2) {
          const err24 = {
            instancePath: instancePath + "/dateRange",
            schemaPath: "#/properties/dateRange/maxItems",
            keyword: "maxItems",
            params: {
              limit: 2
            },
            message: "must NOT have more than 2 items"
          };
          if (vErrors === null) {
            vErrors = [err24];
          } else {
            vErrors.push(err24);
          }
          errors++;
        }
        if (data11.length < 2) {
          const err25 = {
            instancePath: instancePath + "/dateRange",
            schemaPath: "#/properties/dateRange/minItems",
            keyword: "minItems",
            params: {
              limit: 2
            },
            message: "must NOT have fewer than 2 items"
          };
          if (vErrors === null) {
            vErrors = [err25];
          } else {
            vErrors.push(err25);
          }
          errors++;
        }
        const len0 = data11.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data12 = data11[i0];
          const _errs26 = errors;
          let valid4 = false;
          const _errs27 = errors;
          if (typeof data12 !== "string") {
            const err26 = {
              instancePath: instancePath + "/dateRange/" + i0,
              schemaPath: "#/properties/dateRange/items/anyOf/0/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err26];
            } else {
              vErrors.push(err26);
            }
            errors++;
          }
          if ("NOW" !== data12) {
            const err27 = {
              instancePath: instancePath + "/dateRange/" + i0,
              schemaPath: "#/properties/dateRange/items/anyOf/0/const",
              keyword: "const",
              params: {
                allowedValue: "NOW"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err27];
            } else {
              vErrors.push(err27);
            }
            errors++;
          }
          var _valid0 = _errs27 === errors;
          valid4 = valid4 || _valid0;
          if (!valid4) {
            const _errs29 = errors;
            if (!(data12 && typeof data12 == "object" && !Array.isArray(data12))) {
              const err28 = {
                instancePath: instancePath + "/dateRange/" + i0,
                schemaPath: "#/properties/dateRange/items/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              };
              if (vErrors === null) {
                vErrors = [err28];
              } else {
                vErrors.push(err28);
              }
              errors++;
            }
            if (typeof data12 === "string") {
              if (!formats0(data12)) {
                const err29 = {
                  instancePath: instancePath + "/dateRange/" + i0,
                  schemaPath: "#/properties/dateRange/items/anyOf/1/format",
                  keyword: "format",
                  params: {
                    format: "date-time"
                  },
                  message: 'must match format "date-time"'
                };
                if (vErrors === null) {
                  vErrors = [err29];
                } else {
                  vErrors.push(err29);
                }
                errors++;
              }
            }
            var _valid0 = _errs29 === errors;
            valid4 = valid4 || _valid0;
            if (!valid4) {
              const _errs31 = errors;
              if (data12 !== null) {
                const err30 = {
                  instancePath: instancePath + "/dateRange/" + i0,
                  schemaPath: "#/properties/dateRange/items/anyOf/2/type",
                  keyword: "type",
                  params: {
                    type: "null"
                  },
                  message: "must be null"
                };
                if (vErrors === null) {
                  vErrors = [err30];
                } else {
                  vErrors.push(err30);
                }
                errors++;
              }
              var _valid0 = _errs31 === errors;
              valid4 = valid4 || _valid0;
            }
          }
          if (!valid4) {
            const err31 = {
              instancePath: instancePath + "/dateRange/" + i0,
              schemaPath: "#/properties/dateRange/items/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          } else {
            errors = _errs26;
            if (vErrors !== null) {
              if (_errs26) {
                vErrors.length = _errs26;
              } else {
                vErrors = null;
              }
            }
          }
        }
      } else {
        const err32 = {
          instancePath: instancePath + "/dateRange",
          schemaPath: "#/properties/dateRange/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err32];
        } else {
          vErrors.push(err32);
        }
        errors++;
      }
    }
    if (data.listSource !== void 0) {
      if (!validate83(data.listSource, {
        instancePath: instancePath + "/listSource",
        parentData: data,
        parentDataProperty: "listSource",
        rootData
      })) {
        vErrors = vErrors === null ? validate83.errors : vErrors.concat(validate83.errors);
        errors = vErrors.length;
      }
    }
    if (data.filters !== void 0) {
      let data14 = data.filters;
      const _errs35 = errors;
      let valid5 = false;
      const _errs36 = errors;
      if (typeof data14 !== "string") {
        const err33 = {
          instancePath: instancePath + "/filters",
          schemaPath: "#/properties/filters/anyOf/0/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err33];
        } else {
          vErrors.push(err33);
        }
        errors++;
      }
      if ("DEFAULT" !== data14) {
        const err34 = {
          instancePath: instancePath + "/filters",
          schemaPath: "#/properties/filters/anyOf/0/const",
          keyword: "const",
          params: {
            allowedValue: "DEFAULT"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err34];
        } else {
          vErrors.push(err34);
        }
        errors++;
      }
      var _valid1 = _errs36 === errors;
      valid5 = valid5 || _valid1;
      if (!valid5) {
        const _errs38 = errors;
        if (Array.isArray(data14)) {
          const len1 = data14.length;
          for (let i1 = 0; i1 < len1; i1++) {
            if (!validate80(data14[i1], {
              instancePath: instancePath + "/filters/" + i1,
              parentData: data14,
              parentDataProperty: i1,
              rootData
            })) {
              vErrors = vErrors === null ? validate80.errors : vErrors.concat(validate80.errors);
              errors = vErrors.length;
            }
          }
        } else {
          const err35 = {
            instancePath: instancePath + "/filters",
            schemaPath: "#/properties/filters/anyOf/1/type",
            keyword: "type",
            params: {
              type: "array"
            },
            message: "must be array"
          };
          if (vErrors === null) {
            vErrors = [err35];
          } else {
            vErrors.push(err35);
          }
          errors++;
        }
        var _valid1 = _errs38 === errors;
        valid5 = valid5 || _valid1;
      }
      if (!valid5) {
        const err36 = {
          instancePath: instancePath + "/filters",
          schemaPath: "#/properties/filters/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err36];
        } else {
          vErrors.push(err36);
        }
        errors++;
      } else {
        errors = _errs35;
        if (vErrors !== null) {
          if (_errs35) {
            vErrors.length = _errs35;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err37 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err37];
    } else {
      vErrors.push(err37);
    }
    errors++;
  }
  validate90.errors = vErrors;
  return errors === 0;
}
const VideoModule = validate93;
function validate93(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.moduleType === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "moduleType"
        },
        message: "must have required property 'moduleType'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.sourceId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "sourceId"
        },
        message: "must have required property 'sourceId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.moduleType !== void 0) {
      let data0 = data.moduleType;
      if (typeof data0 !== "string") {
        const err2 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if ("SINGLE_VIDEO" !== data0) {
        const err3 = {
          instancePath: instancePath + "/moduleType",
          schemaPath: "#/properties/moduleType/const",
          keyword: "const",
          params: {
            allowedValue: "SINGLE_VIDEO"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.heading !== void 0) {
      if (typeof data.heading !== "string") {
        const err4 = {
          instancePath: instancePath + "/heading",
          schemaPath: "#/properties/heading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.subHeading !== void 0) {
      if (typeof data.subHeading !== "string") {
        const err5 = {
          instancePath: instancePath + "/subHeading",
          schemaPath: "#/properties/subHeading/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.sourceId !== void 0) {
      if (typeof data.sourceId !== "string") {
        const err6 = {
          instancePath: instancePath + "/sourceId",
          schemaPath: "#/properties/sourceId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
  } else {
    const err7 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err7];
    } else {
      vErrors.push(err7);
    }
    errors++;
  }
  validate93.errors = vErrors;
  return errors === 0;
}
const PageModule = validate94;
function validate94(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (!validate56(data, {
    instancePath,
    parentData,
    parentDataProperty,
    rootData
  })) {
    vErrors = vErrors === null ? validate56.errors : vErrors.concat(validate56.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs2 = errors;
    if (!validate75(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData
    })) {
      vErrors = vErrors === null ? validate75.errors : vErrors.concat(validate75.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs2 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs3 = errors;
      if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.moduleType === void 0) {
          const err0 = {
            instancePath,
            schemaPath: "TagsListModule/required",
            keyword: "required",
            params: {
              missingProperty: "moduleType"
            },
            message: "must have required property 'moduleType'"
          };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        if (data.tags === void 0) {
          const err1 = {
            instancePath,
            schemaPath: "TagsListModule/required",
            keyword: "required",
            params: {
              missingProperty: "tags"
            },
            message: "must have required property 'tags'"
          };
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        }
        if (data.moduleType !== void 0) {
          let data0 = data.moduleType;
          if (typeof data0 !== "string") {
            const err2 = {
              instancePath: instancePath + "/moduleType",
              schemaPath: "TagsListModule/properties/moduleType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          if ("TAGS_LIST" !== data0) {
            const err3 = {
              instancePath: instancePath + "/moduleType",
              schemaPath: "TagsListModule/properties/moduleType/const",
              keyword: "const",
              params: {
                allowedValue: "TAGS_LIST"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err3];
            } else {
              vErrors.push(err3);
            }
            errors++;
          }
        }
        if (data.heading !== void 0) {
          if (typeof data.heading !== "string") {
            const err4 = {
              instancePath: instancePath + "/heading",
              schemaPath: "TagsListModule/properties/heading/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err4];
            } else {
              vErrors.push(err4);
            }
            errors++;
          }
        }
        if (data.subHeading !== void 0) {
          if (typeof data.subHeading !== "string") {
            const err5 = {
              instancePath: instancePath + "/subHeading",
              schemaPath: "TagsListModule/properties/subHeading/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err5];
            } else {
              vErrors.push(err5);
            }
            errors++;
          }
        }
        if (data.tags !== void 0) {
          let data3 = data.tags;
          if (Array.isArray(data3)) {
            const len0 = data3.length;
            for (let i0 = 0; i0 < len0; i0++) {
              if (typeof data3[i0] !== "string") {
                const err6 = {
                  instancePath: instancePath + "/tags/" + i0,
                  schemaPath: "TagsListModule/properties/tags/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            }
          } else {
            const err7 = {
              instancePath: instancePath + "/tags",
              schemaPath: "TagsListModule/properties/tags/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
          }
        }
      } else {
        const err8 = {
          instancePath,
          schemaPath: "TagsListModule/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
      var _valid0 = _errs3 === errors;
      valid0 = valid0 || _valid0;
      if (!valid0) {
        const _errs16 = errors;
        if (!validate88(data, {
          instancePath,
          parentData,
          parentDataProperty,
          rootData
        })) {
          vErrors = vErrors === null ? validate88.errors : vErrors.concat(validate88.errors);
          errors = vErrors.length;
        }
        var _valid0 = _errs16 === errors;
        valid0 = valid0 || _valid0;
        if (!valid0) {
          const _errs17 = errors;
          if (!validate90(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData
          })) {
            vErrors = vErrors === null ? validate90.errors : vErrors.concat(validate90.errors);
            errors = vErrors.length;
          }
          var _valid0 = _errs17 === errors;
          valid0 = valid0 || _valid0;
          if (!valid0) {
            const _errs18 = errors;
            if (data && typeof data == "object" && !Array.isArray(data)) {
              if (data.moduleType === void 0) {
                const err9 = {
                  instancePath,
                  schemaPath: "VideoModule/required",
                  keyword: "required",
                  params: {
                    missingProperty: "moduleType"
                  },
                  message: "must have required property 'moduleType'"
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
              if (data.sourceId === void 0) {
                const err10 = {
                  instancePath,
                  schemaPath: "VideoModule/required",
                  keyword: "required",
                  params: {
                    missingProperty: "sourceId"
                  },
                  message: "must have required property 'sourceId'"
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
              if (data.moduleType !== void 0) {
                let data5 = data.moduleType;
                if (typeof data5 !== "string") {
                  const err11 = {
                    instancePath: instancePath + "/moduleType",
                    schemaPath: "VideoModule/properties/moduleType/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                }
                if ("SINGLE_VIDEO" !== data5) {
                  const err12 = {
                    instancePath: instancePath + "/moduleType",
                    schemaPath: "VideoModule/properties/moduleType/const",
                    keyword: "const",
                    params: {
                      allowedValue: "SINGLE_VIDEO"
                    },
                    message: "must be equal to constant"
                  };
                  if (vErrors === null) {
                    vErrors = [err12];
                  } else {
                    vErrors.push(err12);
                  }
                  errors++;
                }
              }
              if (data.heading !== void 0) {
                if (typeof data.heading !== "string") {
                  const err13 = {
                    instancePath: instancePath + "/heading",
                    schemaPath: "VideoModule/properties/heading/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err13];
                  } else {
                    vErrors.push(err13);
                  }
                  errors++;
                }
              }
              if (data.subHeading !== void 0) {
                if (typeof data.subHeading !== "string") {
                  const err14 = {
                    instancePath: instancePath + "/subHeading",
                    schemaPath: "VideoModule/properties/subHeading/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err14];
                  } else {
                    vErrors.push(err14);
                  }
                  errors++;
                }
              }
              if (data.sourceId !== void 0) {
                if (typeof data.sourceId !== "string") {
                  const err15 = {
                    instancePath: instancePath + "/sourceId",
                    schemaPath: "VideoModule/properties/sourceId/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err15];
                  } else {
                    vErrors.push(err15);
                  }
                  errors++;
                }
              }
            } else {
              const err16 = {
                instancePath,
                schemaPath: "VideoModule/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              };
              if (vErrors === null) {
                vErrors = [err16];
              } else {
                vErrors.push(err16);
              }
              errors++;
            }
            var _valid0 = _errs18 === errors;
            valid0 = valid0 || _valid0;
            if (!valid0) {
              const _errs29 = errors;
              if (data && typeof data == "object" && !Array.isArray(data)) {
                if (data.density === void 0) {
                  const err17 = {
                    instancePath,
                    schemaPath: "LiveAndUpcomingListModule/required",
                    keyword: "required",
                    params: {
                      missingProperty: "density"
                    },
                    message: "must have required property 'density'"
                  };
                  if (vErrors === null) {
                    vErrors = [err17];
                  } else {
                    vErrors.push(err17);
                  }
                  errors++;
                }
                if (data.layoutType === void 0) {
                  const err18 = {
                    instancePath,
                    schemaPath: "LiveAndUpcomingListModule/required",
                    keyword: "required",
                    params: {
                      missingProperty: "layoutType"
                    },
                    message: "must have required property 'layoutType'"
                  };
                  if (vErrors === null) {
                    vErrors = [err18];
                  } else {
                    vErrors.push(err18);
                  }
                  errors++;
                }
                if (data.listSource === void 0) {
                  const err19 = {
                    instancePath,
                    schemaPath: "LiveAndUpcomingListModule/required",
                    keyword: "required",
                    params: {
                      missingProperty: "listSource"
                    },
                    message: "must have required property 'listSource'"
                  };
                  if (vErrors === null) {
                    vErrors = [err19];
                  } else {
                    vErrors.push(err19);
                  }
                  errors++;
                }
                if (data.moduleType === void 0) {
                  const err20 = {
                    instancePath,
                    schemaPath: "LiveAndUpcomingListModule/required",
                    keyword: "required",
                    params: {
                      missingProperty: "moduleType"
                    },
                    message: "must have required property 'moduleType'"
                  };
                  if (vErrors === null) {
                    vErrors = [err20];
                  } else {
                    vErrors.push(err20);
                  }
                  errors++;
                }
                if (data.size === void 0) {
                  const err21 = {
                    instancePath,
                    schemaPath: "LiveAndUpcomingListModule/required",
                    keyword: "required",
                    params: {
                      missingProperty: "size"
                    },
                    message: "must have required property 'size'"
                  };
                  if (vErrors === null) {
                    vErrors = [err21];
                  } else {
                    vErrors.push(err21);
                  }
                  errors++;
                }
                if (data.moduleType !== void 0) {
                  let data9 = data.moduleType;
                  if (typeof data9 !== "string") {
                    const err22 = {
                      instancePath: instancePath + "/moduleType",
                      schemaPath: "LiveAndUpcomingListModule/properties/moduleType/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err22];
                    } else {
                      vErrors.push(err22);
                    }
                    errors++;
                  }
                  if ("LIVE_AND_UPCOMING_LIST" !== data9) {
                    const err23 = {
                      instancePath: instancePath + "/moduleType",
                      schemaPath: "LiveAndUpcomingListModule/properties/moduleType/const",
                      keyword: "const",
                      params: {
                        allowedValue: "LIVE_AND_UPCOMING_LIST"
                      },
                      message: "must be equal to constant"
                    };
                    if (vErrors === null) {
                      vErrors = [err23];
                    } else {
                      vErrors.push(err23);
                    }
                    errors++;
                  }
                }
                if (data.heading !== void 0) {
                  if (typeof data.heading !== "string") {
                    const err24 = {
                      instancePath: instancePath + "/heading",
                      schemaPath: "LiveAndUpcomingListModule/properties/heading/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err24];
                    } else {
                      vErrors.push(err24);
                    }
                    errors++;
                  }
                }
                if (data.subHeading !== void 0) {
                  if (typeof data.subHeading !== "string") {
                    const err25 = {
                      instancePath: instancePath + "/subHeading",
                      schemaPath: "LiveAndUpcomingListModule/properties/subHeading/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err25];
                    } else {
                      vErrors.push(err25);
                    }
                    errors++;
                  }
                }
                if (data.layoutType !== void 0) {
                  let data12 = data.layoutType;
                  if (typeof data12 !== "string") {
                    const err26 = {
                      instancePath: instancePath + "/layoutType",
                      schemaPath: "LiveAndUpcomingListModule/properties/layoutType/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err26];
                    } else {
                      vErrors.push(err26);
                    }
                    errors++;
                  }
                  if (!(data12 === "CAROUSEL" || data12 === "GRID")) {
                    const err27 = {
                      instancePath: instancePath + "/layoutType",
                      schemaPath: "LiveAndUpcomingListModule/properties/layoutType/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema85.properties.layoutType.enum
                      },
                      message: "must be equal to one of the allowed values"
                    };
                    if (vErrors === null) {
                      vErrors = [err27];
                    } else {
                      vErrors.push(err27);
                    }
                    errors++;
                  }
                }
                if (data.density !== void 0) {
                  let data13 = data.density;
                  if (typeof data13 !== "string") {
                    const err28 = {
                      instancePath: instancePath + "/density",
                      schemaPath: "LiveAndUpcomingListModule/properties/density/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err28];
                    } else {
                      vErrors.push(err28);
                    }
                    errors++;
                  }
                  if (!(data13 === "NORMAL" || data13 === "DENSE" || data13 === "DENSEST")) {
                    const err29 = {
                      instancePath: instancePath + "/density",
                      schemaPath: "LiveAndUpcomingListModule/properties/density/enum",
                      keyword: "enum",
                      params: {
                        allowedValues: schema85.properties.density.enum
                      },
                      message: "must be equal to one of the allowed values"
                    };
                    if (vErrors === null) {
                      vErrors = [err29];
                    } else {
                      vErrors.push(err29);
                    }
                    errors++;
                  }
                }
                if (data.preferedGridSize !== void 0) {
                  let data14 = data.preferedGridSize;
                  if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
                    if (data14.columns === void 0) {
                      const err30 = {
                        instancePath: instancePath + "/preferedGridSize",
                        schemaPath: "LiveAndUpcomingListModule/properties/preferedGridSize/required",
                        keyword: "required",
                        params: {
                          missingProperty: "columns"
                        },
                        message: "must have required property 'columns'"
                      };
                      if (vErrors === null) {
                        vErrors = [err30];
                      } else {
                        vErrors.push(err30);
                      }
                      errors++;
                    }
                    if (data14.rows === void 0) {
                      const err31 = {
                        instancePath: instancePath + "/preferedGridSize",
                        schemaPath: "LiveAndUpcomingListModule/properties/preferedGridSize/required",
                        keyword: "required",
                        params: {
                          missingProperty: "rows"
                        },
                        message: "must have required property 'rows'"
                      };
                      if (vErrors === null) {
                        vErrors = [err31];
                      } else {
                        vErrors.push(err31);
                      }
                      errors++;
                    }
                    if (data14.columns !== void 0) {
                      let data15 = data14.columns;
                      if (!(typeof data15 == "number" && isFinite(data15))) {
                        const err32 = {
                          instancePath: instancePath + "/preferedGridSize/columns",
                          schemaPath: "LiveAndUpcomingListModule/properties/preferedGridSize/properties/columns/type",
                          keyword: "type",
                          params: {
                            type: "number"
                          },
                          message: "must be number"
                        };
                        if (vErrors === null) {
                          vErrors = [err32];
                        } else {
                          vErrors.push(err32);
                        }
                        errors++;
                      }
                    }
                    if (data14.rows !== void 0) {
                      let data16 = data14.rows;
                      if (!(typeof data16 == "number" && isFinite(data16))) {
                        const err33 = {
                          instancePath: instancePath + "/preferedGridSize/rows",
                          schemaPath: "LiveAndUpcomingListModule/properties/preferedGridSize/properties/rows/type",
                          keyword: "type",
                          params: {
                            type: "number"
                          },
                          message: "must be number"
                        };
                        if (vErrors === null) {
                          vErrors = [err33];
                        } else {
                          vErrors.push(err33);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err34 = {
                      instancePath: instancePath + "/preferedGridSize",
                      schemaPath: "LiveAndUpcomingListModule/properties/preferedGridSize/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err34];
                    } else {
                      vErrors.push(err34);
                    }
                    errors++;
                  }
                }
                if (data.listSource !== void 0) {
                  let data17 = data.listSource;
                  if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                    if (data17.tags !== void 0) {
                      let data18 = data17.tags;
                      if (data18 && typeof data18 == "object" && !Array.isArray(data18)) {
                        if (data18.kind === void 0) {
                          const err35 = {
                            instancePath: instancePath + "/listSource/tags",
                            schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/tags/required",
                            keyword: "required",
                            params: {
                              missingProperty: "kind"
                            },
                            message: "must have required property 'kind'"
                          };
                          if (vErrors === null) {
                            vErrors = [err35];
                          } else {
                            vErrors.push(err35);
                          }
                          errors++;
                        }
                        if (data18.list === void 0) {
                          const err36 = {
                            instancePath: instancePath + "/listSource/tags",
                            schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/tags/required",
                            keyword: "required",
                            params: {
                              missingProperty: "list"
                            },
                            message: "must have required property 'list'"
                          };
                          if (vErrors === null) {
                            vErrors = [err36];
                          } else {
                            vErrors.push(err36);
                          }
                          errors++;
                        }
                        if (data18.kind !== void 0) {
                          let data19 = data18.kind;
                          if (typeof data19 !== "string") {
                            const err37 = {
                              instancePath: instancePath + "/listSource/tags/kind",
                              schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/tags/properties/kind/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err37];
                            } else {
                              vErrors.push(err37);
                            }
                            errors++;
                          }
                          if (!(data19 === "ALL" || data19 === "SOME")) {
                            const err38 = {
                              instancePath: instancePath + "/listSource/tags/kind",
                              schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/tags/properties/kind/enum",
                              keyword: "enum",
                              params: {
                                allowedValues: schema85.properties.listSource.properties.tags.properties.kind.enum
                              },
                              message: "must be equal to one of the allowed values"
                            };
                            if (vErrors === null) {
                              vErrors = [err38];
                            } else {
                              vErrors.push(err38);
                            }
                            errors++;
                          }
                        }
                        if (data18.list !== void 0) {
                          let data20 = data18.list;
                          if (Array.isArray(data20)) {
                            const len1 = data20.length;
                            for (let i1 = 0; i1 < len1; i1++) {
                              if (typeof data20[i1] !== "string") {
                                const err39 = {
                                  instancePath: instancePath + "/listSource/tags/list/" + i1,
                                  schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/tags/properties/list/items/type",
                                  keyword: "type",
                                  params: {
                                    type: "string"
                                  },
                                  message: "must be string"
                                };
                                if (vErrors === null) {
                                  vErrors = [err39];
                                } else {
                                  vErrors.push(err39);
                                }
                                errors++;
                              }
                            }
                          } else {
                            const err40 = {
                              instancePath: instancePath + "/listSource/tags/list",
                              schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/tags/properties/list/type",
                              keyword: "type",
                              params: {
                                type: "array"
                              },
                              message: "must be array"
                            };
                            if (vErrors === null) {
                              vErrors = [err40];
                            } else {
                              vErrors.push(err40);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err41 = {
                          instancePath: instancePath + "/listSource/tags",
                          schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/tags/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        };
                        if (vErrors === null) {
                          vErrors = [err41];
                        } else {
                          vErrors.push(err41);
                        }
                        errors++;
                      }
                    }
                    if (data17.eventId !== void 0) {
                      if (typeof data17.eventId !== "string") {
                        const err42 = {
                          instancePath: instancePath + "/listSource/eventId",
                          schemaPath: "LiveAndUpcomingListModule/properties/listSource/properties/eventId/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err42];
                        } else {
                          vErrors.push(err42);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err43 = {
                      instancePath: instancePath + "/listSource",
                      schemaPath: "LiveAndUpcomingListModule/properties/listSource/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err43];
                    } else {
                      vErrors.push(err43);
                    }
                    errors++;
                  }
                }
                if (data.size !== void 0) {
                  let data23 = data.size;
                  if (!(typeof data23 == "number" && isFinite(data23))) {
                    const err44 = {
                      instancePath: instancePath + "/size",
                      schemaPath: "LiveAndUpcomingListModule/properties/size/type",
                      keyword: "type",
                      params: {
                        type: "number"
                      },
                      message: "must be number"
                    };
                    if (vErrors === null) {
                      vErrors = [err44];
                    } else {
                      vErrors.push(err44);
                    }
                    errors++;
                  }
                }
                if (data.dateRange !== void 0) {
                  let data24 = data.dateRange;
                  if (Array.isArray(data24)) {
                    if (data24.length > 2) {
                      const err45 = {
                        instancePath: instancePath + "/dateRange",
                        schemaPath: "LiveAndUpcomingListModule/properties/dateRange/maxItems",
                        keyword: "maxItems",
                        params: {
                          limit: 2
                        },
                        message: "must NOT have more than 2 items"
                      };
                      if (vErrors === null) {
                        vErrors = [err45];
                      } else {
                        vErrors.push(err45);
                      }
                      errors++;
                    }
                    if (data24.length < 2) {
                      const err46 = {
                        instancePath: instancePath + "/dateRange",
                        schemaPath: "LiveAndUpcomingListModule/properties/dateRange/minItems",
                        keyword: "minItems",
                        params: {
                          limit: 2
                        },
                        message: "must NOT have fewer than 2 items"
                      };
                      if (vErrors === null) {
                        vErrors = [err46];
                      } else {
                        vErrors.push(err46);
                      }
                      errors++;
                    }
                    const len2 = data24.length;
                    for (let i2 = 0; i2 < len2; i2++) {
                      let data25 = data24[i2];
                      const _errs65 = errors;
                      let valid16 = false;
                      const _errs66 = errors;
                      if (typeof data25 !== "string") {
                        const err47 = {
                          instancePath: instancePath + "/dateRange/" + i2,
                          schemaPath: "LiveAndUpcomingListModule/properties/dateRange/items/anyOf/0/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err47];
                        } else {
                          vErrors.push(err47);
                        }
                        errors++;
                      }
                      if ("NOW" !== data25) {
                        const err48 = {
                          instancePath: instancePath + "/dateRange/" + i2,
                          schemaPath: "LiveAndUpcomingListModule/properties/dateRange/items/anyOf/0/const",
                          keyword: "const",
                          params: {
                            allowedValue: "NOW"
                          },
                          message: "must be equal to constant"
                        };
                        if (vErrors === null) {
                          vErrors = [err48];
                        } else {
                          vErrors.push(err48);
                        }
                        errors++;
                      }
                      var _valid1 = _errs66 === errors;
                      valid16 = valid16 || _valid1;
                      if (!valid16) {
                        const _errs68 = errors;
                        if (!(data25 && typeof data25 == "object" && !Array.isArray(data25))) {
                          const err49 = {
                            instancePath: instancePath + "/dateRange/" + i2,
                            schemaPath: "LiveAndUpcomingListModule/properties/dateRange/items/anyOf/1/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          };
                          if (vErrors === null) {
                            vErrors = [err49];
                          } else {
                            vErrors.push(err49);
                          }
                          errors++;
                        }
                        if (typeof data25 === "string") {
                          if (!formats0(data25)) {
                            const err50 = {
                              instancePath: instancePath + "/dateRange/" + i2,
                              schemaPath: "LiveAndUpcomingListModule/properties/dateRange/items/anyOf/1/format",
                              keyword: "format",
                              params: {
                                format: "date-time"
                              },
                              message: 'must match format "date-time"'
                            };
                            if (vErrors === null) {
                              vErrors = [err50];
                            } else {
                              vErrors.push(err50);
                            }
                            errors++;
                          }
                        }
                        var _valid1 = _errs68 === errors;
                        valid16 = valid16 || _valid1;
                        if (!valid16) {
                          const _errs70 = errors;
                          if (data25 !== null) {
                            const err51 = {
                              instancePath: instancePath + "/dateRange/" + i2,
                              schemaPath: "LiveAndUpcomingListModule/properties/dateRange/items/anyOf/2/type",
                              keyword: "type",
                              params: {
                                type: "null"
                              },
                              message: "must be null"
                            };
                            if (vErrors === null) {
                              vErrors = [err51];
                            } else {
                              vErrors.push(err51);
                            }
                            errors++;
                          }
                          var _valid1 = _errs70 === errors;
                          valid16 = valid16 || _valid1;
                        }
                      }
                      if (!valid16) {
                        const err52 = {
                          instancePath: instancePath + "/dateRange/" + i2,
                          schemaPath: "LiveAndUpcomingListModule/properties/dateRange/items/anyOf",
                          keyword: "anyOf",
                          params: {},
                          message: "must match a schema in anyOf"
                        };
                        if (vErrors === null) {
                          vErrors = [err52];
                        } else {
                          vErrors.push(err52);
                        }
                        errors++;
                      } else {
                        errors = _errs65;
                        if (vErrors !== null) {
                          if (_errs65) {
                            vErrors.length = _errs65;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                    }
                  } else {
                    const err53 = {
                      instancePath: instancePath + "/dateRange",
                      schemaPath: "LiveAndUpcomingListModule/properties/dateRange/type",
                      keyword: "type",
                      params: {
                        type: "array"
                      },
                      message: "must be array"
                    };
                    if (vErrors === null) {
                      vErrors = [err53];
                    } else {
                      vErrors.push(err53);
                    }
                    errors++;
                  }
                }
              } else {
                const err54 = {
                  instancePath,
                  schemaPath: "LiveAndUpcomingListModule/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err54];
                } else {
                  vErrors.push(err54);
                }
                errors++;
              }
              var _valid0 = _errs29 === errors;
              valid0 = valid0 || _valid0;
              if (!valid0) {
                const _errs72 = errors;
                if (data && typeof data == "object" && !Array.isArray(data)) {
                  if (data.hideFilter === void 0) {
                    const err55 = {
                      instancePath,
                      schemaPath: "AdSpaceModule/required",
                      keyword: "required",
                      params: {
                        missingProperty: "hideFilter"
                      },
                      message: "must have required property 'hideFilter'"
                    };
                    if (vErrors === null) {
                      vErrors = [err55];
                    } else {
                      vErrors.push(err55);
                    }
                    errors++;
                  }
                  if (data.image === void 0) {
                    const err56 = {
                      instancePath,
                      schemaPath: "AdSpaceModule/required",
                      keyword: "required",
                      params: {
                        missingProperty: "image"
                      },
                      message: "must have required property 'image'"
                    };
                    if (vErrors === null) {
                      vErrors = [err56];
                    } else {
                      vErrors.push(err56);
                    }
                    errors++;
                  }
                  if (data.moduleType === void 0) {
                    const err57 = {
                      instancePath,
                      schemaPath: "AdSpaceModule/required",
                      keyword: "required",
                      params: {
                        missingProperty: "moduleType"
                      },
                      message: "must have required property 'moduleType'"
                    };
                    if (vErrors === null) {
                      vErrors = [err57];
                    } else {
                      vErrors.push(err57);
                    }
                    errors++;
                  }
                  if (data.moduleType !== void 0) {
                    let data26 = data.moduleType;
                    if (typeof data26 !== "string") {
                      const err58 = {
                        instancePath: instancePath + "/moduleType",
                        schemaPath: "AdSpaceModule/properties/moduleType/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err58];
                      } else {
                        vErrors.push(err58);
                      }
                      errors++;
                    }
                    if ("AD_SPACE" !== data26) {
                      const err59 = {
                        instancePath: instancePath + "/moduleType",
                        schemaPath: "AdSpaceModule/properties/moduleType/const",
                        keyword: "const",
                        params: {
                          allowedValue: "AD_SPACE"
                        },
                        message: "must be equal to constant"
                      };
                      if (vErrors === null) {
                        vErrors = [err59];
                      } else {
                        vErrors.push(err59);
                      }
                      errors++;
                    }
                  }
                  if (data.heading !== void 0) {
                    if (typeof data.heading !== "string") {
                      const err60 = {
                        instancePath: instancePath + "/heading",
                        schemaPath: "AdSpaceModule/properties/heading/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err60];
                      } else {
                        vErrors.push(err60);
                      }
                      errors++;
                    }
                  }
                  if (data.subHeading !== void 0) {
                    if (typeof data.subHeading !== "string") {
                      const err61 = {
                        instancePath: instancePath + "/subHeading",
                        schemaPath: "AdSpaceModule/properties/subHeading/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err61];
                      } else {
                        vErrors.push(err61);
                      }
                      errors++;
                    }
                  }
                  if (data.hideFilter !== void 0) {
                    let data29 = data.hideFilter;
                    const _errs82 = errors;
                    let valid19 = false;
                    const _errs83 = errors;
                    if (Array.isArray(data29)) {
                      const len3 = data29.length;
                      for (let i3 = 0; i3 < len3; i3++) {
                        let data30 = data29[i3];
                        if (typeof data30 !== "string") {
                          const err62 = {
                            instancePath: instancePath + "/hideFilter/" + i3,
                            schemaPath: "AdSpaceModule/properties/hideFilter/anyOf/0/items/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err62];
                          } else {
                            vErrors.push(err62);
                          }
                          errors++;
                        }
                        if (!(data30 === "SUBSCRIBED" || data30 === "REGISTERED")) {
                          const err63 = {
                            instancePath: instancePath + "/hideFilter/" + i3,
                            schemaPath: "AdSpaceModule/properties/hideFilter/anyOf/0/items/enum",
                            keyword: "enum",
                            params: {
                              allowedValues: schema20.properties.hideFilter.anyOf[0].items.enum
                            },
                            message: "must be equal to one of the allowed values"
                          };
                          if (vErrors === null) {
                            vErrors = [err63];
                          } else {
                            vErrors.push(err63);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err64 = {
                        instancePath: instancePath + "/hideFilter",
                        schemaPath: "AdSpaceModule/properties/hideFilter/anyOf/0/type",
                        keyword: "type",
                        params: {
                          type: "array"
                        },
                        message: "must be array"
                      };
                      if (vErrors === null) {
                        vErrors = [err64];
                      } else {
                        vErrors.push(err64);
                      }
                      errors++;
                    }
                    var _valid2 = _errs83 === errors;
                    valid19 = valid19 || _valid2;
                    if (!valid19) {
                      const _errs87 = errors;
                      if (data29 !== null) {
                        const err65 = {
                          instancePath: instancePath + "/hideFilter",
                          schemaPath: "AdSpaceModule/properties/hideFilter/anyOf/1/type",
                          keyword: "type",
                          params: {
                            type: "null"
                          },
                          message: "must be null"
                        };
                        if (vErrors === null) {
                          vErrors = [err65];
                        } else {
                          vErrors.push(err65);
                        }
                        errors++;
                      }
                      var _valid2 = _errs87 === errors;
                      valid19 = valid19 || _valid2;
                    }
                    if (!valid19) {
                      const err66 = {
                        instancePath: instancePath + "/hideFilter",
                        schemaPath: "AdSpaceModule/properties/hideFilter/anyOf",
                        keyword: "anyOf",
                        params: {},
                        message: "must match a schema in anyOf"
                      };
                      if (vErrors === null) {
                        vErrors = [err66];
                      } else {
                        vErrors.push(err66);
                      }
                      errors++;
                    } else {
                      errors = _errs82;
                      if (vErrors !== null) {
                        if (_errs82) {
                          vErrors.length = _errs82;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                  }
                  if (data.link !== void 0) {
                    if (typeof data.link !== "string") {
                      const err67 = {
                        instancePath: instancePath + "/link",
                        schemaPath: "AdSpaceModule/properties/link/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err67];
                      } else {
                        vErrors.push(err67);
                      }
                      errors++;
                    }
                  }
                  if (data.internal !== void 0) {
                    if (typeof data.internal !== "boolean") {
                      const err68 = {
                        instancePath: instancePath + "/internal",
                        schemaPath: "AdSpaceModule/properties/internal/type",
                        keyword: "type",
                        params: {
                          type: "boolean"
                        },
                        message: "must be boolean"
                      };
                      if (vErrors === null) {
                        vErrors = [err68];
                      } else {
                        vErrors.push(err68);
                      }
                      errors++;
                    }
                  }
                  if (data.image !== void 0) {
                    let data33 = data.image;
                    if (data33 && typeof data33 == "object" && !Array.isArray(data33)) {
                      if (data33.largeViewport === void 0) {
                        const err69 = {
                          instancePath: instancePath + "/image",
                          schemaPath: "AdSpaceModule/properties/image/required",
                          keyword: "required",
                          params: {
                            missingProperty: "largeViewport"
                          },
                          message: "must have required property 'largeViewport'"
                        };
                        if (vErrors === null) {
                          vErrors = [err69];
                        } else {
                          vErrors.push(err69);
                        }
                        errors++;
                      }
                      if (data33.largeViewport !== void 0) {
                        if (typeof data33.largeViewport !== "string") {
                          const err70 = {
                            instancePath: instancePath + "/image/largeViewport",
                            schemaPath: "AdSpaceModule/properties/image/properties/largeViewport/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err70];
                          } else {
                            vErrors.push(err70);
                          }
                          errors++;
                        }
                      }
                      if (data33.smallViewport !== void 0) {
                        if (typeof data33.smallViewport !== "string") {
                          const err71 = {
                            instancePath: instancePath + "/image/smallViewport",
                            schemaPath: "AdSpaceModule/properties/image/properties/smallViewport/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err71];
                          } else {
                            vErrors.push(err71);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err72 = {
                        instancePath: instancePath + "/image",
                        schemaPath: "AdSpaceModule/properties/image/type",
                        keyword: "type",
                        params: {
                          type: "object"
                        },
                        message: "must be object"
                      };
                      if (vErrors === null) {
                        vErrors = [err72];
                      } else {
                        vErrors.push(err72);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err73 = {
                    instancePath,
                    schemaPath: "AdSpaceModule/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  };
                  if (vErrors === null) {
                    vErrors = [err73];
                  } else {
                    vErrors.push(err73);
                  }
                  errors++;
                }
                var _valid0 = _errs72 === errors;
                valid0 = valid0 || _valid0;
                if (!valid0) {
                  const _errs99 = errors;
                  if (!validate16(data, {
                    instancePath,
                    parentData,
                    parentDataProperty,
                    rootData
                  })) {
                    vErrors = vErrors === null ? validate16.errors : vErrors.concat(validate16.errors);
                    errors = vErrors.length;
                  }
                  var _valid0 = _errs99 === errors;
                  valid0 = valid0 || _valid0;
                }
              }
            }
          }
        }
      }
    }
  }
  if (!valid0) {
    const err74 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err74];
    } else {
      vErrors.push(err74);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate94.errors = vErrors;
  return errors === 0;
}
const PageTab = validate100;
function validate100(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.condition === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "condition"
        },
        message: "must have required property 'condition'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.name === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "name"
        },
        message: "must have required property 'name'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.default === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "default"
        },
        message: "must have required property 'default'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.order === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "order"
        },
        message: "must have required property 'order'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.modules === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "modules"
        },
        message: "must have required property 'modules'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.condition !== void 0) {
      if (data.condition !== null) {
        const err5 = {
          instancePath: instancePath + "/condition",
          schemaPath: "#/properties/condition/type",
          keyword: "type",
          params: {
            type: "null"
          },
          message: "must be null"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err6 = {
          instancePath: instancePath + "/name",
          schemaPath: "#/properties/name/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.icon !== void 0) {
      if (typeof data.icon !== "string") {
        const err7 = {
          instancePath: instancePath + "/icon",
          schemaPath: "#/properties/icon/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.default !== void 0) {
      if (typeof data.default !== "boolean") {
        const err8 = {
          instancePath: instancePath + "/default",
          schemaPath: "#/properties/default/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.order !== void 0) {
      let data4 = data.order;
      if (!(typeof data4 == "number" && isFinite(data4))) {
        const err9 = {
          instancePath: instancePath + "/order",
          schemaPath: "#/properties/order/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.modules !== void 0) {
      let data5 = data.modules;
      if (Array.isArray(data5)) {
        const len0 = data5.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (!validate94(data5[i0], {
            instancePath: instancePath + "/modules/" + i0,
            parentData: data5,
            parentDataProperty: i0,
            rootData
          })) {
            vErrors = vErrors === null ? validate94.errors : vErrors.concat(validate94.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err10 = {
          instancePath: instancePath + "/modules",
          schemaPath: "#/properties/modules/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
  } else {
    const err11 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err11];
    } else {
      vErrors.push(err11);
    }
    errors++;
  }
  validate100.errors = vErrors;
  return errors === 0;
}
const TabbedPageModules = validate102;
function validate102(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      if (!validate100(data[key0], {
        instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
        parentData: data,
        parentDataProperty: key0,
        rootData
      })) {
        vErrors = vErrors === null ? validate100.errors : vErrors.concat(validate100.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  validate102.errors = vErrors;
  return errors === 0;
}
const PageModuleList = validate104;
function validate104(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (Array.isArray(data)) {
    const len0 = data.length;
    for (let i0 = 0; i0 < len0; i0++) {
      if (!validate94(data[i0], {
        instancePath: instancePath + "/" + i0,
        parentData: data,
        parentDataProperty: i0,
        rootData
      })) {
        vErrors = vErrors === null ? validate94.errors : vErrors.concat(validate94.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "array"
      },
      message: "must be array"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  validate104.errors = vErrors;
  return errors === 0;
}
const Page = validate106;
const schema117 = {
  "$id": "Page",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "name": {
      "type": "string"
    },
    "brandingOverride": {
      "type": "object",
      "properties": {
        "accentColor": {
          "type": "string"
        },
        "backgroundColor": {
          "type": "string"
        },
        "themeStyle": {
          "type": "string",
          "enum": ["rounded", "hard"]
        },
        "bannerImages": {
          "type": "object",
          "properties": {
            "3/1": {
              "type": "string"
            },
            "3/4": {
              "type": "string"
            },
            "16/9": {
              "type": "string"
            }
          },
          "required": ["3/1", "3/4", "16/9"]
        },
        "logoImage": {
          "type": "string"
        },
        "contactInformation": {
          "type": "object",
          "properties": {
            "socialMediaLinks": {
              "anyOf": [{
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "type": {
                      "type": "string"
                    },
                    "url": {
                      "type": "string"
                    }
                  },
                  "required": ["type", "url"]
                }
              }, {
                "type": "null"
              }]
            },
            "contactAddressLines": {
              "anyOf": [{
                "type": "array",
                "items": {
                  "type": "string"
                }
              }, {
                "type": "null"
              }]
            },
            "contactPhone": {
              "type": ["string", "null"]
            },
            "contactEmail": {
              "type": ["string", "null"]
            },
            "streamHelpText": {
              "type": ["string", "null"]
            },
            "supportEmail": {
              "type": ["string", "null"]
            },
            "faqLink": {
              "type": ["string", "null"]
            },
            "copyrightNotice": {
              "type": ["string", "null"]
            },
            "privacyPolicy": {
              "anyOf": [{
                "type": "array",
                "items": {
                  "type": "string"
                }
              }, {
                "type": "null"
              }]
            },
            "logoImage": {
              "type": ["string", "null"]
            }
          },
          "required": ["socialMediaLinks", "contactAddressLines", "contactPhone", "contactEmail", "supportEmail", "copyrightNotice"]
        }
      }
    },
    "status": {
      "type": "string",
      "enum": ["PUBLISHED", "DRAFT"]
    },
    "active": {
      "type": "boolean"
    },
    "header": {
      "$ref": "HeaderModule"
    },
    "modules": {
      "anyOf": [{
        "$ref": "TabbedPageModules"
      }, {
        "$ref": "PageModuleList"
      }]
    },
    "metaTags": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "property": {
            "type": "string"
          },
          "content": {
            "type": "string"
          }
        },
        "required": ["property", "content"]
      }
    }
  },
  "required": ["name", "status", "active", "modules"],
  "description": "A page models the layout (order, and content) of a browsable entity (eg: a channel page or organization). The page itself should be abstract enough so that it can be used by multiple target devices (mobile/desktop) and applications (web/mobile app/tv app). Pages will be authored using Backoffice and then eventually Studio."
};
function validate106(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.name === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "name"
        },
        message: "must have required property 'name'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.status === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "status"
        },
        message: "must have required property 'status'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.active === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "active"
        },
        message: "must have required property 'active'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.modules === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "modules"
        },
        message: "must have required property 'modules'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err4 = {
          instancePath: instancePath + "/name",
          schemaPath: "#/properties/name/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.brandingOverride !== void 0) {
      let data1 = data.brandingOverride;
      if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
        if (data1.accentColor !== void 0) {
          if (typeof data1.accentColor !== "string") {
            const err5 = {
              instancePath: instancePath + "/brandingOverride/accentColor",
              schemaPath: "#/properties/brandingOverride/properties/accentColor/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err5];
            } else {
              vErrors.push(err5);
            }
            errors++;
          }
        }
        if (data1.backgroundColor !== void 0) {
          if (typeof data1.backgroundColor !== "string") {
            const err6 = {
              instancePath: instancePath + "/brandingOverride/backgroundColor",
              schemaPath: "#/properties/brandingOverride/properties/backgroundColor/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err6];
            } else {
              vErrors.push(err6);
            }
            errors++;
          }
        }
        if (data1.themeStyle !== void 0) {
          let data4 = data1.themeStyle;
          if (typeof data4 !== "string") {
            const err7 = {
              instancePath: instancePath + "/brandingOverride/themeStyle",
              schemaPath: "#/properties/brandingOverride/properties/themeStyle/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
          }
          if (!(data4 === "rounded" || data4 === "hard")) {
            const err8 = {
              instancePath: instancePath + "/brandingOverride/themeStyle",
              schemaPath: "#/properties/brandingOverride/properties/themeStyle/enum",
              keyword: "enum",
              params: {
                allowedValues: schema117.properties.brandingOverride.properties.themeStyle.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err8];
            } else {
              vErrors.push(err8);
            }
            errors++;
          }
        }
        if (data1.bannerImages !== void 0) {
          let data5 = data1.bannerImages;
          if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
            if (data5["3/1"] === void 0) {
              const err9 = {
                instancePath: instancePath + "/brandingOverride/bannerImages",
                schemaPath: "#/properties/brandingOverride/properties/bannerImages/required",
                keyword: "required",
                params: {
                  missingProperty: "3/1"
                },
                message: "must have required property '3/1'"
              };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            if (data5["3/4"] === void 0) {
              const err10 = {
                instancePath: instancePath + "/brandingOverride/bannerImages",
                schemaPath: "#/properties/brandingOverride/properties/bannerImages/required",
                keyword: "required",
                params: {
                  missingProperty: "3/4"
                },
                message: "must have required property '3/4'"
              };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            if (data5["16/9"] === void 0) {
              const err11 = {
                instancePath: instancePath + "/brandingOverride/bannerImages",
                schemaPath: "#/properties/brandingOverride/properties/bannerImages/required",
                keyword: "required",
                params: {
                  missingProperty: "16/9"
                },
                message: "must have required property '16/9'"
              };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            if (data5["3/1"] !== void 0) {
              if (typeof data5["3/1"] !== "string") {
                const err12 = {
                  instancePath: instancePath + "/brandingOverride/bannerImages/3~11",
                  schemaPath: "#/properties/brandingOverride/properties/bannerImages/properties/3~11/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err12];
                } else {
                  vErrors.push(err12);
                }
                errors++;
              }
            }
            if (data5["3/4"] !== void 0) {
              if (typeof data5["3/4"] !== "string") {
                const err13 = {
                  instancePath: instancePath + "/brandingOverride/bannerImages/3~14",
                  schemaPath: "#/properties/brandingOverride/properties/bannerImages/properties/3~14/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
            }
            if (data5["16/9"] !== void 0) {
              if (typeof data5["16/9"] !== "string") {
                const err14 = {
                  instancePath: instancePath + "/brandingOverride/bannerImages/16~19",
                  schemaPath: "#/properties/brandingOverride/properties/bannerImages/properties/16~19/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
          } else {
            const err15 = {
              instancePath: instancePath + "/brandingOverride/bannerImages",
              schemaPath: "#/properties/brandingOverride/properties/bannerImages/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
        if (data1.logoImage !== void 0) {
          if (typeof data1.logoImage !== "string") {
            const err16 = {
              instancePath: instancePath + "/brandingOverride/logoImage",
              schemaPath: "#/properties/brandingOverride/properties/logoImage/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err16];
            } else {
              vErrors.push(err16);
            }
            errors++;
          }
        }
        if (data1.contactInformation !== void 0) {
          let data10 = data1.contactInformation;
          if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
            if (data10.socialMediaLinks === void 0) {
              const err17 = {
                instancePath: instancePath + "/brandingOverride/contactInformation",
                schemaPath: "#/properties/brandingOverride/properties/contactInformation/required",
                keyword: "required",
                params: {
                  missingProperty: "socialMediaLinks"
                },
                message: "must have required property 'socialMediaLinks'"
              };
              if (vErrors === null) {
                vErrors = [err17];
              } else {
                vErrors.push(err17);
              }
              errors++;
            }
            if (data10.contactAddressLines === void 0) {
              const err18 = {
                instancePath: instancePath + "/brandingOverride/contactInformation",
                schemaPath: "#/properties/brandingOverride/properties/contactInformation/required",
                keyword: "required",
                params: {
                  missingProperty: "contactAddressLines"
                },
                message: "must have required property 'contactAddressLines'"
              };
              if (vErrors === null) {
                vErrors = [err18];
              } else {
                vErrors.push(err18);
              }
              errors++;
            }
            if (data10.contactPhone === void 0) {
              const err19 = {
                instancePath: instancePath + "/brandingOverride/contactInformation",
                schemaPath: "#/properties/brandingOverride/properties/contactInformation/required",
                keyword: "required",
                params: {
                  missingProperty: "contactPhone"
                },
                message: "must have required property 'contactPhone'"
              };
              if (vErrors === null) {
                vErrors = [err19];
              } else {
                vErrors.push(err19);
              }
              errors++;
            }
            if (data10.contactEmail === void 0) {
              const err20 = {
                instancePath: instancePath + "/brandingOverride/contactInformation",
                schemaPath: "#/properties/brandingOverride/properties/contactInformation/required",
                keyword: "required",
                params: {
                  missingProperty: "contactEmail"
                },
                message: "must have required property 'contactEmail'"
              };
              if (vErrors === null) {
                vErrors = [err20];
              } else {
                vErrors.push(err20);
              }
              errors++;
            }
            if (data10.supportEmail === void 0) {
              const err21 = {
                instancePath: instancePath + "/brandingOverride/contactInformation",
                schemaPath: "#/properties/brandingOverride/properties/contactInformation/required",
                keyword: "required",
                params: {
                  missingProperty: "supportEmail"
                },
                message: "must have required property 'supportEmail'"
              };
              if (vErrors === null) {
                vErrors = [err21];
              } else {
                vErrors.push(err21);
              }
              errors++;
            }
            if (data10.copyrightNotice === void 0) {
              const err22 = {
                instancePath: instancePath + "/brandingOverride/contactInformation",
                schemaPath: "#/properties/brandingOverride/properties/contactInformation/required",
                keyword: "required",
                params: {
                  missingProperty: "copyrightNotice"
                },
                message: "must have required property 'copyrightNotice'"
              };
              if (vErrors === null) {
                vErrors = [err22];
              } else {
                vErrors.push(err22);
              }
              errors++;
            }
            if (data10.socialMediaLinks !== void 0) {
              let data11 = data10.socialMediaLinks;
              const _errs24 = errors;
              let valid4 = false;
              const _errs25 = errors;
              if (Array.isArray(data11)) {
                const len0 = data11.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data12 = data11[i0];
                  if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                    if (data12.type === void 0) {
                      const err23 = {
                        instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks/" + i0,
                        schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/required",
                        keyword: "required",
                        params: {
                          missingProperty: "type"
                        },
                        message: "must have required property 'type'"
                      };
                      if (vErrors === null) {
                        vErrors = [err23];
                      } else {
                        vErrors.push(err23);
                      }
                      errors++;
                    }
                    if (data12.url === void 0) {
                      const err24 = {
                        instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks/" + i0,
                        schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/required",
                        keyword: "required",
                        params: {
                          missingProperty: "url"
                        },
                        message: "must have required property 'url'"
                      };
                      if (vErrors === null) {
                        vErrors = [err24];
                      } else {
                        vErrors.push(err24);
                      }
                      errors++;
                    }
                    if (data12.type !== void 0) {
                      if (typeof data12.type !== "string") {
                        const err25 = {
                          instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks/" + i0 + "/type",
                          schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/properties/type/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err25];
                        } else {
                          vErrors.push(err25);
                        }
                        errors++;
                      }
                    }
                    if (data12.url !== void 0) {
                      if (typeof data12.url !== "string") {
                        const err26 = {
                          instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks/" + i0 + "/url",
                          schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/properties/url/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err26];
                        } else {
                          vErrors.push(err26);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err27 = {
                      instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks/" + i0,
                      schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err27];
                    } else {
                      vErrors.push(err27);
                    }
                    errors++;
                  }
                }
              } else {
                const err28 = {
                  instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks",
                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf/0/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err28];
                } else {
                  vErrors.push(err28);
                }
                errors++;
              }
              var _valid0 = _errs25 === errors;
              valid4 = valid4 || _valid0;
              if (!valid4) {
                const _errs33 = errors;
                if (data11 !== null) {
                  const err29 = {
                    instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks",
                    schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf/1/type",
                    keyword: "type",
                    params: {
                      type: "null"
                    },
                    message: "must be null"
                  };
                  if (vErrors === null) {
                    vErrors = [err29];
                  } else {
                    vErrors.push(err29);
                  }
                  errors++;
                }
                var _valid0 = _errs33 === errors;
                valid4 = valid4 || _valid0;
              }
              if (!valid4) {
                const err30 = {
                  instancePath: instancePath + "/brandingOverride/contactInformation/socialMediaLinks",
                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/socialMediaLinks/anyOf",
                  keyword: "anyOf",
                  params: {},
                  message: "must match a schema in anyOf"
                };
                if (vErrors === null) {
                  vErrors = [err30];
                } else {
                  vErrors.push(err30);
                }
                errors++;
              } else {
                errors = _errs24;
                if (vErrors !== null) {
                  if (_errs24) {
                    vErrors.length = _errs24;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data10.contactAddressLines !== void 0) {
              let data15 = data10.contactAddressLines;
              const _errs36 = errors;
              let valid8 = false;
              const _errs37 = errors;
              if (Array.isArray(data15)) {
                const len1 = data15.length;
                for (let i1 = 0; i1 < len1; i1++) {
                  if (typeof data15[i1] !== "string") {
                    const err31 = {
                      instancePath: instancePath + "/brandingOverride/contactInformation/contactAddressLines/" + i1,
                      schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/contactAddressLines/anyOf/0/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err31];
                    } else {
                      vErrors.push(err31);
                    }
                    errors++;
                  }
                }
              } else {
                const err32 = {
                  instancePath: instancePath + "/brandingOverride/contactInformation/contactAddressLines",
                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/contactAddressLines/anyOf/0/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err32];
                } else {
                  vErrors.push(err32);
                }
                errors++;
              }
              var _valid1 = _errs37 === errors;
              valid8 = valid8 || _valid1;
              if (!valid8) {
                const _errs41 = errors;
                if (data15 !== null) {
                  const err33 = {
                    instancePath: instancePath + "/brandingOverride/contactInformation/contactAddressLines",
                    schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/contactAddressLines/anyOf/1/type",
                    keyword: "type",
                    params: {
                      type: "null"
                    },
                    message: "must be null"
                  };
                  if (vErrors === null) {
                    vErrors = [err33];
                  } else {
                    vErrors.push(err33);
                  }
                  errors++;
                }
                var _valid1 = _errs41 === errors;
                valid8 = valid8 || _valid1;
              }
              if (!valid8) {
                const err34 = {
                  instancePath: instancePath + "/brandingOverride/contactInformation/contactAddressLines",
                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/contactAddressLines/anyOf",
                  keyword: "anyOf",
                  params: {},
                  message: "must match a schema in anyOf"
                };
                if (vErrors === null) {
                  vErrors = [err34];
                } else {
                  vErrors.push(err34);
                }
                errors++;
              } else {
                errors = _errs36;
                if (vErrors !== null) {
                  if (_errs36) {
                    vErrors.length = _errs36;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data10.contactPhone !== void 0) {
              let data17 = data10.contactPhone;
              if (typeof data17 !== "string" && data17 !== null) {
                const err35 = {
                  instancePath: instancePath + "/brandingOverride/contactInformation/contactPhone",
                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/contactPhone/type",
                  keyword: "type",
                  params: {
                    type: schema117.properties.brandingOverride.properties.contactInformation.properties.contactPhone.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err35];
                } else {
                  vErrors.push(err35);
                }
                errors++;
              }
            }
            if (data10.contactEmail !== void 0) {
              let data18 = data10.contactEmail;
              if (typeof data18 !== "string" && data18 !== null) {
                const err36 = {
                  instancePath: instancePath + "/brandingOverride/contactInformation/contactEmail",
                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/contactEmail/type",
                  keyword: "type",
                  params: {
                    type: schema117.properties.brandingOverride.properties.contactInformation.properties.contactEmail.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err36];
                } else {
                  vErrors.push(err36);
                }
                errors++;
              }
            }
            if (data10.streamHelpText !== void 0) {
              let data19 = data10.streamHelpText;
              if (typeof data19 !== "string" && data19 !== null) {
                const err37 = {
                  instancePath: instancePath + "/brandingOverride/contactInformation/streamHelpText",
                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/streamHelpText/type",
                  keyword: "type",
                  params: {
                    type: schema117.properties.brandingOverride.properties.contactInformation.properties.streamHelpText.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err37];
                } else {
                  vErrors.push(err37);
                }
                errors++;
              }
            }
            if (data10.supportEmail !== void 0) {
              let data20 = data10.supportEmail;
              if (typeof data20 !== "string" && data20 !== null) {
                const err38 = {
                  instancePath: instancePath + "/brandingOverride/contactInformation/supportEmail",
                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/supportEmail/type",
                  keyword: "type",
                  params: {
                    type: schema117.properties.brandingOverride.properties.contactInformation.properties.supportEmail.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err38];
                } else {
                  vErrors.push(err38);
                }
                errors++;
              }
            }
            if (data10.faqLink !== void 0) {
              let data21 = data10.faqLink;
              if (typeof data21 !== "string" && data21 !== null) {
                const err39 = {
                  instancePath: instancePath + "/brandingOverride/contactInformation/faqLink",
                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/faqLink/type",
                  keyword: "type",
                  params: {
                    type: schema117.properties.brandingOverride.properties.contactInformation.properties.faqLink.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err39];
                } else {
                  vErrors.push(err39);
                }
                errors++;
              }
            }
            if (data10.copyrightNotice !== void 0) {
              let data22 = data10.copyrightNotice;
              if (typeof data22 !== "string" && data22 !== null) {
                const err40 = {
                  instancePath: instancePath + "/brandingOverride/contactInformation/copyrightNotice",
                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/copyrightNotice/type",
                  keyword: "type",
                  params: {
                    type: schema117.properties.brandingOverride.properties.contactInformation.properties.copyrightNotice.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err40];
                } else {
                  vErrors.push(err40);
                }
                errors++;
              }
            }
            if (data10.privacyPolicy !== void 0) {
              let data23 = data10.privacyPolicy;
              const _errs56 = errors;
              let valid11 = false;
              const _errs57 = errors;
              if (Array.isArray(data23)) {
                const len2 = data23.length;
                for (let i2 = 0; i2 < len2; i2++) {
                  if (typeof data23[i2] !== "string") {
                    const err41 = {
                      instancePath: instancePath + "/brandingOverride/contactInformation/privacyPolicy/" + i2,
                      schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/privacyPolicy/anyOf/0/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err41];
                    } else {
                      vErrors.push(err41);
                    }
                    errors++;
                  }
                }
              } else {
                const err42 = {
                  instancePath: instancePath + "/brandingOverride/contactInformation/privacyPolicy",
                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/privacyPolicy/anyOf/0/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err42];
                } else {
                  vErrors.push(err42);
                }
                errors++;
              }
              var _valid2 = _errs57 === errors;
              valid11 = valid11 || _valid2;
              if (!valid11) {
                const _errs61 = errors;
                if (data23 !== null) {
                  const err43 = {
                    instancePath: instancePath + "/brandingOverride/contactInformation/privacyPolicy",
                    schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/privacyPolicy/anyOf/1/type",
                    keyword: "type",
                    params: {
                      type: "null"
                    },
                    message: "must be null"
                  };
                  if (vErrors === null) {
                    vErrors = [err43];
                  } else {
                    vErrors.push(err43);
                  }
                  errors++;
                }
                var _valid2 = _errs61 === errors;
                valid11 = valid11 || _valid2;
              }
              if (!valid11) {
                const err44 = {
                  instancePath: instancePath + "/brandingOverride/contactInformation/privacyPolicy",
                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/privacyPolicy/anyOf",
                  keyword: "anyOf",
                  params: {},
                  message: "must match a schema in anyOf"
                };
                if (vErrors === null) {
                  vErrors = [err44];
                } else {
                  vErrors.push(err44);
                }
                errors++;
              } else {
                errors = _errs56;
                if (vErrors !== null) {
                  if (_errs56) {
                    vErrors.length = _errs56;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data10.logoImage !== void 0) {
              let data25 = data10.logoImage;
              if (typeof data25 !== "string" && data25 !== null) {
                const err45 = {
                  instancePath: instancePath + "/brandingOverride/contactInformation/logoImage",
                  schemaPath: "#/properties/brandingOverride/properties/contactInformation/properties/logoImage/type",
                  keyword: "type",
                  params: {
                    type: schema117.properties.brandingOverride.properties.contactInformation.properties.logoImage.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err45];
                } else {
                  vErrors.push(err45);
                }
                errors++;
              }
            }
          } else {
            const err46 = {
              instancePath: instancePath + "/brandingOverride/contactInformation",
              schemaPath: "#/properties/brandingOverride/properties/contactInformation/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err46];
            } else {
              vErrors.push(err46);
            }
            errors++;
          }
        }
      } else {
        const err47 = {
          instancePath: instancePath + "/brandingOverride",
          schemaPath: "#/properties/brandingOverride/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err47];
        } else {
          vErrors.push(err47);
        }
        errors++;
      }
    }
    if (data.status !== void 0) {
      let data26 = data.status;
      if (typeof data26 !== "string") {
        const err48 = {
          instancePath: instancePath + "/status",
          schemaPath: "#/properties/status/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err48];
        } else {
          vErrors.push(err48);
        }
        errors++;
      }
      if (!(data26 === "PUBLISHED" || data26 === "DRAFT")) {
        const err49 = {
          instancePath: instancePath + "/status",
          schemaPath: "#/properties/status/enum",
          keyword: "enum",
          params: {
            allowedValues: schema117.properties.status.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err49];
        } else {
          vErrors.push(err49);
        }
        errors++;
      }
    }
    if (data.active !== void 0) {
      if (typeof data.active !== "boolean") {
        const err50 = {
          instancePath: instancePath + "/active",
          schemaPath: "#/properties/active/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err50];
        } else {
          vErrors.push(err50);
        }
        errors++;
      }
    }
    if (data.header !== void 0) {
      if (!validate67(data.header, {
        instancePath: instancePath + "/header",
        parentData: data,
        parentDataProperty: "header",
        rootData
      })) {
        vErrors = vErrors === null ? validate67.errors : vErrors.concat(validate67.errors);
        errors = vErrors.length;
      }
    }
    if (data.modules !== void 0) {
      let data29 = data.modules;
      const _errs71 = errors;
      let valid14 = false;
      const _errs72 = errors;
      if (!validate102(data29, {
        instancePath: instancePath + "/modules",
        parentData: data,
        parentDataProperty: "modules",
        rootData
      })) {
        vErrors = vErrors === null ? validate102.errors : vErrors.concat(validate102.errors);
        errors = vErrors.length;
      }
      var _valid3 = _errs72 === errors;
      valid14 = valid14 || _valid3;
      if (!valid14) {
        const _errs73 = errors;
        if (!validate104(data29, {
          instancePath: instancePath + "/modules",
          parentData: data,
          parentDataProperty: "modules",
          rootData
        })) {
          vErrors = vErrors === null ? validate104.errors : vErrors.concat(validate104.errors);
          errors = vErrors.length;
        }
        var _valid3 = _errs73 === errors;
        valid14 = valid14 || _valid3;
      }
      if (!valid14) {
        const err51 = {
          instancePath: instancePath + "/modules",
          schemaPath: "#/properties/modules/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err51];
        } else {
          vErrors.push(err51);
        }
        errors++;
      } else {
        errors = _errs71;
        if (vErrors !== null) {
          if (_errs71) {
            vErrors.length = _errs71;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.metaTags !== void 0) {
      let data30 = data.metaTags;
      if (Array.isArray(data30)) {
        const len3 = data30.length;
        for (let i3 = 0; i3 < len3; i3++) {
          let data31 = data30[i3];
          if (data31 && typeof data31 == "object" && !Array.isArray(data31)) {
            if (data31.property === void 0) {
              const err52 = {
                instancePath: instancePath + "/metaTags/" + i3,
                schemaPath: "#/properties/metaTags/items/required",
                keyword: "required",
                params: {
                  missingProperty: "property"
                },
                message: "must have required property 'property'"
              };
              if (vErrors === null) {
                vErrors = [err52];
              } else {
                vErrors.push(err52);
              }
              errors++;
            }
            if (data31.content === void 0) {
              const err53 = {
                instancePath: instancePath + "/metaTags/" + i3,
                schemaPath: "#/properties/metaTags/items/required",
                keyword: "required",
                params: {
                  missingProperty: "content"
                },
                message: "must have required property 'content'"
              };
              if (vErrors === null) {
                vErrors = [err53];
              } else {
                vErrors.push(err53);
              }
              errors++;
            }
            if (data31.property !== void 0) {
              if (typeof data31.property !== "string") {
                const err54 = {
                  instancePath: instancePath + "/metaTags/" + i3 + "/property",
                  schemaPath: "#/properties/metaTags/items/properties/property/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err54];
                } else {
                  vErrors.push(err54);
                }
                errors++;
              }
            }
            if (data31.content !== void 0) {
              if (typeof data31.content !== "string") {
                const err55 = {
                  instancePath: instancePath + "/metaTags/" + i3 + "/content",
                  schemaPath: "#/properties/metaTags/items/properties/content/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err55];
                } else {
                  vErrors.push(err55);
                }
                errors++;
              }
            }
          } else {
            const err56 = {
              instancePath: instancePath + "/metaTags/" + i3,
              schemaPath: "#/properties/metaTags/items/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err56];
            } else {
              vErrors.push(err56);
            }
            errors++;
          }
        }
      } else {
        const err57 = {
          instancePath: instancePath + "/metaTags",
          schemaPath: "#/properties/metaTags/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err57];
        } else {
          vErrors.push(err57);
        }
        errors++;
      }
    }
  } else {
    const err58 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err58];
    } else {
      vErrors.push(err58);
    }
    errors++;
  }
  validate106.errors = vErrors;
  return errors === 0;
}
const NamedTagType = validate110;
const schema118 = {
  "$id": "NamedTagType",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["EVENT", "ATHLETE", "PLACE", "TOURNAMENT", "TEAM", "SEASON"]
};
function validate110(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (!(data === "EVENT" || data === "ATHLETE" || data === "PLACE" || data === "TOURNAMENT" || data === "TEAM" || data === "SEASON")) {
    const err1 = {
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema118.enum
      },
      message: "must be equal to one of the allowed values"
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate110.errors = vErrors;
  return errors === 0;
}
const NamedTag = validate111;
const schema119 = {
  "$id": "NamedTag",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "name": {
      "type": "string"
    },
    "displayName": {
      "type": ["string", "null"]
    },
    "description": {
      "type": "string"
    },
    "logo": {
      "type": "string"
    },
    "cover": {
      "type": ["string", "null"]
    },
    "url": {
      "type": "string"
    },
    "type": {
      "$ref": "NamedTagType"
    },
    "pages": {
      "anyOf": [{
        "type": "array",
        "items": {
          "$ref": "Page"
        }
      }, {
        "type": "null"
      }]
    },
    "metaData": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "property": {
            "type": "string"
          },
          "content": {
            "type": "string"
          }
        },
        "required": ["property", "content"]
      }
    }
  },
  "required": ["name", "displayName", "description", "logo", "cover", "url", "type", "pages", "metaData"],
  "description": "Named tags add context and information to specific tags."
};
function validate111(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.name === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "name"
        },
        message: "must have required property 'name'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.displayName === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "displayName"
        },
        message: "must have required property 'displayName'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.description === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "description"
        },
        message: "must have required property 'description'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.logo === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "logo"
        },
        message: "must have required property 'logo'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.cover === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "cover"
        },
        message: "must have required property 'cover'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.url === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "url"
        },
        message: "must have required property 'url'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.type === void 0) {
      const err6 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.pages === void 0) {
      const err7 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "pages"
        },
        message: "must have required property 'pages'"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.metaData === void 0) {
      const err8 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "metaData"
        },
        message: "must have required property 'metaData'"
      };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err9 = {
          instancePath: instancePath + "/name",
          schemaPath: "#/properties/name/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.displayName !== void 0) {
      let data1 = data.displayName;
      if (typeof data1 !== "string" && data1 !== null) {
        const err10 = {
          instancePath: instancePath + "/displayName",
          schemaPath: "#/properties/displayName/type",
          keyword: "type",
          params: {
            type: schema119.properties.displayName.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.description !== void 0) {
      if (typeof data.description !== "string") {
        const err11 = {
          instancePath: instancePath + "/description",
          schemaPath: "#/properties/description/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.logo !== void 0) {
      if (typeof data.logo !== "string") {
        const err12 = {
          instancePath: instancePath + "/logo",
          schemaPath: "#/properties/logo/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.cover !== void 0) {
      let data4 = data.cover;
      if (typeof data4 !== "string" && data4 !== null) {
        const err13 = {
          instancePath: instancePath + "/cover",
          schemaPath: "#/properties/cover/type",
          keyword: "type",
          params: {
            type: schema119.properties.cover.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.url !== void 0) {
      if (typeof data.url !== "string") {
        const err14 = {
          instancePath: instancePath + "/url",
          schemaPath: "#/properties/url/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.type !== void 0) {
      let data6 = data.type;
      if (typeof data6 !== "string") {
        const err15 = {
          instancePath: instancePath + "/type",
          schemaPath: "NamedTagType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
      if (!(data6 === "EVENT" || data6 === "ATHLETE" || data6 === "PLACE" || data6 === "TOURNAMENT" || data6 === "TEAM" || data6 === "SEASON")) {
        const err16 = {
          instancePath: instancePath + "/type",
          schemaPath: "NamedTagType/enum",
          keyword: "enum",
          params: {
            allowedValues: schema118.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.pages !== void 0) {
      let data7 = data.pages;
      const _errs17 = errors;
      let valid2 = false;
      const _errs18 = errors;
      if (Array.isArray(data7)) {
        const len0 = data7.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (!validate106(data7[i0], {
            instancePath: instancePath + "/pages/" + i0,
            parentData: data7,
            parentDataProperty: i0,
            rootData
          })) {
            vErrors = vErrors === null ? validate106.errors : vErrors.concat(validate106.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err17 = {
          instancePath: instancePath + "/pages",
          schemaPath: "#/properties/pages/anyOf/0/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
      var _valid0 = _errs18 === errors;
      valid2 = valid2 || _valid0;
      if (!valid2) {
        const _errs21 = errors;
        if (data7 !== null) {
          const err18 = {
            instancePath: instancePath + "/pages",
            schemaPath: "#/properties/pages/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        var _valid0 = _errs21 === errors;
        valid2 = valid2 || _valid0;
      }
      if (!valid2) {
        const err19 = {
          instancePath: instancePath + "/pages",
          schemaPath: "#/properties/pages/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      } else {
        errors = _errs17;
        if (vErrors !== null) {
          if (_errs17) {
            vErrors.length = _errs17;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.metaData !== void 0) {
      let data9 = data.metaData;
      if (Array.isArray(data9)) {
        const len1 = data9.length;
        for (let i1 = 0; i1 < len1; i1++) {
          let data10 = data9[i1];
          if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
            if (data10.property === void 0) {
              const err20 = {
                instancePath: instancePath + "/metaData/" + i1,
                schemaPath: "#/properties/metaData/items/required",
                keyword: "required",
                params: {
                  missingProperty: "property"
                },
                message: "must have required property 'property'"
              };
              if (vErrors === null) {
                vErrors = [err20];
              } else {
                vErrors.push(err20);
              }
              errors++;
            }
            if (data10.content === void 0) {
              const err21 = {
                instancePath: instancePath + "/metaData/" + i1,
                schemaPath: "#/properties/metaData/items/required",
                keyword: "required",
                params: {
                  missingProperty: "content"
                },
                message: "must have required property 'content'"
              };
              if (vErrors === null) {
                vErrors = [err21];
              } else {
                vErrors.push(err21);
              }
              errors++;
            }
            if (data10.property !== void 0) {
              if (typeof data10.property !== "string") {
                const err22 = {
                  instancePath: instancePath + "/metaData/" + i1 + "/property",
                  schemaPath: "#/properties/metaData/items/properties/property/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err22];
                } else {
                  vErrors.push(err22);
                }
                errors++;
              }
            }
            if (data10.content !== void 0) {
              if (typeof data10.content !== "string") {
                const err23 = {
                  instancePath: instancePath + "/metaData/" + i1 + "/content",
                  schemaPath: "#/properties/metaData/items/properties/content/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
            }
          } else {
            const err24 = {
              instancePath: instancePath + "/metaData/" + i1,
              schemaPath: "#/properties/metaData/items/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          }
        }
      } else {
        const err25 = {
          instancePath: instancePath + "/metaData",
          schemaPath: "#/properties/metaData/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err25];
        } else {
          vErrors.push(err25);
        }
        errors++;
      }
    }
  } else {
    const err26 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err26];
    } else {
      vErrors.push(err26);
    }
    errors++;
  }
  validate111.errors = vErrors;
  return errors === 0;
}
const LinkNavigationResource = validate113;
function validate113(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.label === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "label"
        },
        message: "must have required property 'label'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.linkType === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "linkType"
        },
        message: "must have required property 'linkType'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.type === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.url === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "url"
        },
        message: "must have required property 'url'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.linkType !== void 0) {
      let data0 = data.linkType;
      if (typeof data0 !== "string") {
        const err4 = {
          instancePath: instancePath + "/linkType",
          schemaPath: "#/anyOf/0/properties/linkType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if ("url" !== data0) {
        const err5 = {
          instancePath: instancePath + "/linkType",
          schemaPath: "#/anyOf/0/properties/linkType/const",
          keyword: "const",
          params: {
            allowedValue: "url"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.url !== void 0) {
      if (typeof data.url !== "string") {
        const err6 = {
          instancePath: instancePath + "/url",
          schemaPath: "#/anyOf/0/properties/url/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.type !== void 0) {
      let data2 = data.type;
      if (typeof data2 !== "string") {
        const err7 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/anyOf/0/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if ("LINK" !== data2) {
        const err8 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/anyOf/0/properties/type/const",
          keyword: "const",
          params: {
            allowedValue: "LINK"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.label !== void 0) {
      if (typeof data.label !== "string") {
        const err9 = {
          instancePath: instancePath + "/label",
          schemaPath: "#/anyOf/0/properties/label/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.external !== void 0) {
      if (typeof data.external !== "boolean") {
        const err10 = {
          instancePath: instancePath + "/external",
          schemaPath: "#/anyOf/0/properties/external/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
  } else {
    const err11 = {
      instancePath,
      schemaPath: "#/anyOf/0/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err11];
    } else {
      vErrors.push(err11);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs13 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.label === void 0) {
        const err12 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "label"
          },
          message: "must have required property 'label'"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
      if (data.linkType === void 0) {
        const err13 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "linkType"
          },
          message: "must have required property 'linkType'"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
      if (data.pageId === void 0) {
        const err14 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "pageId"
          },
          message: "must have required property 'pageId'"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
      if (data.type === void 0) {
        const err15 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "type"
          },
          message: "must have required property 'type'"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
      if (data.linkType !== void 0) {
        let data5 = data.linkType;
        if (typeof data5 !== "string") {
          const err16 = {
            instancePath: instancePath + "/linkType",
            schemaPath: "#/anyOf/1/properties/linkType/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
        if ("page" !== data5) {
          const err17 = {
            instancePath: instancePath + "/linkType",
            schemaPath: "#/anyOf/1/properties/linkType/const",
            keyword: "const",
            params: {
              allowedValue: "page"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
      }
      if (data.pageId !== void 0) {
        if (typeof data.pageId !== "string") {
          const err18 = {
            instancePath: instancePath + "/pageId",
            schemaPath: "#/anyOf/1/properties/pageId/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
      }
      if (data.type !== void 0) {
        let data7 = data.type;
        if (typeof data7 !== "string") {
          const err19 = {
            instancePath: instancePath + "/type",
            schemaPath: "#/anyOf/1/properties/type/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if ("LINK" !== data7) {
          const err20 = {
            instancePath: instancePath + "/type",
            schemaPath: "#/anyOf/1/properties/type/const",
            keyword: "const",
            params: {
              allowedValue: "LINK"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
      }
      if (data.label !== void 0) {
        if (typeof data.label !== "string") {
          const err21 = {
            instancePath: instancePath + "/label",
            schemaPath: "#/anyOf/1/properties/label/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
      }
      if (data.external !== void 0) {
        if (typeof data.external !== "boolean") {
          const err22 = {
            instancePath: instancePath + "/external",
            schemaPath: "#/anyOf/1/properties/external/type",
            keyword: "type",
            params: {
              type: "boolean"
            },
            message: "must be boolean"
          };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
      }
    } else {
      const err23 = {
        instancePath,
        schemaPath: "#/anyOf/1/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err23];
      } else {
        vErrors.push(err23);
      }
      errors++;
    }
    var _valid0 = _errs13 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs25 = errors;
      if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.eventId === void 0) {
          const err24 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "eventId"
            },
            message: "must have required property 'eventId'"
          };
          if (vErrors === null) {
            vErrors = [err24];
          } else {
            vErrors.push(err24);
          }
          errors++;
        }
        if (data.label === void 0) {
          const err25 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "label"
            },
            message: "must have required property 'label'"
          };
          if (vErrors === null) {
            vErrors = [err25];
          } else {
            vErrors.push(err25);
          }
          errors++;
        }
        if (data.linkType === void 0) {
          const err26 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "linkType"
            },
            message: "must have required property 'linkType'"
          };
          if (vErrors === null) {
            vErrors = [err26];
          } else {
            vErrors.push(err26);
          }
          errors++;
        }
        if (data.type === void 0) {
          const err27 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "type"
            },
            message: "must have required property 'type'"
          };
          if (vErrors === null) {
            vErrors = [err27];
          } else {
            vErrors.push(err27);
          }
          errors++;
        }
        if (data.linkType !== void 0) {
          let data10 = data.linkType;
          if (typeof data10 !== "string") {
            const err28 = {
              instancePath: instancePath + "/linkType",
              schemaPath: "#/anyOf/2/properties/linkType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err28];
            } else {
              vErrors.push(err28);
            }
            errors++;
          }
          if ("event" !== data10) {
            const err29 = {
              instancePath: instancePath + "/linkType",
              schemaPath: "#/anyOf/2/properties/linkType/const",
              keyword: "const",
              params: {
                allowedValue: "event"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err29];
            } else {
              vErrors.push(err29);
            }
            errors++;
          }
        }
        if (data.eventId !== void 0) {
          if (typeof data.eventId !== "string") {
            const err30 = {
              instancePath: instancePath + "/eventId",
              schemaPath: "#/anyOf/2/properties/eventId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err30];
            } else {
              vErrors.push(err30);
            }
            errors++;
          }
        }
        if (data.type !== void 0) {
          let data12 = data.type;
          if (typeof data12 !== "string") {
            const err31 = {
              instancePath: instancePath + "/type",
              schemaPath: "#/anyOf/2/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
          if ("LINK" !== data12) {
            const err32 = {
              instancePath: instancePath + "/type",
              schemaPath: "#/anyOf/2/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "LINK"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err32];
            } else {
              vErrors.push(err32);
            }
            errors++;
          }
        }
        if (data.label !== void 0) {
          if (typeof data.label !== "string") {
            const err33 = {
              instancePath: instancePath + "/label",
              schemaPath: "#/anyOf/2/properties/label/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err33];
            } else {
              vErrors.push(err33);
            }
            errors++;
          }
        }
        if (data.external !== void 0) {
          if (typeof data.external !== "boolean") {
            const err34 = {
              instancePath: instancePath + "/external",
              schemaPath: "#/anyOf/2/properties/external/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err34];
            } else {
              vErrors.push(err34);
            }
            errors++;
          }
        }
      } else {
        const err35 = {
          instancePath,
          schemaPath: "#/anyOf/2/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err35];
        } else {
          vErrors.push(err35);
        }
        errors++;
      }
      var _valid0 = _errs25 === errors;
      valid0 = valid0 || _valid0;
      if (!valid0) {
        const _errs37 = errors;
        if (data && typeof data == "object" && !Array.isArray(data)) {
          if (data.label === void 0) {
            const err36 = {
              instancePath,
              schemaPath: "#/anyOf/3/required",
              keyword: "required",
              params: {
                missingProperty: "label"
              },
              message: "must have required property 'label'"
            };
            if (vErrors === null) {
              vErrors = [err36];
            } else {
              vErrors.push(err36);
            }
            errors++;
          }
          if (data.linkType === void 0) {
            const err37 = {
              instancePath,
              schemaPath: "#/anyOf/3/required",
              keyword: "required",
              params: {
                missingProperty: "linkType"
              },
              message: "must have required property 'linkType'"
            };
            if (vErrors === null) {
              vErrors = [err37];
            } else {
              vErrors.push(err37);
            }
            errors++;
          }
          if (data.type === void 0) {
            const err38 = {
              instancePath,
              schemaPath: "#/anyOf/3/required",
              keyword: "required",
              params: {
                missingProperty: "type"
              },
              message: "must have required property 'type'"
            };
            if (vErrors === null) {
              vErrors = [err38];
            } else {
              vErrors.push(err38);
            }
            errors++;
          }
          if (data.videoId === void 0) {
            const err39 = {
              instancePath,
              schemaPath: "#/anyOf/3/required",
              keyword: "required",
              params: {
                missingProperty: "videoId"
              },
              message: "must have required property 'videoId'"
            };
            if (vErrors === null) {
              vErrors = [err39];
            } else {
              vErrors.push(err39);
            }
            errors++;
          }
          if (data.linkType !== void 0) {
            let data15 = data.linkType;
            if (typeof data15 !== "string") {
              const err40 = {
                instancePath: instancePath + "/linkType",
                schemaPath: "#/anyOf/3/properties/linkType/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err40];
              } else {
                vErrors.push(err40);
              }
              errors++;
            }
            if ("video" !== data15) {
              const err41 = {
                instancePath: instancePath + "/linkType",
                schemaPath: "#/anyOf/3/properties/linkType/const",
                keyword: "const",
                params: {
                  allowedValue: "video"
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err41];
              } else {
                vErrors.push(err41);
              }
              errors++;
            }
          }
          if (data.videoId !== void 0) {
            if (typeof data.videoId !== "string") {
              const err42 = {
                instancePath: instancePath + "/videoId",
                schemaPath: "#/anyOf/3/properties/videoId/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err42];
              } else {
                vErrors.push(err42);
              }
              errors++;
            }
          }
          if (data.type !== void 0) {
            let data17 = data.type;
            if (typeof data17 !== "string") {
              const err43 = {
                instancePath: instancePath + "/type",
                schemaPath: "#/anyOf/3/properties/type/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err43];
              } else {
                vErrors.push(err43);
              }
              errors++;
            }
            if ("LINK" !== data17) {
              const err44 = {
                instancePath: instancePath + "/type",
                schemaPath: "#/anyOf/3/properties/type/const",
                keyword: "const",
                params: {
                  allowedValue: "LINK"
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err44];
              } else {
                vErrors.push(err44);
              }
              errors++;
            }
          }
          if (data.label !== void 0) {
            if (typeof data.label !== "string") {
              const err45 = {
                instancePath: instancePath + "/label",
                schemaPath: "#/anyOf/3/properties/label/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err45];
              } else {
                vErrors.push(err45);
              }
              errors++;
            }
          }
          if (data.external !== void 0) {
            if (typeof data.external !== "boolean") {
              const err46 = {
                instancePath: instancePath + "/external",
                schemaPath: "#/anyOf/3/properties/external/type",
                keyword: "type",
                params: {
                  type: "boolean"
                },
                message: "must be boolean"
              };
              if (vErrors === null) {
                vErrors = [err46];
              } else {
                vErrors.push(err46);
              }
              errors++;
            }
          }
        } else {
          const err47 = {
            instancePath,
            schemaPath: "#/anyOf/3/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err47];
          } else {
            vErrors.push(err47);
          }
          errors++;
        }
        var _valid0 = _errs37 === errors;
        valid0 = valid0 || _valid0;
        if (!valid0) {
          const _errs49 = errors;
          if (data && typeof data == "object" && !Array.isArray(data)) {
            if (data.label === void 0) {
              const err48 = {
                instancePath,
                schemaPath: "#/anyOf/4/required",
                keyword: "required",
                params: {
                  missingProperty: "label"
                },
                message: "must have required property 'label'"
              };
              if (vErrors === null) {
                vErrors = [err48];
              } else {
                vErrors.push(err48);
              }
              errors++;
            }
            if (data.linkType === void 0) {
              const err49 = {
                instancePath,
                schemaPath: "#/anyOf/4/required",
                keyword: "required",
                params: {
                  missingProperty: "linkType"
                },
                message: "must have required property 'linkType'"
              };
              if (vErrors === null) {
                vErrors = [err49];
              } else {
                vErrors.push(err49);
              }
              errors++;
            }
            if (data.tagName === void 0) {
              const err50 = {
                instancePath,
                schemaPath: "#/anyOf/4/required",
                keyword: "required",
                params: {
                  missingProperty: "tagName"
                },
                message: "must have required property 'tagName'"
              };
              if (vErrors === null) {
                vErrors = [err50];
              } else {
                vErrors.push(err50);
              }
              errors++;
            }
            if (data.type === void 0) {
              const err51 = {
                instancePath,
                schemaPath: "#/anyOf/4/required",
                keyword: "required",
                params: {
                  missingProperty: "type"
                },
                message: "must have required property 'type'"
              };
              if (vErrors === null) {
                vErrors = [err51];
              } else {
                vErrors.push(err51);
              }
              errors++;
            }
            if (data.linkType !== void 0) {
              let data20 = data.linkType;
              if (typeof data20 !== "string") {
                const err52 = {
                  instancePath: instancePath + "/linkType",
                  schemaPath: "#/anyOf/4/properties/linkType/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err52];
                } else {
                  vErrors.push(err52);
                }
                errors++;
              }
              if ("tag" !== data20) {
                const err53 = {
                  instancePath: instancePath + "/linkType",
                  schemaPath: "#/anyOf/4/properties/linkType/const",
                  keyword: "const",
                  params: {
                    allowedValue: "tag"
                  },
                  message: "must be equal to constant"
                };
                if (vErrors === null) {
                  vErrors = [err53];
                } else {
                  vErrors.push(err53);
                }
                errors++;
              }
            }
            if (data.tagName !== void 0) {
              if (typeof data.tagName !== "string") {
                const err54 = {
                  instancePath: instancePath + "/tagName",
                  schemaPath: "#/anyOf/4/properties/tagName/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err54];
                } else {
                  vErrors.push(err54);
                }
                errors++;
              }
            }
            if (data.type !== void 0) {
              let data22 = data.type;
              if (typeof data22 !== "string") {
                const err55 = {
                  instancePath: instancePath + "/type",
                  schemaPath: "#/anyOf/4/properties/type/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err55];
                } else {
                  vErrors.push(err55);
                }
                errors++;
              }
              if ("LINK" !== data22) {
                const err56 = {
                  instancePath: instancePath + "/type",
                  schemaPath: "#/anyOf/4/properties/type/const",
                  keyword: "const",
                  params: {
                    allowedValue: "LINK"
                  },
                  message: "must be equal to constant"
                };
                if (vErrors === null) {
                  vErrors = [err56];
                } else {
                  vErrors.push(err56);
                }
                errors++;
              }
            }
            if (data.label !== void 0) {
              if (typeof data.label !== "string") {
                const err57 = {
                  instancePath: instancePath + "/label",
                  schemaPath: "#/anyOf/4/properties/label/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err57];
                } else {
                  vErrors.push(err57);
                }
                errors++;
              }
            }
            if (data.external !== void 0) {
              if (typeof data.external !== "boolean") {
                const err58 = {
                  instancePath: instancePath + "/external",
                  schemaPath: "#/anyOf/4/properties/external/type",
                  keyword: "type",
                  params: {
                    type: "boolean"
                  },
                  message: "must be boolean"
                };
                if (vErrors === null) {
                  vErrors = [err58];
                } else {
                  vErrors.push(err58);
                }
                errors++;
              }
            }
          } else {
            const err59 = {
              instancePath,
              schemaPath: "#/anyOf/4/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err59];
            } else {
              vErrors.push(err59);
            }
            errors++;
          }
          var _valid0 = _errs49 === errors;
          valid0 = valid0 || _valid0;
        }
      }
    }
  }
  if (!valid0) {
    const err60 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err60];
    } else {
      vErrors.push(err60);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate113.errors = vErrors;
  return errors === 0;
}
const RootNavigationResource = validate114;
const schema122 = {
  "$id": "RootNavigationResource",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "anyOf": [{
    "type": "object",
    "properties": {
      "type": {
        "type": "string",
        "const": "CALENDAR"
      }
    },
    "required": ["type"]
  }, {
    "type": "object",
    "properties": {
      "type": {
        "type": "string",
        "const": "EVENTS"
      },
      "label": {
        "type": "string"
      },
      "listSources": {
        "type": "array",
        "items": {
          "type": "object",
          "properties": {
            "label": {
              "type": "string"
            },
            "source": {
              "$ref": "EventListSource"
            },
            "order": {
              "type": "string",
              "enum": ["ASC", "DESC"]
            }
          },
          "required": ["label", "source", "order"]
        }
      }
    },
    "required": ["type"]
  }, {
    "type": "object",
    "properties": {
      "type": {
        "type": "string",
        "const": "NAMED_TAGS"
      },
      "tagType": {
        "$ref": "NamedTagType"
      },
      "label": {
        "type": "string"
      }
    },
    "required": ["type", "tagType"]
  }, {
    "type": "object",
    "properties": {
      "type": {
        "type": "string",
        "const": "MENU"
      },
      "label": {
        "type": "string"
      },
      "items": {
        "type": "array",
        "items": {
          "$ref": "LinkNavigationResource"
        }
      }
    },
    "required": ["type", "label", "items"]
  }, {
    "$ref": "LinkNavigationResource"
  }]
};
function validate114(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.type === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.type !== void 0) {
      let data0 = data.type;
      if (typeof data0 !== "string") {
        const err1 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/anyOf/0/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if ("CALENDAR" !== data0) {
        const err2 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/anyOf/0/properties/type/const",
          keyword: "const",
          params: {
            allowedValue: "CALENDAR"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: "#/anyOf/0/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs5 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.type === void 0) {
        const err4 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "type"
          },
          message: "must have required property 'type'"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if (data.type !== void 0) {
        let data1 = data.type;
        if (typeof data1 !== "string") {
          const err5 = {
            instancePath: instancePath + "/type",
            schemaPath: "#/anyOf/1/properties/type/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
        if ("EVENTS" !== data1) {
          const err6 = {
            instancePath: instancePath + "/type",
            schemaPath: "#/anyOf/1/properties/type/const",
            keyword: "const",
            params: {
              allowedValue: "EVENTS"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
      }
      if (data.label !== void 0) {
        if (typeof data.label !== "string") {
          const err7 = {
            instancePath: instancePath + "/label",
            schemaPath: "#/anyOf/1/properties/label/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
      }
      if (data.listSources !== void 0) {
        let data3 = data.listSources;
        if (Array.isArray(data3)) {
          const len0 = data3.length;
          for (let i0 = 0; i0 < len0; i0++) {
            let data4 = data3[i0];
            if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
              if (data4.label === void 0) {
                const err8 = {
                  instancePath: instancePath + "/listSources/" + i0,
                  schemaPath: "#/anyOf/1/properties/listSources/items/required",
                  keyword: "required",
                  params: {
                    missingProperty: "label"
                  },
                  message: "must have required property 'label'"
                };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
              if (data4.source === void 0) {
                const err9 = {
                  instancePath: instancePath + "/listSources/" + i0,
                  schemaPath: "#/anyOf/1/properties/listSources/items/required",
                  keyword: "required",
                  params: {
                    missingProperty: "source"
                  },
                  message: "must have required property 'source'"
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
              if (data4.order === void 0) {
                const err10 = {
                  instancePath: instancePath + "/listSources/" + i0,
                  schemaPath: "#/anyOf/1/properties/listSources/items/required",
                  keyword: "required",
                  params: {
                    missingProperty: "order"
                  },
                  message: "must have required property 'order'"
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
              if (data4.label !== void 0) {
                if (typeof data4.label !== "string") {
                  const err11 = {
                    instancePath: instancePath + "/listSources/" + i0 + "/label",
                    schemaPath: "#/anyOf/1/properties/listSources/items/properties/label/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                }
              }
              if (data4.source !== void 0) {
                let data6 = data4.source;
                if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                  if (data6.eventIds !== void 0) {
                    let data7 = data6.eventIds;
                    if (Array.isArray(data7)) {
                      const len1 = data7.length;
                      for (let i1 = 0; i1 < len1; i1++) {
                        if (typeof data7[i1] !== "string") {
                          const err12 = {
                            instancePath: instancePath + "/listSources/" + i0 + "/source/eventIds/" + i1,
                            schemaPath: "EventListSource/properties/eventIds/items/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err12];
                          } else {
                            vErrors.push(err12);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err13 = {
                        instancePath: instancePath + "/listSources/" + i0 + "/source/eventIds",
                        schemaPath: "EventListSource/properties/eventIds/type",
                        keyword: "type",
                        params: {
                          type: "array"
                        },
                        message: "must be array"
                      };
                      if (vErrors === null) {
                        vErrors = [err13];
                      } else {
                        vErrors.push(err13);
                      }
                      errors++;
                    }
                  }
                  if (data6.onlyState !== void 0) {
                    let data9 = data6.onlyState;
                    if (typeof data9 !== "string") {
                      const err14 = {
                        instancePath: instancePath + "/listSources/" + i0 + "/source/onlyState",
                        schemaPath: "EventListSource/properties/onlyState/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err14];
                      } else {
                        vErrors.push(err14);
                      }
                      errors++;
                    }
                    if (!(data9 === "UPCOMING" || data9 === "ACTIVE" || data9 === "PASSED" || data9 === "ACTIVE_AND_UPCOMING" || data9 === "PASSED_AND_ACTIVE")) {
                      const err15 = {
                        instancePath: instancePath + "/listSources/" + i0 + "/source/onlyState",
                        schemaPath: "EventListSource/properties/onlyState/enum",
                        keyword: "enum",
                        params: {
                          allowedValues: schema72.properties.onlyState.enum
                        },
                        message: "must be equal to one of the allowed values"
                      };
                      if (vErrors === null) {
                        vErrors = [err15];
                      } else {
                        vErrors.push(err15);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err16 = {
                    instancePath: instancePath + "/listSources/" + i0 + "/source",
                    schemaPath: "EventListSource/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  };
                  if (vErrors === null) {
                    vErrors = [err16];
                  } else {
                    vErrors.push(err16);
                  }
                  errors++;
                }
              }
              if (data4.order !== void 0) {
                let data10 = data4.order;
                if (typeof data10 !== "string") {
                  const err17 = {
                    instancePath: instancePath + "/listSources/" + i0 + "/order",
                    schemaPath: "#/anyOf/1/properties/listSources/items/properties/order/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err17];
                  } else {
                    vErrors.push(err17);
                  }
                  errors++;
                }
                if (!(data10 === "ASC" || data10 === "DESC")) {
                  const err18 = {
                    instancePath: instancePath + "/listSources/" + i0 + "/order",
                    schemaPath: "#/anyOf/1/properties/listSources/items/properties/order/enum",
                    keyword: "enum",
                    params: {
                      allowedValues: schema122.anyOf[1].properties.listSources.items.properties.order.enum
                    },
                    message: "must be equal to one of the allowed values"
                  };
                  if (vErrors === null) {
                    vErrors = [err18];
                  } else {
                    vErrors.push(err18);
                  }
                  errors++;
                }
              }
            } else {
              const err19 = {
                instancePath: instancePath + "/listSources/" + i0,
                schemaPath: "#/anyOf/1/properties/listSources/items/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              };
              if (vErrors === null) {
                vErrors = [err19];
              } else {
                vErrors.push(err19);
              }
              errors++;
            }
          }
        } else {
          const err20 = {
            instancePath: instancePath + "/listSources",
            schemaPath: "#/anyOf/1/properties/listSources/type",
            keyword: "type",
            params: {
              type: "array"
            },
            message: "must be array"
          };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
      }
    } else {
      const err21 = {
        instancePath,
        schemaPath: "#/anyOf/1/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err21];
      } else {
        vErrors.push(err21);
      }
      errors++;
    }
    var _valid0 = _errs5 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs28 = errors;
      if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.type === void 0) {
          const err22 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "type"
            },
            message: "must have required property 'type'"
          };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
        if (data.tagType === void 0) {
          const err23 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "tagType"
            },
            message: "must have required property 'tagType'"
          };
          if (vErrors === null) {
            vErrors = [err23];
          } else {
            vErrors.push(err23);
          }
          errors++;
        }
        if (data.type !== void 0) {
          let data11 = data.type;
          if (typeof data11 !== "string") {
            const err24 = {
              instancePath: instancePath + "/type",
              schemaPath: "#/anyOf/2/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          }
          if ("NAMED_TAGS" !== data11) {
            const err25 = {
              instancePath: instancePath + "/type",
              schemaPath: "#/anyOf/2/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "NAMED_TAGS"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err25];
            } else {
              vErrors.push(err25);
            }
            errors++;
          }
        }
        if (data.tagType !== void 0) {
          let data12 = data.tagType;
          if (typeof data12 !== "string") {
            const err26 = {
              instancePath: instancePath + "/tagType",
              schemaPath: "NamedTagType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err26];
            } else {
              vErrors.push(err26);
            }
            errors++;
          }
          if (!(data12 === "EVENT" || data12 === "ATHLETE" || data12 === "PLACE" || data12 === "TOURNAMENT" || data12 === "TEAM" || data12 === "SEASON")) {
            const err27 = {
              instancePath: instancePath + "/tagType",
              schemaPath: "NamedTagType/enum",
              keyword: "enum",
              params: {
                allowedValues: schema118.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err27];
            } else {
              vErrors.push(err27);
            }
            errors++;
          }
        }
        if (data.label !== void 0) {
          if (typeof data.label !== "string") {
            const err28 = {
              instancePath: instancePath + "/label",
              schemaPath: "#/anyOf/2/properties/label/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err28];
            } else {
              vErrors.push(err28);
            }
            errors++;
          }
        }
      } else {
        const err29 = {
          instancePath,
          schemaPath: "#/anyOf/2/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err29];
        } else {
          vErrors.push(err29);
        }
        errors++;
      }
      var _valid0 = _errs28 === errors;
      valid0 = valid0 || _valid0;
      if (!valid0) {
        const _errs37 = errors;
        if (data && typeof data == "object" && !Array.isArray(data)) {
          if (data.type === void 0) {
            const err30 = {
              instancePath,
              schemaPath: "#/anyOf/3/required",
              keyword: "required",
              params: {
                missingProperty: "type"
              },
              message: "must have required property 'type'"
            };
            if (vErrors === null) {
              vErrors = [err30];
            } else {
              vErrors.push(err30);
            }
            errors++;
          }
          if (data.label === void 0) {
            const err31 = {
              instancePath,
              schemaPath: "#/anyOf/3/required",
              keyword: "required",
              params: {
                missingProperty: "label"
              },
              message: "must have required property 'label'"
            };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
          if (data.items === void 0) {
            const err32 = {
              instancePath,
              schemaPath: "#/anyOf/3/required",
              keyword: "required",
              params: {
                missingProperty: "items"
              },
              message: "must have required property 'items'"
            };
            if (vErrors === null) {
              vErrors = [err32];
            } else {
              vErrors.push(err32);
            }
            errors++;
          }
          if (data.type !== void 0) {
            let data14 = data.type;
            if (typeof data14 !== "string") {
              const err33 = {
                instancePath: instancePath + "/type",
                schemaPath: "#/anyOf/3/properties/type/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err33];
              } else {
                vErrors.push(err33);
              }
              errors++;
            }
            if ("MENU" !== data14) {
              const err34 = {
                instancePath: instancePath + "/type",
                schemaPath: "#/anyOf/3/properties/type/const",
                keyword: "const",
                params: {
                  allowedValue: "MENU"
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err34];
              } else {
                vErrors.push(err34);
              }
              errors++;
            }
          }
          if (data.label !== void 0) {
            if (typeof data.label !== "string") {
              const err35 = {
                instancePath: instancePath + "/label",
                schemaPath: "#/anyOf/3/properties/label/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err35];
              } else {
                vErrors.push(err35);
              }
              errors++;
            }
          }
          if (data.items !== void 0) {
            let data16 = data.items;
            if (Array.isArray(data16)) {
              const len2 = data16.length;
              for (let i2 = 0; i2 < len2; i2++) {
                let data17 = data16[i2];
                const _errs47 = errors;
                let valid16 = false;
                const _errs48 = errors;
                if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                  if (data17.label === void 0) {
                    const err36 = {
                      instancePath: instancePath + "/items/" + i2,
                      schemaPath: "LinkNavigationResource/anyOf/0/required",
                      keyword: "required",
                      params: {
                        missingProperty: "label"
                      },
                      message: "must have required property 'label'"
                    };
                    if (vErrors === null) {
                      vErrors = [err36];
                    } else {
                      vErrors.push(err36);
                    }
                    errors++;
                  }
                  if (data17.linkType === void 0) {
                    const err37 = {
                      instancePath: instancePath + "/items/" + i2,
                      schemaPath: "LinkNavigationResource/anyOf/0/required",
                      keyword: "required",
                      params: {
                        missingProperty: "linkType"
                      },
                      message: "must have required property 'linkType'"
                    };
                    if (vErrors === null) {
                      vErrors = [err37];
                    } else {
                      vErrors.push(err37);
                    }
                    errors++;
                  }
                  if (data17.type === void 0) {
                    const err38 = {
                      instancePath: instancePath + "/items/" + i2,
                      schemaPath: "LinkNavigationResource/anyOf/0/required",
                      keyword: "required",
                      params: {
                        missingProperty: "type"
                      },
                      message: "must have required property 'type'"
                    };
                    if (vErrors === null) {
                      vErrors = [err38];
                    } else {
                      vErrors.push(err38);
                    }
                    errors++;
                  }
                  if (data17.url === void 0) {
                    const err39 = {
                      instancePath: instancePath + "/items/" + i2,
                      schemaPath: "LinkNavigationResource/anyOf/0/required",
                      keyword: "required",
                      params: {
                        missingProperty: "url"
                      },
                      message: "must have required property 'url'"
                    };
                    if (vErrors === null) {
                      vErrors = [err39];
                    } else {
                      vErrors.push(err39);
                    }
                    errors++;
                  }
                  if (data17.linkType !== void 0) {
                    let data18 = data17.linkType;
                    if (typeof data18 !== "string") {
                      const err40 = {
                        instancePath: instancePath + "/items/" + i2 + "/linkType",
                        schemaPath: "LinkNavigationResource/anyOf/0/properties/linkType/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err40];
                      } else {
                        vErrors.push(err40);
                      }
                      errors++;
                    }
                    if ("url" !== data18) {
                      const err41 = {
                        instancePath: instancePath + "/items/" + i2 + "/linkType",
                        schemaPath: "LinkNavigationResource/anyOf/0/properties/linkType/const",
                        keyword: "const",
                        params: {
                          allowedValue: "url"
                        },
                        message: "must be equal to constant"
                      };
                      if (vErrors === null) {
                        vErrors = [err41];
                      } else {
                        vErrors.push(err41);
                      }
                      errors++;
                    }
                  }
                  if (data17.url !== void 0) {
                    if (typeof data17.url !== "string") {
                      const err42 = {
                        instancePath: instancePath + "/items/" + i2 + "/url",
                        schemaPath: "LinkNavigationResource/anyOf/0/properties/url/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err42];
                      } else {
                        vErrors.push(err42);
                      }
                      errors++;
                    }
                  }
                  if (data17.type !== void 0) {
                    let data20 = data17.type;
                    if (typeof data20 !== "string") {
                      const err43 = {
                        instancePath: instancePath + "/items/" + i2 + "/type",
                        schemaPath: "LinkNavigationResource/anyOf/0/properties/type/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err43];
                      } else {
                        vErrors.push(err43);
                      }
                      errors++;
                    }
                    if ("LINK" !== data20) {
                      const err44 = {
                        instancePath: instancePath + "/items/" + i2 + "/type",
                        schemaPath: "LinkNavigationResource/anyOf/0/properties/type/const",
                        keyword: "const",
                        params: {
                          allowedValue: "LINK"
                        },
                        message: "must be equal to constant"
                      };
                      if (vErrors === null) {
                        vErrors = [err44];
                      } else {
                        vErrors.push(err44);
                      }
                      errors++;
                    }
                  }
                  if (data17.label !== void 0) {
                    if (typeof data17.label !== "string") {
                      const err45 = {
                        instancePath: instancePath + "/items/" + i2 + "/label",
                        schemaPath: "LinkNavigationResource/anyOf/0/properties/label/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err45];
                      } else {
                        vErrors.push(err45);
                      }
                      errors++;
                    }
                  }
                  if (data17.external !== void 0) {
                    if (typeof data17.external !== "boolean") {
                      const err46 = {
                        instancePath: instancePath + "/items/" + i2 + "/external",
                        schemaPath: "LinkNavigationResource/anyOf/0/properties/external/type",
                        keyword: "type",
                        params: {
                          type: "boolean"
                        },
                        message: "must be boolean"
                      };
                      if (vErrors === null) {
                        vErrors = [err46];
                      } else {
                        vErrors.push(err46);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err47 = {
                    instancePath: instancePath + "/items/" + i2,
                    schemaPath: "LinkNavigationResource/anyOf/0/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  };
                  if (vErrors === null) {
                    vErrors = [err47];
                  } else {
                    vErrors.push(err47);
                  }
                  errors++;
                }
                var _valid1 = _errs48 === errors;
                valid16 = valid16 || _valid1;
                if (!valid16) {
                  const _errs60 = errors;
                  if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                    if (data17.label === void 0) {
                      const err48 = {
                        instancePath: instancePath + "/items/" + i2,
                        schemaPath: "LinkNavigationResource/anyOf/1/required",
                        keyword: "required",
                        params: {
                          missingProperty: "label"
                        },
                        message: "must have required property 'label'"
                      };
                      if (vErrors === null) {
                        vErrors = [err48];
                      } else {
                        vErrors.push(err48);
                      }
                      errors++;
                    }
                    if (data17.linkType === void 0) {
                      const err49 = {
                        instancePath: instancePath + "/items/" + i2,
                        schemaPath: "LinkNavigationResource/anyOf/1/required",
                        keyword: "required",
                        params: {
                          missingProperty: "linkType"
                        },
                        message: "must have required property 'linkType'"
                      };
                      if (vErrors === null) {
                        vErrors = [err49];
                      } else {
                        vErrors.push(err49);
                      }
                      errors++;
                    }
                    if (data17.pageId === void 0) {
                      const err50 = {
                        instancePath: instancePath + "/items/" + i2,
                        schemaPath: "LinkNavigationResource/anyOf/1/required",
                        keyword: "required",
                        params: {
                          missingProperty: "pageId"
                        },
                        message: "must have required property 'pageId'"
                      };
                      if (vErrors === null) {
                        vErrors = [err50];
                      } else {
                        vErrors.push(err50);
                      }
                      errors++;
                    }
                    if (data17.type === void 0) {
                      const err51 = {
                        instancePath: instancePath + "/items/" + i2,
                        schemaPath: "LinkNavigationResource/anyOf/1/required",
                        keyword: "required",
                        params: {
                          missingProperty: "type"
                        },
                        message: "must have required property 'type'"
                      };
                      if (vErrors === null) {
                        vErrors = [err51];
                      } else {
                        vErrors.push(err51);
                      }
                      errors++;
                    }
                    if (data17.linkType !== void 0) {
                      let data23 = data17.linkType;
                      if (typeof data23 !== "string") {
                        const err52 = {
                          instancePath: instancePath + "/items/" + i2 + "/linkType",
                          schemaPath: "LinkNavigationResource/anyOf/1/properties/linkType/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err52];
                        } else {
                          vErrors.push(err52);
                        }
                        errors++;
                      }
                      if ("page" !== data23) {
                        const err53 = {
                          instancePath: instancePath + "/items/" + i2 + "/linkType",
                          schemaPath: "LinkNavigationResource/anyOf/1/properties/linkType/const",
                          keyword: "const",
                          params: {
                            allowedValue: "page"
                          },
                          message: "must be equal to constant"
                        };
                        if (vErrors === null) {
                          vErrors = [err53];
                        } else {
                          vErrors.push(err53);
                        }
                        errors++;
                      }
                    }
                    if (data17.pageId !== void 0) {
                      if (typeof data17.pageId !== "string") {
                        const err54 = {
                          instancePath: instancePath + "/items/" + i2 + "/pageId",
                          schemaPath: "LinkNavigationResource/anyOf/1/properties/pageId/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err54];
                        } else {
                          vErrors.push(err54);
                        }
                        errors++;
                      }
                    }
                    if (data17.type !== void 0) {
                      let data25 = data17.type;
                      if (typeof data25 !== "string") {
                        const err55 = {
                          instancePath: instancePath + "/items/" + i2 + "/type",
                          schemaPath: "LinkNavigationResource/anyOf/1/properties/type/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err55];
                        } else {
                          vErrors.push(err55);
                        }
                        errors++;
                      }
                      if ("LINK" !== data25) {
                        const err56 = {
                          instancePath: instancePath + "/items/" + i2 + "/type",
                          schemaPath: "LinkNavigationResource/anyOf/1/properties/type/const",
                          keyword: "const",
                          params: {
                            allowedValue: "LINK"
                          },
                          message: "must be equal to constant"
                        };
                        if (vErrors === null) {
                          vErrors = [err56];
                        } else {
                          vErrors.push(err56);
                        }
                        errors++;
                      }
                    }
                    if (data17.label !== void 0) {
                      if (typeof data17.label !== "string") {
                        const err57 = {
                          instancePath: instancePath + "/items/" + i2 + "/label",
                          schemaPath: "LinkNavigationResource/anyOf/1/properties/label/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err57];
                        } else {
                          vErrors.push(err57);
                        }
                        errors++;
                      }
                    }
                    if (data17.external !== void 0) {
                      if (typeof data17.external !== "boolean") {
                        const err58 = {
                          instancePath: instancePath + "/items/" + i2 + "/external",
                          schemaPath: "LinkNavigationResource/anyOf/1/properties/external/type",
                          keyword: "type",
                          params: {
                            type: "boolean"
                          },
                          message: "must be boolean"
                        };
                        if (vErrors === null) {
                          vErrors = [err58];
                        } else {
                          vErrors.push(err58);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err59 = {
                      instancePath: instancePath + "/items/" + i2,
                      schemaPath: "LinkNavigationResource/anyOf/1/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err59];
                    } else {
                      vErrors.push(err59);
                    }
                    errors++;
                  }
                  var _valid1 = _errs60 === errors;
                  valid16 = valid16 || _valid1;
                  if (!valid16) {
                    const _errs72 = errors;
                    if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                      if (data17.eventId === void 0) {
                        const err60 = {
                          instancePath: instancePath + "/items/" + i2,
                          schemaPath: "LinkNavigationResource/anyOf/2/required",
                          keyword: "required",
                          params: {
                            missingProperty: "eventId"
                          },
                          message: "must have required property 'eventId'"
                        };
                        if (vErrors === null) {
                          vErrors = [err60];
                        } else {
                          vErrors.push(err60);
                        }
                        errors++;
                      }
                      if (data17.label === void 0) {
                        const err61 = {
                          instancePath: instancePath + "/items/" + i2,
                          schemaPath: "LinkNavigationResource/anyOf/2/required",
                          keyword: "required",
                          params: {
                            missingProperty: "label"
                          },
                          message: "must have required property 'label'"
                        };
                        if (vErrors === null) {
                          vErrors = [err61];
                        } else {
                          vErrors.push(err61);
                        }
                        errors++;
                      }
                      if (data17.linkType === void 0) {
                        const err62 = {
                          instancePath: instancePath + "/items/" + i2,
                          schemaPath: "LinkNavigationResource/anyOf/2/required",
                          keyword: "required",
                          params: {
                            missingProperty: "linkType"
                          },
                          message: "must have required property 'linkType'"
                        };
                        if (vErrors === null) {
                          vErrors = [err62];
                        } else {
                          vErrors.push(err62);
                        }
                        errors++;
                      }
                      if (data17.type === void 0) {
                        const err63 = {
                          instancePath: instancePath + "/items/" + i2,
                          schemaPath: "LinkNavigationResource/anyOf/2/required",
                          keyword: "required",
                          params: {
                            missingProperty: "type"
                          },
                          message: "must have required property 'type'"
                        };
                        if (vErrors === null) {
                          vErrors = [err63];
                        } else {
                          vErrors.push(err63);
                        }
                        errors++;
                      }
                      if (data17.linkType !== void 0) {
                        let data28 = data17.linkType;
                        if (typeof data28 !== "string") {
                          const err64 = {
                            instancePath: instancePath + "/items/" + i2 + "/linkType",
                            schemaPath: "LinkNavigationResource/anyOf/2/properties/linkType/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err64];
                          } else {
                            vErrors.push(err64);
                          }
                          errors++;
                        }
                        if ("event" !== data28) {
                          const err65 = {
                            instancePath: instancePath + "/items/" + i2 + "/linkType",
                            schemaPath: "LinkNavigationResource/anyOf/2/properties/linkType/const",
                            keyword: "const",
                            params: {
                              allowedValue: "event"
                            },
                            message: "must be equal to constant"
                          };
                          if (vErrors === null) {
                            vErrors = [err65];
                          } else {
                            vErrors.push(err65);
                          }
                          errors++;
                        }
                      }
                      if (data17.eventId !== void 0) {
                        if (typeof data17.eventId !== "string") {
                          const err66 = {
                            instancePath: instancePath + "/items/" + i2 + "/eventId",
                            schemaPath: "LinkNavigationResource/anyOf/2/properties/eventId/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err66];
                          } else {
                            vErrors.push(err66);
                          }
                          errors++;
                        }
                      }
                      if (data17.type !== void 0) {
                        let data30 = data17.type;
                        if (typeof data30 !== "string") {
                          const err67 = {
                            instancePath: instancePath + "/items/" + i2 + "/type",
                            schemaPath: "LinkNavigationResource/anyOf/2/properties/type/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err67];
                          } else {
                            vErrors.push(err67);
                          }
                          errors++;
                        }
                        if ("LINK" !== data30) {
                          const err68 = {
                            instancePath: instancePath + "/items/" + i2 + "/type",
                            schemaPath: "LinkNavigationResource/anyOf/2/properties/type/const",
                            keyword: "const",
                            params: {
                              allowedValue: "LINK"
                            },
                            message: "must be equal to constant"
                          };
                          if (vErrors === null) {
                            vErrors = [err68];
                          } else {
                            vErrors.push(err68);
                          }
                          errors++;
                        }
                      }
                      if (data17.label !== void 0) {
                        if (typeof data17.label !== "string") {
                          const err69 = {
                            instancePath: instancePath + "/items/" + i2 + "/label",
                            schemaPath: "LinkNavigationResource/anyOf/2/properties/label/type",
                            keyword: "type",
                            params: {
                              type: "string"
                            },
                            message: "must be string"
                          };
                          if (vErrors === null) {
                            vErrors = [err69];
                          } else {
                            vErrors.push(err69);
                          }
                          errors++;
                        }
                      }
                      if (data17.external !== void 0) {
                        if (typeof data17.external !== "boolean") {
                          const err70 = {
                            instancePath: instancePath + "/items/" + i2 + "/external",
                            schemaPath: "LinkNavigationResource/anyOf/2/properties/external/type",
                            keyword: "type",
                            params: {
                              type: "boolean"
                            },
                            message: "must be boolean"
                          };
                          if (vErrors === null) {
                            vErrors = [err70];
                          } else {
                            vErrors.push(err70);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err71 = {
                        instancePath: instancePath + "/items/" + i2,
                        schemaPath: "LinkNavigationResource/anyOf/2/type",
                        keyword: "type",
                        params: {
                          type: "object"
                        },
                        message: "must be object"
                      };
                      if (vErrors === null) {
                        vErrors = [err71];
                      } else {
                        vErrors.push(err71);
                      }
                      errors++;
                    }
                    var _valid1 = _errs72 === errors;
                    valid16 = valid16 || _valid1;
                    if (!valid16) {
                      const _errs84 = errors;
                      if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                        if (data17.label === void 0) {
                          const err72 = {
                            instancePath: instancePath + "/items/" + i2,
                            schemaPath: "LinkNavigationResource/anyOf/3/required",
                            keyword: "required",
                            params: {
                              missingProperty: "label"
                            },
                            message: "must have required property 'label'"
                          };
                          if (vErrors === null) {
                            vErrors = [err72];
                          } else {
                            vErrors.push(err72);
                          }
                          errors++;
                        }
                        if (data17.linkType === void 0) {
                          const err73 = {
                            instancePath: instancePath + "/items/" + i2,
                            schemaPath: "LinkNavigationResource/anyOf/3/required",
                            keyword: "required",
                            params: {
                              missingProperty: "linkType"
                            },
                            message: "must have required property 'linkType'"
                          };
                          if (vErrors === null) {
                            vErrors = [err73];
                          } else {
                            vErrors.push(err73);
                          }
                          errors++;
                        }
                        if (data17.type === void 0) {
                          const err74 = {
                            instancePath: instancePath + "/items/" + i2,
                            schemaPath: "LinkNavigationResource/anyOf/3/required",
                            keyword: "required",
                            params: {
                              missingProperty: "type"
                            },
                            message: "must have required property 'type'"
                          };
                          if (vErrors === null) {
                            vErrors = [err74];
                          } else {
                            vErrors.push(err74);
                          }
                          errors++;
                        }
                        if (data17.videoId === void 0) {
                          const err75 = {
                            instancePath: instancePath + "/items/" + i2,
                            schemaPath: "LinkNavigationResource/anyOf/3/required",
                            keyword: "required",
                            params: {
                              missingProperty: "videoId"
                            },
                            message: "must have required property 'videoId'"
                          };
                          if (vErrors === null) {
                            vErrors = [err75];
                          } else {
                            vErrors.push(err75);
                          }
                          errors++;
                        }
                        if (data17.linkType !== void 0) {
                          let data33 = data17.linkType;
                          if (typeof data33 !== "string") {
                            const err76 = {
                              instancePath: instancePath + "/items/" + i2 + "/linkType",
                              schemaPath: "LinkNavigationResource/anyOf/3/properties/linkType/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err76];
                            } else {
                              vErrors.push(err76);
                            }
                            errors++;
                          }
                          if ("video" !== data33) {
                            const err77 = {
                              instancePath: instancePath + "/items/" + i2 + "/linkType",
                              schemaPath: "LinkNavigationResource/anyOf/3/properties/linkType/const",
                              keyword: "const",
                              params: {
                                allowedValue: "video"
                              },
                              message: "must be equal to constant"
                            };
                            if (vErrors === null) {
                              vErrors = [err77];
                            } else {
                              vErrors.push(err77);
                            }
                            errors++;
                          }
                        }
                        if (data17.videoId !== void 0) {
                          if (typeof data17.videoId !== "string") {
                            const err78 = {
                              instancePath: instancePath + "/items/" + i2 + "/videoId",
                              schemaPath: "LinkNavigationResource/anyOf/3/properties/videoId/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err78];
                            } else {
                              vErrors.push(err78);
                            }
                            errors++;
                          }
                        }
                        if (data17.type !== void 0) {
                          let data35 = data17.type;
                          if (typeof data35 !== "string") {
                            const err79 = {
                              instancePath: instancePath + "/items/" + i2 + "/type",
                              schemaPath: "LinkNavigationResource/anyOf/3/properties/type/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err79];
                            } else {
                              vErrors.push(err79);
                            }
                            errors++;
                          }
                          if ("LINK" !== data35) {
                            const err80 = {
                              instancePath: instancePath + "/items/" + i2 + "/type",
                              schemaPath: "LinkNavigationResource/anyOf/3/properties/type/const",
                              keyword: "const",
                              params: {
                                allowedValue: "LINK"
                              },
                              message: "must be equal to constant"
                            };
                            if (vErrors === null) {
                              vErrors = [err80];
                            } else {
                              vErrors.push(err80);
                            }
                            errors++;
                          }
                        }
                        if (data17.label !== void 0) {
                          if (typeof data17.label !== "string") {
                            const err81 = {
                              instancePath: instancePath + "/items/" + i2 + "/label",
                              schemaPath: "LinkNavigationResource/anyOf/3/properties/label/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err81];
                            } else {
                              vErrors.push(err81);
                            }
                            errors++;
                          }
                        }
                        if (data17.external !== void 0) {
                          if (typeof data17.external !== "boolean") {
                            const err82 = {
                              instancePath: instancePath + "/items/" + i2 + "/external",
                              schemaPath: "LinkNavigationResource/anyOf/3/properties/external/type",
                              keyword: "type",
                              params: {
                                type: "boolean"
                              },
                              message: "must be boolean"
                            };
                            if (vErrors === null) {
                              vErrors = [err82];
                            } else {
                              vErrors.push(err82);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err83 = {
                          instancePath: instancePath + "/items/" + i2,
                          schemaPath: "LinkNavigationResource/anyOf/3/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        };
                        if (vErrors === null) {
                          vErrors = [err83];
                        } else {
                          vErrors.push(err83);
                        }
                        errors++;
                      }
                      var _valid1 = _errs84 === errors;
                      valid16 = valid16 || _valid1;
                      if (!valid16) {
                        const _errs96 = errors;
                        if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                          if (data17.label === void 0) {
                            const err84 = {
                              instancePath: instancePath + "/items/" + i2,
                              schemaPath: "LinkNavigationResource/anyOf/4/required",
                              keyword: "required",
                              params: {
                                missingProperty: "label"
                              },
                              message: "must have required property 'label'"
                            };
                            if (vErrors === null) {
                              vErrors = [err84];
                            } else {
                              vErrors.push(err84);
                            }
                            errors++;
                          }
                          if (data17.linkType === void 0) {
                            const err85 = {
                              instancePath: instancePath + "/items/" + i2,
                              schemaPath: "LinkNavigationResource/anyOf/4/required",
                              keyword: "required",
                              params: {
                                missingProperty: "linkType"
                              },
                              message: "must have required property 'linkType'"
                            };
                            if (vErrors === null) {
                              vErrors = [err85];
                            } else {
                              vErrors.push(err85);
                            }
                            errors++;
                          }
                          if (data17.tagName === void 0) {
                            const err86 = {
                              instancePath: instancePath + "/items/" + i2,
                              schemaPath: "LinkNavigationResource/anyOf/4/required",
                              keyword: "required",
                              params: {
                                missingProperty: "tagName"
                              },
                              message: "must have required property 'tagName'"
                            };
                            if (vErrors === null) {
                              vErrors = [err86];
                            } else {
                              vErrors.push(err86);
                            }
                            errors++;
                          }
                          if (data17.type === void 0) {
                            const err87 = {
                              instancePath: instancePath + "/items/" + i2,
                              schemaPath: "LinkNavigationResource/anyOf/4/required",
                              keyword: "required",
                              params: {
                                missingProperty: "type"
                              },
                              message: "must have required property 'type'"
                            };
                            if (vErrors === null) {
                              vErrors = [err87];
                            } else {
                              vErrors.push(err87);
                            }
                            errors++;
                          }
                          if (data17.linkType !== void 0) {
                            let data38 = data17.linkType;
                            if (typeof data38 !== "string") {
                              const err88 = {
                                instancePath: instancePath + "/items/" + i2 + "/linkType",
                                schemaPath: "LinkNavigationResource/anyOf/4/properties/linkType/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err88];
                              } else {
                                vErrors.push(err88);
                              }
                              errors++;
                            }
                            if ("tag" !== data38) {
                              const err89 = {
                                instancePath: instancePath + "/items/" + i2 + "/linkType",
                                schemaPath: "LinkNavigationResource/anyOf/4/properties/linkType/const",
                                keyword: "const",
                                params: {
                                  allowedValue: "tag"
                                },
                                message: "must be equal to constant"
                              };
                              if (vErrors === null) {
                                vErrors = [err89];
                              } else {
                                vErrors.push(err89);
                              }
                              errors++;
                            }
                          }
                          if (data17.tagName !== void 0) {
                            if (typeof data17.tagName !== "string") {
                              const err90 = {
                                instancePath: instancePath + "/items/" + i2 + "/tagName",
                                schemaPath: "LinkNavigationResource/anyOf/4/properties/tagName/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err90];
                              } else {
                                vErrors.push(err90);
                              }
                              errors++;
                            }
                          }
                          if (data17.type !== void 0) {
                            let data40 = data17.type;
                            if (typeof data40 !== "string") {
                              const err91 = {
                                instancePath: instancePath + "/items/" + i2 + "/type",
                                schemaPath: "LinkNavigationResource/anyOf/4/properties/type/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err91];
                              } else {
                                vErrors.push(err91);
                              }
                              errors++;
                            }
                            if ("LINK" !== data40) {
                              const err92 = {
                                instancePath: instancePath + "/items/" + i2 + "/type",
                                schemaPath: "LinkNavigationResource/anyOf/4/properties/type/const",
                                keyword: "const",
                                params: {
                                  allowedValue: "LINK"
                                },
                                message: "must be equal to constant"
                              };
                              if (vErrors === null) {
                                vErrors = [err92];
                              } else {
                                vErrors.push(err92);
                              }
                              errors++;
                            }
                          }
                          if (data17.label !== void 0) {
                            if (typeof data17.label !== "string") {
                              const err93 = {
                                instancePath: instancePath + "/items/" + i2 + "/label",
                                schemaPath: "LinkNavigationResource/anyOf/4/properties/label/type",
                                keyword: "type",
                                params: {
                                  type: "string"
                                },
                                message: "must be string"
                              };
                              if (vErrors === null) {
                                vErrors = [err93];
                              } else {
                                vErrors.push(err93);
                              }
                              errors++;
                            }
                          }
                          if (data17.external !== void 0) {
                            if (typeof data17.external !== "boolean") {
                              const err94 = {
                                instancePath: instancePath + "/items/" + i2 + "/external",
                                schemaPath: "LinkNavigationResource/anyOf/4/properties/external/type",
                                keyword: "type",
                                params: {
                                  type: "boolean"
                                },
                                message: "must be boolean"
                              };
                              if (vErrors === null) {
                                vErrors = [err94];
                              } else {
                                vErrors.push(err94);
                              }
                              errors++;
                            }
                          }
                        } else {
                          const err95 = {
                            instancePath: instancePath + "/items/" + i2,
                            schemaPath: "LinkNavigationResource/anyOf/4/type",
                            keyword: "type",
                            params: {
                              type: "object"
                            },
                            message: "must be object"
                          };
                          if (vErrors === null) {
                            vErrors = [err95];
                          } else {
                            vErrors.push(err95);
                          }
                          errors++;
                        }
                        var _valid1 = _errs96 === errors;
                        valid16 = valid16 || _valid1;
                      }
                    }
                  }
                }
                if (!valid16) {
                  const err96 = {
                    instancePath: instancePath + "/items/" + i2,
                    schemaPath: "LinkNavigationResource/anyOf",
                    keyword: "anyOf",
                    params: {},
                    message: "must match a schema in anyOf"
                  };
                  if (vErrors === null) {
                    vErrors = [err96];
                  } else {
                    vErrors.push(err96);
                  }
                  errors++;
                } else {
                  errors = _errs47;
                  if (vErrors !== null) {
                    if (_errs47) {
                      vErrors.length = _errs47;
                    } else {
                      vErrors = null;
                    }
                  }
                }
              }
            } else {
              const err97 = {
                instancePath: instancePath + "/items",
                schemaPath: "#/anyOf/3/properties/items/type",
                keyword: "type",
                params: {
                  type: "array"
                },
                message: "must be array"
              };
              if (vErrors === null) {
                vErrors = [err97];
              } else {
                vErrors.push(err97);
              }
              errors++;
            }
          }
        } else {
          const err98 = {
            instancePath,
            schemaPath: "#/anyOf/3/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err98];
          } else {
            vErrors.push(err98);
          }
          errors++;
        }
        var _valid0 = _errs37 === errors;
        valid0 = valid0 || _valid0;
        if (!valid0) {
          const _errs108 = errors;
          const _errs110 = errors;
          let valid23 = false;
          const _errs111 = errors;
          if (data && typeof data == "object" && !Array.isArray(data)) {
            if (data.label === void 0) {
              const err99 = {
                instancePath,
                schemaPath: "LinkNavigationResource/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "label"
                },
                message: "must have required property 'label'"
              };
              if (vErrors === null) {
                vErrors = [err99];
              } else {
                vErrors.push(err99);
              }
              errors++;
            }
            if (data.linkType === void 0) {
              const err100 = {
                instancePath,
                schemaPath: "LinkNavigationResource/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "linkType"
                },
                message: "must have required property 'linkType'"
              };
              if (vErrors === null) {
                vErrors = [err100];
              } else {
                vErrors.push(err100);
              }
              errors++;
            }
            if (data.type === void 0) {
              const err101 = {
                instancePath,
                schemaPath: "LinkNavigationResource/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "type"
                },
                message: "must have required property 'type'"
              };
              if (vErrors === null) {
                vErrors = [err101];
              } else {
                vErrors.push(err101);
              }
              errors++;
            }
            if (data.url === void 0) {
              const err102 = {
                instancePath,
                schemaPath: "LinkNavigationResource/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "url"
                },
                message: "must have required property 'url'"
              };
              if (vErrors === null) {
                vErrors = [err102];
              } else {
                vErrors.push(err102);
              }
              errors++;
            }
            if (data.linkType !== void 0) {
              let data43 = data.linkType;
              if (typeof data43 !== "string") {
                const err103 = {
                  instancePath: instancePath + "/linkType",
                  schemaPath: "LinkNavigationResource/anyOf/0/properties/linkType/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err103];
                } else {
                  vErrors.push(err103);
                }
                errors++;
              }
              if ("url" !== data43) {
                const err104 = {
                  instancePath: instancePath + "/linkType",
                  schemaPath: "LinkNavigationResource/anyOf/0/properties/linkType/const",
                  keyword: "const",
                  params: {
                    allowedValue: "url"
                  },
                  message: "must be equal to constant"
                };
                if (vErrors === null) {
                  vErrors = [err104];
                } else {
                  vErrors.push(err104);
                }
                errors++;
              }
            }
            if (data.url !== void 0) {
              if (typeof data.url !== "string") {
                const err105 = {
                  instancePath: instancePath + "/url",
                  schemaPath: "LinkNavigationResource/anyOf/0/properties/url/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err105];
                } else {
                  vErrors.push(err105);
                }
                errors++;
              }
            }
            if (data.type !== void 0) {
              let data45 = data.type;
              if (typeof data45 !== "string") {
                const err106 = {
                  instancePath: instancePath + "/type",
                  schemaPath: "LinkNavigationResource/anyOf/0/properties/type/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err106];
                } else {
                  vErrors.push(err106);
                }
                errors++;
              }
              if ("LINK" !== data45) {
                const err107 = {
                  instancePath: instancePath + "/type",
                  schemaPath: "LinkNavigationResource/anyOf/0/properties/type/const",
                  keyword: "const",
                  params: {
                    allowedValue: "LINK"
                  },
                  message: "must be equal to constant"
                };
                if (vErrors === null) {
                  vErrors = [err107];
                } else {
                  vErrors.push(err107);
                }
                errors++;
              }
            }
            if (data.label !== void 0) {
              if (typeof data.label !== "string") {
                const err108 = {
                  instancePath: instancePath + "/label",
                  schemaPath: "LinkNavigationResource/anyOf/0/properties/label/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err108];
                } else {
                  vErrors.push(err108);
                }
                errors++;
              }
            }
            if (data.external !== void 0) {
              if (typeof data.external !== "boolean") {
                const err109 = {
                  instancePath: instancePath + "/external",
                  schemaPath: "LinkNavigationResource/anyOf/0/properties/external/type",
                  keyword: "type",
                  params: {
                    type: "boolean"
                  },
                  message: "must be boolean"
                };
                if (vErrors === null) {
                  vErrors = [err109];
                } else {
                  vErrors.push(err109);
                }
                errors++;
              }
            }
          } else {
            const err110 = {
              instancePath,
              schemaPath: "LinkNavigationResource/anyOf/0/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err110];
            } else {
              vErrors.push(err110);
            }
            errors++;
          }
          var _valid2 = _errs111 === errors;
          valid23 = valid23 || _valid2;
          if (!valid23) {
            const _errs123 = errors;
            if (data && typeof data == "object" && !Array.isArray(data)) {
              if (data.label === void 0) {
                const err111 = {
                  instancePath,
                  schemaPath: "LinkNavigationResource/anyOf/1/required",
                  keyword: "required",
                  params: {
                    missingProperty: "label"
                  },
                  message: "must have required property 'label'"
                };
                if (vErrors === null) {
                  vErrors = [err111];
                } else {
                  vErrors.push(err111);
                }
                errors++;
              }
              if (data.linkType === void 0) {
                const err112 = {
                  instancePath,
                  schemaPath: "LinkNavigationResource/anyOf/1/required",
                  keyword: "required",
                  params: {
                    missingProperty: "linkType"
                  },
                  message: "must have required property 'linkType'"
                };
                if (vErrors === null) {
                  vErrors = [err112];
                } else {
                  vErrors.push(err112);
                }
                errors++;
              }
              if (data.pageId === void 0) {
                const err113 = {
                  instancePath,
                  schemaPath: "LinkNavigationResource/anyOf/1/required",
                  keyword: "required",
                  params: {
                    missingProperty: "pageId"
                  },
                  message: "must have required property 'pageId'"
                };
                if (vErrors === null) {
                  vErrors = [err113];
                } else {
                  vErrors.push(err113);
                }
                errors++;
              }
              if (data.type === void 0) {
                const err114 = {
                  instancePath,
                  schemaPath: "LinkNavigationResource/anyOf/1/required",
                  keyword: "required",
                  params: {
                    missingProperty: "type"
                  },
                  message: "must have required property 'type'"
                };
                if (vErrors === null) {
                  vErrors = [err114];
                } else {
                  vErrors.push(err114);
                }
                errors++;
              }
              if (data.linkType !== void 0) {
                let data48 = data.linkType;
                if (typeof data48 !== "string") {
                  const err115 = {
                    instancePath: instancePath + "/linkType",
                    schemaPath: "LinkNavigationResource/anyOf/1/properties/linkType/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err115];
                  } else {
                    vErrors.push(err115);
                  }
                  errors++;
                }
                if ("page" !== data48) {
                  const err116 = {
                    instancePath: instancePath + "/linkType",
                    schemaPath: "LinkNavigationResource/anyOf/1/properties/linkType/const",
                    keyword: "const",
                    params: {
                      allowedValue: "page"
                    },
                    message: "must be equal to constant"
                  };
                  if (vErrors === null) {
                    vErrors = [err116];
                  } else {
                    vErrors.push(err116);
                  }
                  errors++;
                }
              }
              if (data.pageId !== void 0) {
                if (typeof data.pageId !== "string") {
                  const err117 = {
                    instancePath: instancePath + "/pageId",
                    schemaPath: "LinkNavigationResource/anyOf/1/properties/pageId/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err117];
                  } else {
                    vErrors.push(err117);
                  }
                  errors++;
                }
              }
              if (data.type !== void 0) {
                let data50 = data.type;
                if (typeof data50 !== "string") {
                  const err118 = {
                    instancePath: instancePath + "/type",
                    schemaPath: "LinkNavigationResource/anyOf/1/properties/type/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err118];
                  } else {
                    vErrors.push(err118);
                  }
                  errors++;
                }
                if ("LINK" !== data50) {
                  const err119 = {
                    instancePath: instancePath + "/type",
                    schemaPath: "LinkNavigationResource/anyOf/1/properties/type/const",
                    keyword: "const",
                    params: {
                      allowedValue: "LINK"
                    },
                    message: "must be equal to constant"
                  };
                  if (vErrors === null) {
                    vErrors = [err119];
                  } else {
                    vErrors.push(err119);
                  }
                  errors++;
                }
              }
              if (data.label !== void 0) {
                if (typeof data.label !== "string") {
                  const err120 = {
                    instancePath: instancePath + "/label",
                    schemaPath: "LinkNavigationResource/anyOf/1/properties/label/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err120];
                  } else {
                    vErrors.push(err120);
                  }
                  errors++;
                }
              }
              if (data.external !== void 0) {
                if (typeof data.external !== "boolean") {
                  const err121 = {
                    instancePath: instancePath + "/external",
                    schemaPath: "LinkNavigationResource/anyOf/1/properties/external/type",
                    keyword: "type",
                    params: {
                      type: "boolean"
                    },
                    message: "must be boolean"
                  };
                  if (vErrors === null) {
                    vErrors = [err121];
                  } else {
                    vErrors.push(err121);
                  }
                  errors++;
                }
              }
            } else {
              const err122 = {
                instancePath,
                schemaPath: "LinkNavigationResource/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              };
              if (vErrors === null) {
                vErrors = [err122];
              } else {
                vErrors.push(err122);
              }
              errors++;
            }
            var _valid2 = _errs123 === errors;
            valid23 = valid23 || _valid2;
            if (!valid23) {
              const _errs135 = errors;
              if (data && typeof data == "object" && !Array.isArray(data)) {
                if (data.eventId === void 0) {
                  const err123 = {
                    instancePath,
                    schemaPath: "LinkNavigationResource/anyOf/2/required",
                    keyword: "required",
                    params: {
                      missingProperty: "eventId"
                    },
                    message: "must have required property 'eventId'"
                  };
                  if (vErrors === null) {
                    vErrors = [err123];
                  } else {
                    vErrors.push(err123);
                  }
                  errors++;
                }
                if (data.label === void 0) {
                  const err124 = {
                    instancePath,
                    schemaPath: "LinkNavigationResource/anyOf/2/required",
                    keyword: "required",
                    params: {
                      missingProperty: "label"
                    },
                    message: "must have required property 'label'"
                  };
                  if (vErrors === null) {
                    vErrors = [err124];
                  } else {
                    vErrors.push(err124);
                  }
                  errors++;
                }
                if (data.linkType === void 0) {
                  const err125 = {
                    instancePath,
                    schemaPath: "LinkNavigationResource/anyOf/2/required",
                    keyword: "required",
                    params: {
                      missingProperty: "linkType"
                    },
                    message: "must have required property 'linkType'"
                  };
                  if (vErrors === null) {
                    vErrors = [err125];
                  } else {
                    vErrors.push(err125);
                  }
                  errors++;
                }
                if (data.type === void 0) {
                  const err126 = {
                    instancePath,
                    schemaPath: "LinkNavigationResource/anyOf/2/required",
                    keyword: "required",
                    params: {
                      missingProperty: "type"
                    },
                    message: "must have required property 'type'"
                  };
                  if (vErrors === null) {
                    vErrors = [err126];
                  } else {
                    vErrors.push(err126);
                  }
                  errors++;
                }
                if (data.linkType !== void 0) {
                  let data53 = data.linkType;
                  if (typeof data53 !== "string") {
                    const err127 = {
                      instancePath: instancePath + "/linkType",
                      schemaPath: "LinkNavigationResource/anyOf/2/properties/linkType/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err127];
                    } else {
                      vErrors.push(err127);
                    }
                    errors++;
                  }
                  if ("event" !== data53) {
                    const err128 = {
                      instancePath: instancePath + "/linkType",
                      schemaPath: "LinkNavigationResource/anyOf/2/properties/linkType/const",
                      keyword: "const",
                      params: {
                        allowedValue: "event"
                      },
                      message: "must be equal to constant"
                    };
                    if (vErrors === null) {
                      vErrors = [err128];
                    } else {
                      vErrors.push(err128);
                    }
                    errors++;
                  }
                }
                if (data.eventId !== void 0) {
                  if (typeof data.eventId !== "string") {
                    const err129 = {
                      instancePath: instancePath + "/eventId",
                      schemaPath: "LinkNavigationResource/anyOf/2/properties/eventId/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err129];
                    } else {
                      vErrors.push(err129);
                    }
                    errors++;
                  }
                }
                if (data.type !== void 0) {
                  let data55 = data.type;
                  if (typeof data55 !== "string") {
                    const err130 = {
                      instancePath: instancePath + "/type",
                      schemaPath: "LinkNavigationResource/anyOf/2/properties/type/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err130];
                    } else {
                      vErrors.push(err130);
                    }
                    errors++;
                  }
                  if ("LINK" !== data55) {
                    const err131 = {
                      instancePath: instancePath + "/type",
                      schemaPath: "LinkNavigationResource/anyOf/2/properties/type/const",
                      keyword: "const",
                      params: {
                        allowedValue: "LINK"
                      },
                      message: "must be equal to constant"
                    };
                    if (vErrors === null) {
                      vErrors = [err131];
                    } else {
                      vErrors.push(err131);
                    }
                    errors++;
                  }
                }
                if (data.label !== void 0) {
                  if (typeof data.label !== "string") {
                    const err132 = {
                      instancePath: instancePath + "/label",
                      schemaPath: "LinkNavigationResource/anyOf/2/properties/label/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err132];
                    } else {
                      vErrors.push(err132);
                    }
                    errors++;
                  }
                }
                if (data.external !== void 0) {
                  if (typeof data.external !== "boolean") {
                    const err133 = {
                      instancePath: instancePath + "/external",
                      schemaPath: "LinkNavigationResource/anyOf/2/properties/external/type",
                      keyword: "type",
                      params: {
                        type: "boolean"
                      },
                      message: "must be boolean"
                    };
                    if (vErrors === null) {
                      vErrors = [err133];
                    } else {
                      vErrors.push(err133);
                    }
                    errors++;
                  }
                }
              } else {
                const err134 = {
                  instancePath,
                  schemaPath: "LinkNavigationResource/anyOf/2/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err134];
                } else {
                  vErrors.push(err134);
                }
                errors++;
              }
              var _valid2 = _errs135 === errors;
              valid23 = valid23 || _valid2;
              if (!valid23) {
                const _errs147 = errors;
                if (data && typeof data == "object" && !Array.isArray(data)) {
                  if (data.label === void 0) {
                    const err135 = {
                      instancePath,
                      schemaPath: "LinkNavigationResource/anyOf/3/required",
                      keyword: "required",
                      params: {
                        missingProperty: "label"
                      },
                      message: "must have required property 'label'"
                    };
                    if (vErrors === null) {
                      vErrors = [err135];
                    } else {
                      vErrors.push(err135);
                    }
                    errors++;
                  }
                  if (data.linkType === void 0) {
                    const err136 = {
                      instancePath,
                      schemaPath: "LinkNavigationResource/anyOf/3/required",
                      keyword: "required",
                      params: {
                        missingProperty: "linkType"
                      },
                      message: "must have required property 'linkType'"
                    };
                    if (vErrors === null) {
                      vErrors = [err136];
                    } else {
                      vErrors.push(err136);
                    }
                    errors++;
                  }
                  if (data.type === void 0) {
                    const err137 = {
                      instancePath,
                      schemaPath: "LinkNavigationResource/anyOf/3/required",
                      keyword: "required",
                      params: {
                        missingProperty: "type"
                      },
                      message: "must have required property 'type'"
                    };
                    if (vErrors === null) {
                      vErrors = [err137];
                    } else {
                      vErrors.push(err137);
                    }
                    errors++;
                  }
                  if (data.videoId === void 0) {
                    const err138 = {
                      instancePath,
                      schemaPath: "LinkNavigationResource/anyOf/3/required",
                      keyword: "required",
                      params: {
                        missingProperty: "videoId"
                      },
                      message: "must have required property 'videoId'"
                    };
                    if (vErrors === null) {
                      vErrors = [err138];
                    } else {
                      vErrors.push(err138);
                    }
                    errors++;
                  }
                  if (data.linkType !== void 0) {
                    let data58 = data.linkType;
                    if (typeof data58 !== "string") {
                      const err139 = {
                        instancePath: instancePath + "/linkType",
                        schemaPath: "LinkNavigationResource/anyOf/3/properties/linkType/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err139];
                      } else {
                        vErrors.push(err139);
                      }
                      errors++;
                    }
                    if ("video" !== data58) {
                      const err140 = {
                        instancePath: instancePath + "/linkType",
                        schemaPath: "LinkNavigationResource/anyOf/3/properties/linkType/const",
                        keyword: "const",
                        params: {
                          allowedValue: "video"
                        },
                        message: "must be equal to constant"
                      };
                      if (vErrors === null) {
                        vErrors = [err140];
                      } else {
                        vErrors.push(err140);
                      }
                      errors++;
                    }
                  }
                  if (data.videoId !== void 0) {
                    if (typeof data.videoId !== "string") {
                      const err141 = {
                        instancePath: instancePath + "/videoId",
                        schemaPath: "LinkNavigationResource/anyOf/3/properties/videoId/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err141];
                      } else {
                        vErrors.push(err141);
                      }
                      errors++;
                    }
                  }
                  if (data.type !== void 0) {
                    let data60 = data.type;
                    if (typeof data60 !== "string") {
                      const err142 = {
                        instancePath: instancePath + "/type",
                        schemaPath: "LinkNavigationResource/anyOf/3/properties/type/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err142];
                      } else {
                        vErrors.push(err142);
                      }
                      errors++;
                    }
                    if ("LINK" !== data60) {
                      const err143 = {
                        instancePath: instancePath + "/type",
                        schemaPath: "LinkNavigationResource/anyOf/3/properties/type/const",
                        keyword: "const",
                        params: {
                          allowedValue: "LINK"
                        },
                        message: "must be equal to constant"
                      };
                      if (vErrors === null) {
                        vErrors = [err143];
                      } else {
                        vErrors.push(err143);
                      }
                      errors++;
                    }
                  }
                  if (data.label !== void 0) {
                    if (typeof data.label !== "string") {
                      const err144 = {
                        instancePath: instancePath + "/label",
                        schemaPath: "LinkNavigationResource/anyOf/3/properties/label/type",
                        keyword: "type",
                        params: {
                          type: "string"
                        },
                        message: "must be string"
                      };
                      if (vErrors === null) {
                        vErrors = [err144];
                      } else {
                        vErrors.push(err144);
                      }
                      errors++;
                    }
                  }
                  if (data.external !== void 0) {
                    if (typeof data.external !== "boolean") {
                      const err145 = {
                        instancePath: instancePath + "/external",
                        schemaPath: "LinkNavigationResource/anyOf/3/properties/external/type",
                        keyword: "type",
                        params: {
                          type: "boolean"
                        },
                        message: "must be boolean"
                      };
                      if (vErrors === null) {
                        vErrors = [err145];
                      } else {
                        vErrors.push(err145);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err146 = {
                    instancePath,
                    schemaPath: "LinkNavigationResource/anyOf/3/type",
                    keyword: "type",
                    params: {
                      type: "object"
                    },
                    message: "must be object"
                  };
                  if (vErrors === null) {
                    vErrors = [err146];
                  } else {
                    vErrors.push(err146);
                  }
                  errors++;
                }
                var _valid2 = _errs147 === errors;
                valid23 = valid23 || _valid2;
                if (!valid23) {
                  const _errs159 = errors;
                  if (data && typeof data == "object" && !Array.isArray(data)) {
                    if (data.label === void 0) {
                      const err147 = {
                        instancePath,
                        schemaPath: "LinkNavigationResource/anyOf/4/required",
                        keyword: "required",
                        params: {
                          missingProperty: "label"
                        },
                        message: "must have required property 'label'"
                      };
                      if (vErrors === null) {
                        vErrors = [err147];
                      } else {
                        vErrors.push(err147);
                      }
                      errors++;
                    }
                    if (data.linkType === void 0) {
                      const err148 = {
                        instancePath,
                        schemaPath: "LinkNavigationResource/anyOf/4/required",
                        keyword: "required",
                        params: {
                          missingProperty: "linkType"
                        },
                        message: "must have required property 'linkType'"
                      };
                      if (vErrors === null) {
                        vErrors = [err148];
                      } else {
                        vErrors.push(err148);
                      }
                      errors++;
                    }
                    if (data.tagName === void 0) {
                      const err149 = {
                        instancePath,
                        schemaPath: "LinkNavigationResource/anyOf/4/required",
                        keyword: "required",
                        params: {
                          missingProperty: "tagName"
                        },
                        message: "must have required property 'tagName'"
                      };
                      if (vErrors === null) {
                        vErrors = [err149];
                      } else {
                        vErrors.push(err149);
                      }
                      errors++;
                    }
                    if (data.type === void 0) {
                      const err150 = {
                        instancePath,
                        schemaPath: "LinkNavigationResource/anyOf/4/required",
                        keyword: "required",
                        params: {
                          missingProperty: "type"
                        },
                        message: "must have required property 'type'"
                      };
                      if (vErrors === null) {
                        vErrors = [err150];
                      } else {
                        vErrors.push(err150);
                      }
                      errors++;
                    }
                    if (data.linkType !== void 0) {
                      let data63 = data.linkType;
                      if (typeof data63 !== "string") {
                        const err151 = {
                          instancePath: instancePath + "/linkType",
                          schemaPath: "LinkNavigationResource/anyOf/4/properties/linkType/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err151];
                        } else {
                          vErrors.push(err151);
                        }
                        errors++;
                      }
                      if ("tag" !== data63) {
                        const err152 = {
                          instancePath: instancePath + "/linkType",
                          schemaPath: "LinkNavigationResource/anyOf/4/properties/linkType/const",
                          keyword: "const",
                          params: {
                            allowedValue: "tag"
                          },
                          message: "must be equal to constant"
                        };
                        if (vErrors === null) {
                          vErrors = [err152];
                        } else {
                          vErrors.push(err152);
                        }
                        errors++;
                      }
                    }
                    if (data.tagName !== void 0) {
                      if (typeof data.tagName !== "string") {
                        const err153 = {
                          instancePath: instancePath + "/tagName",
                          schemaPath: "LinkNavigationResource/anyOf/4/properties/tagName/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err153];
                        } else {
                          vErrors.push(err153);
                        }
                        errors++;
                      }
                    }
                    if (data.type !== void 0) {
                      let data65 = data.type;
                      if (typeof data65 !== "string") {
                        const err154 = {
                          instancePath: instancePath + "/type",
                          schemaPath: "LinkNavigationResource/anyOf/4/properties/type/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err154];
                        } else {
                          vErrors.push(err154);
                        }
                        errors++;
                      }
                      if ("LINK" !== data65) {
                        const err155 = {
                          instancePath: instancePath + "/type",
                          schemaPath: "LinkNavigationResource/anyOf/4/properties/type/const",
                          keyword: "const",
                          params: {
                            allowedValue: "LINK"
                          },
                          message: "must be equal to constant"
                        };
                        if (vErrors === null) {
                          vErrors = [err155];
                        } else {
                          vErrors.push(err155);
                        }
                        errors++;
                      }
                    }
                    if (data.label !== void 0) {
                      if (typeof data.label !== "string") {
                        const err156 = {
                          instancePath: instancePath + "/label",
                          schemaPath: "LinkNavigationResource/anyOf/4/properties/label/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err156];
                        } else {
                          vErrors.push(err156);
                        }
                        errors++;
                      }
                    }
                    if (data.external !== void 0) {
                      if (typeof data.external !== "boolean") {
                        const err157 = {
                          instancePath: instancePath + "/external",
                          schemaPath: "LinkNavigationResource/anyOf/4/properties/external/type",
                          keyword: "type",
                          params: {
                            type: "boolean"
                          },
                          message: "must be boolean"
                        };
                        if (vErrors === null) {
                          vErrors = [err157];
                        } else {
                          vErrors.push(err157);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err158 = {
                      instancePath,
                      schemaPath: "LinkNavigationResource/anyOf/4/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err158];
                    } else {
                      vErrors.push(err158);
                    }
                    errors++;
                  }
                  var _valid2 = _errs159 === errors;
                  valid23 = valid23 || _valid2;
                }
              }
            }
          }
          if (!valid23) {
            const err159 = {
              instancePath,
              schemaPath: "LinkNavigationResource/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err159];
            } else {
              vErrors.push(err159);
            }
            errors++;
          } else {
            errors = _errs110;
            if (vErrors !== null) {
              if (_errs110) {
                vErrors.length = _errs110;
              } else {
                vErrors = null;
              }
            }
          }
          var _valid0 = _errs108 === errors;
          valid0 = valid0 || _valid0;
        }
      }
    }
  }
  if (!valid0) {
    const err160 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err160];
    } else {
      vErrors.push(err160);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate114.errors = vErrors;
  return errors === 0;
}
const ChannelNavigation = validate115;
function validate115(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (Array.isArray(data)) {
    const len0 = data.length;
    for (let i0 = 0; i0 < len0; i0++) {
      if (!validate114(data[i0], {
        instancePath: instancePath + "/" + i0,
        parentData: data,
        parentDataProperty: i0,
        rootData
      })) {
        vErrors = vErrors === null ? validate114.errors : vErrors.concat(validate114.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "array"
      },
      message: "must be array"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  validate115.errors = vErrors;
  return errors === 0;
}
const Channel = validate117;
const schema128 = {
  "$id": "Channel",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "archived": {
      "type": "boolean"
    },
    "name": {
      "type": "string"
    },
    "description": {
      "type": "string"
    },
    "slug": {
      "type": "string"
    },
    "organizationId": {
      "type": ["string", "null"]
    },
    "country": {
      "type": "string"
    },
    "branding": {
      "$ref": "Branding"
    },
    "pages": {
      "type": "array",
      "items": {
        "$ref": "Page"
      }
    },
    "domain": {
      "type": ["string", "null"]
    },
    "channelNavigation": {
      "$ref": "ChannelNavigation"
    }
  },
  "required": ["archived", "name", "description", "slug", "organizationId", "country", "branding", "pages", "domain"],
  "description": "Aggregates the needed data to render a channel."
};
function validate117(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.archived === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "archived"
        },
        message: "must have required property 'archived'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.name === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "name"
        },
        message: "must have required property 'name'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.description === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "description"
        },
        message: "must have required property 'description'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.slug === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "slug"
        },
        message: "must have required property 'slug'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.organizationId === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "organizationId"
        },
        message: "must have required property 'organizationId'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.country === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "country"
        },
        message: "must have required property 'country'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.branding === void 0) {
      const err6 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "branding"
        },
        message: "must have required property 'branding'"
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.pages === void 0) {
      const err7 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "pages"
        },
        message: "must have required property 'pages'"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.domain === void 0) {
      const err8 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "domain"
        },
        message: "must have required property 'domain'"
      };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    if (data.archived !== void 0) {
      if (typeof data.archived !== "boolean") {
        const err9 = {
          instancePath: instancePath + "/archived",
          schemaPath: "#/properties/archived/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err10 = {
          instancePath: instancePath + "/name",
          schemaPath: "#/properties/name/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.description !== void 0) {
      if (typeof data.description !== "string") {
        const err11 = {
          instancePath: instancePath + "/description",
          schemaPath: "#/properties/description/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.slug !== void 0) {
      if (typeof data.slug !== "string") {
        const err12 = {
          instancePath: instancePath + "/slug",
          schemaPath: "#/properties/slug/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.organizationId !== void 0) {
      let data4 = data.organizationId;
      if (typeof data4 !== "string" && data4 !== null) {
        const err13 = {
          instancePath: instancePath + "/organizationId",
          schemaPath: "#/properties/organizationId/type",
          keyword: "type",
          params: {
            type: schema128.properties.organizationId.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.country !== void 0) {
      if (typeof data.country !== "string") {
        const err14 = {
          instancePath: instancePath + "/country",
          schemaPath: "#/properties/country/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.branding !== void 0) {
      let data6 = data.branding;
      if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
        if (data6.accentColor === void 0) {
          const err15 = {
            instancePath: instancePath + "/branding",
            schemaPath: "Branding/required",
            keyword: "required",
            params: {
              missingProperty: "accentColor"
            },
            message: "must have required property 'accentColor'"
          };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if (data6.backgroundColor === void 0) {
          const err16 = {
            instancePath: instancePath + "/branding",
            schemaPath: "Branding/required",
            keyword: "required",
            params: {
              missingProperty: "backgroundColor"
            },
            message: "must have required property 'backgroundColor'"
          };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
        if (data6.themeStyle === void 0) {
          const err17 = {
            instancePath: instancePath + "/branding",
            schemaPath: "Branding/required",
            keyword: "required",
            params: {
              missingProperty: "themeStyle"
            },
            message: "must have required property 'themeStyle'"
          };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
        if (data6.bannerImages === void 0) {
          const err18 = {
            instancePath: instancePath + "/branding",
            schemaPath: "Branding/required",
            keyword: "required",
            params: {
              missingProperty: "bannerImages"
            },
            message: "must have required property 'bannerImages'"
          };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        if (data6.logoImage === void 0) {
          const err19 = {
            instancePath: instancePath + "/branding",
            schemaPath: "Branding/required",
            keyword: "required",
            params: {
              missingProperty: "logoImage"
            },
            message: "must have required property 'logoImage'"
          };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if (data6.accentColor !== void 0) {
          if (typeof data6.accentColor !== "string") {
            const err20 = {
              instancePath: instancePath + "/branding/accentColor",
              schemaPath: "Branding/properties/accentColor/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err20];
            } else {
              vErrors.push(err20);
            }
            errors++;
          }
        }
        if (data6.backgroundColor !== void 0) {
          if (typeof data6.backgroundColor !== "string") {
            const err21 = {
              instancePath: instancePath + "/branding/backgroundColor",
              schemaPath: "Branding/properties/backgroundColor/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
        }
        if (data6.themeStyle !== void 0) {
          let data9 = data6.themeStyle;
          if (typeof data9 !== "string") {
            const err22 = {
              instancePath: instancePath + "/branding/themeStyle",
              schemaPath: "Branding/properties/themeStyle/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err22];
            } else {
              vErrors.push(err22);
            }
            errors++;
          }
          if (!(data9 === "rounded" || data9 === "hard")) {
            const err23 = {
              instancePath: instancePath + "/branding/themeStyle",
              schemaPath: "Branding/properties/themeStyle/enum",
              keyword: "enum",
              params: {
                allowedValues: schema48.properties.themeStyle.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
        }
        if (data6.bannerImages !== void 0) {
          let data10 = data6.bannerImages;
          if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
            if (data10["3/1"] === void 0) {
              const err24 = {
                instancePath: instancePath + "/branding/bannerImages",
                schemaPath: "Branding/properties/bannerImages/required",
                keyword: "required",
                params: {
                  missingProperty: "3/1"
                },
                message: "must have required property '3/1'"
              };
              if (vErrors === null) {
                vErrors = [err24];
              } else {
                vErrors.push(err24);
              }
              errors++;
            }
            if (data10["3/4"] === void 0) {
              const err25 = {
                instancePath: instancePath + "/branding/bannerImages",
                schemaPath: "Branding/properties/bannerImages/required",
                keyword: "required",
                params: {
                  missingProperty: "3/4"
                },
                message: "must have required property '3/4'"
              };
              if (vErrors === null) {
                vErrors = [err25];
              } else {
                vErrors.push(err25);
              }
              errors++;
            }
            if (data10["16/9"] === void 0) {
              const err26 = {
                instancePath: instancePath + "/branding/bannerImages",
                schemaPath: "Branding/properties/bannerImages/required",
                keyword: "required",
                params: {
                  missingProperty: "16/9"
                },
                message: "must have required property '16/9'"
              };
              if (vErrors === null) {
                vErrors = [err26];
              } else {
                vErrors.push(err26);
              }
              errors++;
            }
            if (data10["3/1"] !== void 0) {
              if (typeof data10["3/1"] !== "string") {
                const err27 = {
                  instancePath: instancePath + "/branding/bannerImages/3~11",
                  schemaPath: "Branding/properties/bannerImages/properties/3~11/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err27];
                } else {
                  vErrors.push(err27);
                }
                errors++;
              }
            }
            if (data10["3/4"] !== void 0) {
              if (typeof data10["3/4"] !== "string") {
                const err28 = {
                  instancePath: instancePath + "/branding/bannerImages/3~14",
                  schemaPath: "Branding/properties/bannerImages/properties/3~14/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err28];
                } else {
                  vErrors.push(err28);
                }
                errors++;
              }
            }
            if (data10["16/9"] !== void 0) {
              if (typeof data10["16/9"] !== "string") {
                const err29 = {
                  instancePath: instancePath + "/branding/bannerImages/16~19",
                  schemaPath: "Branding/properties/bannerImages/properties/16~19/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err29];
                } else {
                  vErrors.push(err29);
                }
                errors++;
              }
            }
          } else {
            const err30 = {
              instancePath: instancePath + "/branding/bannerImages",
              schemaPath: "Branding/properties/bannerImages/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err30];
            } else {
              vErrors.push(err30);
            }
            errors++;
          }
        }
        if (data6.logoImage !== void 0) {
          if (typeof data6.logoImage !== "string") {
            const err31 = {
              instancePath: instancePath + "/branding/logoImage",
              schemaPath: "Branding/properties/logoImage/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
        }
        if (data6.contactInformation !== void 0) {
          let data15 = data6.contactInformation;
          if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
            if (data15.socialMediaLinks === void 0) {
              const err32 = {
                instancePath: instancePath + "/branding/contactInformation",
                schemaPath: "Branding/properties/contactInformation/required",
                keyword: "required",
                params: {
                  missingProperty: "socialMediaLinks"
                },
                message: "must have required property 'socialMediaLinks'"
              };
              if (vErrors === null) {
                vErrors = [err32];
              } else {
                vErrors.push(err32);
              }
              errors++;
            }
            if (data15.contactAddressLines === void 0) {
              const err33 = {
                instancePath: instancePath + "/branding/contactInformation",
                schemaPath: "Branding/properties/contactInformation/required",
                keyword: "required",
                params: {
                  missingProperty: "contactAddressLines"
                },
                message: "must have required property 'contactAddressLines'"
              };
              if (vErrors === null) {
                vErrors = [err33];
              } else {
                vErrors.push(err33);
              }
              errors++;
            }
            if (data15.contactPhone === void 0) {
              const err34 = {
                instancePath: instancePath + "/branding/contactInformation",
                schemaPath: "Branding/properties/contactInformation/required",
                keyword: "required",
                params: {
                  missingProperty: "contactPhone"
                },
                message: "must have required property 'contactPhone'"
              };
              if (vErrors === null) {
                vErrors = [err34];
              } else {
                vErrors.push(err34);
              }
              errors++;
            }
            if (data15.contactEmail === void 0) {
              const err35 = {
                instancePath: instancePath + "/branding/contactInformation",
                schemaPath: "Branding/properties/contactInformation/required",
                keyword: "required",
                params: {
                  missingProperty: "contactEmail"
                },
                message: "must have required property 'contactEmail'"
              };
              if (vErrors === null) {
                vErrors = [err35];
              } else {
                vErrors.push(err35);
              }
              errors++;
            }
            if (data15.supportEmail === void 0) {
              const err36 = {
                instancePath: instancePath + "/branding/contactInformation",
                schemaPath: "Branding/properties/contactInformation/required",
                keyword: "required",
                params: {
                  missingProperty: "supportEmail"
                },
                message: "must have required property 'supportEmail'"
              };
              if (vErrors === null) {
                vErrors = [err36];
              } else {
                vErrors.push(err36);
              }
              errors++;
            }
            if (data15.copyrightNotice === void 0) {
              const err37 = {
                instancePath: instancePath + "/branding/contactInformation",
                schemaPath: "Branding/properties/contactInformation/required",
                keyword: "required",
                params: {
                  missingProperty: "copyrightNotice"
                },
                message: "must have required property 'copyrightNotice'"
              };
              if (vErrors === null) {
                vErrors = [err37];
              } else {
                vErrors.push(err37);
              }
              errors++;
            }
            if (data15.socialMediaLinks !== void 0) {
              let data16 = data15.socialMediaLinks;
              const _errs35 = errors;
              let valid5 = false;
              const _errs36 = errors;
              if (Array.isArray(data16)) {
                const len0 = data16.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data17 = data16[i0];
                  if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                    if (data17.type === void 0) {
                      const err38 = {
                        instancePath: instancePath + "/branding/contactInformation/socialMediaLinks/" + i0,
                        schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/required",
                        keyword: "required",
                        params: {
                          missingProperty: "type"
                        },
                        message: "must have required property 'type'"
                      };
                      if (vErrors === null) {
                        vErrors = [err38];
                      } else {
                        vErrors.push(err38);
                      }
                      errors++;
                    }
                    if (data17.url === void 0) {
                      const err39 = {
                        instancePath: instancePath + "/branding/contactInformation/socialMediaLinks/" + i0,
                        schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/required",
                        keyword: "required",
                        params: {
                          missingProperty: "url"
                        },
                        message: "must have required property 'url'"
                      };
                      if (vErrors === null) {
                        vErrors = [err39];
                      } else {
                        vErrors.push(err39);
                      }
                      errors++;
                    }
                    if (data17.type !== void 0) {
                      if (typeof data17.type !== "string") {
                        const err40 = {
                          instancePath: instancePath + "/branding/contactInformation/socialMediaLinks/" + i0 + "/type",
                          schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/properties/type/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err40];
                        } else {
                          vErrors.push(err40);
                        }
                        errors++;
                      }
                    }
                    if (data17.url !== void 0) {
                      if (typeof data17.url !== "string") {
                        const err41 = {
                          instancePath: instancePath + "/branding/contactInformation/socialMediaLinks/" + i0 + "/url",
                          schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/properties/url/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err41];
                        } else {
                          vErrors.push(err41);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err42 = {
                      instancePath: instancePath + "/branding/contactInformation/socialMediaLinks/" + i0,
                      schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf/0/items/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err42];
                    } else {
                      vErrors.push(err42);
                    }
                    errors++;
                  }
                }
              } else {
                const err43 = {
                  instancePath: instancePath + "/branding/contactInformation/socialMediaLinks",
                  schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf/0/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err43];
                } else {
                  vErrors.push(err43);
                }
                errors++;
              }
              var _valid0 = _errs36 === errors;
              valid5 = valid5 || _valid0;
              if (!valid5) {
                const _errs44 = errors;
                if (data16 !== null) {
                  const err44 = {
                    instancePath: instancePath + "/branding/contactInformation/socialMediaLinks",
                    schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf/1/type",
                    keyword: "type",
                    params: {
                      type: "null"
                    },
                    message: "must be null"
                  };
                  if (vErrors === null) {
                    vErrors = [err44];
                  } else {
                    vErrors.push(err44);
                  }
                  errors++;
                }
                var _valid0 = _errs44 === errors;
                valid5 = valid5 || _valid0;
              }
              if (!valid5) {
                const err45 = {
                  instancePath: instancePath + "/branding/contactInformation/socialMediaLinks",
                  schemaPath: "Branding/properties/contactInformation/properties/socialMediaLinks/anyOf",
                  keyword: "anyOf",
                  params: {},
                  message: "must match a schema in anyOf"
                };
                if (vErrors === null) {
                  vErrors = [err45];
                } else {
                  vErrors.push(err45);
                }
                errors++;
              } else {
                errors = _errs35;
                if (vErrors !== null) {
                  if (_errs35) {
                    vErrors.length = _errs35;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data15.contactAddressLines !== void 0) {
              let data20 = data15.contactAddressLines;
              const _errs47 = errors;
              let valid9 = false;
              const _errs48 = errors;
              if (Array.isArray(data20)) {
                const len1 = data20.length;
                for (let i1 = 0; i1 < len1; i1++) {
                  if (typeof data20[i1] !== "string") {
                    const err46 = {
                      instancePath: instancePath + "/branding/contactInformation/contactAddressLines/" + i1,
                      schemaPath: "Branding/properties/contactInformation/properties/contactAddressLines/anyOf/0/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err46];
                    } else {
                      vErrors.push(err46);
                    }
                    errors++;
                  }
                }
              } else {
                const err47 = {
                  instancePath: instancePath + "/branding/contactInformation/contactAddressLines",
                  schemaPath: "Branding/properties/contactInformation/properties/contactAddressLines/anyOf/0/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err47];
                } else {
                  vErrors.push(err47);
                }
                errors++;
              }
              var _valid1 = _errs48 === errors;
              valid9 = valid9 || _valid1;
              if (!valid9) {
                const _errs52 = errors;
                if (data20 !== null) {
                  const err48 = {
                    instancePath: instancePath + "/branding/contactInformation/contactAddressLines",
                    schemaPath: "Branding/properties/contactInformation/properties/contactAddressLines/anyOf/1/type",
                    keyword: "type",
                    params: {
                      type: "null"
                    },
                    message: "must be null"
                  };
                  if (vErrors === null) {
                    vErrors = [err48];
                  } else {
                    vErrors.push(err48);
                  }
                  errors++;
                }
                var _valid1 = _errs52 === errors;
                valid9 = valid9 || _valid1;
              }
              if (!valid9) {
                const err49 = {
                  instancePath: instancePath + "/branding/contactInformation/contactAddressLines",
                  schemaPath: "Branding/properties/contactInformation/properties/contactAddressLines/anyOf",
                  keyword: "anyOf",
                  params: {},
                  message: "must match a schema in anyOf"
                };
                if (vErrors === null) {
                  vErrors = [err49];
                } else {
                  vErrors.push(err49);
                }
                errors++;
              } else {
                errors = _errs47;
                if (vErrors !== null) {
                  if (_errs47) {
                    vErrors.length = _errs47;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data15.contactPhone !== void 0) {
              let data22 = data15.contactPhone;
              if (typeof data22 !== "string" && data22 !== null) {
                const err50 = {
                  instancePath: instancePath + "/branding/contactInformation/contactPhone",
                  schemaPath: "Branding/properties/contactInformation/properties/contactPhone/type",
                  keyword: "type",
                  params: {
                    type: schema48.properties.contactInformation.properties.contactPhone.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err50];
                } else {
                  vErrors.push(err50);
                }
                errors++;
              }
            }
            if (data15.contactEmail !== void 0) {
              let data23 = data15.contactEmail;
              if (typeof data23 !== "string" && data23 !== null) {
                const err51 = {
                  instancePath: instancePath + "/branding/contactInformation/contactEmail",
                  schemaPath: "Branding/properties/contactInformation/properties/contactEmail/type",
                  keyword: "type",
                  params: {
                    type: schema48.properties.contactInformation.properties.contactEmail.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err51];
                } else {
                  vErrors.push(err51);
                }
                errors++;
              }
            }
            if (data15.streamHelpText !== void 0) {
              let data24 = data15.streamHelpText;
              if (typeof data24 !== "string" && data24 !== null) {
                const err52 = {
                  instancePath: instancePath + "/branding/contactInformation/streamHelpText",
                  schemaPath: "Branding/properties/contactInformation/properties/streamHelpText/type",
                  keyword: "type",
                  params: {
                    type: schema48.properties.contactInformation.properties.streamHelpText.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err52];
                } else {
                  vErrors.push(err52);
                }
                errors++;
              }
            }
            if (data15.supportEmail !== void 0) {
              let data25 = data15.supportEmail;
              if (typeof data25 !== "string" && data25 !== null) {
                const err53 = {
                  instancePath: instancePath + "/branding/contactInformation/supportEmail",
                  schemaPath: "Branding/properties/contactInformation/properties/supportEmail/type",
                  keyword: "type",
                  params: {
                    type: schema48.properties.contactInformation.properties.supportEmail.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err53];
                } else {
                  vErrors.push(err53);
                }
                errors++;
              }
            }
            if (data15.faqLink !== void 0) {
              let data26 = data15.faqLink;
              if (typeof data26 !== "string" && data26 !== null) {
                const err54 = {
                  instancePath: instancePath + "/branding/contactInformation/faqLink",
                  schemaPath: "Branding/properties/contactInformation/properties/faqLink/type",
                  keyword: "type",
                  params: {
                    type: schema48.properties.contactInformation.properties.faqLink.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err54];
                } else {
                  vErrors.push(err54);
                }
                errors++;
              }
            }
            if (data15.copyrightNotice !== void 0) {
              let data27 = data15.copyrightNotice;
              if (typeof data27 !== "string" && data27 !== null) {
                const err55 = {
                  instancePath: instancePath + "/branding/contactInformation/copyrightNotice",
                  schemaPath: "Branding/properties/contactInformation/properties/copyrightNotice/type",
                  keyword: "type",
                  params: {
                    type: schema48.properties.contactInformation.properties.copyrightNotice.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err55];
                } else {
                  vErrors.push(err55);
                }
                errors++;
              }
            }
            if (data15.privacyPolicy !== void 0) {
              let data28 = data15.privacyPolicy;
              const _errs67 = errors;
              let valid12 = false;
              const _errs68 = errors;
              if (Array.isArray(data28)) {
                const len2 = data28.length;
                for (let i2 = 0; i2 < len2; i2++) {
                  if (typeof data28[i2] !== "string") {
                    const err56 = {
                      instancePath: instancePath + "/branding/contactInformation/privacyPolicy/" + i2,
                      schemaPath: "Branding/properties/contactInformation/properties/privacyPolicy/anyOf/0/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err56];
                    } else {
                      vErrors.push(err56);
                    }
                    errors++;
                  }
                }
              } else {
                const err57 = {
                  instancePath: instancePath + "/branding/contactInformation/privacyPolicy",
                  schemaPath: "Branding/properties/contactInformation/properties/privacyPolicy/anyOf/0/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err57];
                } else {
                  vErrors.push(err57);
                }
                errors++;
              }
              var _valid2 = _errs68 === errors;
              valid12 = valid12 || _valid2;
              if (!valid12) {
                const _errs72 = errors;
                if (data28 !== null) {
                  const err58 = {
                    instancePath: instancePath + "/branding/contactInformation/privacyPolicy",
                    schemaPath: "Branding/properties/contactInformation/properties/privacyPolicy/anyOf/1/type",
                    keyword: "type",
                    params: {
                      type: "null"
                    },
                    message: "must be null"
                  };
                  if (vErrors === null) {
                    vErrors = [err58];
                  } else {
                    vErrors.push(err58);
                  }
                  errors++;
                }
                var _valid2 = _errs72 === errors;
                valid12 = valid12 || _valid2;
              }
              if (!valid12) {
                const err59 = {
                  instancePath: instancePath + "/branding/contactInformation/privacyPolicy",
                  schemaPath: "Branding/properties/contactInformation/properties/privacyPolicy/anyOf",
                  keyword: "anyOf",
                  params: {},
                  message: "must match a schema in anyOf"
                };
                if (vErrors === null) {
                  vErrors = [err59];
                } else {
                  vErrors.push(err59);
                }
                errors++;
              } else {
                errors = _errs67;
                if (vErrors !== null) {
                  if (_errs67) {
                    vErrors.length = _errs67;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data15.logoImage !== void 0) {
              let data30 = data15.logoImage;
              if (typeof data30 !== "string" && data30 !== null) {
                const err60 = {
                  instancePath: instancePath + "/branding/contactInformation/logoImage",
                  schemaPath: "Branding/properties/contactInformation/properties/logoImage/type",
                  keyword: "type",
                  params: {
                    type: schema48.properties.contactInformation.properties.logoImage.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err60];
                } else {
                  vErrors.push(err60);
                }
                errors++;
              }
            }
          } else {
            const err61 = {
              instancePath: instancePath + "/branding/contactInformation",
              schemaPath: "Branding/properties/contactInformation/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err61];
            } else {
              vErrors.push(err61);
            }
            errors++;
          }
        }
      } else {
        const err62 = {
          instancePath: instancePath + "/branding",
          schemaPath: "Branding/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err62];
        } else {
          vErrors.push(err62);
        }
        errors++;
      }
    }
    if (data.pages !== void 0) {
      let data31 = data.pages;
      if (Array.isArray(data31)) {
        const len3 = data31.length;
        for (let i3 = 0; i3 < len3; i3++) {
          if (!validate106(data31[i3], {
            instancePath: instancePath + "/pages/" + i3,
            parentData: data31,
            parentDataProperty: i3,
            rootData
          })) {
            vErrors = vErrors === null ? validate106.errors : vErrors.concat(validate106.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err63 = {
          instancePath: instancePath + "/pages",
          schemaPath: "#/properties/pages/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err63];
        } else {
          vErrors.push(err63);
        }
        errors++;
      }
    }
    if (data.domain !== void 0) {
      let data33 = data.domain;
      if (typeof data33 !== "string" && data33 !== null) {
        const err64 = {
          instancePath: instancePath + "/domain",
          schemaPath: "#/properties/domain/type",
          keyword: "type",
          params: {
            type: schema128.properties.domain.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err64];
        } else {
          vErrors.push(err64);
        }
        errors++;
      }
    }
    if (data.channelNavigation !== void 0) {
      if (!validate115(data.channelNavigation, {
        instancePath: instancePath + "/channelNavigation",
        parentData: data,
        parentDataProperty: "channelNavigation",
        rootData
      })) {
        vErrors = vErrors === null ? validate115.errors : vErrors.concat(validate115.errors);
        errors = vErrors.length;
      }
    }
  } else {
    const err65 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err65];
    } else {
      vErrors.push(err65);
    }
    errors++;
  }
  validate117.errors = vErrors;
  return errors === 0;
}
const UserConsentRequest = validate120;
const schema130 = {
  "$id": "UserConsentRequest",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "id": {
      "type": "string"
    },
    "title": {
      "type": "string"
    },
    "description": {
      "type": "string"
    },
    "version": {
      "type": "number"
    },
    "group": {
      "type": ["string", "null"]
    }
  },
  "required": ["id", "title", "description", "version", "group"]
};
function validate120(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "id"
        },
        message: "must have required property 'id'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.title === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "title"
        },
        message: "must have required property 'title'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.description === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "description"
        },
        message: "must have required property 'description'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.version === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "version"
        },
        message: "must have required property 'version'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.group === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "group"
        },
        message: "must have required property 'group'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.id !== void 0) {
      if (typeof data.id !== "string") {
        const err5 = {
          instancePath: instancePath + "/id",
          schemaPath: "#/properties/id/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.title !== void 0) {
      if (typeof data.title !== "string") {
        const err6 = {
          instancePath: instancePath + "/title",
          schemaPath: "#/properties/title/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.description !== void 0) {
      if (typeof data.description !== "string") {
        const err7 = {
          instancePath: instancePath + "/description",
          schemaPath: "#/properties/description/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.version !== void 0) {
      let data3 = data.version;
      if (!(typeof data3 == "number" && isFinite(data3))) {
        const err8 = {
          instancePath: instancePath + "/version",
          schemaPath: "#/properties/version/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.group !== void 0) {
      let data4 = data.group;
      if (typeof data4 !== "string" && data4 !== null) {
        const err9 = {
          instancePath: instancePath + "/group",
          schemaPath: "#/properties/group/type",
          keyword: "type",
          params: {
            type: schema130.properties.group.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
  } else {
    const err10 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
  }
  validate120.errors = vErrors;
  return errors === 0;
}
const ChannelTerms = validate121;
function validate121(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "id"
        },
        message: "must have required property 'id'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.version === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "version"
        },
        message: "must have required property 'version'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.title === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "title"
        },
        message: "must have required property 'title'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.description === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "description"
        },
        message: "must have required property 'description'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.externalLink === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "externalLink"
        },
        message: "must have required property 'externalLink'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.id !== void 0) {
      if (typeof data.id !== "string") {
        const err5 = {
          instancePath: instancePath + "/id",
          schemaPath: "#/properties/id/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.version !== void 0) {
      let data1 = data.version;
      if (!(typeof data1 == "number" && isFinite(data1))) {
        const err6 = {
          instancePath: instancePath + "/version",
          schemaPath: "#/properties/version/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.title !== void 0) {
      if (typeof data.title !== "string") {
        const err7 = {
          instancePath: instancePath + "/title",
          schemaPath: "#/properties/title/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.description !== void 0) {
      if (typeof data.description !== "string") {
        const err8 = {
          instancePath: instancePath + "/description",
          schemaPath: "#/properties/description/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.externalLink !== void 0) {
      if (typeof data.externalLink !== "string") {
        const err9 = {
          instancePath: instancePath + "/externalLink",
          schemaPath: "#/properties/externalLink/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
  } else {
    const err10 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
  }
  validate121.errors = vErrors;
  return errors === 0;
}
const UserConsentSettings = validate122;
function validate122(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.groups === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "groups"
        },
        message: "must have required property 'groups'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.requests === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "requests"
        },
        message: "must have required property 'requests'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.terms === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "terms"
        },
        message: "must have required property 'terms'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.groups !== void 0) {
      let data0 = data.groups;
      if (Array.isArray(data0)) {
        const len0 = data0.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data1 = data0[i0];
          if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
            if (data1.id === void 0) {
              const err3 = {
                instancePath: instancePath + "/groups/" + i0,
                schemaPath: "#/properties/groups/items/required",
                keyword: "required",
                params: {
                  missingProperty: "id"
                },
                message: "must have required property 'id'"
              };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
            }
            if (data1.title === void 0) {
              const err4 = {
                instancePath: instancePath + "/groups/" + i0,
                schemaPath: "#/properties/groups/items/required",
                keyword: "required",
                params: {
                  missingProperty: "title"
                },
                message: "must have required property 'title'"
              };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
            if (data1.id !== void 0) {
              if (typeof data1.id !== "string") {
                const err5 = {
                  instancePath: instancePath + "/groups/" + i0 + "/id",
                  schemaPath: "#/properties/groups/items/properties/id/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
              }
            }
            if (data1.title !== void 0) {
              if (typeof data1.title !== "string") {
                const err6 = {
                  instancePath: instancePath + "/groups/" + i0 + "/title",
                  schemaPath: "#/properties/groups/items/properties/title/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            }
          } else {
            const err7 = {
              instancePath: instancePath + "/groups/" + i0,
              schemaPath: "#/properties/groups/items/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
          }
        }
      } else {
        const err8 = {
          instancePath: instancePath + "/groups",
          schemaPath: "#/properties/groups/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.requests !== void 0) {
      let data4 = data.requests;
      if (Array.isArray(data4)) {
        const len1 = data4.length;
        for (let i1 = 0; i1 < len1; i1++) {
          let data5 = data4[i1];
          if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
            if (data5.id === void 0) {
              const err9 = {
                instancePath: instancePath + "/requests/" + i1,
                schemaPath: "UserConsentRequest/required",
                keyword: "required",
                params: {
                  missingProperty: "id"
                },
                message: "must have required property 'id'"
              };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            if (data5.title === void 0) {
              const err10 = {
                instancePath: instancePath + "/requests/" + i1,
                schemaPath: "UserConsentRequest/required",
                keyword: "required",
                params: {
                  missingProperty: "title"
                },
                message: "must have required property 'title'"
              };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            if (data5.description === void 0) {
              const err11 = {
                instancePath: instancePath + "/requests/" + i1,
                schemaPath: "UserConsentRequest/required",
                keyword: "required",
                params: {
                  missingProperty: "description"
                },
                message: "must have required property 'description'"
              };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            if (data5.version === void 0) {
              const err12 = {
                instancePath: instancePath + "/requests/" + i1,
                schemaPath: "UserConsentRequest/required",
                keyword: "required",
                params: {
                  missingProperty: "version"
                },
                message: "must have required property 'version'"
              };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            if (data5.group === void 0) {
              const err13 = {
                instancePath: instancePath + "/requests/" + i1,
                schemaPath: "UserConsentRequest/required",
                keyword: "required",
                params: {
                  missingProperty: "group"
                },
                message: "must have required property 'group'"
              };
              if (vErrors === null) {
                vErrors = [err13];
              } else {
                vErrors.push(err13);
              }
              errors++;
            }
            if (data5.id !== void 0) {
              if (typeof data5.id !== "string") {
                const err14 = {
                  instancePath: instancePath + "/requests/" + i1 + "/id",
                  schemaPath: "UserConsentRequest/properties/id/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
            if (data5.title !== void 0) {
              if (typeof data5.title !== "string") {
                const err15 = {
                  instancePath: instancePath + "/requests/" + i1 + "/title",
                  schemaPath: "UserConsentRequest/properties/title/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
              }
            }
            if (data5.description !== void 0) {
              if (typeof data5.description !== "string") {
                const err16 = {
                  instancePath: instancePath + "/requests/" + i1 + "/description",
                  schemaPath: "UserConsentRequest/properties/description/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
            }
            if (data5.version !== void 0) {
              let data9 = data5.version;
              if (!(typeof data9 == "number" && isFinite(data9))) {
                const err17 = {
                  instancePath: instancePath + "/requests/" + i1 + "/version",
                  schemaPath: "UserConsentRequest/properties/version/type",
                  keyword: "type",
                  params: {
                    type: "number"
                  },
                  message: "must be number"
                };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
              }
            }
            if (data5.group !== void 0) {
              let data10 = data5.group;
              if (typeof data10 !== "string" && data10 !== null) {
                const err18 = {
                  instancePath: instancePath + "/requests/" + i1 + "/group",
                  schemaPath: "UserConsentRequest/properties/group/type",
                  keyword: "type",
                  params: {
                    type: schema130.properties.group.type
                  },
                  message: "must be string,null"
                };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
            }
          } else {
            const err19 = {
              instancePath: instancePath + "/requests/" + i1,
              schemaPath: "UserConsentRequest/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err19];
            } else {
              vErrors.push(err19);
            }
            errors++;
          }
        }
      } else {
        const err20 = {
          instancePath: instancePath + "/requests",
          schemaPath: "#/properties/requests/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
    }
    if (data.terms !== void 0) {
      let data11 = data.terms;
      if (Array.isArray(data11)) {
        const len2 = data11.length;
        for (let i2 = 0; i2 < len2; i2++) {
          let data12 = data11[i2];
          if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
            if (data12.id === void 0) {
              const err21 = {
                instancePath: instancePath + "/terms/" + i2,
                schemaPath: "ChannelTerms/required",
                keyword: "required",
                params: {
                  missingProperty: "id"
                },
                message: "must have required property 'id'"
              };
              if (vErrors === null) {
                vErrors = [err21];
              } else {
                vErrors.push(err21);
              }
              errors++;
            }
            if (data12.version === void 0) {
              const err22 = {
                instancePath: instancePath + "/terms/" + i2,
                schemaPath: "ChannelTerms/required",
                keyword: "required",
                params: {
                  missingProperty: "version"
                },
                message: "must have required property 'version'"
              };
              if (vErrors === null) {
                vErrors = [err22];
              } else {
                vErrors.push(err22);
              }
              errors++;
            }
            if (data12.title === void 0) {
              const err23 = {
                instancePath: instancePath + "/terms/" + i2,
                schemaPath: "ChannelTerms/required",
                keyword: "required",
                params: {
                  missingProperty: "title"
                },
                message: "must have required property 'title'"
              };
              if (vErrors === null) {
                vErrors = [err23];
              } else {
                vErrors.push(err23);
              }
              errors++;
            }
            if (data12.description === void 0) {
              const err24 = {
                instancePath: instancePath + "/terms/" + i2,
                schemaPath: "ChannelTerms/required",
                keyword: "required",
                params: {
                  missingProperty: "description"
                },
                message: "must have required property 'description'"
              };
              if (vErrors === null) {
                vErrors = [err24];
              } else {
                vErrors.push(err24);
              }
              errors++;
            }
            if (data12.externalLink === void 0) {
              const err25 = {
                instancePath: instancePath + "/terms/" + i2,
                schemaPath: "ChannelTerms/required",
                keyword: "required",
                params: {
                  missingProperty: "externalLink"
                },
                message: "must have required property 'externalLink'"
              };
              if (vErrors === null) {
                vErrors = [err25];
              } else {
                vErrors.push(err25);
              }
              errors++;
            }
            if (data12.id !== void 0) {
              if (typeof data12.id !== "string") {
                const err26 = {
                  instancePath: instancePath + "/terms/" + i2 + "/id",
                  schemaPath: "ChannelTerms/properties/id/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err26];
                } else {
                  vErrors.push(err26);
                }
                errors++;
              }
            }
            if (data12.version !== void 0) {
              let data14 = data12.version;
              if (!(typeof data14 == "number" && isFinite(data14))) {
                const err27 = {
                  instancePath: instancePath + "/terms/" + i2 + "/version",
                  schemaPath: "ChannelTerms/properties/version/type",
                  keyword: "type",
                  params: {
                    type: "number"
                  },
                  message: "must be number"
                };
                if (vErrors === null) {
                  vErrors = [err27];
                } else {
                  vErrors.push(err27);
                }
                errors++;
              }
            }
            if (data12.title !== void 0) {
              if (typeof data12.title !== "string") {
                const err28 = {
                  instancePath: instancePath + "/terms/" + i2 + "/title",
                  schemaPath: "ChannelTerms/properties/title/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err28];
                } else {
                  vErrors.push(err28);
                }
                errors++;
              }
            }
            if (data12.description !== void 0) {
              if (typeof data12.description !== "string") {
                const err29 = {
                  instancePath: instancePath + "/terms/" + i2 + "/description",
                  schemaPath: "ChannelTerms/properties/description/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err29];
                } else {
                  vErrors.push(err29);
                }
                errors++;
              }
            }
            if (data12.externalLink !== void 0) {
              if (typeof data12.externalLink !== "string") {
                const err30 = {
                  instancePath: instancePath + "/terms/" + i2 + "/externalLink",
                  schemaPath: "ChannelTerms/properties/externalLink/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err30];
                } else {
                  vErrors.push(err30);
                }
                errors++;
              }
            }
          } else {
            const err31 = {
              instancePath: instancePath + "/terms/" + i2,
              schemaPath: "ChannelTerms/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
        }
      } else {
        const err32 = {
          instancePath: instancePath + "/terms",
          schemaPath: "#/properties/terms/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err32];
        } else {
          vErrors.push(err32);
        }
        errors++;
      }
    }
  } else {
    const err33 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err33];
    } else {
      vErrors.push(err33);
    }
    errors++;
  }
  validate122.errors = vErrors;
  return errors === 0;
}
const Testimonial = validate123;
function validate123(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.imageUrl === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "imageUrl"
        },
        message: "must have required property 'imageUrl'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.quote === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "quote"
        },
        message: "must have required property 'quote'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.name === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "name"
        },
        message: "must have required property 'name'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.role === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "role"
        },
        message: "must have required property 'role'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.imageUrl !== void 0) {
      if (typeof data.imageUrl !== "string") {
        const err4 = {
          instancePath: instancePath + "/imageUrl",
          schemaPath: "#/properties/imageUrl/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.quote !== void 0) {
      if (typeof data.quote !== "string") {
        const err5 = {
          instancePath: instancePath + "/quote",
          schemaPath: "#/properties/quote/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err6 = {
          instancePath: instancePath + "/name",
          schemaPath: "#/properties/name/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.role !== void 0) {
      if (typeof data.role !== "string") {
        const err7 = {
          instancePath: instancePath + "/role",
          schemaPath: "#/properties/role/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
  } else {
    const err8 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err8];
    } else {
      vErrors.push(err8);
    }
    errors++;
  }
  validate123.errors = vErrors;
  return errors === 0;
}
const ViewerRetentionSettings = validate124;
function validate124(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.title === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "title"
        },
        message: "must have required property 'title'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.testimonials === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "testimonials"
        },
        message: "must have required property 'testimonials'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.cancellationReasons === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "cancellationReasons"
        },
        message: "must have required property 'cancellationReasons'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.title !== void 0) {
      if (typeof data.title !== "string") {
        const err3 = {
          instancePath: instancePath + "/title",
          schemaPath: "#/properties/title/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.testimonials !== void 0) {
      let data1 = data.testimonials;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.imageUrl === void 0) {
              const err4 = {
                instancePath: instancePath + "/testimonials/" + i0,
                schemaPath: "Testimonial/required",
                keyword: "required",
                params: {
                  missingProperty: "imageUrl"
                },
                message: "must have required property 'imageUrl'"
              };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
            if (data2.quote === void 0) {
              const err5 = {
                instancePath: instancePath + "/testimonials/" + i0,
                schemaPath: "Testimonial/required",
                keyword: "required",
                params: {
                  missingProperty: "quote"
                },
                message: "must have required property 'quote'"
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if (data2.name === void 0) {
              const err6 = {
                instancePath: instancePath + "/testimonials/" + i0,
                schemaPath: "Testimonial/required",
                keyword: "required",
                params: {
                  missingProperty: "name"
                },
                message: "must have required property 'name'"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            if (data2.role === void 0) {
              const err7 = {
                instancePath: instancePath + "/testimonials/" + i0,
                schemaPath: "Testimonial/required",
                keyword: "required",
                params: {
                  missingProperty: "role"
                },
                message: "must have required property 'role'"
              };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            if (data2.imageUrl !== void 0) {
              if (typeof data2.imageUrl !== "string") {
                const err8 = {
                  instancePath: instancePath + "/testimonials/" + i0 + "/imageUrl",
                  schemaPath: "Testimonial/properties/imageUrl/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
            }
            if (data2.quote !== void 0) {
              if (typeof data2.quote !== "string") {
                const err9 = {
                  instancePath: instancePath + "/testimonials/" + i0 + "/quote",
                  schemaPath: "Testimonial/properties/quote/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
            }
            if (data2.name !== void 0) {
              if (typeof data2.name !== "string") {
                const err10 = {
                  instancePath: instancePath + "/testimonials/" + i0 + "/name",
                  schemaPath: "Testimonial/properties/name/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
            }
            if (data2.role !== void 0) {
              if (typeof data2.role !== "string") {
                const err11 = {
                  instancePath: instancePath + "/testimonials/" + i0 + "/role",
                  schemaPath: "Testimonial/properties/role/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err11];
                } else {
                  vErrors.push(err11);
                }
                errors++;
              }
            }
          } else {
            const err12 = {
              instancePath: instancePath + "/testimonials/" + i0,
              schemaPath: "Testimonial/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
        }
      } else {
        const err13 = {
          instancePath: instancePath + "/testimonials",
          schemaPath: "#/properties/testimonials/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.cancellationReasons !== void 0) {
      let data7 = data.cancellationReasons;
      if (Array.isArray(data7)) {
        const len1 = data7.length;
        for (let i1 = 0; i1 < len1; i1++) {
          if (typeof data7[i1] !== "string") {
            const err14 = {
              instancePath: instancePath + "/cancellationReasons/" + i1,
              schemaPath: "#/properties/cancellationReasons/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err14];
            } else {
              vErrors.push(err14);
            }
            errors++;
          }
        }
      } else {
        const err15 = {
          instancePath: instancePath + "/cancellationReasons",
          schemaPath: "#/properties/cancellationReasons/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
  } else {
    const err16 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err16];
    } else {
      vErrors.push(err16);
    }
    errors++;
  }
  validate124.errors = vErrors;
  return errors === 0;
}
const VideoAttributeValue = validate125;
function validate125(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.name === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "name"
        },
        message: "must have required property 'name'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err1 = {
          instancePath: instancePath + "/name",
          schemaPath: "#/properties/name/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.icon !== void 0) {
      if (typeof data.icon !== "string") {
        const err2 = {
          instancePath: instancePath + "/icon",
          schemaPath: "#/properties/icon/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.group !== void 0) {
      if (typeof data.group !== "string") {
        const err3 = {
          instancePath: instancePath + "/group",
          schemaPath: "#/properties/group/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.label !== void 0) {
      if (typeof data.label !== "string") {
        const err4 = {
          instancePath: instancePath + "/label",
          schemaPath: "#/properties/label/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate125.errors = vErrors;
  return errors === 0;
}
const VideoAttribute = validate126;
function validate126(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.name === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "name"
        },
        message: "must have required property 'name'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.label === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "label"
        },
        message: "must have required property 'label'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.values === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "values"
        },
        message: "must have required property 'values'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err3 = {
          instancePath: instancePath + "/name",
          schemaPath: "#/properties/name/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.label !== void 0) {
      if (typeof data.label !== "string") {
        const err4 = {
          instancePath: instancePath + "/label",
          schemaPath: "#/properties/label/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.icon !== void 0) {
      if (typeof data.icon !== "string") {
        const err5 = {
          instancePath: instancePath + "/icon",
          schemaPath: "#/properties/icon/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.groups !== void 0) {
      let data3 = data.groups;
      if (Array.isArray(data3)) {
        const len0 = data3.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data4 = data3[i0];
          if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
            if (data4.id === void 0) {
              const err6 = {
                instancePath: instancePath + "/groups/" + i0,
                schemaPath: "#/properties/groups/items/required",
                keyword: "required",
                params: {
                  missingProperty: "id"
                },
                message: "must have required property 'id'"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            if (data4.label === void 0) {
              const err7 = {
                instancePath: instancePath + "/groups/" + i0,
                schemaPath: "#/properties/groups/items/required",
                keyword: "required",
                params: {
                  missingProperty: "label"
                },
                message: "must have required property 'label'"
              };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            if (data4.id !== void 0) {
              if (typeof data4.id !== "string") {
                const err8 = {
                  instancePath: instancePath + "/groups/" + i0 + "/id",
                  schemaPath: "#/properties/groups/items/properties/id/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
            }
            if (data4.label !== void 0) {
              if (typeof data4.label !== "string") {
                const err9 = {
                  instancePath: instancePath + "/groups/" + i0 + "/label",
                  schemaPath: "#/properties/groups/items/properties/label/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
            }
          } else {
            const err10 = {
              instancePath: instancePath + "/groups/" + i0,
              schemaPath: "#/properties/groups/items/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err10];
            } else {
              vErrors.push(err10);
            }
            errors++;
          }
        }
      } else {
        const err11 = {
          instancePath: instancePath + "/groups",
          schemaPath: "#/properties/groups/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.videoAnalyticsKey !== void 0) {
      if (typeof data.videoAnalyticsKey !== "string") {
        const err12 = {
          instancePath: instancePath + "/videoAnalyticsKey",
          schemaPath: "#/properties/videoAnalyticsKey/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.values !== void 0) {
      let data8 = data.values;
      if (Array.isArray(data8)) {
        const len1 = data8.length;
        for (let i1 = 0; i1 < len1; i1++) {
          let data9 = data8[i1];
          if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
            if (data9.name === void 0) {
              const err13 = {
                instancePath: instancePath + "/values/" + i1,
                schemaPath: "VideoAttributeValue/required",
                keyword: "required",
                params: {
                  missingProperty: "name"
                },
                message: "must have required property 'name'"
              };
              if (vErrors === null) {
                vErrors = [err13];
              } else {
                vErrors.push(err13);
              }
              errors++;
            }
            if (data9.name !== void 0) {
              if (typeof data9.name !== "string") {
                const err14 = {
                  instancePath: instancePath + "/values/" + i1 + "/name",
                  schemaPath: "VideoAttributeValue/properties/name/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
            if (data9.icon !== void 0) {
              if (typeof data9.icon !== "string") {
                const err15 = {
                  instancePath: instancePath + "/values/" + i1 + "/icon",
                  schemaPath: "VideoAttributeValue/properties/icon/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
              }
            }
            if (data9.group !== void 0) {
              if (typeof data9.group !== "string") {
                const err16 = {
                  instancePath: instancePath + "/values/" + i1 + "/group",
                  schemaPath: "VideoAttributeValue/properties/group/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
            }
            if (data9.label !== void 0) {
              if (typeof data9.label !== "string") {
                const err17 = {
                  instancePath: instancePath + "/values/" + i1 + "/label",
                  schemaPath: "VideoAttributeValue/properties/label/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
              }
            }
          } else {
            const err18 = {
              instancePath: instancePath + "/values/" + i1,
              schemaPath: "VideoAttributeValue/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err18];
            } else {
              vErrors.push(err18);
            }
            errors++;
          }
        }
      } else {
        const err19 = {
          instancePath: instancePath + "/values",
          schemaPath: "#/properties/values/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      }
    }
  } else {
    const err20 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err20];
    } else {
      vErrors.push(err20);
    }
    errors++;
  }
  validate126.errors = vErrors;
  return errors === 0;
}
const VideoAttributesMapping = validate127;
function validate127(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.mappings === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "mappings"
        },
        message: "must have required property 'mappings'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.useNamedTagAsAttribute !== void 0) {
      let data0 = data.useNamedTagAsAttribute;
      if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
        if (data0.type === void 0) {
          const err1 = {
            instancePath: instancePath + "/useNamedTagAsAttribute",
            schemaPath: "#/properties/useNamedTagAsAttribute/required",
            keyword: "required",
            params: {
              missingProperty: "type"
            },
            message: "must have required property 'type'"
          };
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        }
        if (data0.label === void 0) {
          const err2 = {
            instancePath: instancePath + "/useNamedTagAsAttribute",
            schemaPath: "#/properties/useNamedTagAsAttribute/required",
            keyword: "required",
            params: {
              missingProperty: "label"
            },
            message: "must have required property 'label'"
          };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (data0.showIcon === void 0) {
          const err3 = {
            instancePath: instancePath + "/useNamedTagAsAttribute",
            schemaPath: "#/properties/useNamedTagAsAttribute/required",
            keyword: "required",
            params: {
              missingProperty: "showIcon"
            },
            message: "must have required property 'showIcon'"
          };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
        if (data0.type !== void 0) {
          let data1 = data0.type;
          if (typeof data1 !== "string") {
            const err4 = {
              instancePath: instancePath + "/useNamedTagAsAttribute/type",
              schemaPath: "NamedTagType/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err4];
            } else {
              vErrors.push(err4);
            }
            errors++;
          }
          if (!(data1 === "EVENT" || data1 === "ATHLETE" || data1 === "PLACE" || data1 === "TOURNAMENT" || data1 === "TEAM" || data1 === "SEASON")) {
            const err5 = {
              instancePath: instancePath + "/useNamedTagAsAttribute/type",
              schemaPath: "NamedTagType/enum",
              keyword: "enum",
              params: {
                allowedValues: schema118.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err5];
            } else {
              vErrors.push(err5);
            }
            errors++;
          }
        }
        if (data0.label !== void 0) {
          if (typeof data0.label !== "string") {
            const err6 = {
              instancePath: instancePath + "/useNamedTagAsAttribute/label",
              schemaPath: "#/properties/useNamedTagAsAttribute/properties/label/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err6];
            } else {
              vErrors.push(err6);
            }
            errors++;
          }
        }
        if (data0.showIcon !== void 0) {
          if (typeof data0.showIcon !== "boolean") {
            const err7 = {
              instancePath: instancePath + "/useNamedTagAsAttribute/showIcon",
              schemaPath: "#/properties/useNamedTagAsAttribute/properties/showIcon/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
          }
        }
      } else {
        const err8 = {
          instancePath: instancePath + "/useNamedTagAsAttribute",
          schemaPath: "#/properties/useNamedTagAsAttribute/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.mappings !== void 0) {
      let data4 = data.mappings;
      if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
        if (data4.attr0 !== void 0) {
          if (!validate126(data4.attr0, {
            instancePath: instancePath + "/mappings/attr0",
            parentData: data4,
            parentDataProperty: "attr0",
            rootData
          })) {
            vErrors = vErrors === null ? validate126.errors : vErrors.concat(validate126.errors);
            errors = vErrors.length;
          }
        }
        if (data4.attr1 !== void 0) {
          if (!validate126(data4.attr1, {
            instancePath: instancePath + "/mappings/attr1",
            parentData: data4,
            parentDataProperty: "attr1",
            rootData
          })) {
            vErrors = vErrors === null ? validate126.errors : vErrors.concat(validate126.errors);
            errors = vErrors.length;
          }
        }
        if (data4.attr2 !== void 0) {
          if (!validate126(data4.attr2, {
            instancePath: instancePath + "/mappings/attr2",
            parentData: data4,
            parentDataProperty: "attr2",
            rootData
          })) {
            vErrors = vErrors === null ? validate126.errors : vErrors.concat(validate126.errors);
            errors = vErrors.length;
          }
        }
        if (data4.attr3 !== void 0) {
          if (!validate126(data4.attr3, {
            instancePath: instancePath + "/mappings/attr3",
            parentData: data4,
            parentDataProperty: "attr3",
            rootData
          })) {
            vErrors = vErrors === null ? validate126.errors : vErrors.concat(validate126.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err9 = {
          instancePath: instancePath + "/mappings",
          schemaPath: "#/properties/mappings/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.defaultConfig !== void 0) {
      let data9 = data.defaultConfig;
      if (Array.isArray(data9)) {
        const len0 = data9.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (!validate80(data9[i0], {
            instancePath: instancePath + "/defaultConfig/" + i0,
            parentData: data9,
            parentDataProperty: i0,
            rootData
          })) {
            vErrors = vErrors === null ? validate80.errors : vErrors.concat(validate80.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err10 = {
          instancePath: instancePath + "/defaultConfig",
          schemaPath: "#/properties/defaultConfig/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
  } else {
    const err11 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err11];
    } else {
      vErrors.push(err11);
    }
    errors++;
  }
  validate127.errors = vErrors;
  return errors === 0;
}
const Sport80PlanProvider = validate133;
function validate133(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.enabled === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "enabled"
        },
        message: "must have required property 'enabled'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.name === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "name"
        },
        message: "must have required property 'name'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.label === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "label"
        },
        message: "must have required property 'label'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.enabled !== void 0) {
      let data0 = data.enabled;
      const _errs2 = errors;
      let valid1 = false;
      const _errs3 = errors;
      if (Array.isArray(data0)) {
        const len0 = data0.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (typeof data0[i0] !== "string") {
            const err3 = {
              instancePath: instancePath + "/enabled/" + i0,
              schemaPath: "#/properties/enabled/anyOf/0/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err3];
            } else {
              vErrors.push(err3);
            }
            errors++;
          }
        }
      } else {
        const err4 = {
          instancePath: instancePath + "/enabled",
          schemaPath: "#/properties/enabled/anyOf/0/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      var _valid0 = _errs3 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs7 = errors;
        if (typeof data0 !== "boolean") {
          const err5 = {
            instancePath: instancePath + "/enabled",
            schemaPath: "#/properties/enabled/anyOf/1/type",
            keyword: "type",
            params: {
              type: "boolean"
            },
            message: "must be boolean"
          };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
        var _valid0 = _errs7 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err6 = {
          instancePath: instancePath + "/enabled",
          schemaPath: "#/properties/enabled/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      } else {
        errors = _errs2;
        if (vErrors !== null) {
          if (_errs2) {
            vErrors.length = _errs2;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err7 = {
          instancePath: instancePath + "/name",
          schemaPath: "#/properties/name/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.label !== void 0) {
      if (typeof data.label !== "string") {
        const err8 = {
          instancePath: instancePath + "/label",
          schemaPath: "#/properties/label/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.logoUrl !== void 0) {
      if (typeof data.logoUrl !== "string") {
        const err9 = {
          instancePath: instancePath + "/logoUrl",
          schemaPath: "#/properties/logoUrl/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.description !== void 0) {
      if (typeof data.description !== "string") {
        const err10 = {
          instancePath: instancePath + "/description",
          schemaPath: "#/properties/description/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.descriptionWhenLinked !== void 0) {
      if (typeof data.descriptionWhenLinked !== "string") {
        const err11 = {
          instancePath: instancePath + "/descriptionWhenLinked",
          schemaPath: "#/properties/descriptionWhenLinked/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.linkExplanation !== void 0) {
      if (typeof data.linkExplanation !== "string") {
        const err12 = {
          instancePath: instancePath + "/linkExplanation",
          schemaPath: "#/properties/linkExplanation/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.unlinkExplanation !== void 0) {
      if (typeof data.unlinkExplanation !== "string") {
        const err13 = {
          instancePath: instancePath + "/unlinkExplanation",
          schemaPath: "#/properties/unlinkExplanation/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
  } else {
    const err14 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err14];
    } else {
      vErrors.push(err14);
    }
    errors++;
  }
  validate133.errors = vErrors;
  return errors === 0;
}
const ChannelPublicSettings = validate134;
function validate134(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.userConsent === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "userConsent"
        },
        message: "must have required property 'userConsent'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.externalPlanProviders !== void 0) {
      let data0 = data.externalPlanProviders;
      if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
        if (data0.sport80 !== void 0) {
          let data1 = data0.sport80;
          if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
            if (data1.enabled === void 0) {
              const err1 = {
                instancePath: instancePath + "/externalPlanProviders/sport80",
                schemaPath: "Sport80PlanProvider/required",
                keyword: "required",
                params: {
                  missingProperty: "enabled"
                },
                message: "must have required property 'enabled'"
              };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            if (data1.name === void 0) {
              const err2 = {
                instancePath: instancePath + "/externalPlanProviders/sport80",
                schemaPath: "Sport80PlanProvider/required",
                keyword: "required",
                params: {
                  missingProperty: "name"
                },
                message: "must have required property 'name'"
              };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            if (data1.label === void 0) {
              const err3 = {
                instancePath: instancePath + "/externalPlanProviders/sport80",
                schemaPath: "Sport80PlanProvider/required",
                keyword: "required",
                params: {
                  missingProperty: "label"
                },
                message: "must have required property 'label'"
              };
              if (vErrors === null) {
                vErrors = [err3];
              } else {
                vErrors.push(err3);
              }
              errors++;
            }
            if (data1.enabled !== void 0) {
              let data2 = data1.enabled;
              const _errs7 = errors;
              let valid4 = false;
              const _errs8 = errors;
              if (Array.isArray(data2)) {
                const len0 = data2.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  if (typeof data2[i0] !== "string") {
                    const err4 = {
                      instancePath: instancePath + "/externalPlanProviders/sport80/enabled/" + i0,
                      schemaPath: "Sport80PlanProvider/properties/enabled/anyOf/0/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                }
              } else {
                const err5 = {
                  instancePath: instancePath + "/externalPlanProviders/sport80/enabled",
                  schemaPath: "Sport80PlanProvider/properties/enabled/anyOf/0/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
              }
              var _valid0 = _errs8 === errors;
              valid4 = valid4 || _valid0;
              if (!valid4) {
                const _errs12 = errors;
                if (typeof data2 !== "boolean") {
                  const err6 = {
                    instancePath: instancePath + "/externalPlanProviders/sport80/enabled",
                    schemaPath: "Sport80PlanProvider/properties/enabled/anyOf/1/type",
                    keyword: "type",
                    params: {
                      type: "boolean"
                    },
                    message: "must be boolean"
                  };
                  if (vErrors === null) {
                    vErrors = [err6];
                  } else {
                    vErrors.push(err6);
                  }
                  errors++;
                }
                var _valid0 = _errs12 === errors;
                valid4 = valid4 || _valid0;
              }
              if (!valid4) {
                const err7 = {
                  instancePath: instancePath + "/externalPlanProviders/sport80/enabled",
                  schemaPath: "Sport80PlanProvider/properties/enabled/anyOf",
                  keyword: "anyOf",
                  params: {},
                  message: "must match a schema in anyOf"
                };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              } else {
                errors = _errs7;
                if (vErrors !== null) {
                  if (_errs7) {
                    vErrors.length = _errs7;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data1.name !== void 0) {
              if (typeof data1.name !== "string") {
                const err8 = {
                  instancePath: instancePath + "/externalPlanProviders/sport80/name",
                  schemaPath: "Sport80PlanProvider/properties/name/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
            }
            if (data1.label !== void 0) {
              if (typeof data1.label !== "string") {
                const err9 = {
                  instancePath: instancePath + "/externalPlanProviders/sport80/label",
                  schemaPath: "Sport80PlanProvider/properties/label/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
            }
            if (data1.logoUrl !== void 0) {
              if (typeof data1.logoUrl !== "string") {
                const err10 = {
                  instancePath: instancePath + "/externalPlanProviders/sport80/logoUrl",
                  schemaPath: "Sport80PlanProvider/properties/logoUrl/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
            }
            if (data1.description !== void 0) {
              if (typeof data1.description !== "string") {
                const err11 = {
                  instancePath: instancePath + "/externalPlanProviders/sport80/description",
                  schemaPath: "Sport80PlanProvider/properties/description/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err11];
                } else {
                  vErrors.push(err11);
                }
                errors++;
              }
            }
            if (data1.descriptionWhenLinked !== void 0) {
              if (typeof data1.descriptionWhenLinked !== "string") {
                const err12 = {
                  instancePath: instancePath + "/externalPlanProviders/sport80/descriptionWhenLinked",
                  schemaPath: "Sport80PlanProvider/properties/descriptionWhenLinked/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err12];
                } else {
                  vErrors.push(err12);
                }
                errors++;
              }
            }
            if (data1.linkExplanation !== void 0) {
              if (typeof data1.linkExplanation !== "string") {
                const err13 = {
                  instancePath: instancePath + "/externalPlanProviders/sport80/linkExplanation",
                  schemaPath: "Sport80PlanProvider/properties/linkExplanation/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
            }
            if (data1.unlinkExplanation !== void 0) {
              if (typeof data1.unlinkExplanation !== "string") {
                const err14 = {
                  instancePath: instancePath + "/externalPlanProviders/sport80/unlinkExplanation",
                  schemaPath: "Sport80PlanProvider/properties/unlinkExplanation/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
          } else {
            const err15 = {
              instancePath: instancePath + "/externalPlanProviders/sport80",
              schemaPath: "Sport80PlanProvider/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
      } else {
        const err16 = {
          instancePath: instancePath + "/externalPlanProviders",
          schemaPath: "#/properties/externalPlanProviders/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.userConsent !== void 0) {
      if (!validate122(data.userConsent, {
        instancePath: instancePath + "/userConsent",
        parentData: data,
        parentDataProperty: "userConsent",
        rootData
      })) {
        vErrors = vErrors === null ? validate122.errors : vErrors.concat(validate122.errors);
        errors = vErrors.length;
      }
    }
    if (data.viewerRetentionSettings !== void 0) {
      if (!validate124(data.viewerRetentionSettings, {
        instancePath: instancePath + "/viewerRetentionSettings",
        parentData: data,
        parentDataProperty: "viewerRetentionSettings",
        rootData
      })) {
        vErrors = vErrors === null ? validate124.errors : vErrors.concat(validate124.errors);
        errors = vErrors.length;
      }
    }
    if (data.attributesMapping !== void 0) {
      if (!validate127(data.attributesMapping, {
        instancePath: instancePath + "/attributesMapping",
        parentData: data,
        parentDataProperty: "attributesMapping",
        rootData
      })) {
        vErrors = vErrors === null ? validate127.errors : vErrors.concat(validate127.errors);
        errors = vErrors.length;
      }
    }
    if (data.requireMFA !== void 0) {
      if (typeof data.requireMFA !== "boolean") {
        const err17 = {
          instancePath: instancePath + "/requireMFA",
          schemaPath: "#/properties/requireMFA/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
  } else {
    const err18 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err18];
    } else {
      vErrors.push(err18);
    }
    errors++;
  }
  validate134.errors = vErrors;
  return errors === 0;
}
const CreateSetupIntentRequest = validate138;
function validate138(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.channelId === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err1 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
  } else {
    const err2 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate138.errors = vErrors;
  return errors === 0;
}
const CreateSetupIntentResponse = validate139;
function validate139(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.intent === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "intent"
        },
        message: "must have required property 'intent'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/anyOf/0/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (true !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/anyOf/0/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.intent !== void 0) {
      let data1 = data.intent;
      if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
        if (data1.clientSecret === void 0) {
          const err4 = {
            instancePath: instancePath + "/intent",
            schemaPath: "#/anyOf/0/properties/intent/required",
            keyword: "required",
            params: {
              missingProperty: "clientSecret"
            },
            message: "must have required property 'clientSecret'"
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
        if (data1.publicKey === void 0) {
          const err5 = {
            instancePath: instancePath + "/intent",
            schemaPath: "#/anyOf/0/properties/intent/required",
            keyword: "required",
            params: {
              missingProperty: "publicKey"
            },
            message: "must have required property 'publicKey'"
          };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
        if (data1.clientSecret !== void 0) {
          if (typeof data1.clientSecret !== "string") {
            const err6 = {
              instancePath: instancePath + "/intent/clientSecret",
              schemaPath: "#/anyOf/0/properties/intent/properties/clientSecret/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err6];
            } else {
              vErrors.push(err6);
            }
            errors++;
          }
        }
        if (data1.publicKey !== void 0) {
          if (typeof data1.publicKey !== "string") {
            const err7 = {
              instancePath: instancePath + "/intent/publicKey",
              schemaPath: "#/anyOf/0/properties/intent/properties/publicKey/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
          }
        }
      } else {
        const err8 = {
          instancePath: instancePath + "/intent",
          schemaPath: "#/anyOf/0/properties/intent/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
  } else {
    const err9 = {
      instancePath,
      schemaPath: "#/anyOf/0/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err9];
    } else {
      vErrors.push(err9);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs11 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.success === void 0) {
        const err10 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "success"
          },
          message: "must have required property 'success'"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
      if (data.errorReason === void 0) {
        const err11 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "errorReason"
          },
          message: "must have required property 'errorReason'"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if (data.success !== void 0) {
        let data4 = data.success;
        if (typeof data4 !== "boolean") {
          const err12 = {
            instancePath: instancePath + "/success",
            schemaPath: "#/anyOf/1/properties/success/type",
            keyword: "type",
            params: {
              type: "boolean"
            },
            message: "must be boolean"
          };
          if (vErrors === null) {
            vErrors = [err12];
          } else {
            vErrors.push(err12);
          }
          errors++;
        }
        if (false !== data4) {
          const err13 = {
            instancePath: instancePath + "/success",
            schemaPath: "#/anyOf/1/properties/success/const",
            keyword: "const",
            params: {
              allowedValue: false
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
      }
      if (data.errorReason !== void 0) {
        if (typeof data.errorReason !== "string") {
          const err14 = {
            instancePath: instancePath + "/errorReason",
            schemaPath: "#/anyOf/1/properties/errorReason/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
      }
    } else {
      const err15 = {
        instancePath,
        schemaPath: "#/anyOf/1/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err15];
      } else {
        vErrors.push(err15);
      }
      errors++;
    }
    var _valid0 = _errs11 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err16 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err16];
    } else {
      vErrors.push(err16);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate139.errors = vErrors;
  return errors === 0;
}
const CreateSubscriptionRequest = validate140;
function validate140(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.channelId === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.planId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "planId"
        },
        message: "must have required property 'planId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err2 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.planId !== void 0) {
      if (typeof data.planId !== "string") {
        const err3 = {
          instancePath: instancePath + "/planId",
          schemaPath: "#/properties/planId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.selectedCurrency !== void 0) {
      if (typeof data.selectedCurrency !== "string") {
        const err4 = {
          instancePath: instancePath + "/selectedCurrency",
          schemaPath: "#/properties/selectedCurrency/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate140.errors = vErrors;
  return errors === 0;
}
const CreateSubscriptionSuccessfulResponse = validate141;
function validate141(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.subscriptionId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "subscriptionId"
        },
        message: "must have required property 'subscriptionId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (true !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.subscriptionId !== void 0) {
      if (typeof data.subscriptionId !== "string") {
        const err4 = {
          instancePath: instancePath + "/subscriptionId",
          schemaPath: "#/properties/subscriptionId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate141.errors = vErrors;
  return errors === 0;
}
const CreateSubscriptionErrorResponse = validate142;
function validate142(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.errorReason === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "errorReason"
        },
        message: "must have required property 'errorReason'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (false !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: false
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.errorReason !== void 0) {
      if (typeof data.errorReason !== "string") {
        const err4 = {
          instancePath: instancePath + "/errorReason",
          schemaPath: "#/properties/errorReason/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate142.errors = vErrors;
  return errors === 0;
}
const CreateSubscriptionResponse = validate143;
function validate143(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "CreateSubscriptionSuccessfulResponse/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.subscriptionId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "CreateSubscriptionSuccessfulResponse/required",
        keyword: "required",
        params: {
          missingProperty: "subscriptionId"
        },
        message: "must have required property 'subscriptionId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "CreateSubscriptionSuccessfulResponse/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (true !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "CreateSubscriptionSuccessfulResponse/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.subscriptionId !== void 0) {
      if (typeof data.subscriptionId !== "string") {
        const err4 = {
          instancePath: instancePath + "/subscriptionId",
          schemaPath: "CreateSubscriptionSuccessfulResponse/properties/subscriptionId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "CreateSubscriptionSuccessfulResponse/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs8 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.success === void 0) {
        const err6 = {
          instancePath,
          schemaPath: "CreateSubscriptionErrorResponse/required",
          keyword: "required",
          params: {
            missingProperty: "success"
          },
          message: "must have required property 'success'"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if (data.errorReason === void 0) {
        const err7 = {
          instancePath,
          schemaPath: "CreateSubscriptionErrorResponse/required",
          keyword: "required",
          params: {
            missingProperty: "errorReason"
          },
          message: "must have required property 'errorReason'"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if (data.success !== void 0) {
        let data2 = data.success;
        if (typeof data2 !== "boolean") {
          const err8 = {
            instancePath: instancePath + "/success",
            schemaPath: "CreateSubscriptionErrorResponse/properties/success/type",
            keyword: "type",
            params: {
              type: "boolean"
            },
            message: "must be boolean"
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
        if (false !== data2) {
          const err9 = {
            instancePath: instancePath + "/success",
            schemaPath: "CreateSubscriptionErrorResponse/properties/success/const",
            keyword: "const",
            params: {
              allowedValue: false
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
      }
      if (data.errorReason !== void 0) {
        if (typeof data.errorReason !== "string") {
          const err10 = {
            instancePath: instancePath + "/errorReason",
            schemaPath: "CreateSubscriptionErrorResponse/properties/errorReason/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
      }
    } else {
      const err11 = {
        instancePath,
        schemaPath: "CreateSubscriptionErrorResponse/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err11];
      } else {
        vErrors.push(err11);
      }
      errors++;
    }
    var _valid0 = _errs8 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err12 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err12];
    } else {
      vErrors.push(err12);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate143.errors = vErrors;
  return errors === 0;
}
const TicketPrice = validate144;
function validate144(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.effectiveDate === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "effectiveDate"
        },
        message: "must have required property 'effectiveDate'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.price === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "price"
        },
        message: "must have required property 'price'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.currency === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "currency"
        },
        message: "must have required property 'currency'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.effectiveDate !== void 0) {
      let data0 = data.effectiveDate;
      if (!(data0 && typeof data0 == "object" && !Array.isArray(data0))) {
        const err3 = {
          instancePath: instancePath + "/effectiveDate",
          schemaPath: "#/properties/effectiveDate/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
      if (typeof data0 === "string") {
        if (!formats0(data0)) {
          const err4 = {
            instancePath: instancePath + "/effectiveDate",
            schemaPath: "#/properties/effectiveDate/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
      }
    }
    if (data.price !== void 0) {
      let data1 = data.price;
      if (!(typeof data1 == "number" && isFinite(data1))) {
        const err5 = {
          instancePath: instancePath + "/price",
          schemaPath: "#/properties/price/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.currency !== void 0) {
      if (typeof data.currency !== "string") {
        const err6 = {
          instancePath: instancePath + "/currency",
          schemaPath: "#/properties/currency/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.alternateCurrencies !== void 0) {
      let data3 = data.alternateCurrencies;
      if (Array.isArray(data3)) {
        const len0 = data3.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data4 = data3[i0];
          if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
            if (data4.price === void 0) {
              const err7 = {
                instancePath: instancePath + "/alternateCurrencies/" + i0,
                schemaPath: "#/properties/alternateCurrencies/items/required",
                keyword: "required",
                params: {
                  missingProperty: "price"
                },
                message: "must have required property 'price'"
              };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            if (data4.currency === void 0) {
              const err8 = {
                instancePath: instancePath + "/alternateCurrencies/" + i0,
                schemaPath: "#/properties/alternateCurrencies/items/required",
                keyword: "required",
                params: {
                  missingProperty: "currency"
                },
                message: "must have required property 'currency'"
              };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if (data4.price !== void 0) {
              let data5 = data4.price;
              if (!(typeof data5 == "number" && isFinite(data5))) {
                const err9 = {
                  instancePath: instancePath + "/alternateCurrencies/" + i0 + "/price",
                  schemaPath: "#/properties/alternateCurrencies/items/properties/price/type",
                  keyword: "type",
                  params: {
                    type: "number"
                  },
                  message: "must be number"
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
            }
            if (data4.currency !== void 0) {
              if (typeof data4.currency !== "string") {
                const err10 = {
                  instancePath: instancePath + "/alternateCurrencies/" + i0 + "/currency",
                  schemaPath: "#/properties/alternateCurrencies/items/properties/currency/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
            }
          } else {
            const err11 = {
              instancePath: instancePath + "/alternateCurrencies/" + i0,
              schemaPath: "#/properties/alternateCurrencies/items/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err11];
            } else {
              vErrors.push(err11);
            }
            errors++;
          }
        }
      } else {
        const err12 = {
          instancePath: instancePath + "/alternateCurrencies",
          schemaPath: "#/properties/alternateCurrencies/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
  } else {
    const err13 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err13];
    } else {
      vErrors.push(err13);
    }
    errors++;
  }
  validate144.errors = vErrors;
  return errors === 0;
}
const TicketScope = validate145;
const schema155 = {
  "$id": "TicketScope",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "initialCoverage": {
      "type": "boolean"
    },
    "appliesTo": {
      "type": "string",
      "enum": ["STREAMS", "UPLOADS", "STREAMS_AND_UPLOADS"]
    },
    "tags": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "excludeTags": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "attributes": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "excludeAttributes": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "videoIds": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "null"
      }]
    },
    "excludeVideoIds": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "null"
      }]
    },
    "redemptionLimit": {
      "type": ["number", "null"],
      "enum": [1, null]
    },
    "validityAfterRedemptionHours": {
      "type": ["number", "null"]
    }
  },
  "required": ["appliesTo", "redemptionLimit", "validityAfterRedemptionHours"],
  "description": 'Defines which videos are covered by a ticket. The scoping works by having inclusion and exclusion parameters and the algorithm works as follows:   0- if initialCoverage is defined and the value is false, consider the video **not covered**, otherwise consider it **covered**.   1- If a `tags` rule is set AND the video matches the tags defined by the rule, the video is considered **covered**, if it doesn\'t match consider it **not covered**.      If `tags` rule is not set, the result of this step is the same as step (0).   2- If the `excludedTags` rule is set and the video is **covered** in step (1), then if the video matches the exclusion rule consider the video **no covered**.      If the `excludedTags` rule is not defined, the result of this step is the same as from step (1).   3- if `attributes` is defined, check if the video defines the specified attributes.      If it does, assume the ***video coverage check" coverage is true***, else use the      ***coverage from previous steps***.      List is a list of string with the following format: `\u201Cattr[0-3]:.+"` for example      `["attr0:value","attr0:value2", "attr2:valueX"]` where `attr?` is the custom      attribute type, and `value` is one of the allowed values for that specific attribute type.   4- if `excludeAttributes` is defined, check if the video defines the the specified      attributes. If it does, assume the ***attribute coverage is false***, else use      the ***coverage from previous steps***. The list follows the same format as in for the step 2.3.   5- Regardless of the result of (4), if `videoIds` is defined and contains the id of the video, consider the video **covered**.      If `videoIds` is not defined, the result of this step is the same as step (2).   6- Regardless of the result of (5), if the `excludeVideoIds` is defined and contains the id of the video, consider the video **not covered**.\n\n== Redemption limit and validity == If a ticket has a redemption limit set (currently limited to 1), then the ticket has to be bound to a specific videoId, and will only be valid for that video. Since this type of tickets only makes sense in the context of 1 video, this type of tickets should not be shown in the tickets for an event. If `validityAfterRedemptionHours` is set, then the ticket will be considered valid only for that specific amount of time starting from the first valid redemption. A valid redemption means it is used to access a video that is not in the scheduled state. If `validityAfterRedemptionHours` is not set, the ticket is considered valid as long as the event is in progress.'
};
function validate145(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.appliesTo === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "appliesTo"
        },
        message: "must have required property 'appliesTo'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.redemptionLimit === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "redemptionLimit"
        },
        message: "must have required property 'redemptionLimit'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.validityAfterRedemptionHours === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "validityAfterRedemptionHours"
        },
        message: "must have required property 'validityAfterRedemptionHours'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.initialCoverage !== void 0) {
      if (typeof data.initialCoverage !== "boolean") {
        const err3 = {
          instancePath: instancePath + "/initialCoverage",
          schemaPath: "#/properties/initialCoverage/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.appliesTo !== void 0) {
      let data1 = data.appliesTo;
      if (typeof data1 !== "string") {
        const err4 = {
          instancePath: instancePath + "/appliesTo",
          schemaPath: "#/properties/appliesTo/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if (!(data1 === "STREAMS" || data1 === "UPLOADS" || data1 === "STREAMS_AND_UPLOADS")) {
        const err5 = {
          instancePath: instancePath + "/appliesTo",
          schemaPath: "#/properties/appliesTo/enum",
          keyword: "enum",
          params: {
            allowedValues: schema155.properties.appliesTo.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.tags !== void 0) {
      let data2 = data.tags;
      const _errs6 = errors;
      let valid1 = false;
      const _errs7 = errors;
      if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
        if (data2.kind === void 0) {
          const err6 = {
            instancePath: instancePath + "/tags",
            schemaPath: "#/properties/tags/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "kind"
            },
            message: "must have required property 'kind'"
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
        if (data2.list === void 0) {
          const err7 = {
            instancePath: instancePath + "/tags",
            schemaPath: "#/properties/tags/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "list"
            },
            message: "must have required property 'list'"
          };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
        if (data2.kind !== void 0) {
          let data3 = data2.kind;
          if (typeof data3 !== "string") {
            const err8 = {
              instancePath: instancePath + "/tags/kind",
              schemaPath: "#/properties/tags/anyOf/0/properties/kind/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err8];
            } else {
              vErrors.push(err8);
            }
            errors++;
          }
          if (!(data3 === "ALL" || data3 === "SOME")) {
            const err9 = {
              instancePath: instancePath + "/tags/kind",
              schemaPath: "#/properties/tags/anyOf/0/properties/kind/enum",
              keyword: "enum",
              params: {
                allowedValues: schema155.properties.tags.anyOf[0].properties.kind.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err9];
            } else {
              vErrors.push(err9);
            }
            errors++;
          }
        }
        if (data2.list !== void 0) {
          let data4 = data2.list;
          if (Array.isArray(data4)) {
            const len0 = data4.length;
            for (let i0 = 0; i0 < len0; i0++) {
              if (typeof data4[i0] !== "string") {
                const err10 = {
                  instancePath: instancePath + "/tags/list/" + i0,
                  schemaPath: "#/properties/tags/anyOf/0/properties/list/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
            }
          } else {
            const err11 = {
              instancePath: instancePath + "/tags/list",
              schemaPath: "#/properties/tags/anyOf/0/properties/list/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err11];
            } else {
              vErrors.push(err11);
            }
            errors++;
          }
        }
      } else {
        const err12 = {
          instancePath: instancePath + "/tags",
          schemaPath: "#/properties/tags/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
      var _valid0 = _errs7 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs15 = errors;
        if (data2 !== null) {
          const err13 = {
            instancePath: instancePath + "/tags",
            schemaPath: "#/properties/tags/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
        var _valid0 = _errs15 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err14 = {
          instancePath: instancePath + "/tags",
          schemaPath: "#/properties/tags/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      } else {
        errors = _errs6;
        if (vErrors !== null) {
          if (_errs6) {
            vErrors.length = _errs6;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.excludeTags !== void 0) {
      let data6 = data.excludeTags;
      const _errs18 = errors;
      let valid5 = false;
      const _errs19 = errors;
      if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
        if (data6.kind === void 0) {
          const err15 = {
            instancePath: instancePath + "/excludeTags",
            schemaPath: "#/properties/excludeTags/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "kind"
            },
            message: "must have required property 'kind'"
          };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if (data6.list === void 0) {
          const err16 = {
            instancePath: instancePath + "/excludeTags",
            schemaPath: "#/properties/excludeTags/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "list"
            },
            message: "must have required property 'list'"
          };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
        if (data6.kind !== void 0) {
          let data7 = data6.kind;
          if (typeof data7 !== "string") {
            const err17 = {
              instancePath: instancePath + "/excludeTags/kind",
              schemaPath: "#/properties/excludeTags/anyOf/0/properties/kind/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err17];
            } else {
              vErrors.push(err17);
            }
            errors++;
          }
          if (!(data7 === "ALL" || data7 === "SOME")) {
            const err18 = {
              instancePath: instancePath + "/excludeTags/kind",
              schemaPath: "#/properties/excludeTags/anyOf/0/properties/kind/enum",
              keyword: "enum",
              params: {
                allowedValues: schema155.properties.excludeTags.anyOf[0].properties.kind.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err18];
            } else {
              vErrors.push(err18);
            }
            errors++;
          }
        }
        if (data6.list !== void 0) {
          let data8 = data6.list;
          if (Array.isArray(data8)) {
            const len1 = data8.length;
            for (let i1 = 0; i1 < len1; i1++) {
              if (typeof data8[i1] !== "string") {
                const err19 = {
                  instancePath: instancePath + "/excludeTags/list/" + i1,
                  schemaPath: "#/properties/excludeTags/anyOf/0/properties/list/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
            }
          } else {
            const err20 = {
              instancePath: instancePath + "/excludeTags/list",
              schemaPath: "#/properties/excludeTags/anyOf/0/properties/list/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err20];
            } else {
              vErrors.push(err20);
            }
            errors++;
          }
        }
      } else {
        const err21 = {
          instancePath: instancePath + "/excludeTags",
          schemaPath: "#/properties/excludeTags/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err21];
        } else {
          vErrors.push(err21);
        }
        errors++;
      }
      var _valid1 = _errs19 === errors;
      valid5 = valid5 || _valid1;
      if (!valid5) {
        const _errs27 = errors;
        if (data6 !== null) {
          const err22 = {
            instancePath: instancePath + "/excludeTags",
            schemaPath: "#/properties/excludeTags/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
        var _valid1 = _errs27 === errors;
        valid5 = valid5 || _valid1;
      }
      if (!valid5) {
        const err23 = {
          instancePath: instancePath + "/excludeTags",
          schemaPath: "#/properties/excludeTags/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err23];
        } else {
          vErrors.push(err23);
        }
        errors++;
      } else {
        errors = _errs18;
        if (vErrors !== null) {
          if (_errs18) {
            vErrors.length = _errs18;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.attributes !== void 0) {
      let data10 = data.attributes;
      const _errs30 = errors;
      let valid9 = false;
      const _errs31 = errors;
      if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
        if (data10.kind === void 0) {
          const err24 = {
            instancePath: instancePath + "/attributes",
            schemaPath: "#/properties/attributes/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "kind"
            },
            message: "must have required property 'kind'"
          };
          if (vErrors === null) {
            vErrors = [err24];
          } else {
            vErrors.push(err24);
          }
          errors++;
        }
        if (data10.list === void 0) {
          const err25 = {
            instancePath: instancePath + "/attributes",
            schemaPath: "#/properties/attributes/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "list"
            },
            message: "must have required property 'list'"
          };
          if (vErrors === null) {
            vErrors = [err25];
          } else {
            vErrors.push(err25);
          }
          errors++;
        }
        if (data10.kind !== void 0) {
          let data11 = data10.kind;
          if (typeof data11 !== "string") {
            const err26 = {
              instancePath: instancePath + "/attributes/kind",
              schemaPath: "#/properties/attributes/anyOf/0/properties/kind/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err26];
            } else {
              vErrors.push(err26);
            }
            errors++;
          }
          if (!(data11 === "ALL" || data11 === "SOME")) {
            const err27 = {
              instancePath: instancePath + "/attributes/kind",
              schemaPath: "#/properties/attributes/anyOf/0/properties/kind/enum",
              keyword: "enum",
              params: {
                allowedValues: schema155.properties.attributes.anyOf[0].properties.kind.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err27];
            } else {
              vErrors.push(err27);
            }
            errors++;
          }
        }
        if (data10.list !== void 0) {
          let data12 = data10.list;
          if (Array.isArray(data12)) {
            const len2 = data12.length;
            for (let i2 = 0; i2 < len2; i2++) {
              if (typeof data12[i2] !== "string") {
                const err28 = {
                  instancePath: instancePath + "/attributes/list/" + i2,
                  schemaPath: "#/properties/attributes/anyOf/0/properties/list/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err28];
                } else {
                  vErrors.push(err28);
                }
                errors++;
              }
            }
          } else {
            const err29 = {
              instancePath: instancePath + "/attributes/list",
              schemaPath: "#/properties/attributes/anyOf/0/properties/list/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err29];
            } else {
              vErrors.push(err29);
            }
            errors++;
          }
        }
      } else {
        const err30 = {
          instancePath: instancePath + "/attributes",
          schemaPath: "#/properties/attributes/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err30];
        } else {
          vErrors.push(err30);
        }
        errors++;
      }
      var _valid2 = _errs31 === errors;
      valid9 = valid9 || _valid2;
      if (!valid9) {
        const _errs39 = errors;
        if (data10 !== null) {
          const err31 = {
            instancePath: instancePath + "/attributes",
            schemaPath: "#/properties/attributes/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err31];
          } else {
            vErrors.push(err31);
          }
          errors++;
        }
        var _valid2 = _errs39 === errors;
        valid9 = valid9 || _valid2;
      }
      if (!valid9) {
        const err32 = {
          instancePath: instancePath + "/attributes",
          schemaPath: "#/properties/attributes/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err32];
        } else {
          vErrors.push(err32);
        }
        errors++;
      } else {
        errors = _errs30;
        if (vErrors !== null) {
          if (_errs30) {
            vErrors.length = _errs30;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.excludeAttributes !== void 0) {
      let data14 = data.excludeAttributes;
      const _errs42 = errors;
      let valid13 = false;
      const _errs43 = errors;
      if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
        if (data14.kind === void 0) {
          const err33 = {
            instancePath: instancePath + "/excludeAttributes",
            schemaPath: "#/properties/excludeAttributes/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "kind"
            },
            message: "must have required property 'kind'"
          };
          if (vErrors === null) {
            vErrors = [err33];
          } else {
            vErrors.push(err33);
          }
          errors++;
        }
        if (data14.list === void 0) {
          const err34 = {
            instancePath: instancePath + "/excludeAttributes",
            schemaPath: "#/properties/excludeAttributes/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "list"
            },
            message: "must have required property 'list'"
          };
          if (vErrors === null) {
            vErrors = [err34];
          } else {
            vErrors.push(err34);
          }
          errors++;
        }
        if (data14.kind !== void 0) {
          let data15 = data14.kind;
          if (typeof data15 !== "string") {
            const err35 = {
              instancePath: instancePath + "/excludeAttributes/kind",
              schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/kind/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err35];
            } else {
              vErrors.push(err35);
            }
            errors++;
          }
          if (!(data15 === "ALL" || data15 === "SOME")) {
            const err36 = {
              instancePath: instancePath + "/excludeAttributes/kind",
              schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/kind/enum",
              keyword: "enum",
              params: {
                allowedValues: schema155.properties.excludeAttributes.anyOf[0].properties.kind.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err36];
            } else {
              vErrors.push(err36);
            }
            errors++;
          }
        }
        if (data14.list !== void 0) {
          let data16 = data14.list;
          if (Array.isArray(data16)) {
            const len3 = data16.length;
            for (let i3 = 0; i3 < len3; i3++) {
              if (typeof data16[i3] !== "string") {
                const err37 = {
                  instancePath: instancePath + "/excludeAttributes/list/" + i3,
                  schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/list/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err37];
                } else {
                  vErrors.push(err37);
                }
                errors++;
              }
            }
          } else {
            const err38 = {
              instancePath: instancePath + "/excludeAttributes/list",
              schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/list/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err38];
            } else {
              vErrors.push(err38);
            }
            errors++;
          }
        }
      } else {
        const err39 = {
          instancePath: instancePath + "/excludeAttributes",
          schemaPath: "#/properties/excludeAttributes/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err39];
        } else {
          vErrors.push(err39);
        }
        errors++;
      }
      var _valid3 = _errs43 === errors;
      valid13 = valid13 || _valid3;
      if (!valid13) {
        const _errs51 = errors;
        if (data14 !== null) {
          const err40 = {
            instancePath: instancePath + "/excludeAttributes",
            schemaPath: "#/properties/excludeAttributes/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err40];
          } else {
            vErrors.push(err40);
          }
          errors++;
        }
        var _valid3 = _errs51 === errors;
        valid13 = valid13 || _valid3;
      }
      if (!valid13) {
        const err41 = {
          instancePath: instancePath + "/excludeAttributes",
          schemaPath: "#/properties/excludeAttributes/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err41];
        } else {
          vErrors.push(err41);
        }
        errors++;
      } else {
        errors = _errs42;
        if (vErrors !== null) {
          if (_errs42) {
            vErrors.length = _errs42;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.videoIds !== void 0) {
      let data18 = data.videoIds;
      const _errs54 = errors;
      let valid17 = false;
      const _errs55 = errors;
      if (Array.isArray(data18)) {
        const len4 = data18.length;
        for (let i4 = 0; i4 < len4; i4++) {
          if (typeof data18[i4] !== "string") {
            const err42 = {
              instancePath: instancePath + "/videoIds/" + i4,
              schemaPath: "#/properties/videoIds/anyOf/0/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err42];
            } else {
              vErrors.push(err42);
            }
            errors++;
          }
        }
      } else {
        const err43 = {
          instancePath: instancePath + "/videoIds",
          schemaPath: "#/properties/videoIds/anyOf/0/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err43];
        } else {
          vErrors.push(err43);
        }
        errors++;
      }
      var _valid4 = _errs55 === errors;
      valid17 = valid17 || _valid4;
      if (!valid17) {
        const _errs59 = errors;
        if (data18 !== null) {
          const err44 = {
            instancePath: instancePath + "/videoIds",
            schemaPath: "#/properties/videoIds/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err44];
          } else {
            vErrors.push(err44);
          }
          errors++;
        }
        var _valid4 = _errs59 === errors;
        valid17 = valid17 || _valid4;
      }
      if (!valid17) {
        const err45 = {
          instancePath: instancePath + "/videoIds",
          schemaPath: "#/properties/videoIds/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err45];
        } else {
          vErrors.push(err45);
        }
        errors++;
      } else {
        errors = _errs54;
        if (vErrors !== null) {
          if (_errs54) {
            vErrors.length = _errs54;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.excludeVideoIds !== void 0) {
      let data20 = data.excludeVideoIds;
      const _errs62 = errors;
      let valid20 = false;
      const _errs63 = errors;
      if (Array.isArray(data20)) {
        const len5 = data20.length;
        for (let i5 = 0; i5 < len5; i5++) {
          if (typeof data20[i5] !== "string") {
            const err46 = {
              instancePath: instancePath + "/excludeVideoIds/" + i5,
              schemaPath: "#/properties/excludeVideoIds/anyOf/0/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err46];
            } else {
              vErrors.push(err46);
            }
            errors++;
          }
        }
      } else {
        const err47 = {
          instancePath: instancePath + "/excludeVideoIds",
          schemaPath: "#/properties/excludeVideoIds/anyOf/0/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err47];
        } else {
          vErrors.push(err47);
        }
        errors++;
      }
      var _valid5 = _errs63 === errors;
      valid20 = valid20 || _valid5;
      if (!valid20) {
        const _errs67 = errors;
        if (data20 !== null) {
          const err48 = {
            instancePath: instancePath + "/excludeVideoIds",
            schemaPath: "#/properties/excludeVideoIds/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err48];
          } else {
            vErrors.push(err48);
          }
          errors++;
        }
        var _valid5 = _errs67 === errors;
        valid20 = valid20 || _valid5;
      }
      if (!valid20) {
        const err49 = {
          instancePath: instancePath + "/excludeVideoIds",
          schemaPath: "#/properties/excludeVideoIds/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err49];
        } else {
          vErrors.push(err49);
        }
        errors++;
      } else {
        errors = _errs62;
        if (vErrors !== null) {
          if (_errs62) {
            vErrors.length = _errs62;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.redemptionLimit !== void 0) {
      let data22 = data.redemptionLimit;
      if (!(typeof data22 == "number" && isFinite(data22)) && data22 !== null) {
        const err50 = {
          instancePath: instancePath + "/redemptionLimit",
          schemaPath: "#/properties/redemptionLimit/type",
          keyword: "type",
          params: {
            type: schema155.properties.redemptionLimit.type
          },
          message: "must be number,null"
        };
        if (vErrors === null) {
          vErrors = [err50];
        } else {
          vErrors.push(err50);
        }
        errors++;
      }
      if (!(data22 === 1 || data22 === null)) {
        const err51 = {
          instancePath: instancePath + "/redemptionLimit",
          schemaPath: "#/properties/redemptionLimit/enum",
          keyword: "enum",
          params: {
            allowedValues: schema155.properties.redemptionLimit.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err51];
        } else {
          vErrors.push(err51);
        }
        errors++;
      }
    }
    if (data.validityAfterRedemptionHours !== void 0) {
      let data23 = data.validityAfterRedemptionHours;
      if (!(typeof data23 == "number" && isFinite(data23)) && data23 !== null) {
        const err52 = {
          instancePath: instancePath + "/validityAfterRedemptionHours",
          schemaPath: "#/properties/validityAfterRedemptionHours/type",
          keyword: "type",
          params: {
            type: schema155.properties.validityAfterRedemptionHours.type
          },
          message: "must be number,null"
        };
        if (vErrors === null) {
          vErrors = [err52];
        } else {
          vErrors.push(err52);
        }
        errors++;
      }
    }
  } else {
    const err53 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err53];
    } else {
      vErrors.push(err53);
    }
    errors++;
  }
  validate145.errors = vErrors;
  return errors === 0;
}
const Ticket = validate146;
const schema156 = {
  "$id": "Ticket",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "id": {
      "type": "string"
    },
    "name": {
      "type": "string"
    },
    "description": {
      "type": "string"
    },
    "prices": {
      "type": "array",
      "items": {
        "$ref": "TicketPrice"
      }
    },
    "ticketImage": {
      "type": ["string", "null"]
    },
    "scope": {
      "anyOf": [{
        "$ref": "TicketScope"
      }, {
        "type": "null"
      }]
    },
    "geo_restriction": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "null"
      }]
    },
    "available": {
      "type": "boolean"
    }
  },
  "required": ["id", "name", "description", "prices", "ticketImage", "scope", "geo_restriction", "available"],
  "description": "Paid events (or locked events), require a ticket to access. A ticket once purchased will unlock a set of streams in that event. The ticket is valid as long as the event is valid.\n*Scoping*: A scope (`TicketScope`) can be defined per ticket to restrict the range of viewable streams.\n*Prices*: Multiple price(s) can be defined for a ticket, but only one price can be effective at any given point in time. The *effective* price at any given point `t` is the one having the nearest `effectiveDate` satisfying the inequality `effectiveDate < t`. Having multiple price points can be used to implement features like early bird prices, or mid-season discounts."
};
function validate146(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "id"
        },
        message: "must have required property 'id'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.name === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "name"
        },
        message: "must have required property 'name'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.description === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "description"
        },
        message: "must have required property 'description'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.prices === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "prices"
        },
        message: "must have required property 'prices'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.ticketImage === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "ticketImage"
        },
        message: "must have required property 'ticketImage'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.scope === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "scope"
        },
        message: "must have required property 'scope'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.geo_restriction === void 0) {
      const err6 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "geo_restriction"
        },
        message: "must have required property 'geo_restriction'"
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.available === void 0) {
      const err7 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "available"
        },
        message: "must have required property 'available'"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.id !== void 0) {
      if (typeof data.id !== "string") {
        const err8 = {
          instancePath: instancePath + "/id",
          schemaPath: "#/properties/id/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err9 = {
          instancePath: instancePath + "/name",
          schemaPath: "#/properties/name/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.description !== void 0) {
      if (typeof data.description !== "string") {
        const err10 = {
          instancePath: instancePath + "/description",
          schemaPath: "#/properties/description/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.prices !== void 0) {
      let data3 = data.prices;
      if (Array.isArray(data3)) {
        const len0 = data3.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data4 = data3[i0];
          if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
            if (data4.effectiveDate === void 0) {
              const err11 = {
                instancePath: instancePath + "/prices/" + i0,
                schemaPath: "TicketPrice/required",
                keyword: "required",
                params: {
                  missingProperty: "effectiveDate"
                },
                message: "must have required property 'effectiveDate'"
              };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            if (data4.price === void 0) {
              const err12 = {
                instancePath: instancePath + "/prices/" + i0,
                schemaPath: "TicketPrice/required",
                keyword: "required",
                params: {
                  missingProperty: "price"
                },
                message: "must have required property 'price'"
              };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            if (data4.currency === void 0) {
              const err13 = {
                instancePath: instancePath + "/prices/" + i0,
                schemaPath: "TicketPrice/required",
                keyword: "required",
                params: {
                  missingProperty: "currency"
                },
                message: "must have required property 'currency'"
              };
              if (vErrors === null) {
                vErrors = [err13];
              } else {
                vErrors.push(err13);
              }
              errors++;
            }
            if (data4.effectiveDate !== void 0) {
              let data5 = data4.effectiveDate;
              if (!(data5 && typeof data5 == "object" && !Array.isArray(data5))) {
                const err14 = {
                  instancePath: instancePath + "/prices/" + i0 + "/effectiveDate",
                  schemaPath: "TicketPrice/properties/effectiveDate/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
              if (typeof data5 === "string") {
                if (!formats0(data5)) {
                  const err15 = {
                    instancePath: instancePath + "/prices/" + i0 + "/effectiveDate",
                    schemaPath: "TicketPrice/properties/effectiveDate/format",
                    keyword: "format",
                    params: {
                      format: "date-time"
                    },
                    message: 'must match format "date-time"'
                  };
                  if (vErrors === null) {
                    vErrors = [err15];
                  } else {
                    vErrors.push(err15);
                  }
                  errors++;
                }
              }
            }
            if (data4.price !== void 0) {
              let data6 = data4.price;
              if (!(typeof data6 == "number" && isFinite(data6))) {
                const err16 = {
                  instancePath: instancePath + "/prices/" + i0 + "/price",
                  schemaPath: "TicketPrice/properties/price/type",
                  keyword: "type",
                  params: {
                    type: "number"
                  },
                  message: "must be number"
                };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
            }
            if (data4.currency !== void 0) {
              if (typeof data4.currency !== "string") {
                const err17 = {
                  instancePath: instancePath + "/prices/" + i0 + "/currency",
                  schemaPath: "TicketPrice/properties/currency/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
              }
            }
            if (data4.alternateCurrencies !== void 0) {
              let data8 = data4.alternateCurrencies;
              if (Array.isArray(data8)) {
                const len1 = data8.length;
                for (let i1 = 0; i1 < len1; i1++) {
                  let data9 = data8[i1];
                  if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
                    if (data9.price === void 0) {
                      const err18 = {
                        instancePath: instancePath + "/prices/" + i0 + "/alternateCurrencies/" + i1,
                        schemaPath: "TicketPrice/properties/alternateCurrencies/items/required",
                        keyword: "required",
                        params: {
                          missingProperty: "price"
                        },
                        message: "must have required property 'price'"
                      };
                      if (vErrors === null) {
                        vErrors = [err18];
                      } else {
                        vErrors.push(err18);
                      }
                      errors++;
                    }
                    if (data9.currency === void 0) {
                      const err19 = {
                        instancePath: instancePath + "/prices/" + i0 + "/alternateCurrencies/" + i1,
                        schemaPath: "TicketPrice/properties/alternateCurrencies/items/required",
                        keyword: "required",
                        params: {
                          missingProperty: "currency"
                        },
                        message: "must have required property 'currency'"
                      };
                      if (vErrors === null) {
                        vErrors = [err19];
                      } else {
                        vErrors.push(err19);
                      }
                      errors++;
                    }
                    if (data9.price !== void 0) {
                      let data10 = data9.price;
                      if (!(typeof data10 == "number" && isFinite(data10))) {
                        const err20 = {
                          instancePath: instancePath + "/prices/" + i0 + "/alternateCurrencies/" + i1 + "/price",
                          schemaPath: "TicketPrice/properties/alternateCurrencies/items/properties/price/type",
                          keyword: "type",
                          params: {
                            type: "number"
                          },
                          message: "must be number"
                        };
                        if (vErrors === null) {
                          vErrors = [err20];
                        } else {
                          vErrors.push(err20);
                        }
                        errors++;
                      }
                    }
                    if (data9.currency !== void 0) {
                      if (typeof data9.currency !== "string") {
                        const err21 = {
                          instancePath: instancePath + "/prices/" + i0 + "/alternateCurrencies/" + i1 + "/currency",
                          schemaPath: "TicketPrice/properties/alternateCurrencies/items/properties/currency/type",
                          keyword: "type",
                          params: {
                            type: "string"
                          },
                          message: "must be string"
                        };
                        if (vErrors === null) {
                          vErrors = [err21];
                        } else {
                          vErrors.push(err21);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err22 = {
                      instancePath: instancePath + "/prices/" + i0 + "/alternateCurrencies/" + i1,
                      schemaPath: "TicketPrice/properties/alternateCurrencies/items/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err22];
                    } else {
                      vErrors.push(err22);
                    }
                    errors++;
                  }
                }
              } else {
                const err23 = {
                  instancePath: instancePath + "/prices/" + i0 + "/alternateCurrencies",
                  schemaPath: "TicketPrice/properties/alternateCurrencies/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
            }
          } else {
            const err24 = {
              instancePath: instancePath + "/prices/" + i0,
              schemaPath: "TicketPrice/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          }
        }
      } else {
        const err25 = {
          instancePath: instancePath + "/prices",
          schemaPath: "#/properties/prices/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err25];
        } else {
          vErrors.push(err25);
        }
        errors++;
      }
    }
    if (data.ticketImage !== void 0) {
      let data12 = data.ticketImage;
      if (typeof data12 !== "string" && data12 !== null) {
        const err26 = {
          instancePath: instancePath + "/ticketImage",
          schemaPath: "#/properties/ticketImage/type",
          keyword: "type",
          params: {
            type: schema156.properties.ticketImage.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err26];
        } else {
          vErrors.push(err26);
        }
        errors++;
      }
    }
    if (data.scope !== void 0) {
      let data13 = data.scope;
      const _errs29 = errors;
      let valid8 = false;
      const _errs30 = errors;
      if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
        if (data13.appliesTo === void 0) {
          const err27 = {
            instancePath: instancePath + "/scope",
            schemaPath: "TicketScope/required",
            keyword: "required",
            params: {
              missingProperty: "appliesTo"
            },
            message: "must have required property 'appliesTo'"
          };
          if (vErrors === null) {
            vErrors = [err27];
          } else {
            vErrors.push(err27);
          }
          errors++;
        }
        if (data13.redemptionLimit === void 0) {
          const err28 = {
            instancePath: instancePath + "/scope",
            schemaPath: "TicketScope/required",
            keyword: "required",
            params: {
              missingProperty: "redemptionLimit"
            },
            message: "must have required property 'redemptionLimit'"
          };
          if (vErrors === null) {
            vErrors = [err28];
          } else {
            vErrors.push(err28);
          }
          errors++;
        }
        if (data13.validityAfterRedemptionHours === void 0) {
          const err29 = {
            instancePath: instancePath + "/scope",
            schemaPath: "TicketScope/required",
            keyword: "required",
            params: {
              missingProperty: "validityAfterRedemptionHours"
            },
            message: "must have required property 'validityAfterRedemptionHours'"
          };
          if (vErrors === null) {
            vErrors = [err29];
          } else {
            vErrors.push(err29);
          }
          errors++;
        }
        if (data13.initialCoverage !== void 0) {
          if (typeof data13.initialCoverage !== "boolean") {
            const err30 = {
              instancePath: instancePath + "/scope/initialCoverage",
              schemaPath: "TicketScope/properties/initialCoverage/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err30];
            } else {
              vErrors.push(err30);
            }
            errors++;
          }
        }
        if (data13.appliesTo !== void 0) {
          let data15 = data13.appliesTo;
          if (typeof data15 !== "string") {
            const err31 = {
              instancePath: instancePath + "/scope/appliesTo",
              schemaPath: "TicketScope/properties/appliesTo/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
          if (!(data15 === "STREAMS" || data15 === "UPLOADS" || data15 === "STREAMS_AND_UPLOADS")) {
            const err32 = {
              instancePath: instancePath + "/scope/appliesTo",
              schemaPath: "TicketScope/properties/appliesTo/enum",
              keyword: "enum",
              params: {
                allowedValues: schema155.properties.appliesTo.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err32];
            } else {
              vErrors.push(err32);
            }
            errors++;
          }
        }
        if (data13.tags !== void 0) {
          let data16 = data13.tags;
          const _errs38 = errors;
          let valid11 = false;
          const _errs39 = errors;
          if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
            if (data16.kind === void 0) {
              const err33 = {
                instancePath: instancePath + "/scope/tags",
                schemaPath: "TicketScope/properties/tags/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "kind"
                },
                message: "must have required property 'kind'"
              };
              if (vErrors === null) {
                vErrors = [err33];
              } else {
                vErrors.push(err33);
              }
              errors++;
            }
            if (data16.list === void 0) {
              const err34 = {
                instancePath: instancePath + "/scope/tags",
                schemaPath: "TicketScope/properties/tags/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "list"
                },
                message: "must have required property 'list'"
              };
              if (vErrors === null) {
                vErrors = [err34];
              } else {
                vErrors.push(err34);
              }
              errors++;
            }
            if (data16.kind !== void 0) {
              let data17 = data16.kind;
              if (typeof data17 !== "string") {
                const err35 = {
                  instancePath: instancePath + "/scope/tags/kind",
                  schemaPath: "TicketScope/properties/tags/anyOf/0/properties/kind/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err35];
                } else {
                  vErrors.push(err35);
                }
                errors++;
              }
              if (!(data17 === "ALL" || data17 === "SOME")) {
                const err36 = {
                  instancePath: instancePath + "/scope/tags/kind",
                  schemaPath: "TicketScope/properties/tags/anyOf/0/properties/kind/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema155.properties.tags.anyOf[0].properties.kind.enum
                  },
                  message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) {
                  vErrors = [err36];
                } else {
                  vErrors.push(err36);
                }
                errors++;
              }
            }
            if (data16.list !== void 0) {
              let data18 = data16.list;
              if (Array.isArray(data18)) {
                const len2 = data18.length;
                for (let i2 = 0; i2 < len2; i2++) {
                  if (typeof data18[i2] !== "string") {
                    const err37 = {
                      instancePath: instancePath + "/scope/tags/list/" + i2,
                      schemaPath: "TicketScope/properties/tags/anyOf/0/properties/list/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err37];
                    } else {
                      vErrors.push(err37);
                    }
                    errors++;
                  }
                }
              } else {
                const err38 = {
                  instancePath: instancePath + "/scope/tags/list",
                  schemaPath: "TicketScope/properties/tags/anyOf/0/properties/list/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err38];
                } else {
                  vErrors.push(err38);
                }
                errors++;
              }
            }
          } else {
            const err39 = {
              instancePath: instancePath + "/scope/tags",
              schemaPath: "TicketScope/properties/tags/anyOf/0/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err39];
            } else {
              vErrors.push(err39);
            }
            errors++;
          }
          var _valid1 = _errs39 === errors;
          valid11 = valid11 || _valid1;
          if (!valid11) {
            const _errs47 = errors;
            if (data16 !== null) {
              const err40 = {
                instancePath: instancePath + "/scope/tags",
                schemaPath: "TicketScope/properties/tags/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err40];
              } else {
                vErrors.push(err40);
              }
              errors++;
            }
            var _valid1 = _errs47 === errors;
            valid11 = valid11 || _valid1;
          }
          if (!valid11) {
            const err41 = {
              instancePath: instancePath + "/scope/tags",
              schemaPath: "TicketScope/properties/tags/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err41];
            } else {
              vErrors.push(err41);
            }
            errors++;
          } else {
            errors = _errs38;
            if (vErrors !== null) {
              if (_errs38) {
                vErrors.length = _errs38;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data13.excludeTags !== void 0) {
          let data20 = data13.excludeTags;
          const _errs50 = errors;
          let valid15 = false;
          const _errs51 = errors;
          if (data20 && typeof data20 == "object" && !Array.isArray(data20)) {
            if (data20.kind === void 0) {
              const err42 = {
                instancePath: instancePath + "/scope/excludeTags",
                schemaPath: "TicketScope/properties/excludeTags/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "kind"
                },
                message: "must have required property 'kind'"
              };
              if (vErrors === null) {
                vErrors = [err42];
              } else {
                vErrors.push(err42);
              }
              errors++;
            }
            if (data20.list === void 0) {
              const err43 = {
                instancePath: instancePath + "/scope/excludeTags",
                schemaPath: "TicketScope/properties/excludeTags/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "list"
                },
                message: "must have required property 'list'"
              };
              if (vErrors === null) {
                vErrors = [err43];
              } else {
                vErrors.push(err43);
              }
              errors++;
            }
            if (data20.kind !== void 0) {
              let data21 = data20.kind;
              if (typeof data21 !== "string") {
                const err44 = {
                  instancePath: instancePath + "/scope/excludeTags/kind",
                  schemaPath: "TicketScope/properties/excludeTags/anyOf/0/properties/kind/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err44];
                } else {
                  vErrors.push(err44);
                }
                errors++;
              }
              if (!(data21 === "ALL" || data21 === "SOME")) {
                const err45 = {
                  instancePath: instancePath + "/scope/excludeTags/kind",
                  schemaPath: "TicketScope/properties/excludeTags/anyOf/0/properties/kind/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema155.properties.excludeTags.anyOf[0].properties.kind.enum
                  },
                  message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) {
                  vErrors = [err45];
                } else {
                  vErrors.push(err45);
                }
                errors++;
              }
            }
            if (data20.list !== void 0) {
              let data22 = data20.list;
              if (Array.isArray(data22)) {
                const len3 = data22.length;
                for (let i3 = 0; i3 < len3; i3++) {
                  if (typeof data22[i3] !== "string") {
                    const err46 = {
                      instancePath: instancePath + "/scope/excludeTags/list/" + i3,
                      schemaPath: "TicketScope/properties/excludeTags/anyOf/0/properties/list/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err46];
                    } else {
                      vErrors.push(err46);
                    }
                    errors++;
                  }
                }
              } else {
                const err47 = {
                  instancePath: instancePath + "/scope/excludeTags/list",
                  schemaPath: "TicketScope/properties/excludeTags/anyOf/0/properties/list/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err47];
                } else {
                  vErrors.push(err47);
                }
                errors++;
              }
            }
          } else {
            const err48 = {
              instancePath: instancePath + "/scope/excludeTags",
              schemaPath: "TicketScope/properties/excludeTags/anyOf/0/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err48];
            } else {
              vErrors.push(err48);
            }
            errors++;
          }
          var _valid2 = _errs51 === errors;
          valid15 = valid15 || _valid2;
          if (!valid15) {
            const _errs59 = errors;
            if (data20 !== null) {
              const err49 = {
                instancePath: instancePath + "/scope/excludeTags",
                schemaPath: "TicketScope/properties/excludeTags/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err49];
              } else {
                vErrors.push(err49);
              }
              errors++;
            }
            var _valid2 = _errs59 === errors;
            valid15 = valid15 || _valid2;
          }
          if (!valid15) {
            const err50 = {
              instancePath: instancePath + "/scope/excludeTags",
              schemaPath: "TicketScope/properties/excludeTags/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err50];
            } else {
              vErrors.push(err50);
            }
            errors++;
          } else {
            errors = _errs50;
            if (vErrors !== null) {
              if (_errs50) {
                vErrors.length = _errs50;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data13.attributes !== void 0) {
          let data24 = data13.attributes;
          const _errs62 = errors;
          let valid19 = false;
          const _errs63 = errors;
          if (data24 && typeof data24 == "object" && !Array.isArray(data24)) {
            if (data24.kind === void 0) {
              const err51 = {
                instancePath: instancePath + "/scope/attributes",
                schemaPath: "TicketScope/properties/attributes/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "kind"
                },
                message: "must have required property 'kind'"
              };
              if (vErrors === null) {
                vErrors = [err51];
              } else {
                vErrors.push(err51);
              }
              errors++;
            }
            if (data24.list === void 0) {
              const err52 = {
                instancePath: instancePath + "/scope/attributes",
                schemaPath: "TicketScope/properties/attributes/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "list"
                },
                message: "must have required property 'list'"
              };
              if (vErrors === null) {
                vErrors = [err52];
              } else {
                vErrors.push(err52);
              }
              errors++;
            }
            if (data24.kind !== void 0) {
              let data25 = data24.kind;
              if (typeof data25 !== "string") {
                const err53 = {
                  instancePath: instancePath + "/scope/attributes/kind",
                  schemaPath: "TicketScope/properties/attributes/anyOf/0/properties/kind/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err53];
                } else {
                  vErrors.push(err53);
                }
                errors++;
              }
              if (!(data25 === "ALL" || data25 === "SOME")) {
                const err54 = {
                  instancePath: instancePath + "/scope/attributes/kind",
                  schemaPath: "TicketScope/properties/attributes/anyOf/0/properties/kind/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema155.properties.attributes.anyOf[0].properties.kind.enum
                  },
                  message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) {
                  vErrors = [err54];
                } else {
                  vErrors.push(err54);
                }
                errors++;
              }
            }
            if (data24.list !== void 0) {
              let data26 = data24.list;
              if (Array.isArray(data26)) {
                const len4 = data26.length;
                for (let i4 = 0; i4 < len4; i4++) {
                  if (typeof data26[i4] !== "string") {
                    const err55 = {
                      instancePath: instancePath + "/scope/attributes/list/" + i4,
                      schemaPath: "TicketScope/properties/attributes/anyOf/0/properties/list/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err55];
                    } else {
                      vErrors.push(err55);
                    }
                    errors++;
                  }
                }
              } else {
                const err56 = {
                  instancePath: instancePath + "/scope/attributes/list",
                  schemaPath: "TicketScope/properties/attributes/anyOf/0/properties/list/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err56];
                } else {
                  vErrors.push(err56);
                }
                errors++;
              }
            }
          } else {
            const err57 = {
              instancePath: instancePath + "/scope/attributes",
              schemaPath: "TicketScope/properties/attributes/anyOf/0/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err57];
            } else {
              vErrors.push(err57);
            }
            errors++;
          }
          var _valid3 = _errs63 === errors;
          valid19 = valid19 || _valid3;
          if (!valid19) {
            const _errs71 = errors;
            if (data24 !== null) {
              const err58 = {
                instancePath: instancePath + "/scope/attributes",
                schemaPath: "TicketScope/properties/attributes/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err58];
              } else {
                vErrors.push(err58);
              }
              errors++;
            }
            var _valid3 = _errs71 === errors;
            valid19 = valid19 || _valid3;
          }
          if (!valid19) {
            const err59 = {
              instancePath: instancePath + "/scope/attributes",
              schemaPath: "TicketScope/properties/attributes/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err59];
            } else {
              vErrors.push(err59);
            }
            errors++;
          } else {
            errors = _errs62;
            if (vErrors !== null) {
              if (_errs62) {
                vErrors.length = _errs62;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data13.excludeAttributes !== void 0) {
          let data28 = data13.excludeAttributes;
          const _errs74 = errors;
          let valid23 = false;
          const _errs75 = errors;
          if (data28 && typeof data28 == "object" && !Array.isArray(data28)) {
            if (data28.kind === void 0) {
              const err60 = {
                instancePath: instancePath + "/scope/excludeAttributes",
                schemaPath: "TicketScope/properties/excludeAttributes/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "kind"
                },
                message: "must have required property 'kind'"
              };
              if (vErrors === null) {
                vErrors = [err60];
              } else {
                vErrors.push(err60);
              }
              errors++;
            }
            if (data28.list === void 0) {
              const err61 = {
                instancePath: instancePath + "/scope/excludeAttributes",
                schemaPath: "TicketScope/properties/excludeAttributes/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "list"
                },
                message: "must have required property 'list'"
              };
              if (vErrors === null) {
                vErrors = [err61];
              } else {
                vErrors.push(err61);
              }
              errors++;
            }
            if (data28.kind !== void 0) {
              let data29 = data28.kind;
              if (typeof data29 !== "string") {
                const err62 = {
                  instancePath: instancePath + "/scope/excludeAttributes/kind",
                  schemaPath: "TicketScope/properties/excludeAttributes/anyOf/0/properties/kind/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err62];
                } else {
                  vErrors.push(err62);
                }
                errors++;
              }
              if (!(data29 === "ALL" || data29 === "SOME")) {
                const err63 = {
                  instancePath: instancePath + "/scope/excludeAttributes/kind",
                  schemaPath: "TicketScope/properties/excludeAttributes/anyOf/0/properties/kind/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema155.properties.excludeAttributes.anyOf[0].properties.kind.enum
                  },
                  message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) {
                  vErrors = [err63];
                } else {
                  vErrors.push(err63);
                }
                errors++;
              }
            }
            if (data28.list !== void 0) {
              let data30 = data28.list;
              if (Array.isArray(data30)) {
                const len5 = data30.length;
                for (let i5 = 0; i5 < len5; i5++) {
                  if (typeof data30[i5] !== "string") {
                    const err64 = {
                      instancePath: instancePath + "/scope/excludeAttributes/list/" + i5,
                      schemaPath: "TicketScope/properties/excludeAttributes/anyOf/0/properties/list/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err64];
                    } else {
                      vErrors.push(err64);
                    }
                    errors++;
                  }
                }
              } else {
                const err65 = {
                  instancePath: instancePath + "/scope/excludeAttributes/list",
                  schemaPath: "TicketScope/properties/excludeAttributes/anyOf/0/properties/list/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err65];
                } else {
                  vErrors.push(err65);
                }
                errors++;
              }
            }
          } else {
            const err66 = {
              instancePath: instancePath + "/scope/excludeAttributes",
              schemaPath: "TicketScope/properties/excludeAttributes/anyOf/0/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err66];
            } else {
              vErrors.push(err66);
            }
            errors++;
          }
          var _valid4 = _errs75 === errors;
          valid23 = valid23 || _valid4;
          if (!valid23) {
            const _errs83 = errors;
            if (data28 !== null) {
              const err67 = {
                instancePath: instancePath + "/scope/excludeAttributes",
                schemaPath: "TicketScope/properties/excludeAttributes/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err67];
              } else {
                vErrors.push(err67);
              }
              errors++;
            }
            var _valid4 = _errs83 === errors;
            valid23 = valid23 || _valid4;
          }
          if (!valid23) {
            const err68 = {
              instancePath: instancePath + "/scope/excludeAttributes",
              schemaPath: "TicketScope/properties/excludeAttributes/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err68];
            } else {
              vErrors.push(err68);
            }
            errors++;
          } else {
            errors = _errs74;
            if (vErrors !== null) {
              if (_errs74) {
                vErrors.length = _errs74;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data13.videoIds !== void 0) {
          let data32 = data13.videoIds;
          const _errs86 = errors;
          let valid27 = false;
          const _errs87 = errors;
          if (Array.isArray(data32)) {
            const len6 = data32.length;
            for (let i6 = 0; i6 < len6; i6++) {
              if (typeof data32[i6] !== "string") {
                const err69 = {
                  instancePath: instancePath + "/scope/videoIds/" + i6,
                  schemaPath: "TicketScope/properties/videoIds/anyOf/0/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err69];
                } else {
                  vErrors.push(err69);
                }
                errors++;
              }
            }
          } else {
            const err70 = {
              instancePath: instancePath + "/scope/videoIds",
              schemaPath: "TicketScope/properties/videoIds/anyOf/0/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err70];
            } else {
              vErrors.push(err70);
            }
            errors++;
          }
          var _valid5 = _errs87 === errors;
          valid27 = valid27 || _valid5;
          if (!valid27) {
            const _errs91 = errors;
            if (data32 !== null) {
              const err71 = {
                instancePath: instancePath + "/scope/videoIds",
                schemaPath: "TicketScope/properties/videoIds/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err71];
              } else {
                vErrors.push(err71);
              }
              errors++;
            }
            var _valid5 = _errs91 === errors;
            valid27 = valid27 || _valid5;
          }
          if (!valid27) {
            const err72 = {
              instancePath: instancePath + "/scope/videoIds",
              schemaPath: "TicketScope/properties/videoIds/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err72];
            } else {
              vErrors.push(err72);
            }
            errors++;
          } else {
            errors = _errs86;
            if (vErrors !== null) {
              if (_errs86) {
                vErrors.length = _errs86;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data13.excludeVideoIds !== void 0) {
          let data34 = data13.excludeVideoIds;
          const _errs94 = errors;
          let valid30 = false;
          const _errs95 = errors;
          if (Array.isArray(data34)) {
            const len7 = data34.length;
            for (let i7 = 0; i7 < len7; i7++) {
              if (typeof data34[i7] !== "string") {
                const err73 = {
                  instancePath: instancePath + "/scope/excludeVideoIds/" + i7,
                  schemaPath: "TicketScope/properties/excludeVideoIds/anyOf/0/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err73];
                } else {
                  vErrors.push(err73);
                }
                errors++;
              }
            }
          } else {
            const err74 = {
              instancePath: instancePath + "/scope/excludeVideoIds",
              schemaPath: "TicketScope/properties/excludeVideoIds/anyOf/0/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err74];
            } else {
              vErrors.push(err74);
            }
            errors++;
          }
          var _valid6 = _errs95 === errors;
          valid30 = valid30 || _valid6;
          if (!valid30) {
            const _errs99 = errors;
            if (data34 !== null) {
              const err75 = {
                instancePath: instancePath + "/scope/excludeVideoIds",
                schemaPath: "TicketScope/properties/excludeVideoIds/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err75];
              } else {
                vErrors.push(err75);
              }
              errors++;
            }
            var _valid6 = _errs99 === errors;
            valid30 = valid30 || _valid6;
          }
          if (!valid30) {
            const err76 = {
              instancePath: instancePath + "/scope/excludeVideoIds",
              schemaPath: "TicketScope/properties/excludeVideoIds/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err76];
            } else {
              vErrors.push(err76);
            }
            errors++;
          } else {
            errors = _errs94;
            if (vErrors !== null) {
              if (_errs94) {
                vErrors.length = _errs94;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data13.redemptionLimit !== void 0) {
          let data36 = data13.redemptionLimit;
          if (!(typeof data36 == "number" && isFinite(data36)) && data36 !== null) {
            const err77 = {
              instancePath: instancePath + "/scope/redemptionLimit",
              schemaPath: "TicketScope/properties/redemptionLimit/type",
              keyword: "type",
              params: {
                type: schema155.properties.redemptionLimit.type
              },
              message: "must be number,null"
            };
            if (vErrors === null) {
              vErrors = [err77];
            } else {
              vErrors.push(err77);
            }
            errors++;
          }
          if (!(data36 === 1 || data36 === null)) {
            const err78 = {
              instancePath: instancePath + "/scope/redemptionLimit",
              schemaPath: "TicketScope/properties/redemptionLimit/enum",
              keyword: "enum",
              params: {
                allowedValues: schema155.properties.redemptionLimit.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err78];
            } else {
              vErrors.push(err78);
            }
            errors++;
          }
        }
        if (data13.validityAfterRedemptionHours !== void 0) {
          let data37 = data13.validityAfterRedemptionHours;
          if (!(typeof data37 == "number" && isFinite(data37)) && data37 !== null) {
            const err79 = {
              instancePath: instancePath + "/scope/validityAfterRedemptionHours",
              schemaPath: "TicketScope/properties/validityAfterRedemptionHours/type",
              keyword: "type",
              params: {
                type: schema155.properties.validityAfterRedemptionHours.type
              },
              message: "must be number,null"
            };
            if (vErrors === null) {
              vErrors = [err79];
            } else {
              vErrors.push(err79);
            }
            errors++;
          }
        }
      } else {
        const err80 = {
          instancePath: instancePath + "/scope",
          schemaPath: "TicketScope/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err80];
        } else {
          vErrors.push(err80);
        }
        errors++;
      }
      var _valid0 = _errs30 === errors;
      valid8 = valid8 || _valid0;
      if (!valid8) {
        const _errs105 = errors;
        if (data13 !== null) {
          const err81 = {
            instancePath: instancePath + "/scope",
            schemaPath: "#/properties/scope/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err81];
          } else {
            vErrors.push(err81);
          }
          errors++;
        }
        var _valid0 = _errs105 === errors;
        valid8 = valid8 || _valid0;
      }
      if (!valid8) {
        const err82 = {
          instancePath: instancePath + "/scope",
          schemaPath: "#/properties/scope/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err82];
        } else {
          vErrors.push(err82);
        }
        errors++;
      } else {
        errors = _errs29;
        if (vErrors !== null) {
          if (_errs29) {
            vErrors.length = _errs29;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.geo_restriction !== void 0) {
      let data38 = data.geo_restriction;
      const _errs108 = errors;
      let valid33 = false;
      const _errs109 = errors;
      if (Array.isArray(data38)) {
        const len8 = data38.length;
        for (let i8 = 0; i8 < len8; i8++) {
          if (typeof data38[i8] !== "string") {
            const err83 = {
              instancePath: instancePath + "/geo_restriction/" + i8,
              schemaPath: "#/properties/geo_restriction/anyOf/0/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err83];
            } else {
              vErrors.push(err83);
            }
            errors++;
          }
        }
      } else {
        const err84 = {
          instancePath: instancePath + "/geo_restriction",
          schemaPath: "#/properties/geo_restriction/anyOf/0/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err84];
        } else {
          vErrors.push(err84);
        }
        errors++;
      }
      var _valid7 = _errs109 === errors;
      valid33 = valid33 || _valid7;
      if (!valid33) {
        const _errs113 = errors;
        if (data38 !== null) {
          const err85 = {
            instancePath: instancePath + "/geo_restriction",
            schemaPath: "#/properties/geo_restriction/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err85];
          } else {
            vErrors.push(err85);
          }
          errors++;
        }
        var _valid7 = _errs113 === errors;
        valid33 = valid33 || _valid7;
      }
      if (!valid33) {
        const err86 = {
          instancePath: instancePath + "/geo_restriction",
          schemaPath: "#/properties/geo_restriction/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err86];
        } else {
          vErrors.push(err86);
        }
        errors++;
      } else {
        errors = _errs108;
        if (vErrors !== null) {
          if (_errs108) {
            vErrors.length = _errs108;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.available !== void 0) {
      if (typeof data.available !== "boolean") {
        const err87 = {
          instancePath: instancePath + "/available",
          schemaPath: "#/properties/available/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err87];
        } else {
          vErrors.push(err87);
        }
        errors++;
      }
    }
  } else {
    const err88 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err88];
    } else {
      vErrors.push(err88);
    }
    errors++;
  }
  validate146.errors = vErrors;
  return errors === 0;
}
const Event = validate147;
const schema159 = {
  "$id": "Event",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "title": {
      "type": "string"
    },
    "description": {
      "type": "string"
    },
    "startTime": {
      "type": "object",
      "format": "date-time"
    },
    "endTime": {
      "type": "object",
      "format": "date-time"
    },
    "tickets": {
      "type": "array",
      "items": {
        "$ref": "Ticket"
      }
    },
    "hideTicketCTA": {
      "type": "boolean"
    },
    "pages": {
      "type": "array",
      "items": {
        "$ref": "Page"
      }
    },
    "published": {
      "type": "boolean"
    },
    "archived": {
      "type": "boolean"
    },
    "organizationId": {
      "type": ["string", "null"]
    },
    "channelId": {
      "type": "string"
    },
    "posterImage": {
      "type": "string"
    },
    "includedInPlans": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "null"
      }]
    },
    "excludedFromPlans": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "null"
      }]
    }
  },
  "required": ["title", "description", "startTime", "endTime", "tickets", "pages", "published", "archived", "organizationId", "channelId", "posterImage"],
  "description": "An event is the main content type in a channel and represents one or multiple live streams, uploads, ads, etc. The event can span multiple days and can be promoted in advance. The defining features of the event is that tickets can be purchased to unlock specific content."
};
function validate147(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.title === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "title"
        },
        message: "must have required property 'title'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.description === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "description"
        },
        message: "must have required property 'description'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.startTime === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "startTime"
        },
        message: "must have required property 'startTime'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.endTime === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "endTime"
        },
        message: "must have required property 'endTime'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.tickets === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "tickets"
        },
        message: "must have required property 'tickets'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.pages === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "pages"
        },
        message: "must have required property 'pages'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.published === void 0) {
      const err6 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "published"
        },
        message: "must have required property 'published'"
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.archived === void 0) {
      const err7 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "archived"
        },
        message: "must have required property 'archived'"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.organizationId === void 0) {
      const err8 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "organizationId"
        },
        message: "must have required property 'organizationId'"
      };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    if (data.channelId === void 0) {
      const err9 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err9];
      } else {
        vErrors.push(err9);
      }
      errors++;
    }
    if (data.posterImage === void 0) {
      const err10 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "posterImage"
        },
        message: "must have required property 'posterImage'"
      };
      if (vErrors === null) {
        vErrors = [err10];
      } else {
        vErrors.push(err10);
      }
      errors++;
    }
    if (data.title !== void 0) {
      if (typeof data.title !== "string") {
        const err11 = {
          instancePath: instancePath + "/title",
          schemaPath: "#/properties/title/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.description !== void 0) {
      if (typeof data.description !== "string") {
        const err12 = {
          instancePath: instancePath + "/description",
          schemaPath: "#/properties/description/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.startTime !== void 0) {
      let data2 = data.startTime;
      if (!(data2 && typeof data2 == "object" && !Array.isArray(data2))) {
        const err13 = {
          instancePath: instancePath + "/startTime",
          schemaPath: "#/properties/startTime/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
      if (typeof data2 === "string") {
        if (!formats0(data2)) {
          const err14 = {
            instancePath: instancePath + "/startTime",
            schemaPath: "#/properties/startTime/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
      }
    }
    if (data.endTime !== void 0) {
      let data3 = data.endTime;
      if (!(data3 && typeof data3 == "object" && !Array.isArray(data3))) {
        const err15 = {
          instancePath: instancePath + "/endTime",
          schemaPath: "#/properties/endTime/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
      if (typeof data3 === "string") {
        if (!formats0(data3)) {
          const err16 = {
            instancePath: instancePath + "/endTime",
            schemaPath: "#/properties/endTime/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
      }
    }
    if (data.tickets !== void 0) {
      let data4 = data.tickets;
      if (Array.isArray(data4)) {
        const len0 = data4.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (!validate146(data4[i0], {
            instancePath: instancePath + "/tickets/" + i0,
            parentData: data4,
            parentDataProperty: i0,
            rootData
          })) {
            vErrors = vErrors === null ? validate146.errors : vErrors.concat(validate146.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err17 = {
          instancePath: instancePath + "/tickets",
          schemaPath: "#/properties/tickets/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.hideTicketCTA !== void 0) {
      if (typeof data.hideTicketCTA !== "boolean") {
        const err18 = {
          instancePath: instancePath + "/hideTicketCTA",
          schemaPath: "#/properties/hideTicketCTA/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
    if (data.pages !== void 0) {
      let data7 = data.pages;
      if (Array.isArray(data7)) {
        const len1 = data7.length;
        for (let i1 = 0; i1 < len1; i1++) {
          if (!validate106(data7[i1], {
            instancePath: instancePath + "/pages/" + i1,
            parentData: data7,
            parentDataProperty: i1,
            rootData
          })) {
            vErrors = vErrors === null ? validate106.errors : vErrors.concat(validate106.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err19 = {
          instancePath: instancePath + "/pages",
          schemaPath: "#/properties/pages/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      }
    }
    if (data.published !== void 0) {
      if (typeof data.published !== "boolean") {
        const err20 = {
          instancePath: instancePath + "/published",
          schemaPath: "#/properties/published/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
    }
    if (data.archived !== void 0) {
      if (typeof data.archived !== "boolean") {
        const err21 = {
          instancePath: instancePath + "/archived",
          schemaPath: "#/properties/archived/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err21];
        } else {
          vErrors.push(err21);
        }
        errors++;
      }
    }
    if (data.organizationId !== void 0) {
      let data11 = data.organizationId;
      if (typeof data11 !== "string" && data11 !== null) {
        const err22 = {
          instancePath: instancePath + "/organizationId",
          schemaPath: "#/properties/organizationId/type",
          keyword: "type",
          params: {
            type: schema159.properties.organizationId.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err22];
        } else {
          vErrors.push(err22);
        }
        errors++;
      }
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err23 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err23];
        } else {
          vErrors.push(err23);
        }
        errors++;
      }
    }
    if (data.posterImage !== void 0) {
      if (typeof data.posterImage !== "string") {
        const err24 = {
          instancePath: instancePath + "/posterImage",
          schemaPath: "#/properties/posterImage/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err24];
        } else {
          vErrors.push(err24);
        }
        errors++;
      }
    }
    if (data.includedInPlans !== void 0) {
      let data14 = data.includedInPlans;
      const _errs28 = errors;
      let valid5 = false;
      const _errs29 = errors;
      if (Array.isArray(data14)) {
        const len2 = data14.length;
        for (let i2 = 0; i2 < len2; i2++) {
          if (typeof data14[i2] !== "string") {
            const err25 = {
              instancePath: instancePath + "/includedInPlans/" + i2,
              schemaPath: "#/properties/includedInPlans/anyOf/0/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err25];
            } else {
              vErrors.push(err25);
            }
            errors++;
          }
        }
      } else {
        const err26 = {
          instancePath: instancePath + "/includedInPlans",
          schemaPath: "#/properties/includedInPlans/anyOf/0/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err26];
        } else {
          vErrors.push(err26);
        }
        errors++;
      }
      var _valid0 = _errs29 === errors;
      valid5 = valid5 || _valid0;
      if (!valid5) {
        const _errs33 = errors;
        if (data14 !== null) {
          const err27 = {
            instancePath: instancePath + "/includedInPlans",
            schemaPath: "#/properties/includedInPlans/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err27];
          } else {
            vErrors.push(err27);
          }
          errors++;
        }
        var _valid0 = _errs33 === errors;
        valid5 = valid5 || _valid0;
      }
      if (!valid5) {
        const err28 = {
          instancePath: instancePath + "/includedInPlans",
          schemaPath: "#/properties/includedInPlans/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err28];
        } else {
          vErrors.push(err28);
        }
        errors++;
      } else {
        errors = _errs28;
        if (vErrors !== null) {
          if (_errs28) {
            vErrors.length = _errs28;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.excludedFromPlans !== void 0) {
      let data16 = data.excludedFromPlans;
      const _errs36 = errors;
      let valid8 = false;
      const _errs37 = errors;
      if (Array.isArray(data16)) {
        const len3 = data16.length;
        for (let i3 = 0; i3 < len3; i3++) {
          if (typeof data16[i3] !== "string") {
            const err29 = {
              instancePath: instancePath + "/excludedFromPlans/" + i3,
              schemaPath: "#/properties/excludedFromPlans/anyOf/0/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err29];
            } else {
              vErrors.push(err29);
            }
            errors++;
          }
        }
      } else {
        const err30 = {
          instancePath: instancePath + "/excludedFromPlans",
          schemaPath: "#/properties/excludedFromPlans/anyOf/0/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err30];
        } else {
          vErrors.push(err30);
        }
        errors++;
      }
      var _valid1 = _errs37 === errors;
      valid8 = valid8 || _valid1;
      if (!valid8) {
        const _errs41 = errors;
        if (data16 !== null) {
          const err31 = {
            instancePath: instancePath + "/excludedFromPlans",
            schemaPath: "#/properties/excludedFromPlans/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err31];
          } else {
            vErrors.push(err31);
          }
          errors++;
        }
        var _valid1 = _errs41 === errors;
        valid8 = valid8 || _valid1;
      }
      if (!valid8) {
        const err32 = {
          instancePath: instancePath + "/excludedFromPlans",
          schemaPath: "#/properties/excludedFromPlans/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err32];
        } else {
          vErrors.push(err32);
        }
        errors++;
      } else {
        errors = _errs36;
        if (vErrors !== null) {
          if (_errs36) {
            vErrors.length = _errs36;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err33 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err33];
    } else {
      vErrors.push(err33);
    }
    errors++;
  }
  validate147.errors = vErrors;
  return errors === 0;
}
const Feedback = validate150;
const schema160 = {
  "$id": "Feedback",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "type": {
      "type": "string",
      "const": "VIDEO"
    },
    "videoId": {
      "type": "string"
    },
    "eventId": {
      "type": ["string", "null"]
    },
    "videoType": {
      "type": "string",
      "enum": ["SHORT", "STREAM", "UPLOAD"]
    },
    "isLive": {
      "type": "boolean"
    },
    "timestamp": {
      "type": "object",
      "format": "date-time"
    },
    "userId": {
      "type": "string"
    },
    "testingGroup": {
      "type": "string"
    },
    "channelId": {
      "type": "string"
    },
    "accessType": {
      "type": "string",
      "enum": ["TICKET", "SUBSCRIPTION", "FREE"]
    },
    "feedback": {
      "type": "object",
      "properties": {
        "rating": {
          "type": ["number", "null"]
        },
        "message": {
          "type": ["string", "null"]
        }
      },
      "required": ["rating", "message"]
    },
    "location": {
      "anyOf": [{
        "$ref": "UserLocation"
      }, {
        "type": "null"
      }]
    }
  },
  "required": ["type", "videoId", "eventId", "videoType", "isLive", "timestamp", "userId", "testingGroup", "channelId", "accessType", "feedback", "location"]
};
function validate150(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.type === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.videoId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "videoId"
        },
        message: "must have required property 'videoId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.eventId === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "eventId"
        },
        message: "must have required property 'eventId'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.videoType === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "videoType"
        },
        message: "must have required property 'videoType'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.isLive === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "isLive"
        },
        message: "must have required property 'isLive'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.timestamp === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "timestamp"
        },
        message: "must have required property 'timestamp'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.userId === void 0) {
      const err6 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "userId"
        },
        message: "must have required property 'userId'"
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.testingGroup === void 0) {
      const err7 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "testingGroup"
        },
        message: "must have required property 'testingGroup'"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.channelId === void 0) {
      const err8 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    if (data.accessType === void 0) {
      const err9 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "accessType"
        },
        message: "must have required property 'accessType'"
      };
      if (vErrors === null) {
        vErrors = [err9];
      } else {
        vErrors.push(err9);
      }
      errors++;
    }
    if (data.feedback === void 0) {
      const err10 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "feedback"
        },
        message: "must have required property 'feedback'"
      };
      if (vErrors === null) {
        vErrors = [err10];
      } else {
        vErrors.push(err10);
      }
      errors++;
    }
    if (data.location === void 0) {
      const err11 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "location"
        },
        message: "must have required property 'location'"
      };
      if (vErrors === null) {
        vErrors = [err11];
      } else {
        vErrors.push(err11);
      }
      errors++;
    }
    if (data.type !== void 0) {
      let data0 = data.type;
      if (typeof data0 !== "string") {
        const err12 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
      if ("VIDEO" !== data0) {
        const err13 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/const",
          keyword: "const",
          params: {
            allowedValue: "VIDEO"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.videoId !== void 0) {
      if (typeof data.videoId !== "string") {
        const err14 = {
          instancePath: instancePath + "/videoId",
          schemaPath: "#/properties/videoId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.eventId !== void 0) {
      let data2 = data.eventId;
      if (typeof data2 !== "string" && data2 !== null) {
        const err15 = {
          instancePath: instancePath + "/eventId",
          schemaPath: "#/properties/eventId/type",
          keyword: "type",
          params: {
            type: schema160.properties.eventId.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
    if (data.videoType !== void 0) {
      let data3 = data.videoType;
      if (typeof data3 !== "string") {
        const err16 = {
          instancePath: instancePath + "/videoType",
          schemaPath: "#/properties/videoType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
      if (!(data3 === "SHORT" || data3 === "STREAM" || data3 === "UPLOAD")) {
        const err17 = {
          instancePath: instancePath + "/videoType",
          schemaPath: "#/properties/videoType/enum",
          keyword: "enum",
          params: {
            allowedValues: schema160.properties.videoType.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.isLive !== void 0) {
      if (typeof data.isLive !== "boolean") {
        const err18 = {
          instancePath: instancePath + "/isLive",
          schemaPath: "#/properties/isLive/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
    if (data.timestamp !== void 0) {
      let data5 = data.timestamp;
      if (!(data5 && typeof data5 == "object" && !Array.isArray(data5))) {
        const err19 = {
          instancePath: instancePath + "/timestamp",
          schemaPath: "#/properties/timestamp/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      }
      if (typeof data5 === "string") {
        if (!formats0(data5)) {
          const err20 = {
            instancePath: instancePath + "/timestamp",
            schemaPath: "#/properties/timestamp/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
      }
    }
    if (data.userId !== void 0) {
      if (typeof data.userId !== "string") {
        const err21 = {
          instancePath: instancePath + "/userId",
          schemaPath: "#/properties/userId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err21];
        } else {
          vErrors.push(err21);
        }
        errors++;
      }
    }
    if (data.testingGroup !== void 0) {
      if (typeof data.testingGroup !== "string") {
        const err22 = {
          instancePath: instancePath + "/testingGroup",
          schemaPath: "#/properties/testingGroup/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err22];
        } else {
          vErrors.push(err22);
        }
        errors++;
      }
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err23 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err23];
        } else {
          vErrors.push(err23);
        }
        errors++;
      }
    }
    if (data.accessType !== void 0) {
      let data9 = data.accessType;
      if (typeof data9 !== "string") {
        const err24 = {
          instancePath: instancePath + "/accessType",
          schemaPath: "#/properties/accessType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err24];
        } else {
          vErrors.push(err24);
        }
        errors++;
      }
      if (!(data9 === "TICKET" || data9 === "SUBSCRIPTION" || data9 === "FREE")) {
        const err25 = {
          instancePath: instancePath + "/accessType",
          schemaPath: "#/properties/accessType/enum",
          keyword: "enum",
          params: {
            allowedValues: schema160.properties.accessType.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err25];
        } else {
          vErrors.push(err25);
        }
        errors++;
      }
    }
    if (data.feedback !== void 0) {
      let data10 = data.feedback;
      if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
        if (data10.rating === void 0) {
          const err26 = {
            instancePath: instancePath + "/feedback",
            schemaPath: "#/properties/feedback/required",
            keyword: "required",
            params: {
              missingProperty: "rating"
            },
            message: "must have required property 'rating'"
          };
          if (vErrors === null) {
            vErrors = [err26];
          } else {
            vErrors.push(err26);
          }
          errors++;
        }
        if (data10.message === void 0) {
          const err27 = {
            instancePath: instancePath + "/feedback",
            schemaPath: "#/properties/feedback/required",
            keyword: "required",
            params: {
              missingProperty: "message"
            },
            message: "must have required property 'message'"
          };
          if (vErrors === null) {
            vErrors = [err27];
          } else {
            vErrors.push(err27);
          }
          errors++;
        }
        if (data10.rating !== void 0) {
          let data11 = data10.rating;
          if (!(typeof data11 == "number" && isFinite(data11)) && data11 !== null) {
            const err28 = {
              instancePath: instancePath + "/feedback/rating",
              schemaPath: "#/properties/feedback/properties/rating/type",
              keyword: "type",
              params: {
                type: schema160.properties.feedback.properties.rating.type
              },
              message: "must be number,null"
            };
            if (vErrors === null) {
              vErrors = [err28];
            } else {
              vErrors.push(err28);
            }
            errors++;
          }
        }
        if (data10.message !== void 0) {
          let data12 = data10.message;
          if (typeof data12 !== "string" && data12 !== null) {
            const err29 = {
              instancePath: instancePath + "/feedback/message",
              schemaPath: "#/properties/feedback/properties/message/type",
              keyword: "type",
              params: {
                type: schema160.properties.feedback.properties.message.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err29];
            } else {
              vErrors.push(err29);
            }
            errors++;
          }
        }
      } else {
        const err30 = {
          instancePath: instancePath + "/feedback",
          schemaPath: "#/properties/feedback/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err30];
        } else {
          vErrors.push(err30);
        }
        errors++;
      }
    }
    if (data.location !== void 0) {
      let data13 = data.location;
      const _errs28 = errors;
      let valid2 = false;
      const _errs29 = errors;
      if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
        if (data13.IP === void 0) {
          const err31 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "IP"
            },
            message: "must have required property 'IP'"
          };
          if (vErrors === null) {
            vErrors = [err31];
          } else {
            vErrors.push(err31);
          }
          errors++;
        }
        if (data13.latlng === void 0) {
          const err32 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "latlng"
            },
            message: "must have required property 'latlng'"
          };
          if (vErrors === null) {
            vErrors = [err32];
          } else {
            vErrors.push(err32);
          }
          errors++;
        }
        if (data13.city === void 0) {
          const err33 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "city"
            },
            message: "must have required property 'city'"
          };
          if (vErrors === null) {
            vErrors = [err33];
          } else {
            vErrors.push(err33);
          }
          errors++;
        }
        if (data13.country === void 0) {
          const err34 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "country"
            },
            message: "must have required property 'country'"
          };
          if (vErrors === null) {
            vErrors = [err34];
          } else {
            vErrors.push(err34);
          }
          errors++;
        }
        if (data13.region === void 0) {
          const err35 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "region"
            },
            message: "must have required property 'region'"
          };
          if (vErrors === null) {
            vErrors = [err35];
          } else {
            vErrors.push(err35);
          }
          errors++;
        }
        if (data13.IP !== void 0) {
          let data14 = data13.IP;
          if (typeof data14 !== "string" && data14 !== null) {
            const err36 = {
              instancePath: instancePath + "/location/IP",
              schemaPath: "UserLocation/properties/IP/type",
              keyword: "type",
              params: {
                type: schema56.properties.IP.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err36];
            } else {
              vErrors.push(err36);
            }
            errors++;
          }
        }
        if (data13.latlng !== void 0) {
          let data15 = data13.latlng;
          if (typeof data15 !== "string" && data15 !== null) {
            const err37 = {
              instancePath: instancePath + "/location/latlng",
              schemaPath: "UserLocation/properties/latlng/type",
              keyword: "type",
              params: {
                type: schema56.properties.latlng.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err37];
            } else {
              vErrors.push(err37);
            }
            errors++;
          }
        }
        if (data13.city !== void 0) {
          let data16 = data13.city;
          if (typeof data16 !== "string" && data16 !== null) {
            const err38 = {
              instancePath: instancePath + "/location/city",
              schemaPath: "UserLocation/properties/city/type",
              keyword: "type",
              params: {
                type: schema56.properties.city.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err38];
            } else {
              vErrors.push(err38);
            }
            errors++;
          }
        }
        if (data13.country !== void 0) {
          let data17 = data13.country;
          if (typeof data17 !== "string" && data17 !== null) {
            const err39 = {
              instancePath: instancePath + "/location/country",
              schemaPath: "UserLocation/properties/country/type",
              keyword: "type",
              params: {
                type: schema56.properties.country.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err39];
            } else {
              vErrors.push(err39);
            }
            errors++;
          }
        }
        if (data13.region !== void 0) {
          let data18 = data13.region;
          if (typeof data18 !== "string" && data18 !== null) {
            const err40 = {
              instancePath: instancePath + "/location/region",
              schemaPath: "UserLocation/properties/region/type",
              keyword: "type",
              params: {
                type: schema56.properties.region.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err40];
            } else {
              vErrors.push(err40);
            }
            errors++;
          }
        }
      } else {
        const err41 = {
          instancePath: instancePath + "/location",
          schemaPath: "UserLocation/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err41];
        } else {
          vErrors.push(err41);
        }
        errors++;
      }
      var _valid0 = _errs29 === errors;
      valid2 = valid2 || _valid0;
      if (!valid2) {
        const _errs42 = errors;
        if (data13 !== null) {
          const err42 = {
            instancePath: instancePath + "/location",
            schemaPath: "#/properties/location/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err42];
          } else {
            vErrors.push(err42);
          }
          errors++;
        }
        var _valid0 = _errs42 === errors;
        valid2 = valid2 || _valid0;
      }
      if (!valid2) {
        const err43 = {
          instancePath: instancePath + "/location",
          schemaPath: "#/properties/location/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err43];
        } else {
          vErrors.push(err43);
        }
        errors++;
      } else {
        errors = _errs28;
        if (vErrors !== null) {
          if (_errs28) {
            vErrors.length = _errs28;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err44 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err44];
    } else {
      vErrors.push(err44);
    }
    errors++;
  }
  validate150.errors = vErrors;
  return errors === 0;
}
const SaveFeedbackRequest = validate151;
const schema162 = {
  "$id": "SaveFeedbackRequest",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "type": {
      "type": "string",
      "const": "VIDEO"
    },
    "videoId": {
      "type": "string"
    },
    "eventId": {
      "type": ["string", "null"]
    },
    "videoType": {
      "type": "string",
      "enum": ["SHORT", "STREAM", "UPLOAD"]
    },
    "isLive": {
      "type": "boolean"
    },
    "testingGroup": {
      "type": "string"
    },
    "channelId": {
      "type": "string"
    },
    "accessType": {
      "type": "string",
      "enum": ["TICKET", "SUBSCRIPTION", "FREE"]
    },
    "feedback": {
      "type": "object",
      "properties": {
        "rating": {
          "type": ["number", "null"]
        },
        "message": {
          "type": ["string", "null"]
        }
      },
      "required": ["rating", "message"]
    }
  },
  "required": ["type", "videoId", "eventId", "videoType", "isLive", "testingGroup", "channelId", "accessType", "feedback"]
};
function validate151(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.type === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.videoId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "videoId"
        },
        message: "must have required property 'videoId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.eventId === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "eventId"
        },
        message: "must have required property 'eventId'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.videoType === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "videoType"
        },
        message: "must have required property 'videoType'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.isLive === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "isLive"
        },
        message: "must have required property 'isLive'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.testingGroup === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "testingGroup"
        },
        message: "must have required property 'testingGroup'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.channelId === void 0) {
      const err6 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.accessType === void 0) {
      const err7 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "accessType"
        },
        message: "must have required property 'accessType'"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.feedback === void 0) {
      const err8 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "feedback"
        },
        message: "must have required property 'feedback'"
      };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    if (data.type !== void 0) {
      let data0 = data.type;
      if (typeof data0 !== "string") {
        const err9 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if ("VIDEO" !== data0) {
        const err10 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/const",
          keyword: "const",
          params: {
            allowedValue: "VIDEO"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.videoId !== void 0) {
      if (typeof data.videoId !== "string") {
        const err11 = {
          instancePath: instancePath + "/videoId",
          schemaPath: "#/properties/videoId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.eventId !== void 0) {
      let data2 = data.eventId;
      if (typeof data2 !== "string" && data2 !== null) {
        const err12 = {
          instancePath: instancePath + "/eventId",
          schemaPath: "#/properties/eventId/type",
          keyword: "type",
          params: {
            type: schema162.properties.eventId.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.videoType !== void 0) {
      let data3 = data.videoType;
      if (typeof data3 !== "string") {
        const err13 = {
          instancePath: instancePath + "/videoType",
          schemaPath: "#/properties/videoType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
      if (!(data3 === "SHORT" || data3 === "STREAM" || data3 === "UPLOAD")) {
        const err14 = {
          instancePath: instancePath + "/videoType",
          schemaPath: "#/properties/videoType/enum",
          keyword: "enum",
          params: {
            allowedValues: schema162.properties.videoType.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.isLive !== void 0) {
      if (typeof data.isLive !== "boolean") {
        const err15 = {
          instancePath: instancePath + "/isLive",
          schemaPath: "#/properties/isLive/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
    if (data.testingGroup !== void 0) {
      if (typeof data.testingGroup !== "string") {
        const err16 = {
          instancePath: instancePath + "/testingGroup",
          schemaPath: "#/properties/testingGroup/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err17 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.accessType !== void 0) {
      let data7 = data.accessType;
      if (typeof data7 !== "string") {
        const err18 = {
          instancePath: instancePath + "/accessType",
          schemaPath: "#/properties/accessType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
      if (!(data7 === "TICKET" || data7 === "SUBSCRIPTION" || data7 === "FREE")) {
        const err19 = {
          instancePath: instancePath + "/accessType",
          schemaPath: "#/properties/accessType/enum",
          keyword: "enum",
          params: {
            allowedValues: schema162.properties.accessType.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      }
    }
    if (data.feedback !== void 0) {
      let data8 = data.feedback;
      if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
        if (data8.rating === void 0) {
          const err20 = {
            instancePath: instancePath + "/feedback",
            schemaPath: "#/properties/feedback/required",
            keyword: "required",
            params: {
              missingProperty: "rating"
            },
            message: "must have required property 'rating'"
          };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
        if (data8.message === void 0) {
          const err21 = {
            instancePath: instancePath + "/feedback",
            schemaPath: "#/properties/feedback/required",
            keyword: "required",
            params: {
              missingProperty: "message"
            },
            message: "must have required property 'message'"
          };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
        if (data8.rating !== void 0) {
          let data9 = data8.rating;
          if (!(typeof data9 == "number" && isFinite(data9)) && data9 !== null) {
            const err22 = {
              instancePath: instancePath + "/feedback/rating",
              schemaPath: "#/properties/feedback/properties/rating/type",
              keyword: "type",
              params: {
                type: schema162.properties.feedback.properties.rating.type
              },
              message: "must be number,null"
            };
            if (vErrors === null) {
              vErrors = [err22];
            } else {
              vErrors.push(err22);
            }
            errors++;
          }
        }
        if (data8.message !== void 0) {
          let data10 = data8.message;
          if (typeof data10 !== "string" && data10 !== null) {
            const err23 = {
              instancePath: instancePath + "/feedback/message",
              schemaPath: "#/properties/feedback/properties/message/type",
              keyword: "type",
              params: {
                type: schema162.properties.feedback.properties.message.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
        }
      } else {
        const err24 = {
          instancePath: instancePath + "/feedback",
          schemaPath: "#/properties/feedback/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err24];
        } else {
          vErrors.push(err24);
        }
        errors++;
      }
    }
  } else {
    const err25 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err25];
    } else {
      vErrors.push(err25);
    }
    errors++;
  }
  validate151.errors = vErrors;
  return errors === 0;
}
const SaveFeedbackSuccessfulResponse = validate152;
function validate152(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.feedbackId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "feedbackId"
        },
        message: "must have required property 'feedbackId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (true !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.feedbackId !== void 0) {
      if (typeof data.feedbackId !== "string") {
        const err4 = {
          instancePath: instancePath + "/feedbackId",
          schemaPath: "#/properties/feedbackId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate152.errors = vErrors;
  return errors === 0;
}
const SaveFeedbackErrorResponse = validate153;
function validate153(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.error === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "error"
        },
        message: "must have required property 'error'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (false !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: false
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.error !== void 0) {
      if (typeof data.error !== "string") {
        const err4 = {
          instancePath: instancePath + "/error",
          schemaPath: "#/properties/error/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate153.errors = vErrors;
  return errors === 0;
}
const SaveFeedbackResponse = validate154;
function validate154(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "SaveFeedbackSuccessfulResponse/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.feedbackId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "SaveFeedbackSuccessfulResponse/required",
        keyword: "required",
        params: {
          missingProperty: "feedbackId"
        },
        message: "must have required property 'feedbackId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "SaveFeedbackSuccessfulResponse/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (true !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "SaveFeedbackSuccessfulResponse/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.feedbackId !== void 0) {
      if (typeof data.feedbackId !== "string") {
        const err4 = {
          instancePath: instancePath + "/feedbackId",
          schemaPath: "SaveFeedbackSuccessfulResponse/properties/feedbackId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "SaveFeedbackSuccessfulResponse/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs8 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.success === void 0) {
        const err6 = {
          instancePath,
          schemaPath: "SaveFeedbackErrorResponse/required",
          keyword: "required",
          params: {
            missingProperty: "success"
          },
          message: "must have required property 'success'"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if (data.error === void 0) {
        const err7 = {
          instancePath,
          schemaPath: "SaveFeedbackErrorResponse/required",
          keyword: "required",
          params: {
            missingProperty: "error"
          },
          message: "must have required property 'error'"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if (data.success !== void 0) {
        let data2 = data.success;
        if (typeof data2 !== "boolean") {
          const err8 = {
            instancePath: instancePath + "/success",
            schemaPath: "SaveFeedbackErrorResponse/properties/success/type",
            keyword: "type",
            params: {
              type: "boolean"
            },
            message: "must be boolean"
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
        if (false !== data2) {
          const err9 = {
            instancePath: instancePath + "/success",
            schemaPath: "SaveFeedbackErrorResponse/properties/success/const",
            keyword: "const",
            params: {
              allowedValue: false
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
      }
      if (data.error !== void 0) {
        if (typeof data.error !== "string") {
          const err10 = {
            instancePath: instancePath + "/error",
            schemaPath: "SaveFeedbackErrorResponse/properties/error/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
      }
    } else {
      const err11 = {
        instancePath,
        schemaPath: "SaveFeedbackErrorResponse/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err11];
      } else {
        vErrors.push(err11);
      }
      errors++;
    }
    var _valid0 = _errs8 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err12 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err12];
    } else {
      vErrors.push(err12);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate154.errors = vErrors;
  return errors === 0;
}
const PlanScope = validate155;
const schema168 = {
  "$id": "PlanScope",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "initialCoverage": {
      "type": ["boolean", "null"]
    },
    "tags": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "excludeTags": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "attributes": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "excludeAttributes": {
      "anyOf": [{
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": ["ALL", "SOME"]
          },
          "list": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["kind", "list"]
      }, {
        "type": "null"
      }]
    },
    "predicateCombination": {
      "type": ["string", "null"],
      "enum": ["OR", "AND", null]
    },
    "includedPlans": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "null"
      }]
    }
  },
  "description": 'Defines which videos a subscription would give you access to. The algorithm to determine if a video or event is allowed or denied is as follows:\n\n1. If `initialCoverage` is defined, use that value as a starting point to determine if the video or event is covered. Assume the value to be **true** if not defined. 2. Video Coverage Check:     1. If `tags` is defined, check if the video has the specified tags,        If it does, assume the ***video coverage check" coverage is true***, else use the        ***coverage from previous steps***.     2. if `excludeTags` is defined, check if the video has the specified tags,        If it does, assume the ***video coverage check" coverage is false***, else use the        ***coverage from previous steps***.     3. if `attributes` is defined, check if the video defines the specified attributes.        If it does, assume the ***video coverage check" coverage is true***, else use the        ***coverage from previous steps***.        List is a list of string with the following format: `\u201Cattr[0-3]:.+"` for example        `["attr0:value","attr0:value2", "attr2:valueX"]` where `attr?` is the custom        attribute type, and `value` is one of the allowed values for that specific attribute type.     4. if `excludeAttributes` is defined, check if the video defines the the specified        attributes. If it does, assume the ***attribute coverage is false***, else use        the ***coverage from previous steps***. The list follows the same format as in for the step 2.3. 3. Event Coverage Check     1. Check if the event itself defines the `Event#includedInPlans` property. If it does and        the current plan is listed. Consider the ***event coverage to be true***, else use        the ***initial coverage***.     2. Check if the event defines the `Event#excludedFromPlans` property. If it does and the current        plan is listed. Consider the ***event coverage to be false***, else use        the ***initial coverage***. 4. Use the `predicateCombination` operator to determine how to combine the results from    the *video coverage check* (step 2) and *event coverage check* (from step 3).    if `predicateCombination===null` then consider it as an `OR`. 5. If step 4 returns false: check recursively the included plans and return ***true***    ***only if at least one of the sub plans returns positive coverage***.'
};
function validate155(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.initialCoverage !== void 0) {
      let data0 = data.initialCoverage;
      if (typeof data0 !== "boolean" && data0 !== null) {
        const err0 = {
          instancePath: instancePath + "/initialCoverage",
          schemaPath: "#/properties/initialCoverage/type",
          keyword: "type",
          params: {
            type: schema168.properties.initialCoverage.type
          },
          message: "must be boolean,null"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.tags !== void 0) {
      let data1 = data.tags;
      const _errs4 = errors;
      let valid1 = false;
      const _errs5 = errors;
      if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
        if (data1.kind === void 0) {
          const err1 = {
            instancePath: instancePath + "/tags",
            schemaPath: "#/properties/tags/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "kind"
            },
            message: "must have required property 'kind'"
          };
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        }
        if (data1.list === void 0) {
          const err2 = {
            instancePath: instancePath + "/tags",
            schemaPath: "#/properties/tags/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "list"
            },
            message: "must have required property 'list'"
          };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (data1.kind !== void 0) {
          let data2 = data1.kind;
          if (typeof data2 !== "string") {
            const err3 = {
              instancePath: instancePath + "/tags/kind",
              schemaPath: "#/properties/tags/anyOf/0/properties/kind/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err3];
            } else {
              vErrors.push(err3);
            }
            errors++;
          }
          if (!(data2 === "ALL" || data2 === "SOME")) {
            const err4 = {
              instancePath: instancePath + "/tags/kind",
              schemaPath: "#/properties/tags/anyOf/0/properties/kind/enum",
              keyword: "enum",
              params: {
                allowedValues: schema168.properties.tags.anyOf[0].properties.kind.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err4];
            } else {
              vErrors.push(err4);
            }
            errors++;
          }
        }
        if (data1.list !== void 0) {
          let data3 = data1.list;
          if (Array.isArray(data3)) {
            const len0 = data3.length;
            for (let i0 = 0; i0 < len0; i0++) {
              if (typeof data3[i0] !== "string") {
                const err5 = {
                  instancePath: instancePath + "/tags/list/" + i0,
                  schemaPath: "#/properties/tags/anyOf/0/properties/list/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err5];
                } else {
                  vErrors.push(err5);
                }
                errors++;
              }
            }
          } else {
            const err6 = {
              instancePath: instancePath + "/tags/list",
              schemaPath: "#/properties/tags/anyOf/0/properties/list/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err6];
            } else {
              vErrors.push(err6);
            }
            errors++;
          }
        }
      } else {
        const err7 = {
          instancePath: instancePath + "/tags",
          schemaPath: "#/properties/tags/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      var _valid0 = _errs5 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs13 = errors;
        if (data1 !== null) {
          const err8 = {
            instancePath: instancePath + "/tags",
            schemaPath: "#/properties/tags/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
        var _valid0 = _errs13 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err9 = {
          instancePath: instancePath + "/tags",
          schemaPath: "#/properties/tags/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      } else {
        errors = _errs4;
        if (vErrors !== null) {
          if (_errs4) {
            vErrors.length = _errs4;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.excludeTags !== void 0) {
      let data5 = data.excludeTags;
      const _errs16 = errors;
      let valid5 = false;
      const _errs17 = errors;
      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
        if (data5.kind === void 0) {
          const err10 = {
            instancePath: instancePath + "/excludeTags",
            schemaPath: "#/properties/excludeTags/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "kind"
            },
            message: "must have required property 'kind'"
          };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
        if (data5.list === void 0) {
          const err11 = {
            instancePath: instancePath + "/excludeTags",
            schemaPath: "#/properties/excludeTags/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "list"
            },
            message: "must have required property 'list'"
          };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
        if (data5.kind !== void 0) {
          let data6 = data5.kind;
          if (typeof data6 !== "string") {
            const err12 = {
              instancePath: instancePath + "/excludeTags/kind",
              schemaPath: "#/properties/excludeTags/anyOf/0/properties/kind/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
          if (!(data6 === "ALL" || data6 === "SOME")) {
            const err13 = {
              instancePath: instancePath + "/excludeTags/kind",
              schemaPath: "#/properties/excludeTags/anyOf/0/properties/kind/enum",
              keyword: "enum",
              params: {
                allowedValues: schema168.properties.excludeTags.anyOf[0].properties.kind.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
        }
        if (data5.list !== void 0) {
          let data7 = data5.list;
          if (Array.isArray(data7)) {
            const len1 = data7.length;
            for (let i1 = 0; i1 < len1; i1++) {
              if (typeof data7[i1] !== "string") {
                const err14 = {
                  instancePath: instancePath + "/excludeTags/list/" + i1,
                  schemaPath: "#/properties/excludeTags/anyOf/0/properties/list/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
          } else {
            const err15 = {
              instancePath: instancePath + "/excludeTags/list",
              schemaPath: "#/properties/excludeTags/anyOf/0/properties/list/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
      } else {
        const err16 = {
          instancePath: instancePath + "/excludeTags",
          schemaPath: "#/properties/excludeTags/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
      var _valid1 = _errs17 === errors;
      valid5 = valid5 || _valid1;
      if (!valid5) {
        const _errs25 = errors;
        if (data5 !== null) {
          const err17 = {
            instancePath: instancePath + "/excludeTags",
            schemaPath: "#/properties/excludeTags/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
        var _valid1 = _errs25 === errors;
        valid5 = valid5 || _valid1;
      }
      if (!valid5) {
        const err18 = {
          instancePath: instancePath + "/excludeTags",
          schemaPath: "#/properties/excludeTags/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      } else {
        errors = _errs16;
        if (vErrors !== null) {
          if (_errs16) {
            vErrors.length = _errs16;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.attributes !== void 0) {
      let data9 = data.attributes;
      const _errs28 = errors;
      let valid9 = false;
      const _errs29 = errors;
      if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
        if (data9.kind === void 0) {
          const err19 = {
            instancePath: instancePath + "/attributes",
            schemaPath: "#/properties/attributes/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "kind"
            },
            message: "must have required property 'kind'"
          };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if (data9.list === void 0) {
          const err20 = {
            instancePath: instancePath + "/attributes",
            schemaPath: "#/properties/attributes/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "list"
            },
            message: "must have required property 'list'"
          };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
        if (data9.kind !== void 0) {
          let data10 = data9.kind;
          if (typeof data10 !== "string") {
            const err21 = {
              instancePath: instancePath + "/attributes/kind",
              schemaPath: "#/properties/attributes/anyOf/0/properties/kind/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
          if (!(data10 === "ALL" || data10 === "SOME")) {
            const err22 = {
              instancePath: instancePath + "/attributes/kind",
              schemaPath: "#/properties/attributes/anyOf/0/properties/kind/enum",
              keyword: "enum",
              params: {
                allowedValues: schema168.properties.attributes.anyOf[0].properties.kind.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err22];
            } else {
              vErrors.push(err22);
            }
            errors++;
          }
        }
        if (data9.list !== void 0) {
          let data11 = data9.list;
          if (Array.isArray(data11)) {
            const len2 = data11.length;
            for (let i2 = 0; i2 < len2; i2++) {
              if (typeof data11[i2] !== "string") {
                const err23 = {
                  instancePath: instancePath + "/attributes/list/" + i2,
                  schemaPath: "#/properties/attributes/anyOf/0/properties/list/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
            }
          } else {
            const err24 = {
              instancePath: instancePath + "/attributes/list",
              schemaPath: "#/properties/attributes/anyOf/0/properties/list/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          }
        }
      } else {
        const err25 = {
          instancePath: instancePath + "/attributes",
          schemaPath: "#/properties/attributes/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err25];
        } else {
          vErrors.push(err25);
        }
        errors++;
      }
      var _valid2 = _errs29 === errors;
      valid9 = valid9 || _valid2;
      if (!valid9) {
        const _errs37 = errors;
        if (data9 !== null) {
          const err26 = {
            instancePath: instancePath + "/attributes",
            schemaPath: "#/properties/attributes/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err26];
          } else {
            vErrors.push(err26);
          }
          errors++;
        }
        var _valid2 = _errs37 === errors;
        valid9 = valid9 || _valid2;
      }
      if (!valid9) {
        const err27 = {
          instancePath: instancePath + "/attributes",
          schemaPath: "#/properties/attributes/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err27];
        } else {
          vErrors.push(err27);
        }
        errors++;
      } else {
        errors = _errs28;
        if (vErrors !== null) {
          if (_errs28) {
            vErrors.length = _errs28;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.excludeAttributes !== void 0) {
      let data13 = data.excludeAttributes;
      const _errs40 = errors;
      let valid13 = false;
      const _errs41 = errors;
      if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
        if (data13.kind === void 0) {
          const err28 = {
            instancePath: instancePath + "/excludeAttributes",
            schemaPath: "#/properties/excludeAttributes/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "kind"
            },
            message: "must have required property 'kind'"
          };
          if (vErrors === null) {
            vErrors = [err28];
          } else {
            vErrors.push(err28);
          }
          errors++;
        }
        if (data13.list === void 0) {
          const err29 = {
            instancePath: instancePath + "/excludeAttributes",
            schemaPath: "#/properties/excludeAttributes/anyOf/0/required",
            keyword: "required",
            params: {
              missingProperty: "list"
            },
            message: "must have required property 'list'"
          };
          if (vErrors === null) {
            vErrors = [err29];
          } else {
            vErrors.push(err29);
          }
          errors++;
        }
        if (data13.kind !== void 0) {
          let data14 = data13.kind;
          if (typeof data14 !== "string") {
            const err30 = {
              instancePath: instancePath + "/excludeAttributes/kind",
              schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/kind/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err30];
            } else {
              vErrors.push(err30);
            }
            errors++;
          }
          if (!(data14 === "ALL" || data14 === "SOME")) {
            const err31 = {
              instancePath: instancePath + "/excludeAttributes/kind",
              schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/kind/enum",
              keyword: "enum",
              params: {
                allowedValues: schema168.properties.excludeAttributes.anyOf[0].properties.kind.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
        }
        if (data13.list !== void 0) {
          let data15 = data13.list;
          if (Array.isArray(data15)) {
            const len3 = data15.length;
            for (let i3 = 0; i3 < len3; i3++) {
              if (typeof data15[i3] !== "string") {
                const err32 = {
                  instancePath: instancePath + "/excludeAttributes/list/" + i3,
                  schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/list/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err32];
                } else {
                  vErrors.push(err32);
                }
                errors++;
              }
            }
          } else {
            const err33 = {
              instancePath: instancePath + "/excludeAttributes/list",
              schemaPath: "#/properties/excludeAttributes/anyOf/0/properties/list/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err33];
            } else {
              vErrors.push(err33);
            }
            errors++;
          }
        }
      } else {
        const err34 = {
          instancePath: instancePath + "/excludeAttributes",
          schemaPath: "#/properties/excludeAttributes/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err34];
        } else {
          vErrors.push(err34);
        }
        errors++;
      }
      var _valid3 = _errs41 === errors;
      valid13 = valid13 || _valid3;
      if (!valid13) {
        const _errs49 = errors;
        if (data13 !== null) {
          const err35 = {
            instancePath: instancePath + "/excludeAttributes",
            schemaPath: "#/properties/excludeAttributes/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err35];
          } else {
            vErrors.push(err35);
          }
          errors++;
        }
        var _valid3 = _errs49 === errors;
        valid13 = valid13 || _valid3;
      }
      if (!valid13) {
        const err36 = {
          instancePath: instancePath + "/excludeAttributes",
          schemaPath: "#/properties/excludeAttributes/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err36];
        } else {
          vErrors.push(err36);
        }
        errors++;
      } else {
        errors = _errs40;
        if (vErrors !== null) {
          if (_errs40) {
            vErrors.length = _errs40;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.predicateCombination !== void 0) {
      let data17 = data.predicateCombination;
      if (typeof data17 !== "string" && data17 !== null) {
        const err37 = {
          instancePath: instancePath + "/predicateCombination",
          schemaPath: "#/properties/predicateCombination/type",
          keyword: "type",
          params: {
            type: schema168.properties.predicateCombination.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err37];
        } else {
          vErrors.push(err37);
        }
        errors++;
      }
      if (!(data17 === "OR" || data17 === "AND" || data17 === null)) {
        const err38 = {
          instancePath: instancePath + "/predicateCombination",
          schemaPath: "#/properties/predicateCombination/enum",
          keyword: "enum",
          params: {
            allowedValues: schema168.properties.predicateCombination.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err38];
        } else {
          vErrors.push(err38);
        }
        errors++;
      }
    }
    if (data.includedPlans !== void 0) {
      let data18 = data.includedPlans;
      const _errs54 = errors;
      let valid17 = false;
      const _errs55 = errors;
      if (Array.isArray(data18)) {
        const len4 = data18.length;
        for (let i4 = 0; i4 < len4; i4++) {
          if (typeof data18[i4] !== "string") {
            const err39 = {
              instancePath: instancePath + "/includedPlans/" + i4,
              schemaPath: "#/properties/includedPlans/anyOf/0/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err39];
            } else {
              vErrors.push(err39);
            }
            errors++;
          }
        }
      } else {
        const err40 = {
          instancePath: instancePath + "/includedPlans",
          schemaPath: "#/properties/includedPlans/anyOf/0/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err40];
        } else {
          vErrors.push(err40);
        }
        errors++;
      }
      var _valid4 = _errs55 === errors;
      valid17 = valid17 || _valid4;
      if (!valid17) {
        const _errs59 = errors;
        if (data18 !== null) {
          const err41 = {
            instancePath: instancePath + "/includedPlans",
            schemaPath: "#/properties/includedPlans/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err41];
          } else {
            vErrors.push(err41);
          }
          errors++;
        }
        var _valid4 = _errs59 === errors;
        valid17 = valid17 || _valid4;
      }
      if (!valid17) {
        const err42 = {
          instancePath: instancePath + "/includedPlans",
          schemaPath: "#/properties/includedPlans/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err42];
        } else {
          vErrors.push(err42);
        }
        errors++;
      } else {
        errors = _errs54;
        if (vErrors !== null) {
          if (_errs54) {
            vErrors.length = _errs54;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err43 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err43];
    } else {
      vErrors.push(err43);
    }
    errors++;
  }
  validate155.errors = vErrors;
  return errors === 0;
}
const Plan = validate156;
const schema169 = {
  "$id": "Plan",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "archived": {
      "type": "boolean"
    },
    "name": {
      "type": "string"
    },
    "descriptionShort": {
      "type": ["string", "null"]
    },
    "descriptionLong": {
      "type": ["string", "null"]
    },
    "available": {
      "type": "boolean"
    },
    "image": {
      "type": ["string", "null"]
    },
    "scope": {
      "anyOf": [{
        "$ref": "PlanScope"
      }, {
        "type": "null"
      }]
    },
    "priceAlternatives": {
      "type": "array",
      "items": {
        "$ref": "PlanPrice"
      }
    },
    "geo_restriction": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "null"
      }]
    }
  },
  "required": ["archived", "name", "descriptionShort", "descriptionLong", "available", "image", "scope", "priceAlternatives", "geo_restriction"],
  "description": "Content in a channel is either locked or unlocked. Locked content can be accessed through a ticket (if that content is part of an event), or through a subscription. Free content is always accessible.   A channel can define multiple subscription \u201CPlans\u201D, each plan can define rules to restrict which content they unlock."
};
function validate156(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.archived === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "archived"
        },
        message: "must have required property 'archived'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.name === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "name"
        },
        message: "must have required property 'name'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.descriptionShort === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "descriptionShort"
        },
        message: "must have required property 'descriptionShort'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.descriptionLong === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "descriptionLong"
        },
        message: "must have required property 'descriptionLong'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.available === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "available"
        },
        message: "must have required property 'available'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.image === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "image"
        },
        message: "must have required property 'image'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.scope === void 0) {
      const err6 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "scope"
        },
        message: "must have required property 'scope'"
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.priceAlternatives === void 0) {
      const err7 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "priceAlternatives"
        },
        message: "must have required property 'priceAlternatives'"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.geo_restriction === void 0) {
      const err8 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "geo_restriction"
        },
        message: "must have required property 'geo_restriction'"
      };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    if (data.archived !== void 0) {
      if (typeof data.archived !== "boolean") {
        const err9 = {
          instancePath: instancePath + "/archived",
          schemaPath: "#/properties/archived/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err10 = {
          instancePath: instancePath + "/name",
          schemaPath: "#/properties/name/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.descriptionShort !== void 0) {
      let data2 = data.descriptionShort;
      if (typeof data2 !== "string" && data2 !== null) {
        const err11 = {
          instancePath: instancePath + "/descriptionShort",
          schemaPath: "#/properties/descriptionShort/type",
          keyword: "type",
          params: {
            type: schema169.properties.descriptionShort.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.descriptionLong !== void 0) {
      let data3 = data.descriptionLong;
      if (typeof data3 !== "string" && data3 !== null) {
        const err12 = {
          instancePath: instancePath + "/descriptionLong",
          schemaPath: "#/properties/descriptionLong/type",
          keyword: "type",
          params: {
            type: schema169.properties.descriptionLong.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.available !== void 0) {
      if (typeof data.available !== "boolean") {
        const err13 = {
          instancePath: instancePath + "/available",
          schemaPath: "#/properties/available/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.image !== void 0) {
      let data5 = data.image;
      if (typeof data5 !== "string" && data5 !== null) {
        const err14 = {
          instancePath: instancePath + "/image",
          schemaPath: "#/properties/image/type",
          keyword: "type",
          params: {
            type: schema169.properties.image.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.scope !== void 0) {
      let data6 = data.scope;
      const _errs14 = errors;
      let valid1 = false;
      const _errs15 = errors;
      if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
        if (data6.initialCoverage !== void 0) {
          let data7 = data6.initialCoverage;
          if (typeof data7 !== "boolean" && data7 !== null) {
            const err15 = {
              instancePath: instancePath + "/scope/initialCoverage",
              schemaPath: "PlanScope/properties/initialCoverage/type",
              keyword: "type",
              params: {
                type: schema168.properties.initialCoverage.type
              },
              message: "must be boolean,null"
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
        if (data6.tags !== void 0) {
          let data8 = data6.tags;
          const _errs21 = errors;
          let valid4 = false;
          const _errs22 = errors;
          if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
            if (data8.kind === void 0) {
              const err16 = {
                instancePath: instancePath + "/scope/tags",
                schemaPath: "PlanScope/properties/tags/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "kind"
                },
                message: "must have required property 'kind'"
              };
              if (vErrors === null) {
                vErrors = [err16];
              } else {
                vErrors.push(err16);
              }
              errors++;
            }
            if (data8.list === void 0) {
              const err17 = {
                instancePath: instancePath + "/scope/tags",
                schemaPath: "PlanScope/properties/tags/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "list"
                },
                message: "must have required property 'list'"
              };
              if (vErrors === null) {
                vErrors = [err17];
              } else {
                vErrors.push(err17);
              }
              errors++;
            }
            if (data8.kind !== void 0) {
              let data9 = data8.kind;
              if (typeof data9 !== "string") {
                const err18 = {
                  instancePath: instancePath + "/scope/tags/kind",
                  schemaPath: "PlanScope/properties/tags/anyOf/0/properties/kind/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
              if (!(data9 === "ALL" || data9 === "SOME")) {
                const err19 = {
                  instancePath: instancePath + "/scope/tags/kind",
                  schemaPath: "PlanScope/properties/tags/anyOf/0/properties/kind/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema168.properties.tags.anyOf[0].properties.kind.enum
                  },
                  message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
            }
            if (data8.list !== void 0) {
              let data10 = data8.list;
              if (Array.isArray(data10)) {
                const len0 = data10.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  if (typeof data10[i0] !== "string") {
                    const err20 = {
                      instancePath: instancePath + "/scope/tags/list/" + i0,
                      schemaPath: "PlanScope/properties/tags/anyOf/0/properties/list/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err20];
                    } else {
                      vErrors.push(err20);
                    }
                    errors++;
                  }
                }
              } else {
                const err21 = {
                  instancePath: instancePath + "/scope/tags/list",
                  schemaPath: "PlanScope/properties/tags/anyOf/0/properties/list/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err21];
                } else {
                  vErrors.push(err21);
                }
                errors++;
              }
            }
          } else {
            const err22 = {
              instancePath: instancePath + "/scope/tags",
              schemaPath: "PlanScope/properties/tags/anyOf/0/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err22];
            } else {
              vErrors.push(err22);
            }
            errors++;
          }
          var _valid1 = _errs22 === errors;
          valid4 = valid4 || _valid1;
          if (!valid4) {
            const _errs30 = errors;
            if (data8 !== null) {
              const err23 = {
                instancePath: instancePath + "/scope/tags",
                schemaPath: "PlanScope/properties/tags/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err23];
              } else {
                vErrors.push(err23);
              }
              errors++;
            }
            var _valid1 = _errs30 === errors;
            valid4 = valid4 || _valid1;
          }
          if (!valid4) {
            const err24 = {
              instancePath: instancePath + "/scope/tags",
              schemaPath: "PlanScope/properties/tags/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          } else {
            errors = _errs21;
            if (vErrors !== null) {
              if (_errs21) {
                vErrors.length = _errs21;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data6.excludeTags !== void 0) {
          let data12 = data6.excludeTags;
          const _errs33 = errors;
          let valid8 = false;
          const _errs34 = errors;
          if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
            if (data12.kind === void 0) {
              const err25 = {
                instancePath: instancePath + "/scope/excludeTags",
                schemaPath: "PlanScope/properties/excludeTags/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "kind"
                },
                message: "must have required property 'kind'"
              };
              if (vErrors === null) {
                vErrors = [err25];
              } else {
                vErrors.push(err25);
              }
              errors++;
            }
            if (data12.list === void 0) {
              const err26 = {
                instancePath: instancePath + "/scope/excludeTags",
                schemaPath: "PlanScope/properties/excludeTags/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "list"
                },
                message: "must have required property 'list'"
              };
              if (vErrors === null) {
                vErrors = [err26];
              } else {
                vErrors.push(err26);
              }
              errors++;
            }
            if (data12.kind !== void 0) {
              let data13 = data12.kind;
              if (typeof data13 !== "string") {
                const err27 = {
                  instancePath: instancePath + "/scope/excludeTags/kind",
                  schemaPath: "PlanScope/properties/excludeTags/anyOf/0/properties/kind/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err27];
                } else {
                  vErrors.push(err27);
                }
                errors++;
              }
              if (!(data13 === "ALL" || data13 === "SOME")) {
                const err28 = {
                  instancePath: instancePath + "/scope/excludeTags/kind",
                  schemaPath: "PlanScope/properties/excludeTags/anyOf/0/properties/kind/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema168.properties.excludeTags.anyOf[0].properties.kind.enum
                  },
                  message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) {
                  vErrors = [err28];
                } else {
                  vErrors.push(err28);
                }
                errors++;
              }
            }
            if (data12.list !== void 0) {
              let data14 = data12.list;
              if (Array.isArray(data14)) {
                const len1 = data14.length;
                for (let i1 = 0; i1 < len1; i1++) {
                  if (typeof data14[i1] !== "string") {
                    const err29 = {
                      instancePath: instancePath + "/scope/excludeTags/list/" + i1,
                      schemaPath: "PlanScope/properties/excludeTags/anyOf/0/properties/list/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err29];
                    } else {
                      vErrors.push(err29);
                    }
                    errors++;
                  }
                }
              } else {
                const err30 = {
                  instancePath: instancePath + "/scope/excludeTags/list",
                  schemaPath: "PlanScope/properties/excludeTags/anyOf/0/properties/list/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err30];
                } else {
                  vErrors.push(err30);
                }
                errors++;
              }
            }
          } else {
            const err31 = {
              instancePath: instancePath + "/scope/excludeTags",
              schemaPath: "PlanScope/properties/excludeTags/anyOf/0/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
          var _valid2 = _errs34 === errors;
          valid8 = valid8 || _valid2;
          if (!valid8) {
            const _errs42 = errors;
            if (data12 !== null) {
              const err32 = {
                instancePath: instancePath + "/scope/excludeTags",
                schemaPath: "PlanScope/properties/excludeTags/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err32];
              } else {
                vErrors.push(err32);
              }
              errors++;
            }
            var _valid2 = _errs42 === errors;
            valid8 = valid8 || _valid2;
          }
          if (!valid8) {
            const err33 = {
              instancePath: instancePath + "/scope/excludeTags",
              schemaPath: "PlanScope/properties/excludeTags/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err33];
            } else {
              vErrors.push(err33);
            }
            errors++;
          } else {
            errors = _errs33;
            if (vErrors !== null) {
              if (_errs33) {
                vErrors.length = _errs33;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data6.attributes !== void 0) {
          let data16 = data6.attributes;
          const _errs45 = errors;
          let valid12 = false;
          const _errs46 = errors;
          if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
            if (data16.kind === void 0) {
              const err34 = {
                instancePath: instancePath + "/scope/attributes",
                schemaPath: "PlanScope/properties/attributes/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "kind"
                },
                message: "must have required property 'kind'"
              };
              if (vErrors === null) {
                vErrors = [err34];
              } else {
                vErrors.push(err34);
              }
              errors++;
            }
            if (data16.list === void 0) {
              const err35 = {
                instancePath: instancePath + "/scope/attributes",
                schemaPath: "PlanScope/properties/attributes/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "list"
                },
                message: "must have required property 'list'"
              };
              if (vErrors === null) {
                vErrors = [err35];
              } else {
                vErrors.push(err35);
              }
              errors++;
            }
            if (data16.kind !== void 0) {
              let data17 = data16.kind;
              if (typeof data17 !== "string") {
                const err36 = {
                  instancePath: instancePath + "/scope/attributes/kind",
                  schemaPath: "PlanScope/properties/attributes/anyOf/0/properties/kind/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err36];
                } else {
                  vErrors.push(err36);
                }
                errors++;
              }
              if (!(data17 === "ALL" || data17 === "SOME")) {
                const err37 = {
                  instancePath: instancePath + "/scope/attributes/kind",
                  schemaPath: "PlanScope/properties/attributes/anyOf/0/properties/kind/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema168.properties.attributes.anyOf[0].properties.kind.enum
                  },
                  message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) {
                  vErrors = [err37];
                } else {
                  vErrors.push(err37);
                }
                errors++;
              }
            }
            if (data16.list !== void 0) {
              let data18 = data16.list;
              if (Array.isArray(data18)) {
                const len2 = data18.length;
                for (let i2 = 0; i2 < len2; i2++) {
                  if (typeof data18[i2] !== "string") {
                    const err38 = {
                      instancePath: instancePath + "/scope/attributes/list/" + i2,
                      schemaPath: "PlanScope/properties/attributes/anyOf/0/properties/list/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err38];
                    } else {
                      vErrors.push(err38);
                    }
                    errors++;
                  }
                }
              } else {
                const err39 = {
                  instancePath: instancePath + "/scope/attributes/list",
                  schemaPath: "PlanScope/properties/attributes/anyOf/0/properties/list/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err39];
                } else {
                  vErrors.push(err39);
                }
                errors++;
              }
            }
          } else {
            const err40 = {
              instancePath: instancePath + "/scope/attributes",
              schemaPath: "PlanScope/properties/attributes/anyOf/0/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err40];
            } else {
              vErrors.push(err40);
            }
            errors++;
          }
          var _valid3 = _errs46 === errors;
          valid12 = valid12 || _valid3;
          if (!valid12) {
            const _errs54 = errors;
            if (data16 !== null) {
              const err41 = {
                instancePath: instancePath + "/scope/attributes",
                schemaPath: "PlanScope/properties/attributes/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err41];
              } else {
                vErrors.push(err41);
              }
              errors++;
            }
            var _valid3 = _errs54 === errors;
            valid12 = valid12 || _valid3;
          }
          if (!valid12) {
            const err42 = {
              instancePath: instancePath + "/scope/attributes",
              schemaPath: "PlanScope/properties/attributes/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err42];
            } else {
              vErrors.push(err42);
            }
            errors++;
          } else {
            errors = _errs45;
            if (vErrors !== null) {
              if (_errs45) {
                vErrors.length = _errs45;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data6.excludeAttributes !== void 0) {
          let data20 = data6.excludeAttributes;
          const _errs57 = errors;
          let valid16 = false;
          const _errs58 = errors;
          if (data20 && typeof data20 == "object" && !Array.isArray(data20)) {
            if (data20.kind === void 0) {
              const err43 = {
                instancePath: instancePath + "/scope/excludeAttributes",
                schemaPath: "PlanScope/properties/excludeAttributes/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "kind"
                },
                message: "must have required property 'kind'"
              };
              if (vErrors === null) {
                vErrors = [err43];
              } else {
                vErrors.push(err43);
              }
              errors++;
            }
            if (data20.list === void 0) {
              const err44 = {
                instancePath: instancePath + "/scope/excludeAttributes",
                schemaPath: "PlanScope/properties/excludeAttributes/anyOf/0/required",
                keyword: "required",
                params: {
                  missingProperty: "list"
                },
                message: "must have required property 'list'"
              };
              if (vErrors === null) {
                vErrors = [err44];
              } else {
                vErrors.push(err44);
              }
              errors++;
            }
            if (data20.kind !== void 0) {
              let data21 = data20.kind;
              if (typeof data21 !== "string") {
                const err45 = {
                  instancePath: instancePath + "/scope/excludeAttributes/kind",
                  schemaPath: "PlanScope/properties/excludeAttributes/anyOf/0/properties/kind/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err45];
                } else {
                  vErrors.push(err45);
                }
                errors++;
              }
              if (!(data21 === "ALL" || data21 === "SOME")) {
                const err46 = {
                  instancePath: instancePath + "/scope/excludeAttributes/kind",
                  schemaPath: "PlanScope/properties/excludeAttributes/anyOf/0/properties/kind/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema168.properties.excludeAttributes.anyOf[0].properties.kind.enum
                  },
                  message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) {
                  vErrors = [err46];
                } else {
                  vErrors.push(err46);
                }
                errors++;
              }
            }
            if (data20.list !== void 0) {
              let data22 = data20.list;
              if (Array.isArray(data22)) {
                const len3 = data22.length;
                for (let i3 = 0; i3 < len3; i3++) {
                  if (typeof data22[i3] !== "string") {
                    const err47 = {
                      instancePath: instancePath + "/scope/excludeAttributes/list/" + i3,
                      schemaPath: "PlanScope/properties/excludeAttributes/anyOf/0/properties/list/items/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err47];
                    } else {
                      vErrors.push(err47);
                    }
                    errors++;
                  }
                }
              } else {
                const err48 = {
                  instancePath: instancePath + "/scope/excludeAttributes/list",
                  schemaPath: "PlanScope/properties/excludeAttributes/anyOf/0/properties/list/type",
                  keyword: "type",
                  params: {
                    type: "array"
                  },
                  message: "must be array"
                };
                if (vErrors === null) {
                  vErrors = [err48];
                } else {
                  vErrors.push(err48);
                }
                errors++;
              }
            }
          } else {
            const err49 = {
              instancePath: instancePath + "/scope/excludeAttributes",
              schemaPath: "PlanScope/properties/excludeAttributes/anyOf/0/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err49];
            } else {
              vErrors.push(err49);
            }
            errors++;
          }
          var _valid4 = _errs58 === errors;
          valid16 = valid16 || _valid4;
          if (!valid16) {
            const _errs66 = errors;
            if (data20 !== null) {
              const err50 = {
                instancePath: instancePath + "/scope/excludeAttributes",
                schemaPath: "PlanScope/properties/excludeAttributes/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err50];
              } else {
                vErrors.push(err50);
              }
              errors++;
            }
            var _valid4 = _errs66 === errors;
            valid16 = valid16 || _valid4;
          }
          if (!valid16) {
            const err51 = {
              instancePath: instancePath + "/scope/excludeAttributes",
              schemaPath: "PlanScope/properties/excludeAttributes/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err51];
            } else {
              vErrors.push(err51);
            }
            errors++;
          } else {
            errors = _errs57;
            if (vErrors !== null) {
              if (_errs57) {
                vErrors.length = _errs57;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data6.predicateCombination !== void 0) {
          let data24 = data6.predicateCombination;
          if (typeof data24 !== "string" && data24 !== null) {
            const err52 = {
              instancePath: instancePath + "/scope/predicateCombination",
              schemaPath: "PlanScope/properties/predicateCombination/type",
              keyword: "type",
              params: {
                type: schema168.properties.predicateCombination.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err52];
            } else {
              vErrors.push(err52);
            }
            errors++;
          }
          if (!(data24 === "OR" || data24 === "AND" || data24 === null)) {
            const err53 = {
              instancePath: instancePath + "/scope/predicateCombination",
              schemaPath: "PlanScope/properties/predicateCombination/enum",
              keyword: "enum",
              params: {
                allowedValues: schema168.properties.predicateCombination.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err53];
            } else {
              vErrors.push(err53);
            }
            errors++;
          }
        }
        if (data6.includedPlans !== void 0) {
          let data25 = data6.includedPlans;
          const _errs71 = errors;
          let valid20 = false;
          const _errs72 = errors;
          if (Array.isArray(data25)) {
            const len4 = data25.length;
            for (let i4 = 0; i4 < len4; i4++) {
              if (typeof data25[i4] !== "string") {
                const err54 = {
                  instancePath: instancePath + "/scope/includedPlans/" + i4,
                  schemaPath: "PlanScope/properties/includedPlans/anyOf/0/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err54];
                } else {
                  vErrors.push(err54);
                }
                errors++;
              }
            }
          } else {
            const err55 = {
              instancePath: instancePath + "/scope/includedPlans",
              schemaPath: "PlanScope/properties/includedPlans/anyOf/0/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err55];
            } else {
              vErrors.push(err55);
            }
            errors++;
          }
          var _valid5 = _errs72 === errors;
          valid20 = valid20 || _valid5;
          if (!valid20) {
            const _errs76 = errors;
            if (data25 !== null) {
              const err56 = {
                instancePath: instancePath + "/scope/includedPlans",
                schemaPath: "PlanScope/properties/includedPlans/anyOf/1/type",
                keyword: "type",
                params: {
                  type: "null"
                },
                message: "must be null"
              };
              if (vErrors === null) {
                vErrors = [err56];
              } else {
                vErrors.push(err56);
              }
              errors++;
            }
            var _valid5 = _errs76 === errors;
            valid20 = valid20 || _valid5;
          }
          if (!valid20) {
            const err57 = {
              instancePath: instancePath + "/scope/includedPlans",
              schemaPath: "PlanScope/properties/includedPlans/anyOf",
              keyword: "anyOf",
              params: {},
              message: "must match a schema in anyOf"
            };
            if (vErrors === null) {
              vErrors = [err57];
            } else {
              vErrors.push(err57);
            }
            errors++;
          } else {
            errors = _errs71;
            if (vErrors !== null) {
              if (_errs71) {
                vErrors.length = _errs71;
              } else {
                vErrors = null;
              }
            }
          }
        }
      } else {
        const err58 = {
          instancePath: instancePath + "/scope",
          schemaPath: "PlanScope/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err58];
        } else {
          vErrors.push(err58);
        }
        errors++;
      }
      var _valid0 = _errs15 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs78 = errors;
        if (data6 !== null) {
          const err59 = {
            instancePath: instancePath + "/scope",
            schemaPath: "#/properties/scope/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err59];
          } else {
            vErrors.push(err59);
          }
          errors++;
        }
        var _valid0 = _errs78 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err60 = {
          instancePath: instancePath + "/scope",
          schemaPath: "#/properties/scope/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err60];
        } else {
          vErrors.push(err60);
        }
        errors++;
      } else {
        errors = _errs14;
        if (vErrors !== null) {
          if (_errs14) {
            vErrors.length = _errs14;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.priceAlternatives !== void 0) {
      let data27 = data.priceAlternatives;
      if (Array.isArray(data27)) {
        const len5 = data27.length;
        for (let i5 = 0; i5 < len5; i5++) {
          if (!validate24(data27[i5], {
            instancePath: instancePath + "/priceAlternatives/" + i5,
            parentData: data27,
            parentDataProperty: i5,
            rootData
          })) {
            vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err61 = {
          instancePath: instancePath + "/priceAlternatives",
          schemaPath: "#/properties/priceAlternatives/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err61];
        } else {
          vErrors.push(err61);
        }
        errors++;
      }
    }
    if (data.geo_restriction !== void 0) {
      let data29 = data.geo_restriction;
      const _errs84 = errors;
      let valid25 = false;
      const _errs85 = errors;
      if (Array.isArray(data29)) {
        const len6 = data29.length;
        for (let i6 = 0; i6 < len6; i6++) {
          if (typeof data29[i6] !== "string") {
            const err62 = {
              instancePath: instancePath + "/geo_restriction/" + i6,
              schemaPath: "#/properties/geo_restriction/anyOf/0/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err62];
            } else {
              vErrors.push(err62);
            }
            errors++;
          }
        }
      } else {
        const err63 = {
          instancePath: instancePath + "/geo_restriction",
          schemaPath: "#/properties/geo_restriction/anyOf/0/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err63];
        } else {
          vErrors.push(err63);
        }
        errors++;
      }
      var _valid6 = _errs85 === errors;
      valid25 = valid25 || _valid6;
      if (!valid25) {
        const _errs89 = errors;
        if (data29 !== null) {
          const err64 = {
            instancePath: instancePath + "/geo_restriction",
            schemaPath: "#/properties/geo_restriction/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err64];
          } else {
            vErrors.push(err64);
          }
          errors++;
        }
        var _valid6 = _errs89 === errors;
        valid25 = valid25 || _valid6;
      }
      if (!valid25) {
        const err65 = {
          instancePath: instancePath + "/geo_restriction",
          schemaPath: "#/properties/geo_restriction/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err65];
        } else {
          vErrors.push(err65);
        }
        errors++;
      } else {
        errors = _errs84;
        if (vErrors !== null) {
          if (_errs84) {
            vErrors.length = _errs84;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err66 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err66];
    } else {
      vErrors.push(err66);
    }
    errors++;
  }
  validate156.errors = vErrors;
  return errors === 0;
}
const SubscriptionCancellation = validate158;
const schema171 = {
  "$id": "SubscriptionCancellation",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "initiated": {
      "type": "object",
      "format": "date-time"
    },
    "effective": {
      "type": "object",
      "format": "date-time"
    },
    "reason": {
      "type": "string"
    },
    "origin": {
      "type": "string",
      "enum": ["STRIPE", "APP"]
    },
    "canUncancel": {
      "type": "boolean"
    }
  },
  "required": ["initiated", "effective", "reason", "origin", "canUncancel"]
};
function validate158(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.initiated === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "initiated"
        },
        message: "must have required property 'initiated'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.effective === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "effective"
        },
        message: "must have required property 'effective'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.reason === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "reason"
        },
        message: "must have required property 'reason'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.origin === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "origin"
        },
        message: "must have required property 'origin'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.canUncancel === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "canUncancel"
        },
        message: "must have required property 'canUncancel'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.initiated !== void 0) {
      let data0 = data.initiated;
      if (!(data0 && typeof data0 == "object" && !Array.isArray(data0))) {
        const err5 = {
          instancePath: instancePath + "/initiated",
          schemaPath: "#/properties/initiated/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if (typeof data0 === "string") {
        if (!formats0(data0)) {
          const err6 = {
            instancePath: instancePath + "/initiated",
            schemaPath: "#/properties/initiated/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
      }
    }
    if (data.effective !== void 0) {
      let data1 = data.effective;
      if (!(data1 && typeof data1 == "object" && !Array.isArray(data1))) {
        const err7 = {
          instancePath: instancePath + "/effective",
          schemaPath: "#/properties/effective/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if (typeof data1 === "string") {
        if (!formats0(data1)) {
          const err8 = {
            instancePath: instancePath + "/effective",
            schemaPath: "#/properties/effective/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
      }
    }
    if (data.reason !== void 0) {
      if (typeof data.reason !== "string") {
        const err9 = {
          instancePath: instancePath + "/reason",
          schemaPath: "#/properties/reason/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.origin !== void 0) {
      let data3 = data.origin;
      if (typeof data3 !== "string") {
        const err10 = {
          instancePath: instancePath + "/origin",
          schemaPath: "#/properties/origin/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
      if (!(data3 === "STRIPE" || data3 === "APP")) {
        const err11 = {
          instancePath: instancePath + "/origin",
          schemaPath: "#/properties/origin/enum",
          keyword: "enum",
          params: {
            allowedValues: schema171.properties.origin.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.canUncancel !== void 0) {
      if (typeof data.canUncancel !== "boolean") {
        const err12 = {
          instancePath: instancePath + "/canUncancel",
          schemaPath: "#/properties/canUncancel/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
  } else {
    const err13 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err13];
    } else {
      vErrors.push(err13);
    }
    errors++;
  }
  validate158.errors = vErrors;
  return errors === 0;
}
const SubscriptionStatus = validate159;
const schema172 = {
  "$id": "SubscriptionStatus",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["NEEDS_ACTION", "PAUSED", "PENDING", "TRIALING", "ACTIVE", "CANCELLING", "TERMINATED"]
};
function validate159(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (!(data === "NEEDS_ACTION" || data === "PAUSED" || data === "PENDING" || data === "TRIALING" || data === "ACTIVE" || data === "CANCELLING" || data === "TERMINATED")) {
    const err1 = {
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema172.enum
      },
      message: "must be equal to one of the allowed values"
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate159.errors = vErrors;
  return errors === 0;
}
const Subscription = validate160;
const schema173 = {
  "$id": "Subscription",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "status": {
      "$ref": "SubscriptionStatus"
    },
    "userId": {
      "type": "string"
    },
    "planId": {
      "type": "string"
    },
    "selectedConfig": {
      "type": "object",
      "properties": {
        "currency": {
          "type": "string"
        },
        "periodicity": {
          "$ref": "BillingPeriodicity"
        },
        "installments": {
          "type": ["boolean", "null"]
        }
      },
      "required": ["currency", "periodicity"]
    },
    "subscriptionId": {
      "type": "string"
    },
    "location": {
      "anyOf": [{
        "$ref": "UserLocation"
      }, {
        "type": "null"
      }]
    },
    "lastTimeUsed": {
      "anyOf": [{
        "type": "object",
        "format": "date-time"
      }, {
        "type": "null"
      }]
    },
    "coupon": {
      "type": ["string", "null"]
    },
    "cancellation": {
      "$ref": "SubscriptionCancellation"
    },
    "requiredUserAction": {
      "type": "object",
      "properties": {
        "code": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "referenceUrl": {
          "type": "string"
        }
      },
      "required": ["code"]
    },
    "pausedUntil": {
      "type": "object",
      "properties": {
        "date": {
          "type": "object",
          "format": "date-time"
        },
        "proratableTime": {
          "type": "number"
        }
      },
      "required": ["date", "proratableTime"]
    },
    "pauseDate": {
      "type": "object",
      "format": "date-time"
    },
    "nextPeriodicCheck": {
      "type": "object",
      "format": "date-time"
    },
    "lastReminderSentDate": {
      "type": "object",
      "format": "date-time"
    },
    "creationDate": {
      "type": "object",
      "format": "date-time"
    }
  },
  "required": ["status", "userId", "planId", "selectedConfig", "subscriptionId", "location", "lastTimeUsed", "coupon", "creationDate"]
};
function validate160(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.status === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "status"
        },
        message: "must have required property 'status'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.userId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "userId"
        },
        message: "must have required property 'userId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.planId === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "planId"
        },
        message: "must have required property 'planId'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.selectedConfig === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "selectedConfig"
        },
        message: "must have required property 'selectedConfig'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.subscriptionId === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "subscriptionId"
        },
        message: "must have required property 'subscriptionId'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.location === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "location"
        },
        message: "must have required property 'location'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.lastTimeUsed === void 0) {
      const err6 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "lastTimeUsed"
        },
        message: "must have required property 'lastTimeUsed'"
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.coupon === void 0) {
      const err7 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "coupon"
        },
        message: "must have required property 'coupon'"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.creationDate === void 0) {
      const err8 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "creationDate"
        },
        message: "must have required property 'creationDate'"
      };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    if (data.status !== void 0) {
      let data0 = data.status;
      if (typeof data0 !== "string") {
        const err9 = {
          instancePath: instancePath + "/status",
          schemaPath: "SubscriptionStatus/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if (!(data0 === "NEEDS_ACTION" || data0 === "PAUSED" || data0 === "PENDING" || data0 === "TRIALING" || data0 === "ACTIVE" || data0 === "CANCELLING" || data0 === "TERMINATED")) {
        const err10 = {
          instancePath: instancePath + "/status",
          schemaPath: "SubscriptionStatus/enum",
          keyword: "enum",
          params: {
            allowedValues: schema172.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.userId !== void 0) {
      if (typeof data.userId !== "string") {
        const err11 = {
          instancePath: instancePath + "/userId",
          schemaPath: "#/properties/userId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.planId !== void 0) {
      if (typeof data.planId !== "string") {
        const err12 = {
          instancePath: instancePath + "/planId",
          schemaPath: "#/properties/planId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.selectedConfig !== void 0) {
      let data3 = data.selectedConfig;
      if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
        if (data3.currency === void 0) {
          const err13 = {
            instancePath: instancePath + "/selectedConfig",
            schemaPath: "#/properties/selectedConfig/required",
            keyword: "required",
            params: {
              missingProperty: "currency"
            },
            message: "must have required property 'currency'"
          };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
        if (data3.periodicity === void 0) {
          const err14 = {
            instancePath: instancePath + "/selectedConfig",
            schemaPath: "#/properties/selectedConfig/required",
            keyword: "required",
            params: {
              missingProperty: "periodicity"
            },
            message: "must have required property 'periodicity'"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
        if (data3.currency !== void 0) {
          if (typeof data3.currency !== "string") {
            const err15 = {
              instancePath: instancePath + "/selectedConfig/currency",
              schemaPath: "#/properties/selectedConfig/properties/currency/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
        if (data3.periodicity !== void 0) {
          let data5 = data3.periodicity;
          if (typeof data5 !== "string") {
            const err16 = {
              instancePath: instancePath + "/selectedConfig/periodicity",
              schemaPath: "BillingPeriodicity/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err16];
            } else {
              vErrors.push(err16);
            }
            errors++;
          }
          if (!(data5 === "MONTHLY" || data5 === "YEARLY")) {
            const err17 = {
              instancePath: instancePath + "/selectedConfig/periodicity",
              schemaPath: "BillingPeriodicity/enum",
              keyword: "enum",
              params: {
                allowedValues: schema21.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err17];
            } else {
              vErrors.push(err17);
            }
            errors++;
          }
        }
        if (data3.installments !== void 0) {
          let data6 = data3.installments;
          if (typeof data6 !== "boolean" && data6 !== null) {
            const err18 = {
              instancePath: instancePath + "/selectedConfig/installments",
              schemaPath: "#/properties/selectedConfig/properties/installments/type",
              keyword: "type",
              params: {
                type: schema173.properties.selectedConfig.properties.installments.type
              },
              message: "must be boolean,null"
            };
            if (vErrors === null) {
              vErrors = [err18];
            } else {
              vErrors.push(err18);
            }
            errors++;
          }
        }
      } else {
        const err19 = {
          instancePath: instancePath + "/selectedConfig",
          schemaPath: "#/properties/selectedConfig/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      }
    }
    if (data.subscriptionId !== void 0) {
      if (typeof data.subscriptionId !== "string") {
        const err20 = {
          instancePath: instancePath + "/subscriptionId",
          schemaPath: "#/properties/subscriptionId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
    }
    if (data.location !== void 0) {
      let data8 = data.location;
      const _errs20 = errors;
      let valid4 = false;
      const _errs21 = errors;
      if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
        if (data8.IP === void 0) {
          const err21 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "IP"
            },
            message: "must have required property 'IP'"
          };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
        if (data8.latlng === void 0) {
          const err22 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "latlng"
            },
            message: "must have required property 'latlng'"
          };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
        if (data8.city === void 0) {
          const err23 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "city"
            },
            message: "must have required property 'city'"
          };
          if (vErrors === null) {
            vErrors = [err23];
          } else {
            vErrors.push(err23);
          }
          errors++;
        }
        if (data8.country === void 0) {
          const err24 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "country"
            },
            message: "must have required property 'country'"
          };
          if (vErrors === null) {
            vErrors = [err24];
          } else {
            vErrors.push(err24);
          }
          errors++;
        }
        if (data8.region === void 0) {
          const err25 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "region"
            },
            message: "must have required property 'region'"
          };
          if (vErrors === null) {
            vErrors = [err25];
          } else {
            vErrors.push(err25);
          }
          errors++;
        }
        if (data8.IP !== void 0) {
          let data9 = data8.IP;
          if (typeof data9 !== "string" && data9 !== null) {
            const err26 = {
              instancePath: instancePath + "/location/IP",
              schemaPath: "UserLocation/properties/IP/type",
              keyword: "type",
              params: {
                type: schema56.properties.IP.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err26];
            } else {
              vErrors.push(err26);
            }
            errors++;
          }
        }
        if (data8.latlng !== void 0) {
          let data10 = data8.latlng;
          if (typeof data10 !== "string" && data10 !== null) {
            const err27 = {
              instancePath: instancePath + "/location/latlng",
              schemaPath: "UserLocation/properties/latlng/type",
              keyword: "type",
              params: {
                type: schema56.properties.latlng.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err27];
            } else {
              vErrors.push(err27);
            }
            errors++;
          }
        }
        if (data8.city !== void 0) {
          let data11 = data8.city;
          if (typeof data11 !== "string" && data11 !== null) {
            const err28 = {
              instancePath: instancePath + "/location/city",
              schemaPath: "UserLocation/properties/city/type",
              keyword: "type",
              params: {
                type: schema56.properties.city.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err28];
            } else {
              vErrors.push(err28);
            }
            errors++;
          }
        }
        if (data8.country !== void 0) {
          let data12 = data8.country;
          if (typeof data12 !== "string" && data12 !== null) {
            const err29 = {
              instancePath: instancePath + "/location/country",
              schemaPath: "UserLocation/properties/country/type",
              keyword: "type",
              params: {
                type: schema56.properties.country.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err29];
            } else {
              vErrors.push(err29);
            }
            errors++;
          }
        }
        if (data8.region !== void 0) {
          let data13 = data8.region;
          if (typeof data13 !== "string" && data13 !== null) {
            const err30 = {
              instancePath: instancePath + "/location/region",
              schemaPath: "UserLocation/properties/region/type",
              keyword: "type",
              params: {
                type: schema56.properties.region.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err30];
            } else {
              vErrors.push(err30);
            }
            errors++;
          }
        }
      } else {
        const err31 = {
          instancePath: instancePath + "/location",
          schemaPath: "UserLocation/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err31];
        } else {
          vErrors.push(err31);
        }
        errors++;
      }
      var _valid0 = _errs21 === errors;
      valid4 = valid4 || _valid0;
      if (!valid4) {
        const _errs34 = errors;
        if (data8 !== null) {
          const err32 = {
            instancePath: instancePath + "/location",
            schemaPath: "#/properties/location/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err32];
          } else {
            vErrors.push(err32);
          }
          errors++;
        }
        var _valid0 = _errs34 === errors;
        valid4 = valid4 || _valid0;
      }
      if (!valid4) {
        const err33 = {
          instancePath: instancePath + "/location",
          schemaPath: "#/properties/location/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err33];
        } else {
          vErrors.push(err33);
        }
        errors++;
      } else {
        errors = _errs20;
        if (vErrors !== null) {
          if (_errs20) {
            vErrors.length = _errs20;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.lastTimeUsed !== void 0) {
      let data14 = data.lastTimeUsed;
      const _errs37 = errors;
      let valid7 = false;
      const _errs38 = errors;
      if (!(data14 && typeof data14 == "object" && !Array.isArray(data14))) {
        const err34 = {
          instancePath: instancePath + "/lastTimeUsed",
          schemaPath: "#/properties/lastTimeUsed/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err34];
        } else {
          vErrors.push(err34);
        }
        errors++;
      }
      if (typeof data14 === "string") {
        if (!formats0(data14)) {
          const err35 = {
            instancePath: instancePath + "/lastTimeUsed",
            schemaPath: "#/properties/lastTimeUsed/anyOf/0/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err35];
          } else {
            vErrors.push(err35);
          }
          errors++;
        }
      }
      var _valid1 = _errs38 === errors;
      valid7 = valid7 || _valid1;
      if (!valid7) {
        const _errs40 = errors;
        if (data14 !== null) {
          const err36 = {
            instancePath: instancePath + "/lastTimeUsed",
            schemaPath: "#/properties/lastTimeUsed/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err36];
          } else {
            vErrors.push(err36);
          }
          errors++;
        }
        var _valid1 = _errs40 === errors;
        valid7 = valid7 || _valid1;
      }
      if (!valid7) {
        const err37 = {
          instancePath: instancePath + "/lastTimeUsed",
          schemaPath: "#/properties/lastTimeUsed/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err37];
        } else {
          vErrors.push(err37);
        }
        errors++;
      } else {
        errors = _errs37;
        if (vErrors !== null) {
          if (_errs37) {
            vErrors.length = _errs37;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.coupon !== void 0) {
      let data15 = data.coupon;
      if (typeof data15 !== "string" && data15 !== null) {
        const err38 = {
          instancePath: instancePath + "/coupon",
          schemaPath: "#/properties/coupon/type",
          keyword: "type",
          params: {
            type: schema173.properties.coupon.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err38];
        } else {
          vErrors.push(err38);
        }
        errors++;
      }
    }
    if (data.cancellation !== void 0) {
      let data16 = data.cancellation;
      if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
        if (data16.initiated === void 0) {
          const err39 = {
            instancePath: instancePath + "/cancellation",
            schemaPath: "SubscriptionCancellation/required",
            keyword: "required",
            params: {
              missingProperty: "initiated"
            },
            message: "must have required property 'initiated'"
          };
          if (vErrors === null) {
            vErrors = [err39];
          } else {
            vErrors.push(err39);
          }
          errors++;
        }
        if (data16.effective === void 0) {
          const err40 = {
            instancePath: instancePath + "/cancellation",
            schemaPath: "SubscriptionCancellation/required",
            keyword: "required",
            params: {
              missingProperty: "effective"
            },
            message: "must have required property 'effective'"
          };
          if (vErrors === null) {
            vErrors = [err40];
          } else {
            vErrors.push(err40);
          }
          errors++;
        }
        if (data16.reason === void 0) {
          const err41 = {
            instancePath: instancePath + "/cancellation",
            schemaPath: "SubscriptionCancellation/required",
            keyword: "required",
            params: {
              missingProperty: "reason"
            },
            message: "must have required property 'reason'"
          };
          if (vErrors === null) {
            vErrors = [err41];
          } else {
            vErrors.push(err41);
          }
          errors++;
        }
        if (data16.origin === void 0) {
          const err42 = {
            instancePath: instancePath + "/cancellation",
            schemaPath: "SubscriptionCancellation/required",
            keyword: "required",
            params: {
              missingProperty: "origin"
            },
            message: "must have required property 'origin'"
          };
          if (vErrors === null) {
            vErrors = [err42];
          } else {
            vErrors.push(err42);
          }
          errors++;
        }
        if (data16.canUncancel === void 0) {
          const err43 = {
            instancePath: instancePath + "/cancellation",
            schemaPath: "SubscriptionCancellation/required",
            keyword: "required",
            params: {
              missingProperty: "canUncancel"
            },
            message: "must have required property 'canUncancel'"
          };
          if (vErrors === null) {
            vErrors = [err43];
          } else {
            vErrors.push(err43);
          }
          errors++;
        }
        if (data16.initiated !== void 0) {
          let data17 = data16.initiated;
          if (!(data17 && typeof data17 == "object" && !Array.isArray(data17))) {
            const err44 = {
              instancePath: instancePath + "/cancellation/initiated",
              schemaPath: "SubscriptionCancellation/properties/initiated/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err44];
            } else {
              vErrors.push(err44);
            }
            errors++;
          }
          if (typeof data17 === "string") {
            if (!formats0(data17)) {
              const err45 = {
                instancePath: instancePath + "/cancellation/initiated",
                schemaPath: "SubscriptionCancellation/properties/initiated/format",
                keyword: "format",
                params: {
                  format: "date-time"
                },
                message: 'must match format "date-time"'
              };
              if (vErrors === null) {
                vErrors = [err45];
              } else {
                vErrors.push(err45);
              }
              errors++;
            }
          }
        }
        if (data16.effective !== void 0) {
          let data18 = data16.effective;
          if (!(data18 && typeof data18 == "object" && !Array.isArray(data18))) {
            const err46 = {
              instancePath: instancePath + "/cancellation/effective",
              schemaPath: "SubscriptionCancellation/properties/effective/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err46];
            } else {
              vErrors.push(err46);
            }
            errors++;
          }
          if (typeof data18 === "string") {
            if (!formats0(data18)) {
              const err47 = {
                instancePath: instancePath + "/cancellation/effective",
                schemaPath: "SubscriptionCancellation/properties/effective/format",
                keyword: "format",
                params: {
                  format: "date-time"
                },
                message: 'must match format "date-time"'
              };
              if (vErrors === null) {
                vErrors = [err47];
              } else {
                vErrors.push(err47);
              }
              errors++;
            }
          }
        }
        if (data16.reason !== void 0) {
          if (typeof data16.reason !== "string") {
            const err48 = {
              instancePath: instancePath + "/cancellation/reason",
              schemaPath: "SubscriptionCancellation/properties/reason/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err48];
            } else {
              vErrors.push(err48);
            }
            errors++;
          }
        }
        if (data16.origin !== void 0) {
          let data20 = data16.origin;
          if (typeof data20 !== "string") {
            const err49 = {
              instancePath: instancePath + "/cancellation/origin",
              schemaPath: "SubscriptionCancellation/properties/origin/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err49];
            } else {
              vErrors.push(err49);
            }
            errors++;
          }
          if (!(data20 === "STRIPE" || data20 === "APP")) {
            const err50 = {
              instancePath: instancePath + "/cancellation/origin",
              schemaPath: "SubscriptionCancellation/properties/origin/enum",
              keyword: "enum",
              params: {
                allowedValues: schema171.properties.origin.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err50];
            } else {
              vErrors.push(err50);
            }
            errors++;
          }
        }
        if (data16.canUncancel !== void 0) {
          if (typeof data16.canUncancel !== "boolean") {
            const err51 = {
              instancePath: instancePath + "/cancellation/canUncancel",
              schemaPath: "SubscriptionCancellation/properties/canUncancel/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err51];
            } else {
              vErrors.push(err51);
            }
            errors++;
          }
        }
      } else {
        const err52 = {
          instancePath: instancePath + "/cancellation",
          schemaPath: "SubscriptionCancellation/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err52];
        } else {
          vErrors.push(err52);
        }
        errors++;
      }
    }
    if (data.requiredUserAction !== void 0) {
      let data22 = data.requiredUserAction;
      if (data22 && typeof data22 == "object" && !Array.isArray(data22)) {
        if (data22.code === void 0) {
          const err53 = {
            instancePath: instancePath + "/requiredUserAction",
            schemaPath: "#/properties/requiredUserAction/required",
            keyword: "required",
            params: {
              missingProperty: "code"
            },
            message: "must have required property 'code'"
          };
          if (vErrors === null) {
            vErrors = [err53];
          } else {
            vErrors.push(err53);
          }
          errors++;
        }
        if (data22.code !== void 0) {
          if (typeof data22.code !== "string") {
            const err54 = {
              instancePath: instancePath + "/requiredUserAction/code",
              schemaPath: "#/properties/requiredUserAction/properties/code/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err54];
            } else {
              vErrors.push(err54);
            }
            errors++;
          }
        }
        if (data22.description !== void 0) {
          if (typeof data22.description !== "string") {
            const err55 = {
              instancePath: instancePath + "/requiredUserAction/description",
              schemaPath: "#/properties/requiredUserAction/properties/description/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err55];
            } else {
              vErrors.push(err55);
            }
            errors++;
          }
        }
        if (data22.referenceUrl !== void 0) {
          if (typeof data22.referenceUrl !== "string") {
            const err56 = {
              instancePath: instancePath + "/requiredUserAction/referenceUrl",
              schemaPath: "#/properties/requiredUserAction/properties/referenceUrl/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err56];
            } else {
              vErrors.push(err56);
            }
            errors++;
          }
        }
      } else {
        const err57 = {
          instancePath: instancePath + "/requiredUserAction",
          schemaPath: "#/properties/requiredUserAction/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err57];
        } else {
          vErrors.push(err57);
        }
        errors++;
      }
    }
    if (data.pausedUntil !== void 0) {
      let data26 = data.pausedUntil;
      if (data26 && typeof data26 == "object" && !Array.isArray(data26)) {
        if (data26.date === void 0) {
          const err58 = {
            instancePath: instancePath + "/pausedUntil",
            schemaPath: "#/properties/pausedUntil/required",
            keyword: "required",
            params: {
              missingProperty: "date"
            },
            message: "must have required property 'date'"
          };
          if (vErrors === null) {
            vErrors = [err58];
          } else {
            vErrors.push(err58);
          }
          errors++;
        }
        if (data26.proratableTime === void 0) {
          const err59 = {
            instancePath: instancePath + "/pausedUntil",
            schemaPath: "#/properties/pausedUntil/required",
            keyword: "required",
            params: {
              missingProperty: "proratableTime"
            },
            message: "must have required property 'proratableTime'"
          };
          if (vErrors === null) {
            vErrors = [err59];
          } else {
            vErrors.push(err59);
          }
          errors++;
        }
        if (data26.date !== void 0) {
          let data27 = data26.date;
          if (!(data27 && typeof data27 == "object" && !Array.isArray(data27))) {
            const err60 = {
              instancePath: instancePath + "/pausedUntil/date",
              schemaPath: "#/properties/pausedUntil/properties/date/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err60];
            } else {
              vErrors.push(err60);
            }
            errors++;
          }
          if (typeof data27 === "string") {
            if (!formats0(data27)) {
              const err61 = {
                instancePath: instancePath + "/pausedUntil/date",
                schemaPath: "#/properties/pausedUntil/properties/date/format",
                keyword: "format",
                params: {
                  format: "date-time"
                },
                message: 'must match format "date-time"'
              };
              if (vErrors === null) {
                vErrors = [err61];
              } else {
                vErrors.push(err61);
              }
              errors++;
            }
          }
        }
        if (data26.proratableTime !== void 0) {
          let data28 = data26.proratableTime;
          if (!(typeof data28 == "number" && isFinite(data28))) {
            const err62 = {
              instancePath: instancePath + "/pausedUntil/proratableTime",
              schemaPath: "#/properties/pausedUntil/properties/proratableTime/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err62];
            } else {
              vErrors.push(err62);
            }
            errors++;
          }
        }
      } else {
        const err63 = {
          instancePath: instancePath + "/pausedUntil",
          schemaPath: "#/properties/pausedUntil/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err63];
        } else {
          vErrors.push(err63);
        }
        errors++;
      }
    }
    if (data.pauseDate !== void 0) {
      let data29 = data.pauseDate;
      if (!(data29 && typeof data29 == "object" && !Array.isArray(data29))) {
        const err64 = {
          instancePath: instancePath + "/pauseDate",
          schemaPath: "#/properties/pauseDate/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err64];
        } else {
          vErrors.push(err64);
        }
        errors++;
      }
      if (typeof data29 === "string") {
        if (!formats0(data29)) {
          const err65 = {
            instancePath: instancePath + "/pauseDate",
            schemaPath: "#/properties/pauseDate/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err65];
          } else {
            vErrors.push(err65);
          }
          errors++;
        }
      }
    }
    if (data.nextPeriodicCheck !== void 0) {
      let data30 = data.nextPeriodicCheck;
      if (!(data30 && typeof data30 == "object" && !Array.isArray(data30))) {
        const err66 = {
          instancePath: instancePath + "/nextPeriodicCheck",
          schemaPath: "#/properties/nextPeriodicCheck/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err66];
        } else {
          vErrors.push(err66);
        }
        errors++;
      }
      if (typeof data30 === "string") {
        if (!formats0(data30)) {
          const err67 = {
            instancePath: instancePath + "/nextPeriodicCheck",
            schemaPath: "#/properties/nextPeriodicCheck/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err67];
          } else {
            vErrors.push(err67);
          }
          errors++;
        }
      }
    }
    if (data.lastReminderSentDate !== void 0) {
      let data31 = data.lastReminderSentDate;
      if (!(data31 && typeof data31 == "object" && !Array.isArray(data31))) {
        const err68 = {
          instancePath: instancePath + "/lastReminderSentDate",
          schemaPath: "#/properties/lastReminderSentDate/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err68];
        } else {
          vErrors.push(err68);
        }
        errors++;
      }
      if (typeof data31 === "string") {
        if (!formats0(data31)) {
          const err69 = {
            instancePath: instancePath + "/lastReminderSentDate",
            schemaPath: "#/properties/lastReminderSentDate/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err69];
          } else {
            vErrors.push(err69);
          }
          errors++;
        }
      }
    }
    if (data.creationDate !== void 0) {
      let data32 = data.creationDate;
      if (!(data32 && typeof data32 == "object" && !Array.isArray(data32))) {
        const err70 = {
          instancePath: instancePath + "/creationDate",
          schemaPath: "#/properties/creationDate/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err70];
        } else {
          vErrors.push(err70);
        }
        errors++;
      }
      if (typeof data32 === "string") {
        if (!formats0(data32)) {
          const err71 = {
            instancePath: instancePath + "/creationDate",
            schemaPath: "#/properties/creationDate/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err71];
          } else {
            vErrors.push(err71);
          }
          errors++;
        }
      }
    }
  } else {
    const err72 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err72];
    } else {
      vErrors.push(err72);
    }
    errors++;
  }
  validate160.errors = vErrors;
  return errors === 0;
}
const GetAccessRequest = validate161;
function validate161(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.videoId === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "videoId"
        },
        message: "must have required property 'videoId'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.channelId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.videoId !== void 0) {
      if (typeof data.videoId !== "string") {
        const err2 = {
          instancePath: instancePath + "/videoId",
          schemaPath: "#/properties/videoId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err3 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate161.errors = vErrors;
  return errors === 0;
}
const GetAccessGrantType = validate162;
function validate162(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.type === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.ticketEntries === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "ticketEntries"
        },
        message: "must have required property 'ticketEntries'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.type !== void 0) {
      let data0 = data.type;
      if (typeof data0 !== "string") {
        const err2 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/anyOf/0/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if ("TICKET" !== data0) {
        const err3 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/anyOf/0/properties/type/const",
          keyword: "const",
          params: {
            allowedValue: "TICKET"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.ticketEntries !== void 0) {
      let data1 = data.ticketEntries;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.entry === void 0) {
              const err4 = {
                instancePath: instancePath + "/ticketEntries/" + i0,
                schemaPath: "#/anyOf/0/properties/ticketEntries/items/required",
                keyword: "required",
                params: {
                  missingProperty: "entry"
                },
                message: "must have required property 'entry'"
              };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
            if (data2.id === void 0) {
              const err5 = {
                instancePath: instancePath + "/ticketEntries/" + i0,
                schemaPath: "#/anyOf/0/properties/ticketEntries/items/required",
                keyword: "required",
                params: {
                  missingProperty: "id"
                },
                message: "must have required property 'id'"
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if (data2.entry !== void 0) {
              if (!validate42(data2.entry, {
                instancePath: instancePath + "/ticketEntries/" + i0 + "/entry",
                parentData: data2,
                parentDataProperty: "entry",
                rootData
              })) {
                vErrors = vErrors === null ? validate42.errors : vErrors.concat(validate42.errors);
                errors = vErrors.length;
              }
            }
            if (data2.id !== void 0) {
              if (typeof data2.id !== "string") {
                const err6 = {
                  instancePath: instancePath + "/ticketEntries/" + i0 + "/id",
                  schemaPath: "#/anyOf/0/properties/ticketEntries/items/properties/id/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            }
          } else {
            const err7 = {
              instancePath: instancePath + "/ticketEntries/" + i0,
              schemaPath: "#/anyOf/0/properties/ticketEntries/items/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
          }
        }
      } else {
        const err8 = {
          instancePath: instancePath + "/ticketEntries",
          schemaPath: "#/anyOf/0/properties/ticketEntries/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
  } else {
    const err9 = {
      instancePath,
      schemaPath: "#/anyOf/0/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err9];
    } else {
      vErrors.push(err9);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs12 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.type === void 0) {
        const err10 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "type"
          },
          message: "must have required property 'type'"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
      if (data.subscriptionEntry === void 0) {
        const err11 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "subscriptionEntry"
          },
          message: "must have required property 'subscriptionEntry'"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if (data.subscriptionEntryId === void 0) {
        const err12 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "subscriptionEntryId"
          },
          message: "must have required property 'subscriptionEntryId'"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
      if (data.planId === void 0) {
        const err13 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "planId"
          },
          message: "must have required property 'planId'"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
      if (data.type !== void 0) {
        let data5 = data.type;
        if (typeof data5 !== "string") {
          const err14 = {
            instancePath: instancePath + "/type",
            schemaPath: "#/anyOf/1/properties/type/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
        if ("SUBSCRIPTION" !== data5) {
          const err15 = {
            instancePath: instancePath + "/type",
            schemaPath: "#/anyOf/1/properties/type/const",
            keyword: "const",
            params: {
              allowedValue: "SUBSCRIPTION"
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
      }
      if (data.subscriptionEntry !== void 0) {
        if (!validate160(data.subscriptionEntry, {
          instancePath: instancePath + "/subscriptionEntry",
          parentData: data,
          parentDataProperty: "subscriptionEntry",
          rootData
        })) {
          vErrors = vErrors === null ? validate160.errors : vErrors.concat(validate160.errors);
          errors = vErrors.length;
        }
      }
      if (data.subscriptionEntryId !== void 0) {
        if (typeof data.subscriptionEntryId !== "string") {
          const err16 = {
            instancePath: instancePath + "/subscriptionEntryId",
            schemaPath: "#/anyOf/1/properties/subscriptionEntryId/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
      }
      if (data.planId !== void 0) {
        if (typeof data.planId !== "string") {
          const err17 = {
            instancePath: instancePath + "/planId",
            schemaPath: "#/anyOf/1/properties/planId/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
      }
    } else {
      const err18 = {
        instancePath,
        schemaPath: "#/anyOf/1/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err18];
      } else {
        vErrors.push(err18);
      }
      errors++;
    }
    var _valid0 = _errs12 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs21 = errors;
      if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.type === void 0) {
          const err19 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "type"
            },
            message: "must have required property 'type'"
          };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if (data.type !== void 0) {
          let data9 = data.type;
          if (typeof data9 !== "string") {
            const err20 = {
              instancePath: instancePath + "/type",
              schemaPath: "#/anyOf/2/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err20];
            } else {
              vErrors.push(err20);
            }
            errors++;
          }
          if ("FREE" !== data9) {
            const err21 = {
              instancePath: instancePath + "/type",
              schemaPath: "#/anyOf/2/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "FREE"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
        }
      } else {
        const err22 = {
          instancePath,
          schemaPath: "#/anyOf/2/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err22];
        } else {
          vErrors.push(err22);
        }
        errors++;
      }
      var _valid0 = _errs21 === errors;
      valid0 = valid0 || _valid0;
    }
  }
  if (!valid0) {
    const err23 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err23];
    } else {
      vErrors.push(err23);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate162.errors = vErrors;
  return errors === 0;
}
const GetAccessGrantedResponse = validate165;
function validate165(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.granted === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "granted"
        },
        message: "must have required property 'granted'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.accessType === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "accessType"
        },
        message: "must have required property 'accessType'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.granted !== void 0) {
      let data0 = data.granted;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/granted",
          schemaPath: "#/properties/granted/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (true !== data0) {
        const err3 = {
          instancePath: instancePath + "/granted",
          schemaPath: "#/properties/granted/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.url !== void 0) {
      if (typeof data.url !== "string") {
        const err4 = {
          instancePath: instancePath + "/url",
          schemaPath: "#/properties/url/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.accessType !== void 0) {
      if (!validate162(data.accessType, {
        instancePath: instancePath + "/accessType",
        parentData: data,
        parentDataProperty: "accessType",
        rootData
      })) {
        vErrors = vErrors === null ? validate162.errors : vErrors.concat(validate162.errors);
        errors = vErrors.length;
      }
    }
    if (data.preparedPaymentMethods !== void 0) {
      if (!validate45(data.preparedPaymentMethods, {
        instancePath: instancePath + "/preparedPaymentMethods",
        parentData: data,
        parentDataProperty: "preparedPaymentMethods",
        rootData
      })) {
        vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
        errors = vErrors.length;
      }
    }
    if (data.availableOptions !== void 0) {
      let data4 = data.availableOptions;
      if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
        if (data4.plans !== void 0) {
          let data5 = data4.plans;
          if (Array.isArray(data5)) {
            const len0 = data5.length;
            for (let i0 = 0; i0 < len0; i0++) {
              let data6 = data5[i0];
              if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                if (data6.plan === void 0) {
                  const err5 = {
                    instancePath: instancePath + "/availableOptions/plans/" + i0,
                    schemaPath: "#/properties/availableOptions/properties/plans/items/required",
                    keyword: "required",
                    params: {
                      missingProperty: "plan"
                    },
                    message: "must have required property 'plan'"
                  };
                  if (vErrors === null) {
                    vErrors = [err5];
                  } else {
                    vErrors.push(err5);
                  }
                  errors++;
                }
                if (data6.id === void 0) {
                  const err6 = {
                    instancePath: instancePath + "/availableOptions/plans/" + i0,
                    schemaPath: "#/properties/availableOptions/properties/plans/items/required",
                    keyword: "required",
                    params: {
                      missingProperty: "id"
                    },
                    message: "must have required property 'id'"
                  };
                  if (vErrors === null) {
                    vErrors = [err6];
                  } else {
                    vErrors.push(err6);
                  }
                  errors++;
                }
                if (data6.plan !== void 0) {
                  if (!validate156(data6.plan, {
                    instancePath: instancePath + "/availableOptions/plans/" + i0 + "/plan",
                    parentData: data6,
                    parentDataProperty: "plan",
                    rootData
                  })) {
                    vErrors = vErrors === null ? validate156.errors : vErrors.concat(validate156.errors);
                    errors = vErrors.length;
                  }
                }
                if (data6.id !== void 0) {
                  if (typeof data6.id !== "string") {
                    const err7 = {
                      instancePath: instancePath + "/availableOptions/plans/" + i0 + "/id",
                      schemaPath: "#/properties/availableOptions/properties/plans/items/properties/id/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err7];
                    } else {
                      vErrors.push(err7);
                    }
                    errors++;
                  }
                }
              } else {
                const err8 = {
                  instancePath: instancePath + "/availableOptions/plans/" + i0,
                  schemaPath: "#/properties/availableOptions/properties/plans/items/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
            }
          } else {
            const err9 = {
              instancePath: instancePath + "/availableOptions/plans",
              schemaPath: "#/properties/availableOptions/properties/plans/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err9];
            } else {
              vErrors.push(err9);
            }
            errors++;
          }
        }
        if (data4.tickets !== void 0) {
          let data9 = data4.tickets;
          if (Array.isArray(data9)) {
            const len1 = data9.length;
            for (let i1 = 0; i1 < len1; i1++) {
              if (!validate146(data9[i1], {
                instancePath: instancePath + "/availableOptions/tickets/" + i1,
                parentData: data9,
                parentDataProperty: i1,
                rootData
              })) {
                vErrors = vErrors === null ? validate146.errors : vErrors.concat(validate146.errors);
                errors = vErrors.length;
              }
            }
          } else {
            const err10 = {
              instancePath: instancePath + "/availableOptions/tickets",
              schemaPath: "#/properties/availableOptions/properties/tickets/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err10];
            } else {
              vErrors.push(err10);
            }
            errors++;
          }
        }
      } else {
        const err11 = {
          instancePath: instancePath + "/availableOptions",
          schemaPath: "#/properties/availableOptions/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
  } else {
    const err12 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err12];
    } else {
      vErrors.push(err12);
    }
    errors++;
  }
  validate165.errors = vErrors;
  return errors === 0;
}
const GetAccessDeniedResponseReason = validate170;
const schema181 = {
  "$id": "GetAccessDeniedResponseReason",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["NOT_REGISTERED", "CONTENT_GONE", "NO_ACCESS", "TICKET_AND_SUBSCRIPTION_INVALID", "TICKET_EXPIRED", "SUBSCRIPTION_INVALID", "GEO_RESTRICTION"]
};
function validate170(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (!(data === "NOT_REGISTERED" || data === "CONTENT_GONE" || data === "NO_ACCESS" || data === "TICKET_AND_SUBSCRIPTION_INVALID" || data === "TICKET_EXPIRED" || data === "SUBSCRIPTION_INVALID" || data === "GEO_RESTRICTION")) {
    const err1 = {
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema181.enum
      },
      message: "must be equal to one of the allowed values"
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate170.errors = vErrors;
  return errors === 0;
}
const GetAccessDeniedResponse = validate171;
function validate171(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.granted === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "granted"
        },
        message: "must have required property 'granted'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.reason === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "reason"
        },
        message: "must have required property 'reason'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.granted !== void 0) {
      let data0 = data.granted;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/granted",
          schemaPath: "#/properties/granted/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (false !== data0) {
        const err3 = {
          instancePath: instancePath + "/granted",
          schemaPath: "#/properties/granted/const",
          keyword: "const",
          params: {
            allowedValue: false
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.reason !== void 0) {
      let data1 = data.reason;
      if (typeof data1 !== "string") {
        const err4 = {
          instancePath: instancePath + "/reason",
          schemaPath: "GetAccessDeniedResponseReason/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if (!(data1 === "NOT_REGISTERED" || data1 === "CONTENT_GONE" || data1 === "NO_ACCESS" || data1 === "TICKET_AND_SUBSCRIPTION_INVALID" || data1 === "TICKET_EXPIRED" || data1 === "SUBSCRIPTION_INVALID" || data1 === "GEO_RESTRICTION")) {
        const err5 = {
          instancePath: instancePath + "/reason",
          schemaPath: "GetAccessDeniedResponseReason/enum",
          keyword: "enum",
          params: {
            allowedValues: schema181.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.invalidSubscriptions !== void 0) {
      let data2 = data.invalidSubscriptions;
      if (Array.isArray(data2)) {
        const len0 = data2.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data3 = data2[i0];
          if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
            if (data3.id === void 0) {
              const err6 = {
                instancePath: instancePath + "/invalidSubscriptions/" + i0,
                schemaPath: "#/properties/invalidSubscriptions/items/required",
                keyword: "required",
                params: {
                  missingProperty: "id"
                },
                message: "must have required property 'id'"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            if (data3.status === void 0) {
              const err7 = {
                instancePath: instancePath + "/invalidSubscriptions/" + i0,
                schemaPath: "#/properties/invalidSubscriptions/items/required",
                keyword: "required",
                params: {
                  missingProperty: "status"
                },
                message: "must have required property 'status'"
              };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            if (data3.planId === void 0) {
              const err8 = {
                instancePath: instancePath + "/invalidSubscriptions/" + i0,
                schemaPath: "#/properties/invalidSubscriptions/items/required",
                keyword: "required",
                params: {
                  missingProperty: "planId"
                },
                message: "must have required property 'planId'"
              };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if (data3.id !== void 0) {
              if (typeof data3.id !== "string") {
                const err9 = {
                  instancePath: instancePath + "/invalidSubscriptions/" + i0 + "/id",
                  schemaPath: "#/properties/invalidSubscriptions/items/properties/id/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
            }
            if (data3.status !== void 0) {
              let data5 = data3.status;
              if (typeof data5 !== "string") {
                const err10 = {
                  instancePath: instancePath + "/invalidSubscriptions/" + i0 + "/status",
                  schemaPath: "SubscriptionStatus/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
              if (!(data5 === "NEEDS_ACTION" || data5 === "PAUSED" || data5 === "PENDING" || data5 === "TRIALING" || data5 === "ACTIVE" || data5 === "CANCELLING" || data5 === "TERMINATED")) {
                const err11 = {
                  instancePath: instancePath + "/invalidSubscriptions/" + i0 + "/status",
                  schemaPath: "SubscriptionStatus/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema172.enum
                  },
                  message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) {
                  vErrors = [err11];
                } else {
                  vErrors.push(err11);
                }
                errors++;
              }
            }
            if (data3.planId !== void 0) {
              if (typeof data3.planId !== "string") {
                const err12 = {
                  instancePath: instancePath + "/invalidSubscriptions/" + i0 + "/planId",
                  schemaPath: "#/properties/invalidSubscriptions/items/properties/planId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err12];
                } else {
                  vErrors.push(err12);
                }
                errors++;
              }
            }
          } else {
            const err13 = {
              instancePath: instancePath + "/invalidSubscriptions/" + i0,
              schemaPath: "#/properties/invalidSubscriptions/items/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
        }
      } else {
        const err14 = {
          instancePath: instancePath + "/invalidSubscriptions",
          schemaPath: "#/properties/invalidSubscriptions/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.preparedPaymentMethods !== void 0) {
      if (!validate45(data.preparedPaymentMethods, {
        instancePath: instancePath + "/preparedPaymentMethods",
        parentData: data,
        parentDataProperty: "preparedPaymentMethods",
        rootData
      })) {
        vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
        errors = vErrors.length;
      }
    }
    if (data.availableOptions !== void 0) {
      let data8 = data.availableOptions;
      if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
        if (data8.plans !== void 0) {
          let data9 = data8.plans;
          if (Array.isArray(data9)) {
            const len1 = data9.length;
            for (let i1 = 0; i1 < len1; i1++) {
              let data10 = data9[i1];
              if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                if (data10.plan === void 0) {
                  const err15 = {
                    instancePath: instancePath + "/availableOptions/plans/" + i1,
                    schemaPath: "#/properties/availableOptions/properties/plans/items/required",
                    keyword: "required",
                    params: {
                      missingProperty: "plan"
                    },
                    message: "must have required property 'plan'"
                  };
                  if (vErrors === null) {
                    vErrors = [err15];
                  } else {
                    vErrors.push(err15);
                  }
                  errors++;
                }
                if (data10.id === void 0) {
                  const err16 = {
                    instancePath: instancePath + "/availableOptions/plans/" + i1,
                    schemaPath: "#/properties/availableOptions/properties/plans/items/required",
                    keyword: "required",
                    params: {
                      missingProperty: "id"
                    },
                    message: "must have required property 'id'"
                  };
                  if (vErrors === null) {
                    vErrors = [err16];
                  } else {
                    vErrors.push(err16);
                  }
                  errors++;
                }
                if (data10.plan !== void 0) {
                  if (!validate156(data10.plan, {
                    instancePath: instancePath + "/availableOptions/plans/" + i1 + "/plan",
                    parentData: data10,
                    parentDataProperty: "plan",
                    rootData
                  })) {
                    vErrors = vErrors === null ? validate156.errors : vErrors.concat(validate156.errors);
                    errors = vErrors.length;
                  }
                }
                if (data10.id !== void 0) {
                  if (typeof data10.id !== "string") {
                    const err17 = {
                      instancePath: instancePath + "/availableOptions/plans/" + i1 + "/id",
                      schemaPath: "#/properties/availableOptions/properties/plans/items/properties/id/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err17];
                    } else {
                      vErrors.push(err17);
                    }
                    errors++;
                  }
                }
              } else {
                const err18 = {
                  instancePath: instancePath + "/availableOptions/plans/" + i1,
                  schemaPath: "#/properties/availableOptions/properties/plans/items/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
            }
          } else {
            const err19 = {
              instancePath: instancePath + "/availableOptions/plans",
              schemaPath: "#/properties/availableOptions/properties/plans/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err19];
            } else {
              vErrors.push(err19);
            }
            errors++;
          }
        }
        if (data8.tickets !== void 0) {
          let data13 = data8.tickets;
          if (Array.isArray(data13)) {
            const len2 = data13.length;
            for (let i2 = 0; i2 < len2; i2++) {
              if (!validate146(data13[i2], {
                instancePath: instancePath + "/availableOptions/tickets/" + i2,
                parentData: data13,
                parentDataProperty: i2,
                rootData
              })) {
                vErrors = vErrors === null ? validate146.errors : vErrors.concat(validate146.errors);
                errors = vErrors.length;
              }
            }
          } else {
            const err20 = {
              instancePath: instancePath + "/availableOptions/tickets",
              schemaPath: "#/properties/availableOptions/properties/tickets/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err20];
            } else {
              vErrors.push(err20);
            }
            errors++;
          }
        }
      } else {
        const err21 = {
          instancePath: instancePath + "/availableOptions",
          schemaPath: "#/properties/availableOptions/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err21];
        } else {
          vErrors.push(err21);
        }
        errors++;
      }
    }
  } else {
    const err22 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err22];
    } else {
      vErrors.push(err22);
    }
    errors++;
  }
  validate171.errors = vErrors;
  return errors === 0;
}
const GetAccessResponse = validate175;
function validate175(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (!validate171(data, {
    instancePath,
    parentData,
    parentDataProperty,
    rootData
  })) {
    vErrors = vErrors === null ? validate171.errors : vErrors.concat(validate171.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs2 = errors;
    if (!validate165(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData
    })) {
      vErrors = vErrors === null ? validate165.errors : vErrors.concat(validate165.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs2 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err0 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate175.errors = vErrors;
  return errors === 0;
}
const Invite = validate178;
const schema186 = {
  "$id": "Invite",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "channelId": {
      "type": "string"
    },
    "expiracyDate": {
      "type": "object",
      "format": "date-time"
    },
    "intentType": {
      "type": "string",
      "enum": ["ADMIN", "MEMBER", "PRE_REGISTER", "STREAMER", "TRAINER"]
    },
    "inviteMessage": {
      "type": "string"
    },
    "status": {
      "type": "string",
      "enum": ["PENDING", "REJECTED", "ACCEPTED", "PROCESSING"]
    },
    "tokenHash": {
      "type": "string"
    }
  },
  "required": ["expiracyDate", "intentType", "status", "tokenHash"]
};
function validate178(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.expiracyDate === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "expiracyDate"
        },
        message: "must have required property 'expiracyDate'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.intentType === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "intentType"
        },
        message: "must have required property 'intentType'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.status === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "status"
        },
        message: "must have required property 'status'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.tokenHash === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "tokenHash"
        },
        message: "must have required property 'tokenHash'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err4 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.expiracyDate !== void 0) {
      let data1 = data.expiracyDate;
      if (!(data1 && typeof data1 == "object" && !Array.isArray(data1))) {
        const err5 = {
          instancePath: instancePath + "/expiracyDate",
          schemaPath: "#/properties/expiracyDate/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if (typeof data1 === "string") {
        if (!formats0(data1)) {
          const err6 = {
            instancePath: instancePath + "/expiracyDate",
            schemaPath: "#/properties/expiracyDate/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
      }
    }
    if (data.intentType !== void 0) {
      let data2 = data.intentType;
      if (typeof data2 !== "string") {
        const err7 = {
          instancePath: instancePath + "/intentType",
          schemaPath: "#/properties/intentType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if (!(data2 === "ADMIN" || data2 === "MEMBER" || data2 === "PRE_REGISTER" || data2 === "STREAMER" || data2 === "TRAINER")) {
        const err8 = {
          instancePath: instancePath + "/intentType",
          schemaPath: "#/properties/intentType/enum",
          keyword: "enum",
          params: {
            allowedValues: schema186.properties.intentType.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.inviteMessage !== void 0) {
      if (typeof data.inviteMessage !== "string") {
        const err9 = {
          instancePath: instancePath + "/inviteMessage",
          schemaPath: "#/properties/inviteMessage/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.status !== void 0) {
      let data4 = data.status;
      if (typeof data4 !== "string") {
        const err10 = {
          instancePath: instancePath + "/status",
          schemaPath: "#/properties/status/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
      if (!(data4 === "PENDING" || data4 === "REJECTED" || data4 === "ACCEPTED" || data4 === "PROCESSING")) {
        const err11 = {
          instancePath: instancePath + "/status",
          schemaPath: "#/properties/status/enum",
          keyword: "enum",
          params: {
            allowedValues: schema186.properties.status.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.tokenHash !== void 0) {
      if (typeof data.tokenHash !== "string") {
        const err12 = {
          instancePath: instancePath + "/tokenHash",
          schemaPath: "#/properties/tokenHash/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
  } else {
    const err13 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err13];
    } else {
      vErrors.push(err13);
    }
    errors++;
  }
  validate178.errors = vErrors;
  return errors === 0;
}
const SAML_PROVIDERS = validate179;
const schema187 = {
  "$id": "SAML_PROVIDERS",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["sport80"]
};
function validate179(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (!(data === "sport80")) {
    const err1 = {
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema187.enum
      },
      message: "must be equal to one of the allowed values"
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate179.errors = vErrors;
  return errors === 0;
}
const SAML_LINK_OPERATION = validate180;
const schema188 = {
  "$id": "SAML_LINK_OPERATION",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["LINK", "UNLINK", "RECHECK"]
};
function validate180(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (!(data === "LINK" || data === "UNLINK" || data === "RECHECK")) {
    const err1 = {
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema188.enum
      },
      message: "must be equal to one of the allowed values"
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate180.errors = vErrors;
  return errors === 0;
}
const ACCOUNT_LINKING_RESULT = validate181;
const schema189 = {
  "$id": "ACCOUNT_LINKING_RESULT",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["LINKED", "NO_LINKABLE_PLAN", "ACCOUNT_ALREADY_LINKED", "ACCOUNT_LINKED_TO_OTHER_USER"]
};
function validate181(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (!(data === "LINKED" || data === "NO_LINKABLE_PLAN" || data === "ACCOUNT_ALREADY_LINKED" || data === "ACCOUNT_LINKED_TO_OTHER_USER")) {
    const err1 = {
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema189.enum
      },
      message: "must be equal to one of the allowed values"
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate181.errors = vErrors;
  return errors === 0;
}
const ACCOUNT_UNLINKING_RESULT = validate182;
const schema190 = {
  "$id": "ACCOUNT_UNLINKING_RESULT",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["UNLINKED", "NOT_SAME_USER", "USER_NOT_LINKED"]
};
function validate182(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (!(data === "UNLINKED" || data === "NOT_SAME_USER" || data === "USER_NOT_LINKED")) {
    const err1 = {
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema190.enum
      },
      message: "must be equal to one of the allowed values"
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate182.errors = vErrors;
  return errors === 0;
}
const ACCOUNT_RELINK_RESULT = validate183;
const schema191 = {
  "$id": "ACCOUNT_RELINK_RESULT",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "string",
  "enum": ["RELINKED", "USER_NOT_LINKED", "RELINKED_DIFFERENT_PACKAGE", "UNLINKED"]
};
function validate183(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== "string") {
    const err0 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "string"
      },
      message: "must be string"
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
  }
  if (!(data === "RELINKED" || data === "USER_NOT_LINKED" || data === "RELINKED_DIFFERENT_PACKAGE" || data === "UNLINKED")) {
    const err1 = {
      instancePath,
      schemaPath: "#/enum",
      keyword: "enum",
      params: {
        allowedValues: schema191.enum
      },
      message: "must be equal to one of the allowed values"
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate183.errors = vErrors;
  return errors === 0;
}
const LinkExternalAccountRequest = validate184;
function validate184(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.channelId === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.providerType === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "providerType"
        },
        message: "must have required property 'providerType'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err2 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.providerType !== void 0) {
      if (typeof data.providerType !== "string") {
        const err3 = {
          instancePath: instancePath + "/providerType",
          schemaPath: "#/properties/providerType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate184.errors = vErrors;
  return errors === 0;
}
const LinkExternalSAMLAccountRequest = validate185;
function validate185(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.channelId === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.providerType === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "providerType"
        },
        message: "must have required property 'providerType'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.returnUrl === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "returnUrl"
        },
        message: "must have required property 'returnUrl'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.providerId === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "providerId"
        },
        message: "must have required property 'providerId'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.operation === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "operation"
        },
        message: "must have required property 'operation'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err5 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.providerType !== void 0) {
      let data1 = data.providerType;
      if (typeof data1 !== "string") {
        const err6 = {
          instancePath: instancePath + "/providerType",
          schemaPath: "#/properties/providerType/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if ("SAML" !== data1) {
        const err7 = {
          instancePath: instancePath + "/providerType",
          schemaPath: "#/properties/providerType/const",
          keyword: "const",
          params: {
            allowedValue: "SAML"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.returnUrl !== void 0) {
      if (typeof data.returnUrl !== "string") {
        const err8 = {
          instancePath: instancePath + "/returnUrl",
          schemaPath: "#/properties/returnUrl/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.providerId !== void 0) {
      let data3 = data.providerId;
      if (typeof data3 !== "string") {
        const err9 = {
          instancePath: instancePath + "/providerId",
          schemaPath: "SAML_PROVIDERS/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if (!(data3 === "sport80")) {
        const err10 = {
          instancePath: instancePath + "/providerId",
          schemaPath: "SAML_PROVIDERS/enum",
          keyword: "enum",
          params: {
            allowedValues: schema187.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.operation !== void 0) {
      let data4 = data.operation;
      if (typeof data4 !== "string") {
        const err11 = {
          instancePath: instancePath + "/operation",
          schemaPath: "SAML_LINK_OPERATION/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if (!(data4 === "LINK" || data4 === "UNLINK" || data4 === "RECHECK")) {
        const err12 = {
          instancePath: instancePath + "/operation",
          schemaPath: "SAML_LINK_OPERATION/enum",
          keyword: "enum",
          params: {
            allowedValues: schema188.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
  } else {
    const err13 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err13];
    } else {
      vErrors.push(err13);
    }
    errors++;
  }
  validate185.errors = vErrors;
  return errors === 0;
}
const LinkExternalAccountSuccessfulResponse = validate186;
function validate186(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.redirection === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "redirection"
        },
        message: "must have required property 'redirection'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (true !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.redirection !== void 0) {
      if (typeof data.redirection !== "string") {
        const err4 = {
          instancePath: instancePath + "/redirection",
          schemaPath: "#/properties/redirection/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate186.errors = vErrors;
  return errors === 0;
}
const LinkExternalAccountErrorResponse = validate187;
function validate187(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.errorReason === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "errorReason"
        },
        message: "must have required property 'errorReason'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (false !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: false
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.errorReason !== void 0) {
      if (typeof data.errorReason !== "string") {
        const err4 = {
          instancePath: instancePath + "/errorReason",
          schemaPath: "#/properties/errorReason/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate187.errors = vErrors;
  return errors === 0;
}
const LinkExternalAccountResponse = validate188;
function validate188(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "LinkExternalAccountSuccessfulResponse/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.redirection === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "LinkExternalAccountSuccessfulResponse/required",
        keyword: "required",
        params: {
          missingProperty: "redirection"
        },
        message: "must have required property 'redirection'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "LinkExternalAccountSuccessfulResponse/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (true !== data0) {
        const err3 = {
          instancePath: instancePath + "/success",
          schemaPath: "LinkExternalAccountSuccessfulResponse/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.redirection !== void 0) {
      if (typeof data.redirection !== "string") {
        const err4 = {
          instancePath: instancePath + "/redirection",
          schemaPath: "LinkExternalAccountSuccessfulResponse/properties/redirection/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "LinkExternalAccountSuccessfulResponse/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs8 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.success === void 0) {
        const err6 = {
          instancePath,
          schemaPath: "LinkExternalAccountErrorResponse/required",
          keyword: "required",
          params: {
            missingProperty: "success"
          },
          message: "must have required property 'success'"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if (data.errorReason === void 0) {
        const err7 = {
          instancePath,
          schemaPath: "LinkExternalAccountErrorResponse/required",
          keyword: "required",
          params: {
            missingProperty: "errorReason"
          },
          message: "must have required property 'errorReason'"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if (data.success !== void 0) {
        let data2 = data.success;
        if (typeof data2 !== "boolean") {
          const err8 = {
            instancePath: instancePath + "/success",
            schemaPath: "LinkExternalAccountErrorResponse/properties/success/type",
            keyword: "type",
            params: {
              type: "boolean"
            },
            message: "must be boolean"
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
        if (false !== data2) {
          const err9 = {
            instancePath: instancePath + "/success",
            schemaPath: "LinkExternalAccountErrorResponse/properties/success/const",
            keyword: "const",
            params: {
              allowedValue: false
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
      }
      if (data.errorReason !== void 0) {
        if (typeof data.errorReason !== "string") {
          const err10 = {
            instancePath: instancePath + "/errorReason",
            schemaPath: "LinkExternalAccountErrorResponse/properties/errorReason/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
      }
    } else {
      const err11 = {
        instancePath,
        schemaPath: "LinkExternalAccountErrorResponse/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err11];
      } else {
        vErrors.push(err11);
      }
      errors++;
    }
    var _valid0 = _errs8 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err12 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err12];
    } else {
      vErrors.push(err12);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate188.errors = vErrors;
  return errors === 0;
}
const ManageSubscriptionRequest = validate189;
function validate189(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.channelId === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.subscriptionId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "subscriptionId"
        },
        message: "must have required property 'subscriptionId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.command === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "command"
        },
        message: "must have required property 'command'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err3 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.subscriptionId !== void 0) {
      if (typeof data.subscriptionId !== "string") {
        const err4 = {
          instancePath: instancePath + "/subscriptionId",
          schemaPath: "#/properties/subscriptionId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.command !== void 0) {
      let data2 = data.command;
      const _errs6 = errors;
      let valid1 = false;
      const _errs7 = errors;
      if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
        if (data2.type === void 0) {
          const err5 = {
            instancePath: instancePath + "/command",
            schemaPath: "CancelSubscriptionCommand/required",
            keyword: "required",
            params: {
              missingProperty: "type"
            },
            message: "must have required property 'type'"
          };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
        if (data2.reason === void 0) {
          const err6 = {
            instancePath: instancePath + "/command",
            schemaPath: "CancelSubscriptionCommand/required",
            keyword: "required",
            params: {
              missingProperty: "reason"
            },
            message: "must have required property 'reason'"
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
        if (data2.type !== void 0) {
          let data3 = data2.type;
          if (typeof data3 !== "string") {
            const err7 = {
              instancePath: instancePath + "/command/type",
              schemaPath: "CancelSubscriptionCommand/properties/type/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
          }
          if ("CANCEL" !== data3) {
            const err8 = {
              instancePath: instancePath + "/command/type",
              schemaPath: "CancelSubscriptionCommand/properties/type/const",
              keyword: "const",
              params: {
                allowedValue: "CANCEL"
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err8];
            } else {
              vErrors.push(err8);
            }
            errors++;
          }
        }
        if (data2.reason !== void 0) {
          if (typeof data2.reason !== "string") {
            const err9 = {
              instancePath: instancePath + "/command/reason",
              schemaPath: "CancelSubscriptionCommand/properties/reason/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err9];
            } else {
              vErrors.push(err9);
            }
            errors++;
          }
        }
      } else {
        const err10 = {
          instancePath: instancePath + "/command",
          schemaPath: "CancelSubscriptionCommand/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
      var _valid0 = _errs7 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs14 = errors;
        if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
          if (data2.type === void 0) {
            const err11 = {
              instancePath: instancePath + "/command",
              schemaPath: "UncancelSubscriptionCommand/required",
              keyword: "required",
              params: {
                missingProperty: "type"
              },
              message: "must have required property 'type'"
            };
            if (vErrors === null) {
              vErrors = [err11];
            } else {
              vErrors.push(err11);
            }
            errors++;
          }
          if (data2.type !== void 0) {
            let data5 = data2.type;
            if (typeof data5 !== "string") {
              const err12 = {
                instancePath: instancePath + "/command/type",
                schemaPath: "UncancelSubscriptionCommand/properties/type/type",
                keyword: "type",
                params: {
                  type: "string"
                },
                message: "must be string"
              };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            if ("UNCANCEL" !== data5) {
              const err13 = {
                instancePath: instancePath + "/command/type",
                schemaPath: "UncancelSubscriptionCommand/properties/type/const",
                keyword: "const",
                params: {
                  allowedValue: "UNCANCEL"
                },
                message: "must be equal to constant"
              };
              if (vErrors === null) {
                vErrors = [err13];
              } else {
                vErrors.push(err13);
              }
              errors++;
            }
          }
        } else {
          const err14 = {
            instancePath: instancePath + "/command",
            schemaPath: "UncancelSubscriptionCommand/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
        var _valid0 = _errs14 === errors;
        valid1 = valid1 || _valid0;
        if (!valid1) {
          const _errs19 = errors;
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.type === void 0) {
              const err15 = {
                instancePath: instancePath + "/command",
                schemaPath: "UpdateSubscriptionPaymentCommand/required",
                keyword: "required",
                params: {
                  missingProperty: "type"
                },
                message: "must have required property 'type'"
              };
              if (vErrors === null) {
                vErrors = [err15];
              } else {
                vErrors.push(err15);
              }
              errors++;
            }
            if (data2.newPaymentMethodId === void 0) {
              const err16 = {
                instancePath: instancePath + "/command",
                schemaPath: "UpdateSubscriptionPaymentCommand/required",
                keyword: "required",
                params: {
                  missingProperty: "newPaymentMethodId"
                },
                message: "must have required property 'newPaymentMethodId'"
              };
              if (vErrors === null) {
                vErrors = [err16];
              } else {
                vErrors.push(err16);
              }
              errors++;
            }
            if (data2.type !== void 0) {
              let data6 = data2.type;
              if (typeof data6 !== "string") {
                const err17 = {
                  instancePath: instancePath + "/command/type",
                  schemaPath: "UpdateSubscriptionPaymentCommand/properties/type/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
              }
              if ("UPDATE_PAYMENT_METHOD" !== data6) {
                const err18 = {
                  instancePath: instancePath + "/command/type",
                  schemaPath: "UpdateSubscriptionPaymentCommand/properties/type/const",
                  keyword: "const",
                  params: {
                    allowedValue: "UPDATE_PAYMENT_METHOD"
                  },
                  message: "must be equal to constant"
                };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
            }
            if (data2.newPaymentMethodId !== void 0) {
              if (typeof data2.newPaymentMethodId !== "string") {
                const err19 = {
                  instancePath: instancePath + "/command/newPaymentMethodId",
                  schemaPath: "UpdateSubscriptionPaymentCommand/properties/newPaymentMethodId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
            }
            if (data2.chargeImmediately !== void 0) {
              if (typeof data2.chargeImmediately !== "boolean") {
                const err20 = {
                  instancePath: instancePath + "/command/chargeImmediately",
                  schemaPath: "UpdateSubscriptionPaymentCommand/properties/chargeImmediately/type",
                  keyword: "type",
                  params: {
                    type: "boolean"
                  },
                  message: "must be boolean"
                };
                if (vErrors === null) {
                  vErrors = [err20];
                } else {
                  vErrors.push(err20);
                }
                errors++;
              }
            }
          } else {
            const err21 = {
              instancePath: instancePath + "/command",
              schemaPath: "UpdateSubscriptionPaymentCommand/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
          var _valid0 = _errs19 === errors;
          valid1 = valid1 || _valid0;
          if (!valid1) {
            const _errs28 = errors;
            if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
              if (data2.type === void 0) {
                const err22 = {
                  instancePath: instancePath + "/command",
                  schemaPath: "PauseSubscriptionCommand/required",
                  keyword: "required",
                  params: {
                    missingProperty: "type"
                  },
                  message: "must have required property 'type'"
                };
                if (vErrors === null) {
                  vErrors = [err22];
                } else {
                  vErrors.push(err22);
                }
                errors++;
              }
              if (data2.duration === void 0) {
                const err23 = {
                  instancePath: instancePath + "/command",
                  schemaPath: "PauseSubscriptionCommand/required",
                  keyword: "required",
                  params: {
                    missingProperty: "duration"
                  },
                  message: "must have required property 'duration'"
                };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
              if (data2.type !== void 0) {
                let data9 = data2.type;
                if (typeof data9 !== "string") {
                  const err24 = {
                    instancePath: instancePath + "/command/type",
                    schemaPath: "PauseSubscriptionCommand/properties/type/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err24];
                  } else {
                    vErrors.push(err24);
                  }
                  errors++;
                }
                if ("PAUSE" !== data9) {
                  const err25 = {
                    instancePath: instancePath + "/command/type",
                    schemaPath: "PauseSubscriptionCommand/properties/type/const",
                    keyword: "const",
                    params: {
                      allowedValue: "PAUSE"
                    },
                    message: "must be equal to constant"
                  };
                  if (vErrors === null) {
                    vErrors = [err25];
                  } else {
                    vErrors.push(err25);
                  }
                  errors++;
                }
              }
              if (data2.duration !== void 0) {
                let data10 = data2.duration;
                const _errs34 = errors;
                let valid10 = false;
                const _errs35 = errors;
                if (!(typeof data10 == "number" && isFinite(data10))) {
                  const err26 = {
                    instancePath: instancePath + "/command/duration",
                    schemaPath: "PauseSubscriptionCommand/properties/duration/anyOf/0/type",
                    keyword: "type",
                    params: {
                      type: "number"
                    },
                    message: "must be number"
                  };
                  if (vErrors === null) {
                    vErrors = [err26];
                  } else {
                    vErrors.push(err26);
                  }
                  errors++;
                }
                var _valid1 = _errs35 === errors;
                valid10 = valid10 || _valid1;
                if (!valid10) {
                  const _errs37 = errors;
                  if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                    if (data10.date === void 0) {
                      const err27 = {
                        instancePath: instancePath + "/command/duration",
                        schemaPath: "PauseSubscriptionCommand/properties/duration/anyOf/1/required",
                        keyword: "required",
                        params: {
                          missingProperty: "date"
                        },
                        message: "must have required property 'date'"
                      };
                      if (vErrors === null) {
                        vErrors = [err27];
                      } else {
                        vErrors.push(err27);
                      }
                      errors++;
                    }
                    if (data10.date !== void 0) {
                      let data11 = data10.date;
                      if (!(typeof data11 == "number" && isFinite(data11))) {
                        const err28 = {
                          instancePath: instancePath + "/command/duration/date",
                          schemaPath: "PauseSubscriptionCommand/properties/duration/anyOf/1/properties/date/type",
                          keyword: "type",
                          params: {
                            type: "number"
                          },
                          message: "must be number"
                        };
                        if (vErrors === null) {
                          vErrors = [err28];
                        } else {
                          vErrors.push(err28);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err29 = {
                      instancePath: instancePath + "/command/duration",
                      schemaPath: "PauseSubscriptionCommand/properties/duration/anyOf/1/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err29];
                    } else {
                      vErrors.push(err29);
                    }
                    errors++;
                  }
                  var _valid1 = _errs37 === errors;
                  valid10 = valid10 || _valid1;
                }
                if (!valid10) {
                  const err30 = {
                    instancePath: instancePath + "/command/duration",
                    schemaPath: "PauseSubscriptionCommand/properties/duration/anyOf",
                    keyword: "anyOf",
                    params: {},
                    message: "must match a schema in anyOf"
                  };
                  if (vErrors === null) {
                    vErrors = [err30];
                  } else {
                    vErrors.push(err30);
                  }
                  errors++;
                } else {
                  errors = _errs34;
                  if (vErrors !== null) {
                    if (_errs34) {
                      vErrors.length = _errs34;
                    } else {
                      vErrors = null;
                    }
                  }
                }
              }
            } else {
              const err31 = {
                instancePath: instancePath + "/command",
                schemaPath: "PauseSubscriptionCommand/type",
                keyword: "type",
                params: {
                  type: "object"
                },
                message: "must be object"
              };
              if (vErrors === null) {
                vErrors = [err31];
              } else {
                vErrors.push(err31);
              }
              errors++;
            }
            var _valid0 = _errs28 === errors;
            valid1 = valid1 || _valid0;
            if (!valid1) {
              const _errs41 = errors;
              if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                if (data2.type === void 0) {
                  const err32 = {
                    instancePath: instancePath + "/command",
                    schemaPath: "UnpauseSubscriptionCommand/required",
                    keyword: "required",
                    params: {
                      missingProperty: "type"
                    },
                    message: "must have required property 'type'"
                  };
                  if (vErrors === null) {
                    vErrors = [err32];
                  } else {
                    vErrors.push(err32);
                  }
                  errors++;
                }
                if (data2.type !== void 0) {
                  let data12 = data2.type;
                  if (typeof data12 !== "string") {
                    const err33 = {
                      instancePath: instancePath + "/command/type",
                      schemaPath: "UnpauseSubscriptionCommand/properties/type/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err33];
                    } else {
                      vErrors.push(err33);
                    }
                    errors++;
                  }
                  if ("UNPAUSE" !== data12) {
                    const err34 = {
                      instancePath: instancePath + "/command/type",
                      schemaPath: "UnpauseSubscriptionCommand/properties/type/const",
                      keyword: "const",
                      params: {
                        allowedValue: "UNPAUSE"
                      },
                      message: "must be equal to constant"
                    };
                    if (vErrors === null) {
                      vErrors = [err34];
                    } else {
                      vErrors.push(err34);
                    }
                    errors++;
                  }
                }
              } else {
                const err35 = {
                  instancePath: instancePath + "/command",
                  schemaPath: "UnpauseSubscriptionCommand/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err35];
                } else {
                  vErrors.push(err35);
                }
                errors++;
              }
              var _valid0 = _errs41 === errors;
              valid1 = valid1 || _valid0;
            }
          }
        }
      }
      if (!valid1) {
        const err36 = {
          instancePath: instancePath + "/command",
          schemaPath: "#/properties/command/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err36];
        } else {
          vErrors.push(err36);
        }
        errors++;
      } else {
        errors = _errs6;
        if (vErrors !== null) {
          if (_errs6) {
            vErrors.length = _errs6;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err37 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err37];
    } else {
      vErrors.push(err37);
    }
    errors++;
  }
  validate189.errors = vErrors;
  return errors === 0;
}
const CancelSubscriptionCommand = validate190;
function validate190(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.type === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.reason === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "reason"
        },
        message: "must have required property 'reason'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.type !== void 0) {
      let data0 = data.type;
      if (typeof data0 !== "string") {
        const err2 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if ("CANCEL" !== data0) {
        const err3 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/const",
          keyword: "const",
          params: {
            allowedValue: "CANCEL"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.reason !== void 0) {
      if (typeof data.reason !== "string") {
        const err4 = {
          instancePath: instancePath + "/reason",
          schemaPath: "#/properties/reason/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate190.errors = vErrors;
  return errors === 0;
}
const UncancelSubscriptionCommand = validate191;
function validate191(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.type === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.type !== void 0) {
      let data0 = data.type;
      if (typeof data0 !== "string") {
        const err1 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if ("UNCANCEL" !== data0) {
        const err2 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/const",
          keyword: "const",
          params: {
            allowedValue: "UNCANCEL"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate191.errors = vErrors;
  return errors === 0;
}
const UpdateSubscriptionPaymentCommand = validate192;
function validate192(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.type === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.newPaymentMethodId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "newPaymentMethodId"
        },
        message: "must have required property 'newPaymentMethodId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.type !== void 0) {
      let data0 = data.type;
      if (typeof data0 !== "string") {
        const err2 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if ("UPDATE_PAYMENT_METHOD" !== data0) {
        const err3 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/const",
          keyword: "const",
          params: {
            allowedValue: "UPDATE_PAYMENT_METHOD"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.newPaymentMethodId !== void 0) {
      if (typeof data.newPaymentMethodId !== "string") {
        const err4 = {
          instancePath: instancePath + "/newPaymentMethodId",
          schemaPath: "#/properties/newPaymentMethodId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.chargeImmediately !== void 0) {
      if (typeof data.chargeImmediately !== "boolean") {
        const err5 = {
          instancePath: instancePath + "/chargeImmediately",
          schemaPath: "#/properties/chargeImmediately/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
  } else {
    const err6 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err6];
    } else {
      vErrors.push(err6);
    }
    errors++;
  }
  validate192.errors = vErrors;
  return errors === 0;
}
const PauseSubscriptionCommand = validate193;
function validate193(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.type === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.duration === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "duration"
        },
        message: "must have required property 'duration'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.type !== void 0) {
      let data0 = data.type;
      if (typeof data0 !== "string") {
        const err2 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if ("PAUSE" !== data0) {
        const err3 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/const",
          keyword: "const",
          params: {
            allowedValue: "PAUSE"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.duration !== void 0) {
      let data1 = data.duration;
      const _errs4 = errors;
      let valid1 = false;
      const _errs5 = errors;
      if (!(typeof data1 == "number" && isFinite(data1))) {
        const err4 = {
          instancePath: instancePath + "/duration",
          schemaPath: "#/properties/duration/anyOf/0/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      var _valid0 = _errs5 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs7 = errors;
        if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
          if (data1.date === void 0) {
            const err5 = {
              instancePath: instancePath + "/duration",
              schemaPath: "#/properties/duration/anyOf/1/required",
              keyword: "required",
              params: {
                missingProperty: "date"
              },
              message: "must have required property 'date'"
            };
            if (vErrors === null) {
              vErrors = [err5];
            } else {
              vErrors.push(err5);
            }
            errors++;
          }
          if (data1.date !== void 0) {
            let data2 = data1.date;
            if (!(typeof data2 == "number" && isFinite(data2))) {
              const err6 = {
                instancePath: instancePath + "/duration/date",
                schemaPath: "#/properties/duration/anyOf/1/properties/date/type",
                keyword: "type",
                params: {
                  type: "number"
                },
                message: "must be number"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
          }
        } else {
          const err7 = {
            instancePath: instancePath + "/duration",
            schemaPath: "#/properties/duration/anyOf/1/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
        var _valid0 = _errs7 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err8 = {
          instancePath: instancePath + "/duration",
          schemaPath: "#/properties/duration/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      } else {
        errors = _errs4;
        if (vErrors !== null) {
          if (_errs4) {
            vErrors.length = _errs4;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err9 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err9];
    } else {
      vErrors.push(err9);
    }
    errors++;
  }
  validate193.errors = vErrors;
  return errors === 0;
}
const UnpauseSubscriptionCommand = validate194;
function validate194(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.type === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.type !== void 0) {
      let data0 = data.type;
      if (typeof data0 !== "string") {
        const err1 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if ("UNPAUSE" !== data0) {
        const err2 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/const",
          keyword: "const",
          params: {
            allowedValue: "UNPAUSE"
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate194.errors = vErrors;
  return errors === 0;
}
const ManageSubscriptionResponse = validate195;
function validate195(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err1 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/anyOf/0/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (true !== data0) {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/anyOf/0/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: "#/anyOf/0/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs5 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.effectiveDate === void 0) {
        const err4 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "effectiveDate"
          },
          message: "must have required property 'effectiveDate'"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if (data.success === void 0) {
        const err5 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "success"
          },
          message: "must have required property 'success'"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if (data.success !== void 0) {
        let data1 = data.success;
        if (typeof data1 !== "boolean") {
          const err6 = {
            instancePath: instancePath + "/success",
            schemaPath: "#/anyOf/1/properties/success/type",
            keyword: "type",
            params: {
              type: "boolean"
            },
            message: "must be boolean"
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
        if (true !== data1) {
          const err7 = {
            instancePath: instancePath + "/success",
            schemaPath: "#/anyOf/1/properties/success/const",
            keyword: "const",
            params: {
              allowedValue: true
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
      }
      if (data.effectiveDate !== void 0) {
        let data2 = data.effectiveDate;
        if (typeof data2 === "string") {
          if (!formats0(data2)) {
            const err8 = {
              instancePath: instancePath + "/effectiveDate",
              schemaPath: "#/anyOf/1/properties/effectiveDate/format",
              keyword: "format",
              params: {
                format: "date-time"
              },
              message: 'must match format "date-time"'
            };
            if (vErrors === null) {
              vErrors = [err8];
            } else {
              vErrors.push(err8);
            }
            errors++;
          }
        } else {
          const err9 = {
            instancePath: instancePath + "/effectiveDate",
            schemaPath: "#/anyOf/1/properties/effectiveDate/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
      }
    } else {
      const err10 = {
        instancePath,
        schemaPath: "#/anyOf/1/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err10];
      } else {
        vErrors.push(err10);
      }
      errors++;
    }
    var _valid0 = _errs5 === errors;
    valid0 = valid0 || _valid0;
    if (!valid0) {
      const _errs11 = errors;
      if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.errorReason === void 0) {
          const err11 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "errorReason"
            },
            message: "must have required property 'errorReason'"
          };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
        if (data.success === void 0) {
          const err12 = {
            instancePath,
            schemaPath: "#/anyOf/2/required",
            keyword: "required",
            params: {
              missingProperty: "success"
            },
            message: "must have required property 'success'"
          };
          if (vErrors === null) {
            vErrors = [err12];
          } else {
            vErrors.push(err12);
          }
          errors++;
        }
        if (data.errorReason !== void 0) {
          if (typeof data.errorReason !== "string") {
            const err13 = {
              instancePath: instancePath + "/errorReason",
              schemaPath: "#/anyOf/2/properties/errorReason/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
        }
        if (data.success !== void 0) {
          let data4 = data.success;
          if (typeof data4 !== "boolean") {
            const err14 = {
              instancePath: instancePath + "/success",
              schemaPath: "#/anyOf/2/properties/success/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err14];
            } else {
              vErrors.push(err14);
            }
            errors++;
          }
          if (false !== data4) {
            const err15 = {
              instancePath: instancePath + "/success",
              schemaPath: "#/anyOf/2/properties/success/const",
              keyword: "const",
              params: {
                allowedValue: false
              },
              message: "must be equal to constant"
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
      } else {
        const err16 = {
          instancePath,
          schemaPath: "#/anyOf/2/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
      var _valid0 = _errs11 === errors;
      valid0 = valid0 || _valid0;
    }
  }
  if (!valid0) {
    const err17 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err17];
    } else {
      vErrors.push(err17);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate195.errors = vErrors;
  return errors === 0;
}
const UpdateUserConsentRequest = validate196;
function validate196(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.responses === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "responses"
        },
        message: "must have required property 'responses'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.terms === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "terms"
        },
        message: "must have required property 'terms'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.channelId === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.merge !== void 0) {
      if (typeof data.merge !== "boolean") {
        const err3 = {
          instancePath: instancePath + "/merge",
          schemaPath: "#/properties/merge/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.responses !== void 0) {
      let data1 = data.responses;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.requestId === void 0) {
              const err4 = {
                instancePath: instancePath + "/responses/" + i0,
                schemaPath: "#/properties/responses/items/required",
                keyword: "required",
                params: {
                  missingProperty: "requestId"
                },
                message: "must have required property 'requestId'"
              };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
            if (data2.consented === void 0) {
              const err5 = {
                instancePath: instancePath + "/responses/" + i0,
                schemaPath: "#/properties/responses/items/required",
                keyword: "required",
                params: {
                  missingProperty: "consented"
                },
                message: "must have required property 'consented'"
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if (data2.version === void 0) {
              const err6 = {
                instancePath: instancePath + "/responses/" + i0,
                schemaPath: "#/properties/responses/items/required",
                keyword: "required",
                params: {
                  missingProperty: "version"
                },
                message: "must have required property 'version'"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            if (data2.requestId !== void 0) {
              if (typeof data2.requestId !== "string") {
                const err7 = {
                  instancePath: instancePath + "/responses/" + i0 + "/requestId",
                  schemaPath: "#/properties/responses/items/properties/requestId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
            }
            if (data2.consented !== void 0) {
              if (typeof data2.consented !== "boolean") {
                const err8 = {
                  instancePath: instancePath + "/responses/" + i0 + "/consented",
                  schemaPath: "#/properties/responses/items/properties/consented/type",
                  keyword: "type",
                  params: {
                    type: "boolean"
                  },
                  message: "must be boolean"
                };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
            }
            if (data2.version !== void 0) {
              let data5 = data2.version;
              if (!(typeof data5 == "number" && isFinite(data5))) {
                const err9 = {
                  instancePath: instancePath + "/responses/" + i0 + "/version",
                  schemaPath: "#/properties/responses/items/properties/version/type",
                  keyword: "type",
                  params: {
                    type: "number"
                  },
                  message: "must be number"
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
            }
          } else {
            const err10 = {
              instancePath: instancePath + "/responses/" + i0,
              schemaPath: "#/properties/responses/items/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err10];
            } else {
              vErrors.push(err10);
            }
            errors++;
          }
        }
      } else {
        const err11 = {
          instancePath: instancePath + "/responses",
          schemaPath: "#/properties/responses/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.terms !== void 0) {
      let data6 = data.terms;
      if (Array.isArray(data6)) {
        const len1 = data6.length;
        for (let i1 = 0; i1 < len1; i1++) {
          let data7 = data6[i1];
          if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
            if (data7.termsId === void 0) {
              const err12 = {
                instancePath: instancePath + "/terms/" + i1,
                schemaPath: "#/properties/terms/items/required",
                keyword: "required",
                params: {
                  missingProperty: "termsId"
                },
                message: "must have required property 'termsId'"
              };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            if (data7.version === void 0) {
              const err13 = {
                instancePath: instancePath + "/terms/" + i1,
                schemaPath: "#/properties/terms/items/required",
                keyword: "required",
                params: {
                  missingProperty: "version"
                },
                message: "must have required property 'version'"
              };
              if (vErrors === null) {
                vErrors = [err13];
              } else {
                vErrors.push(err13);
              }
              errors++;
            }
            if (data7.termsId !== void 0) {
              if (typeof data7.termsId !== "string") {
                const err14 = {
                  instancePath: instancePath + "/terms/" + i1 + "/termsId",
                  schemaPath: "#/properties/terms/items/properties/termsId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
            if (data7.version !== void 0) {
              let data9 = data7.version;
              if (!(typeof data9 == "number" && isFinite(data9))) {
                const err15 = {
                  instancePath: instancePath + "/terms/" + i1 + "/version",
                  schemaPath: "#/properties/terms/items/properties/version/type",
                  keyword: "type",
                  params: {
                    type: "number"
                  },
                  message: "must be number"
                };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
              }
            }
          } else {
            const err16 = {
              instancePath: instancePath + "/terms/" + i1,
              schemaPath: "#/properties/terms/items/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err16];
            } else {
              vErrors.push(err16);
            }
            errors++;
          }
        }
      } else {
        const err17 = {
          instancePath: instancePath + "/terms",
          schemaPath: "#/properties/terms/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err18 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
  } else {
    const err19 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err19];
    } else {
      vErrors.push(err19);
    }
    errors++;
  }
  validate196.errors = vErrors;
  return errors === 0;
}
const UpdateUserConsentResponse = validate197;
function validate197(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  const _errs1 = errors;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.success === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/anyOf/0/required",
        keyword: "required",
        params: {
          missingProperty: "success"
        },
        message: "must have required property 'success'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.success !== void 0) {
      let data0 = data.success;
      if (typeof data0 !== "boolean") {
        const err1 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/anyOf/0/properties/success/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (true !== data0) {
        const err2 = {
          instancePath: instancePath + "/success",
          schemaPath: "#/anyOf/0/properties/success/const",
          keyword: "const",
          params: {
            allowedValue: true
          },
          message: "must be equal to constant"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: "#/anyOf/0/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  var _valid0 = _errs1 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs5 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
      if (data.success === void 0) {
        const err4 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "success"
          },
          message: "must have required property 'success'"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if (data.errorReason === void 0) {
        const err5 = {
          instancePath,
          schemaPath: "#/anyOf/1/required",
          keyword: "required",
          params: {
            missingProperty: "errorReason"
          },
          message: "must have required property 'errorReason'"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if (data.success !== void 0) {
        let data1 = data.success;
        if (typeof data1 !== "boolean") {
          const err6 = {
            instancePath: instancePath + "/success",
            schemaPath: "#/anyOf/1/properties/success/type",
            keyword: "type",
            params: {
              type: "boolean"
            },
            message: "must be boolean"
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
        if (false !== data1) {
          const err7 = {
            instancePath: instancePath + "/success",
            schemaPath: "#/anyOf/1/properties/success/const",
            keyword: "const",
            params: {
              allowedValue: false
            },
            message: "must be equal to constant"
          };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
      }
      if (data.errorReason !== void 0) {
        if (typeof data.errorReason !== "string") {
          const err8 = {
            instancePath: instancePath + "/errorReason",
            schemaPath: "#/anyOf/1/properties/errorReason/type",
            keyword: "type",
            params: {
              type: "string"
            },
            message: "must be string"
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
      }
    } else {
      const err9 = {
        instancePath,
        schemaPath: "#/anyOf/1/type",
        keyword: "type",
        params: {
          type: "object"
        },
        message: "must be object"
      };
      if (vErrors === null) {
        vErrors = [err9];
      } else {
        vErrors.push(err9);
      }
      errors++;
    }
    var _valid0 = _errs5 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err10 = {
      instancePath,
      schemaPath: "#/anyOf",
      keyword: "anyOf",
      params: {},
      message: "must match a schema in anyOf"
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate197.errors = vErrors;
  return errors === 0;
}
const UserConsentEntryResponse = validate198;
function validate198(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.consentedVersion === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "consentedVersion"
        },
        message: "must have required property 'consentedVersion'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.consented === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "consented"
        },
        message: "must have required property 'consented'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.date === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "date"
        },
        message: "must have required property 'date'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.consentedVersion !== void 0) {
      let data0 = data.consentedVersion;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err3 = {
          instancePath: instancePath + "/consentedVersion",
          schemaPath: "#/properties/consentedVersion/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.consented !== void 0) {
      if (typeof data.consented !== "boolean") {
        const err4 = {
          instancePath: instancePath + "/consented",
          schemaPath: "#/properties/consented/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.date !== void 0) {
      let data2 = data.date;
      if (!(data2 && typeof data2 == "object" && !Array.isArray(data2))) {
        const err5 = {
          instancePath: instancePath + "/date",
          schemaPath: "#/properties/date/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if (typeof data2 === "string") {
        if (!formats0(data2)) {
          const err6 = {
            instancePath: instancePath + "/date",
            schemaPath: "#/properties/date/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
      }
    }
  } else {
    const err7 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err7];
    } else {
      vErrors.push(err7);
    }
    errors++;
  }
  validate198.errors = vErrors;
  return errors === 0;
}
const UserConsentEntryTermsResponse = validate199;
function validate199(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.consentedVersion === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "consentedVersion"
        },
        message: "must have required property 'consentedVersion'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.date === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "date"
        },
        message: "must have required property 'date'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.consentedVersion !== void 0) {
      let data0 = data.consentedVersion;
      if (!(typeof data0 == "number" && isFinite(data0))) {
        const err2 = {
          instancePath: instancePath + "/consentedVersion",
          schemaPath: "#/properties/consentedVersion/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.date !== void 0) {
      let data1 = data.date;
      if (!(data1 && typeof data1 == "object" && !Array.isArray(data1))) {
        const err3 = {
          instancePath: instancePath + "/date",
          schemaPath: "#/properties/date/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
      if (typeof data1 === "string") {
        if (!formats0(data1)) {
          const err4 = {
            instancePath: instancePath + "/date",
            schemaPath: "#/properties/date/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate199.errors = vErrors;
  return errors === 0;
}
const UserConsentEntry = validate200;
function validate200(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.userId === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "userId"
        },
        message: "must have required property 'userId'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.channelId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.updateDate === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "updateDate"
        },
        message: "must have required property 'updateDate'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.userId !== void 0) {
      if (typeof data.userId !== "string") {
        const err3 = {
          instancePath: instancePath + "/userId",
          schemaPath: "#/properties/userId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err4 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.consents !== void 0) {
      let data2 = data.consents;
      if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
        for (const key0 in data2) {
          let data3 = data2[key0];
          if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
            if (data3.consentedVersion === void 0) {
              const err5 = {
                instancePath: instancePath + "/consents/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
                schemaPath: "UserConsentEntryResponse/required",
                keyword: "required",
                params: {
                  missingProperty: "consentedVersion"
                },
                message: "must have required property 'consentedVersion'"
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if (data3.consented === void 0) {
              const err6 = {
                instancePath: instancePath + "/consents/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
                schemaPath: "UserConsentEntryResponse/required",
                keyword: "required",
                params: {
                  missingProperty: "consented"
                },
                message: "must have required property 'consented'"
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            if (data3.date === void 0) {
              const err7 = {
                instancePath: instancePath + "/consents/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
                schemaPath: "UserConsentEntryResponse/required",
                keyword: "required",
                params: {
                  missingProperty: "date"
                },
                message: "must have required property 'date'"
              };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            if (data3.consentedVersion !== void 0) {
              let data4 = data3.consentedVersion;
              if (!(typeof data4 == "number" && isFinite(data4))) {
                const err8 = {
                  instancePath: instancePath + "/consents/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/consentedVersion",
                  schemaPath: "UserConsentEntryResponse/properties/consentedVersion/type",
                  keyword: "type",
                  params: {
                    type: "number"
                  },
                  message: "must be number"
                };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
            }
            if (data3.consented !== void 0) {
              if (typeof data3.consented !== "boolean") {
                const err9 = {
                  instancePath: instancePath + "/consents/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/consented",
                  schemaPath: "UserConsentEntryResponse/properties/consented/type",
                  keyword: "type",
                  params: {
                    type: "boolean"
                  },
                  message: "must be boolean"
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
            }
            if (data3.date !== void 0) {
              let data6 = data3.date;
              if (!(data6 && typeof data6 == "object" && !Array.isArray(data6))) {
                const err10 = {
                  instancePath: instancePath + "/consents/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/date",
                  schemaPath: "UserConsentEntryResponse/properties/date/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
              if (typeof data6 === "string") {
                if (!formats0(data6)) {
                  const err11 = {
                    instancePath: instancePath + "/consents/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/date",
                    schemaPath: "UserConsentEntryResponse/properties/date/format",
                    keyword: "format",
                    params: {
                      format: "date-time"
                    },
                    message: 'must match format "date-time"'
                  };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                }
              }
            }
          } else {
            const err12 = {
              instancePath: instancePath + "/consents/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
              schemaPath: "UserConsentEntryResponse/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
        }
      } else {
        const err13 = {
          instancePath: instancePath + "/consents",
          schemaPath: "#/properties/consents/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.terms !== void 0) {
      let data7 = data.terms;
      if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
        for (const key1 in data7) {
          let data8 = data7[key1];
          if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
            if (data8.consentedVersion === void 0) {
              const err14 = {
                instancePath: instancePath + "/terms/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
                schemaPath: "UserConsentEntryTermsResponse/required",
                keyword: "required",
                params: {
                  missingProperty: "consentedVersion"
                },
                message: "must have required property 'consentedVersion'"
              };
              if (vErrors === null) {
                vErrors = [err14];
              } else {
                vErrors.push(err14);
              }
              errors++;
            }
            if (data8.date === void 0) {
              const err15 = {
                instancePath: instancePath + "/terms/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
                schemaPath: "UserConsentEntryTermsResponse/required",
                keyword: "required",
                params: {
                  missingProperty: "date"
                },
                message: "must have required property 'date'"
              };
              if (vErrors === null) {
                vErrors = [err15];
              } else {
                vErrors.push(err15);
              }
              errors++;
            }
            if (data8.consentedVersion !== void 0) {
              let data9 = data8.consentedVersion;
              if (!(typeof data9 == "number" && isFinite(data9))) {
                const err16 = {
                  instancePath: instancePath + "/terms/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/consentedVersion",
                  schemaPath: "UserConsentEntryTermsResponse/properties/consentedVersion/type",
                  keyword: "type",
                  params: {
                    type: "number"
                  },
                  message: "must be number"
                };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
            }
            if (data8.date !== void 0) {
              let data10 = data8.date;
              if (!(data10 && typeof data10 == "object" && !Array.isArray(data10))) {
                const err17 = {
                  instancePath: instancePath + "/terms/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/date",
                  schemaPath: "UserConsentEntryTermsResponse/properties/date/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
              }
              if (typeof data10 === "string") {
                if (!formats0(data10)) {
                  const err18 = {
                    instancePath: instancePath + "/terms/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/date",
                    schemaPath: "UserConsentEntryTermsResponse/properties/date/format",
                    keyword: "format",
                    params: {
                      format: "date-time"
                    },
                    message: 'must match format "date-time"'
                  };
                  if (vErrors === null) {
                    vErrors = [err18];
                  } else {
                    vErrors.push(err18);
                  }
                  errors++;
                }
              }
            }
          } else {
            const err19 = {
              instancePath: instancePath + "/terms/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
              schemaPath: "UserConsentEntryTermsResponse/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err19];
            } else {
              vErrors.push(err19);
            }
            errors++;
          }
        }
      } else {
        const err20 = {
          instancePath: instancePath + "/terms",
          schemaPath: "#/properties/terms/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
    }
    if (data.updateDate !== void 0) {
      let data11 = data.updateDate;
      if (!(data11 && typeof data11 == "object" && !Array.isArray(data11))) {
        const err21 = {
          instancePath: instancePath + "/updateDate",
          schemaPath: "#/properties/updateDate/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err21];
        } else {
          vErrors.push(err21);
        }
        errors++;
      }
      if (typeof data11 === "string") {
        if (!formats0(data11)) {
          const err22 = {
            instancePath: instancePath + "/updateDate",
            schemaPath: "#/properties/updateDate/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
      }
    }
  } else {
    const err23 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err23];
    } else {
      vErrors.push(err23);
    }
    errors++;
  }
  validate200.errors = vErrors;
  return errors === 0;
}
const Sport80ExternalInfo = validate201;
function validate201(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.contactUuid === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "contactUuid"
        },
        message: "must have required property 'contactUuid'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.lastCheck === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "lastCheck"
        },
        message: "must have required property 'lastCheck'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.packageName === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "packageName"
        },
        message: "must have required property 'packageName'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.email === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "email"
        },
        message: "must have required property 'email'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.name === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "name"
        },
        message: "must have required property 'name'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.contactUuid !== void 0) {
      if (typeof data.contactUuid !== "string") {
        const err5 = {
          instancePath: instancePath + "/contactUuid",
          schemaPath: "#/properties/contactUuid/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.lastCheck !== void 0) {
      let data1 = data.lastCheck;
      if (!(data1 && typeof data1 == "object" && !Array.isArray(data1))) {
        const err6 = {
          instancePath: instancePath + "/lastCheck",
          schemaPath: "#/properties/lastCheck/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if (typeof data1 === "string") {
        if (!formats0(data1)) {
          const err7 = {
            instancePath: instancePath + "/lastCheck",
            schemaPath: "#/properties/lastCheck/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
      }
    }
    if (data.packageName !== void 0) {
      if (typeof data.packageName !== "string") {
        const err8 = {
          instancePath: instancePath + "/packageName",
          schemaPath: "#/properties/packageName/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.email !== void 0) {
      if (typeof data.email !== "string") {
        const err9 = {
          instancePath: instancePath + "/email",
          schemaPath: "#/properties/email/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err10 = {
          instancePath: instancePath + "/name",
          schemaPath: "#/properties/name/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
  } else {
    const err11 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err11];
    } else {
      vErrors.push(err11);
    }
    errors++;
  }
  validate201.errors = vErrors;
  return errors === 0;
}
const UserExternalIntegrationsData = validate202;
function validate202(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.payment !== void 0) {
      let data0 = data.payment;
      if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
        if (data0.stripe !== void 0) {
          let data1 = data0.stripe;
          if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
            for (const key0 in data1) {
              let data2 = data1[key0];
              if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                if (data2.customerId === void 0) {
                  const err0 = {
                    instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
                    schemaPath: "#/properties/payment/properties/stripe/additionalProperties/required",
                    keyword: "required",
                    params: {
                      missingProperty: "customerId"
                    },
                    message: "must have required property 'customerId'"
                  };
                  if (vErrors === null) {
                    vErrors = [err0];
                  } else {
                    vErrors.push(err0);
                  }
                  errors++;
                }
                if (data2.customerId !== void 0) {
                  if (typeof data2.customerId !== "string") {
                    const err1 = {
                      instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/customerId",
                      schemaPath: "#/properties/payment/properties/stripe/additionalProperties/properties/customerId/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err1];
                    } else {
                      vErrors.push(err1);
                    }
                    errors++;
                  }
                }
                if (data2.savedPaymentMethods !== void 0) {
                  let data4 = data2.savedPaymentMethods;
                  if (Array.isArray(data4)) {
                    const len0 = data4.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      let data5 = data4[i0];
                      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                        if (data5.paymentMethodId === void 0) {
                          const err2 = {
                            instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/savedPaymentMethods/" + i0,
                            schemaPath: "StripeSavedPaymentMethods/required",
                            keyword: "required",
                            params: {
                              missingProperty: "paymentMethodId"
                            },
                            message: "must have required property 'paymentMethodId'"
                          };
                          if (vErrors === null) {
                            vErrors = [err2];
                          } else {
                            vErrors.push(err2);
                          }
                          errors++;
                        }
                        if (data5.type === void 0) {
                          const err3 = {
                            instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/savedPaymentMethods/" + i0,
                            schemaPath: "StripeSavedPaymentMethods/required",
                            keyword: "required",
                            params: {
                              missingProperty: "type"
                            },
                            message: "must have required property 'type'"
                          };
                          if (vErrors === null) {
                            vErrors = [err3];
                          } else {
                            vErrors.push(err3);
                          }
                          errors++;
                        }
                        if (data5.description === void 0) {
                          const err4 = {
                            instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/savedPaymentMethods/" + i0,
                            schemaPath: "StripeSavedPaymentMethods/required",
                            keyword: "required",
                            params: {
                              missingProperty: "description"
                            },
                            message: "must have required property 'description'"
                          };
                          if (vErrors === null) {
                            vErrors = [err4];
                          } else {
                            vErrors.push(err4);
                          }
                          errors++;
                        }
                        if (data5.paymentMethodId !== void 0) {
                          if (typeof data5.paymentMethodId !== "string") {
                            const err5 = {
                              instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/savedPaymentMethods/" + i0 + "/paymentMethodId",
                              schemaPath: "StripeSavedPaymentMethods/properties/paymentMethodId/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err5];
                            } else {
                              vErrors.push(err5);
                            }
                            errors++;
                          }
                        }
                        if (data5.type !== void 0) {
                          if (typeof data5.type !== "string") {
                            const err6 = {
                              instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/savedPaymentMethods/" + i0 + "/type",
                              schemaPath: "StripeSavedPaymentMethods/properties/type/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err6];
                            } else {
                              vErrors.push(err6);
                            }
                            errors++;
                          }
                        }
                        if (data5.description !== void 0) {
                          if (typeof data5.description !== "string") {
                            const err7 = {
                              instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/savedPaymentMethods/" + i0 + "/description",
                              schemaPath: "StripeSavedPaymentMethods/properties/description/type",
                              keyword: "type",
                              params: {
                                type: "string"
                              },
                              message: "must be string"
                            };
                            if (vErrors === null) {
                              vErrors = [err7];
                            } else {
                              vErrors.push(err7);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err8 = {
                          instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/savedPaymentMethods/" + i0,
                          schemaPath: "StripeSavedPaymentMethods/type",
                          keyword: "type",
                          params: {
                            type: "object"
                          },
                          message: "must be object"
                        };
                        if (vErrors === null) {
                          vErrors = [err8];
                        } else {
                          vErrors.push(err8);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err9 = {
                      instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/savedPaymentMethods",
                      schemaPath: "#/properties/payment/properties/stripe/additionalProperties/properties/savedPaymentMethods/type",
                      keyword: "type",
                      params: {
                        type: "array"
                      },
                      message: "must be array"
                    };
                    if (vErrors === null) {
                      vErrors = [err9];
                    } else {
                      vErrors.push(err9);
                    }
                    errors++;
                  }
                }
              } else {
                const err10 = {
                  instancePath: instancePath + "/payment/stripe/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
                  schemaPath: "#/properties/payment/properties/stripe/additionalProperties/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
            }
          } else {
            const err11 = {
              instancePath: instancePath + "/payment/stripe",
              schemaPath: "#/properties/payment/properties/stripe/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err11];
            } else {
              vErrors.push(err11);
            }
            errors++;
          }
        }
        if (data0.sport80 !== void 0) {
          let data9 = data0.sport80;
          if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
            for (const key1 in data9) {
              let data10 = data9[key1];
              if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                if (data10.contactUuid === void 0) {
                  const err12 = {
                    instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
                    schemaPath: "Sport80ExternalInfo/required",
                    keyword: "required",
                    params: {
                      missingProperty: "contactUuid"
                    },
                    message: "must have required property 'contactUuid'"
                  };
                  if (vErrors === null) {
                    vErrors = [err12];
                  } else {
                    vErrors.push(err12);
                  }
                  errors++;
                }
                if (data10.lastCheck === void 0) {
                  const err13 = {
                    instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
                    schemaPath: "Sport80ExternalInfo/required",
                    keyword: "required",
                    params: {
                      missingProperty: "lastCheck"
                    },
                    message: "must have required property 'lastCheck'"
                  };
                  if (vErrors === null) {
                    vErrors = [err13];
                  } else {
                    vErrors.push(err13);
                  }
                  errors++;
                }
                if (data10.packageName === void 0) {
                  const err14 = {
                    instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
                    schemaPath: "Sport80ExternalInfo/required",
                    keyword: "required",
                    params: {
                      missingProperty: "packageName"
                    },
                    message: "must have required property 'packageName'"
                  };
                  if (vErrors === null) {
                    vErrors = [err14];
                  } else {
                    vErrors.push(err14);
                  }
                  errors++;
                }
                if (data10.email === void 0) {
                  const err15 = {
                    instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
                    schemaPath: "Sport80ExternalInfo/required",
                    keyword: "required",
                    params: {
                      missingProperty: "email"
                    },
                    message: "must have required property 'email'"
                  };
                  if (vErrors === null) {
                    vErrors = [err15];
                  } else {
                    vErrors.push(err15);
                  }
                  errors++;
                }
                if (data10.name === void 0) {
                  const err16 = {
                    instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
                    schemaPath: "Sport80ExternalInfo/required",
                    keyword: "required",
                    params: {
                      missingProperty: "name"
                    },
                    message: "must have required property 'name'"
                  };
                  if (vErrors === null) {
                    vErrors = [err16];
                  } else {
                    vErrors.push(err16);
                  }
                  errors++;
                }
                if (data10.contactUuid !== void 0) {
                  if (typeof data10.contactUuid !== "string") {
                    const err17 = {
                      instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/contactUuid",
                      schemaPath: "Sport80ExternalInfo/properties/contactUuid/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err17];
                    } else {
                      vErrors.push(err17);
                    }
                    errors++;
                  }
                }
                if (data10.lastCheck !== void 0) {
                  let data12 = data10.lastCheck;
                  if (!(data12 && typeof data12 == "object" && !Array.isArray(data12))) {
                    const err18 = {
                      instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/lastCheck",
                      schemaPath: "Sport80ExternalInfo/properties/lastCheck/type",
                      keyword: "type",
                      params: {
                        type: "object"
                      },
                      message: "must be object"
                    };
                    if (vErrors === null) {
                      vErrors = [err18];
                    } else {
                      vErrors.push(err18);
                    }
                    errors++;
                  }
                  if (typeof data12 === "string") {
                    if (!formats0(data12)) {
                      const err19 = {
                        instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/lastCheck",
                        schemaPath: "Sport80ExternalInfo/properties/lastCheck/format",
                        keyword: "format",
                        params: {
                          format: "date-time"
                        },
                        message: 'must match format "date-time"'
                      };
                      if (vErrors === null) {
                        vErrors = [err19];
                      } else {
                        vErrors.push(err19);
                      }
                      errors++;
                    }
                  }
                }
                if (data10.packageName !== void 0) {
                  if (typeof data10.packageName !== "string") {
                    const err20 = {
                      instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/packageName",
                      schemaPath: "Sport80ExternalInfo/properties/packageName/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err20];
                    } else {
                      vErrors.push(err20);
                    }
                    errors++;
                  }
                }
                if (data10.email !== void 0) {
                  if (typeof data10.email !== "string") {
                    const err21 = {
                      instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/email",
                      schemaPath: "Sport80ExternalInfo/properties/email/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err21];
                    } else {
                      vErrors.push(err21);
                    }
                    errors++;
                  }
                }
                if (data10.name !== void 0) {
                  if (typeof data10.name !== "string") {
                    const err22 = {
                      instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1") + "/name",
                      schemaPath: "Sport80ExternalInfo/properties/name/type",
                      keyword: "type",
                      params: {
                        type: "string"
                      },
                      message: "must be string"
                    };
                    if (vErrors === null) {
                      vErrors = [err22];
                    } else {
                      vErrors.push(err22);
                    }
                    errors++;
                  }
                }
              } else {
                const err23 = {
                  instancePath: instancePath + "/payment/sport80/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
                  schemaPath: "Sport80ExternalInfo/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
            }
          } else {
            const err24 = {
              instancePath: instancePath + "/payment/sport80",
              schemaPath: "#/properties/payment/properties/sport80/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          }
        }
      } else {
        const err25 = {
          instancePath: instancePath + "/payment",
          schemaPath: "#/properties/payment/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err25];
        } else {
          vErrors.push(err25);
        }
        errors++;
      }
    }
  } else {
    const err26 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err26];
    } else {
      vErrors.push(err26);
    }
    errors++;
  }
  validate202.errors = vErrors;
  return errors === 0;
}
const ChannelSubscriptions = validate203;
const schema224 = {
  "$id": "ChannelSubscriptions",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "additionalProperties": {
    "type": "object",
    "properties": {
      "channelId": {
        "type": "string"
      },
      "subscription": {
        "type": "string",
        "enum": ["ACTIVE", "PENDING", "TERMINATED"]
      },
      "tickets": {
        "type": "number"
      },
      "lastFeedbackProvided": {
        "type": "object",
        "format": "date-time"
      }
    },
    "required": ["channelId"]
  },
  "description": "Holds information about subscriptions to different channels"
};
function validate203(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      let data0 = data[key0];
      if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
        if (data0.channelId === void 0) {
          const err0 = {
            instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
            schemaPath: "#/additionalProperties/required",
            keyword: "required",
            params: {
              missingProperty: "channelId"
            },
            message: "must have required property 'channelId'"
          };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        }
        if (data0.channelId !== void 0) {
          if (typeof data0.channelId !== "string") {
            const err1 = {
              instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/channelId",
              schemaPath: "#/additionalProperties/properties/channelId/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
        }
        if (data0.subscription !== void 0) {
          let data2 = data0.subscription;
          if (typeof data2 !== "string") {
            const err2 = {
              instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/subscription",
              schemaPath: "#/additionalProperties/properties/subscription/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
          if (!(data2 === "ACTIVE" || data2 === "PENDING" || data2 === "TERMINATED")) {
            const err3 = {
              instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/subscription",
              schemaPath: "#/additionalProperties/properties/subscription/enum",
              keyword: "enum",
              params: {
                allowedValues: schema224.additionalProperties.properties.subscription.enum
              },
              message: "must be equal to one of the allowed values"
            };
            if (vErrors === null) {
              vErrors = [err3];
            } else {
              vErrors.push(err3);
            }
            errors++;
          }
        }
        if (data0.tickets !== void 0) {
          let data3 = data0.tickets;
          if (!(typeof data3 == "number" && isFinite(data3))) {
            const err4 = {
              instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/tickets",
              schemaPath: "#/additionalProperties/properties/tickets/type",
              keyword: "type",
              params: {
                type: "number"
              },
              message: "must be number"
            };
            if (vErrors === null) {
              vErrors = [err4];
            } else {
              vErrors.push(err4);
            }
            errors++;
          }
        }
        if (data0.lastFeedbackProvided !== void 0) {
          let data4 = data0.lastFeedbackProvided;
          if (!(data4 && typeof data4 == "object" && !Array.isArray(data4))) {
            const err5 = {
              instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/lastFeedbackProvided",
              schemaPath: "#/additionalProperties/properties/lastFeedbackProvided/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err5];
            } else {
              vErrors.push(err5);
            }
            errors++;
          }
          if (typeof data4 === "string") {
            if (!formats0(data4)) {
              const err6 = {
                instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/lastFeedbackProvided",
                schemaPath: "#/additionalProperties/properties/lastFeedbackProvided/format",
                keyword: "format",
                params: {
                  format: "date-time"
                },
                message: 'must match format "date-time"'
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
          }
        }
      } else {
        const err7 = {
          instancePath: instancePath + "/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
          schemaPath: "#/additionalProperties/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
  } else {
    const err8 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err8];
    } else {
      vErrors.push(err8);
    }
    errors++;
  }
  validate203.errors = vErrors;
  return errors === 0;
}
const UserInfo = validate204;
const schema225 = {
  "$id": "UserInfo",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "email": {
      "type": "string"
    },
    "photoURL": {
      "type": ["string", "null"]
    },
    "displayName": {
      "type": ["string", "null"]
    },
    "stripeCustomerId": {
      "type": "string"
    },
    "externalIntegrationsData": {
      "$ref": "UserExternalIntegrationsData"
    },
    "subscriptions": {
      "$ref": "ChannelSubscriptions"
    },
    "fingerprint": {
      "type": ["string", "number"]
    },
    "onboardingStatus": {
      "$ref": "UserGuidedOnboardingStatus"
    }
  },
  "required": ["email"]
};
function validate204(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.email === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "email"
        },
        message: "must have required property 'email'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.email !== void 0) {
      if (typeof data.email !== "string") {
        const err1 = {
          instancePath: instancePath + "/email",
          schemaPath: "#/properties/email/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.photoURL !== void 0) {
      let data1 = data.photoURL;
      if (typeof data1 !== "string" && data1 !== null) {
        const err2 = {
          instancePath: instancePath + "/photoURL",
          schemaPath: "#/properties/photoURL/type",
          keyword: "type",
          params: {
            type: schema225.properties.photoURL.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.displayName !== void 0) {
      let data2 = data.displayName;
      if (typeof data2 !== "string" && data2 !== null) {
        const err3 = {
          instancePath: instancePath + "/displayName",
          schemaPath: "#/properties/displayName/type",
          keyword: "type",
          params: {
            type: schema225.properties.displayName.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.stripeCustomerId !== void 0) {
      if (typeof data.stripeCustomerId !== "string") {
        const err4 = {
          instancePath: instancePath + "/stripeCustomerId",
          schemaPath: "#/properties/stripeCustomerId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.externalIntegrationsData !== void 0) {
      if (!validate202(data.externalIntegrationsData, {
        instancePath: instancePath + "/externalIntegrationsData",
        parentData: data,
        parentDataProperty: "externalIntegrationsData",
        rootData
      })) {
        vErrors = vErrors === null ? validate202.errors : vErrors.concat(validate202.errors);
        errors = vErrors.length;
      }
    }
    if (data.subscriptions !== void 0) {
      let data5 = data.subscriptions;
      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
        for (const key0 in data5) {
          let data6 = data5[key0];
          if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
            if (data6.channelId === void 0) {
              const err5 = {
                instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
                schemaPath: "ChannelSubscriptions/additionalProperties/required",
                keyword: "required",
                params: {
                  missingProperty: "channelId"
                },
                message: "must have required property 'channelId'"
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if (data6.channelId !== void 0) {
              if (typeof data6.channelId !== "string") {
                const err6 = {
                  instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/channelId",
                  schemaPath: "ChannelSubscriptions/additionalProperties/properties/channelId/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            }
            if (data6.subscription !== void 0) {
              let data8 = data6.subscription;
              if (typeof data8 !== "string") {
                const err7 = {
                  instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/subscription",
                  schemaPath: "ChannelSubscriptions/additionalProperties/properties/subscription/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
              if (!(data8 === "ACTIVE" || data8 === "PENDING" || data8 === "TERMINATED")) {
                const err8 = {
                  instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/subscription",
                  schemaPath: "ChannelSubscriptions/additionalProperties/properties/subscription/enum",
                  keyword: "enum",
                  params: {
                    allowedValues: schema224.additionalProperties.properties.subscription.enum
                  },
                  message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
            }
            if (data6.tickets !== void 0) {
              let data9 = data6.tickets;
              if (!(typeof data9 == "number" && isFinite(data9))) {
                const err9 = {
                  instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/tickets",
                  schemaPath: "ChannelSubscriptions/additionalProperties/properties/tickets/type",
                  keyword: "type",
                  params: {
                    type: "number"
                  },
                  message: "must be number"
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
            }
            if (data6.lastFeedbackProvided !== void 0) {
              let data10 = data6.lastFeedbackProvided;
              if (!(data10 && typeof data10 == "object" && !Array.isArray(data10))) {
                const err10 = {
                  instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/lastFeedbackProvided",
                  schemaPath: "ChannelSubscriptions/additionalProperties/properties/lastFeedbackProvided/type",
                  keyword: "type",
                  params: {
                    type: "object"
                  },
                  message: "must be object"
                };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
              if (typeof data10 === "string") {
                if (!formats0(data10)) {
                  const err11 = {
                    instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1") + "/lastFeedbackProvided",
                    schemaPath: "ChannelSubscriptions/additionalProperties/properties/lastFeedbackProvided/format",
                    keyword: "format",
                    params: {
                      format: "date-time"
                    },
                    message: 'must match format "date-time"'
                  };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                }
              }
            }
          } else {
            const err12 = {
              instancePath: instancePath + "/subscriptions/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),
              schemaPath: "ChannelSubscriptions/additionalProperties/type",
              keyword: "type",
              params: {
                type: "object"
              },
              message: "must be object"
            };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
        }
      } else {
        const err13 = {
          instancePath: instancePath + "/subscriptions",
          schemaPath: "ChannelSubscriptions/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.fingerprint !== void 0) {
      let data11 = data.fingerprint;
      if (typeof data11 !== "string" && !(typeof data11 == "number" && isFinite(data11))) {
        const err14 = {
          instancePath: instancePath + "/fingerprint",
          schemaPath: "#/properties/fingerprint/type",
          keyword: "type",
          params: {
            type: schema225.properties.fingerprint.type
          },
          message: "must be string,number"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.onboardingStatus !== void 0) {
      let data12 = data.onboardingStatus;
      if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
        if (data12.skipTutorial !== void 0) {
          if (typeof data12.skipTutorial !== "boolean") {
            const err15 = {
              instancePath: instancePath + "/onboardingStatus/skipTutorial",
              schemaPath: "UserGuidedOnboardingStatus/properties/skipTutorial/type",
              keyword: "type",
              params: {
                type: "boolean"
              },
              message: "must be boolean"
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
        if (data12.completed !== void 0) {
          let data14 = data12.completed;
          if (Array.isArray(data14)) {
            const len0 = data14.length;
            for (let i0 = 0; i0 < len0; i0++) {
              if (typeof data14[i0] !== "string") {
                const err16 = {
                  instancePath: instancePath + "/onboardingStatus/completed/" + i0,
                  schemaPath: "UserGuidedOnboardingStatus/properties/completed/items/type",
                  keyword: "type",
                  params: {
                    type: "string"
                  },
                  message: "must be string"
                };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
            }
          } else {
            const err17 = {
              instancePath: instancePath + "/onboardingStatus/completed",
              schemaPath: "UserGuidedOnboardingStatus/properties/completed/type",
              keyword: "type",
              params: {
                type: "array"
              },
              message: "must be array"
            };
            if (vErrors === null) {
              vErrors = [err17];
            } else {
              vErrors.push(err17);
            }
            errors++;
          }
        }
      } else {
        const err18 = {
          instancePath: instancePath + "/onboardingStatus",
          schemaPath: "UserGuidedOnboardingStatus/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
  } else {
    const err19 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err19];
    } else {
      vErrors.push(err19);
    }
    errors++;
  }
  validate204.errors = vErrors;
  return errors === 0;
}
const UserGuidedOnboardingStatus = validate206;
function validate206(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.skipTutorial !== void 0) {
      if (typeof data.skipTutorial !== "boolean") {
        const err0 = {
          instancePath: instancePath + "/skipTutorial",
          schemaPath: "#/properties/skipTutorial/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.completed !== void 0) {
      let data1 = data.completed;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (typeof data1[i0] !== "string") {
            const err1 = {
              instancePath: instancePath + "/completed/" + i0,
              schemaPath: "#/properties/completed/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
        }
      } else {
        const err2 = {
          instancePath: instancePath + "/completed",
          schemaPath: "#/properties/completed/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate206.errors = vErrors;
  return errors === 0;
}
const VideoCoreInfo = validate207;
const schema229 = {
  "$id": "VideoCoreInfo",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "attr0": {
      "type": "string"
    },
    "attr1": {
      "type": "string"
    },
    "attr2": {
      "type": "string"
    },
    "attr3": {
      "type": "string"
    },
    "name": {
      "type": "string"
    },
    "description": {
      "type": "string"
    },
    "eventId": {
      "type": ["string", "null"]
    },
    "unlocked": {
      "type": "boolean"
    },
    "channelId": {
      "type": "string"
    },
    "published": {
      "type": "boolean"
    },
    "restrictedTo": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "object",
        "properties": {
          "exclude": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["exclude"]
      }]
    },
    "externalIds": {
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "tags": {
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "posterImage": {
      "type": "string"
    }
  },
  "required": ["name", "description", "eventId", "unlocked", "channelId", "published", "tags", "posterImage"],
  "description": "Information required by a video regardless of the source itself."
};
function validate207(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.name === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "name"
        },
        message: "must have required property 'name'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.description === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "description"
        },
        message: "must have required property 'description'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.eventId === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "eventId"
        },
        message: "must have required property 'eventId'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.unlocked === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "unlocked"
        },
        message: "must have required property 'unlocked'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.channelId === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.published === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "published"
        },
        message: "must have required property 'published'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.tags === void 0) {
      const err6 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "tags"
        },
        message: "must have required property 'tags'"
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.posterImage === void 0) {
      const err7 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "posterImage"
        },
        message: "must have required property 'posterImage'"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.attr0 !== void 0) {
      if (typeof data.attr0 !== "string") {
        const err8 = {
          instancePath: instancePath + "/attr0",
          schemaPath: "#/properties/attr0/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.attr1 !== void 0) {
      if (typeof data.attr1 !== "string") {
        const err9 = {
          instancePath: instancePath + "/attr1",
          schemaPath: "#/properties/attr1/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.attr2 !== void 0) {
      if (typeof data.attr2 !== "string") {
        const err10 = {
          instancePath: instancePath + "/attr2",
          schemaPath: "#/properties/attr2/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.attr3 !== void 0) {
      if (typeof data.attr3 !== "string") {
        const err11 = {
          instancePath: instancePath + "/attr3",
          schemaPath: "#/properties/attr3/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err12 = {
          instancePath: instancePath + "/name",
          schemaPath: "#/properties/name/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.description !== void 0) {
      if (typeof data.description !== "string") {
        const err13 = {
          instancePath: instancePath + "/description",
          schemaPath: "#/properties/description/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.eventId !== void 0) {
      let data6 = data.eventId;
      if (typeof data6 !== "string" && data6 !== null) {
        const err14 = {
          instancePath: instancePath + "/eventId",
          schemaPath: "#/properties/eventId/type",
          keyword: "type",
          params: {
            type: schema229.properties.eventId.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.unlocked !== void 0) {
      if (typeof data.unlocked !== "boolean") {
        const err15 = {
          instancePath: instancePath + "/unlocked",
          schemaPath: "#/properties/unlocked/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err16 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.published !== void 0) {
      if (typeof data.published !== "boolean") {
        const err17 = {
          instancePath: instancePath + "/published",
          schemaPath: "#/properties/published/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.restrictedTo !== void 0) {
      let data10 = data.restrictedTo;
      const _errs22 = errors;
      let valid1 = false;
      const _errs23 = errors;
      if (Array.isArray(data10)) {
        const len0 = data10.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (typeof data10[i0] !== "string") {
            const err18 = {
              instancePath: instancePath + "/restrictedTo/" + i0,
              schemaPath: "#/properties/restrictedTo/anyOf/0/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err18];
            } else {
              vErrors.push(err18);
            }
            errors++;
          }
        }
      } else {
        const err19 = {
          instancePath: instancePath + "/restrictedTo",
          schemaPath: "#/properties/restrictedTo/anyOf/0/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      }
      var _valid0 = _errs23 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs27 = errors;
        if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
          if (data10.exclude === void 0) {
            const err20 = {
              instancePath: instancePath + "/restrictedTo",
              schemaPath: "#/properties/restrictedTo/anyOf/1/required",
              keyword: "required",
              params: {
                missingProperty: "exclude"
              },
              message: "must have required property 'exclude'"
            };
            if (vErrors === null) {
              vErrors = [err20];
            } else {
              vErrors.push(err20);
            }
            errors++;
          }
          if (data10.exclude !== void 0) {
            let data12 = data10.exclude;
            if (Array.isArray(data12)) {
              const len1 = data12.length;
              for (let i1 = 0; i1 < len1; i1++) {
                if (typeof data12[i1] !== "string") {
                  const err21 = {
                    instancePath: instancePath + "/restrictedTo/exclude/" + i1,
                    schemaPath: "#/properties/restrictedTo/anyOf/1/properties/exclude/items/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err21];
                  } else {
                    vErrors.push(err21);
                  }
                  errors++;
                }
              }
            } else {
              const err22 = {
                instancePath: instancePath + "/restrictedTo/exclude",
                schemaPath: "#/properties/restrictedTo/anyOf/1/properties/exclude/type",
                keyword: "type",
                params: {
                  type: "array"
                },
                message: "must be array"
              };
              if (vErrors === null) {
                vErrors = [err22];
              } else {
                vErrors.push(err22);
              }
              errors++;
            }
          }
        } else {
          const err23 = {
            instancePath: instancePath + "/restrictedTo",
            schemaPath: "#/properties/restrictedTo/anyOf/1/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err23];
          } else {
            vErrors.push(err23);
          }
          errors++;
        }
        var _valid0 = _errs27 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err24 = {
          instancePath: instancePath + "/restrictedTo",
          schemaPath: "#/properties/restrictedTo/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err24];
        } else {
          vErrors.push(err24);
        }
        errors++;
      } else {
        errors = _errs22;
        if (vErrors !== null) {
          if (_errs22) {
            vErrors.length = _errs22;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.externalIds !== void 0) {
      let data14 = data.externalIds;
      if (Array.isArray(data14)) {
        const len2 = data14.length;
        for (let i2 = 0; i2 < len2; i2++) {
          if (typeof data14[i2] !== "string") {
            const err25 = {
              instancePath: instancePath + "/externalIds/" + i2,
              schemaPath: "#/properties/externalIds/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err25];
            } else {
              vErrors.push(err25);
            }
            errors++;
          }
        }
      } else {
        const err26 = {
          instancePath: instancePath + "/externalIds",
          schemaPath: "#/properties/externalIds/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err26];
        } else {
          vErrors.push(err26);
        }
        errors++;
      }
    }
    if (data.tags !== void 0) {
      let data16 = data.tags;
      if (Array.isArray(data16)) {
        const len3 = data16.length;
        for (let i3 = 0; i3 < len3; i3++) {
          if (typeof data16[i3] !== "string") {
            const err27 = {
              instancePath: instancePath + "/tags/" + i3,
              schemaPath: "#/properties/tags/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err27];
            } else {
              vErrors.push(err27);
            }
            errors++;
          }
        }
      } else {
        const err28 = {
          instancePath: instancePath + "/tags",
          schemaPath: "#/properties/tags/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err28];
        } else {
          vErrors.push(err28);
        }
        errors++;
      }
    }
    if (data.posterImage !== void 0) {
      if (typeof data.posterImage !== "string") {
        const err29 = {
          instancePath: instancePath + "/posterImage",
          schemaPath: "#/properties/posterImage/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err29];
        } else {
          vErrors.push(err29);
        }
        errors++;
      }
    }
  } else {
    const err30 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err30];
    } else {
      vErrors.push(err30);
    }
    errors++;
  }
  validate207.errors = vErrors;
  return errors === 0;
}
const Video = validate208;
const schema230 = {
  "$id": "Video",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "attr0": {
      "type": "string"
    },
    "attr1": {
      "type": "string"
    },
    "attr2": {
      "type": "string"
    },
    "attr3": {
      "type": "string"
    },
    "name": {
      "type": "string"
    },
    "description": {
      "type": "string"
    },
    "eventId": {
      "type": ["string", "null"]
    },
    "unlocked": {
      "type": "boolean"
    },
    "channelId": {
      "type": "string"
    },
    "published": {
      "type": "boolean"
    },
    "restrictedTo": {
      "anyOf": [{
        "type": "array",
        "items": {
          "type": "string"
        }
      }, {
        "type": "object",
        "properties": {
          "exclude": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": ["exclude"]
      }]
    },
    "externalIds": {
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "tags": {
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "posterImage": {
      "type": "string"
    },
    "archived": {
      "type": "boolean"
    },
    "type": {
      "type": "string",
      "enum": ["SHORT", "UPLOAD", "STREAM"]
    },
    "streamState": {
      "type": ["string", "null"],
      "enum": ["SCHEDULED", "LIVE", "FINISHED", null]
    },
    "startTime": {
      "anyOf": [{
        "type": "object",
        "format": "date-time"
      }, {
        "type": "null"
      }]
    },
    "endTime": {
      "anyOf": [{
        "type": "object",
        "format": "date-time"
      }, {
        "type": "null"
      }]
    },
    "uploadTime": {
      "type": "object",
      "format": "date-time"
    },
    "duration": {
      "type": ["number", "null"]
    },
    "videoLocation": {
      "type": "string"
    },
    "views": {
      "type": "number"
    },
    "popularity": {
      "type": "number"
    },
    "organizationId": {
      "type": ["string", "null"]
    }
  },
  "required": ["archived", "channelId", "description", "duration", "endTime", "eventId", "name", "organizationId", "popularity", "posterImage", "published", "startTime", "streamState", "tags", "type", "unlocked", "uploadTime", "videoLocation", "views"],
  "description": "A video models a media file along with metadata that a user consumes in the platform. Videos can be uploaded as short form content,or as long form events. They can also be livestreamed and then transformed to a VOD.\n*Popularity score*: The proposed implementation for the popularity score (that is simple and straightforward to implement) is an algorithm using an [exponential moving average](https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average) with time as a variable: > Let `p` be the current popularity score of a video. if an event (video view or similar) happens at time `t` then the current popularity score can be calculated as: `p = (a*p) + (1-a)*t` Where `a=2/(N+1)` and `N` the number of past events that will affect the new score. The popularity for new videos can be set to the creation timestamp of the video (which means new content will be boosted), or set to a reasonable point in the past (which means the video would need to bubble up). >"
};
function validate208(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.archived === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "archived"
        },
        message: "must have required property 'archived'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.channelId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.description === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "description"
        },
        message: "must have required property 'description'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.duration === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "duration"
        },
        message: "must have required property 'duration'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.endTime === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "endTime"
        },
        message: "must have required property 'endTime'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.eventId === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "eventId"
        },
        message: "must have required property 'eventId'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.name === void 0) {
      const err6 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "name"
        },
        message: "must have required property 'name'"
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.organizationId === void 0) {
      const err7 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "organizationId"
        },
        message: "must have required property 'organizationId'"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.popularity === void 0) {
      const err8 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "popularity"
        },
        message: "must have required property 'popularity'"
      };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    if (data.posterImage === void 0) {
      const err9 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "posterImage"
        },
        message: "must have required property 'posterImage'"
      };
      if (vErrors === null) {
        vErrors = [err9];
      } else {
        vErrors.push(err9);
      }
      errors++;
    }
    if (data.published === void 0) {
      const err10 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "published"
        },
        message: "must have required property 'published'"
      };
      if (vErrors === null) {
        vErrors = [err10];
      } else {
        vErrors.push(err10);
      }
      errors++;
    }
    if (data.startTime === void 0) {
      const err11 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "startTime"
        },
        message: "must have required property 'startTime'"
      };
      if (vErrors === null) {
        vErrors = [err11];
      } else {
        vErrors.push(err11);
      }
      errors++;
    }
    if (data.streamState === void 0) {
      const err12 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "streamState"
        },
        message: "must have required property 'streamState'"
      };
      if (vErrors === null) {
        vErrors = [err12];
      } else {
        vErrors.push(err12);
      }
      errors++;
    }
    if (data.tags === void 0) {
      const err13 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "tags"
        },
        message: "must have required property 'tags'"
      };
      if (vErrors === null) {
        vErrors = [err13];
      } else {
        vErrors.push(err13);
      }
      errors++;
    }
    if (data.type === void 0) {
      const err14 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "type"
        },
        message: "must have required property 'type'"
      };
      if (vErrors === null) {
        vErrors = [err14];
      } else {
        vErrors.push(err14);
      }
      errors++;
    }
    if (data.unlocked === void 0) {
      const err15 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "unlocked"
        },
        message: "must have required property 'unlocked'"
      };
      if (vErrors === null) {
        vErrors = [err15];
      } else {
        vErrors.push(err15);
      }
      errors++;
    }
    if (data.uploadTime === void 0) {
      const err16 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "uploadTime"
        },
        message: "must have required property 'uploadTime'"
      };
      if (vErrors === null) {
        vErrors = [err16];
      } else {
        vErrors.push(err16);
      }
      errors++;
    }
    if (data.videoLocation === void 0) {
      const err17 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "videoLocation"
        },
        message: "must have required property 'videoLocation'"
      };
      if (vErrors === null) {
        vErrors = [err17];
      } else {
        vErrors.push(err17);
      }
      errors++;
    }
    if (data.views === void 0) {
      const err18 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "views"
        },
        message: "must have required property 'views'"
      };
      if (vErrors === null) {
        vErrors = [err18];
      } else {
        vErrors.push(err18);
      }
      errors++;
    }
    if (data.attr0 !== void 0) {
      if (typeof data.attr0 !== "string") {
        const err19 = {
          instancePath: instancePath + "/attr0",
          schemaPath: "#/properties/attr0/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      }
    }
    if (data.attr1 !== void 0) {
      if (typeof data.attr1 !== "string") {
        const err20 = {
          instancePath: instancePath + "/attr1",
          schemaPath: "#/properties/attr1/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
    }
    if (data.attr2 !== void 0) {
      if (typeof data.attr2 !== "string") {
        const err21 = {
          instancePath: instancePath + "/attr2",
          schemaPath: "#/properties/attr2/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err21];
        } else {
          vErrors.push(err21);
        }
        errors++;
      }
    }
    if (data.attr3 !== void 0) {
      if (typeof data.attr3 !== "string") {
        const err22 = {
          instancePath: instancePath + "/attr3",
          schemaPath: "#/properties/attr3/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err22];
        } else {
          vErrors.push(err22);
        }
        errors++;
      }
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err23 = {
          instancePath: instancePath + "/name",
          schemaPath: "#/properties/name/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err23];
        } else {
          vErrors.push(err23);
        }
        errors++;
      }
    }
    if (data.description !== void 0) {
      if (typeof data.description !== "string") {
        const err24 = {
          instancePath: instancePath + "/description",
          schemaPath: "#/properties/description/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err24];
        } else {
          vErrors.push(err24);
        }
        errors++;
      }
    }
    if (data.eventId !== void 0) {
      let data6 = data.eventId;
      if (typeof data6 !== "string" && data6 !== null) {
        const err25 = {
          instancePath: instancePath + "/eventId",
          schemaPath: "#/properties/eventId/type",
          keyword: "type",
          params: {
            type: schema230.properties.eventId.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err25];
        } else {
          vErrors.push(err25);
        }
        errors++;
      }
    }
    if (data.unlocked !== void 0) {
      if (typeof data.unlocked !== "boolean") {
        const err26 = {
          instancePath: instancePath + "/unlocked",
          schemaPath: "#/properties/unlocked/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err26];
        } else {
          vErrors.push(err26);
        }
        errors++;
      }
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err27 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err27];
        } else {
          vErrors.push(err27);
        }
        errors++;
      }
    }
    if (data.published !== void 0) {
      if (typeof data.published !== "boolean") {
        const err28 = {
          instancePath: instancePath + "/published",
          schemaPath: "#/properties/published/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err28];
        } else {
          vErrors.push(err28);
        }
        errors++;
      }
    }
    if (data.restrictedTo !== void 0) {
      let data10 = data.restrictedTo;
      const _errs22 = errors;
      let valid1 = false;
      const _errs23 = errors;
      if (Array.isArray(data10)) {
        const len0 = data10.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (typeof data10[i0] !== "string") {
            const err29 = {
              instancePath: instancePath + "/restrictedTo/" + i0,
              schemaPath: "#/properties/restrictedTo/anyOf/0/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err29];
            } else {
              vErrors.push(err29);
            }
            errors++;
          }
        }
      } else {
        const err30 = {
          instancePath: instancePath + "/restrictedTo",
          schemaPath: "#/properties/restrictedTo/anyOf/0/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err30];
        } else {
          vErrors.push(err30);
        }
        errors++;
      }
      var _valid0 = _errs23 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs27 = errors;
        if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
          if (data10.exclude === void 0) {
            const err31 = {
              instancePath: instancePath + "/restrictedTo",
              schemaPath: "#/properties/restrictedTo/anyOf/1/required",
              keyword: "required",
              params: {
                missingProperty: "exclude"
              },
              message: "must have required property 'exclude'"
            };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
          if (data10.exclude !== void 0) {
            let data12 = data10.exclude;
            if (Array.isArray(data12)) {
              const len1 = data12.length;
              for (let i1 = 0; i1 < len1; i1++) {
                if (typeof data12[i1] !== "string") {
                  const err32 = {
                    instancePath: instancePath + "/restrictedTo/exclude/" + i1,
                    schemaPath: "#/properties/restrictedTo/anyOf/1/properties/exclude/items/type",
                    keyword: "type",
                    params: {
                      type: "string"
                    },
                    message: "must be string"
                  };
                  if (vErrors === null) {
                    vErrors = [err32];
                  } else {
                    vErrors.push(err32);
                  }
                  errors++;
                }
              }
            } else {
              const err33 = {
                instancePath: instancePath + "/restrictedTo/exclude",
                schemaPath: "#/properties/restrictedTo/anyOf/1/properties/exclude/type",
                keyword: "type",
                params: {
                  type: "array"
                },
                message: "must be array"
              };
              if (vErrors === null) {
                vErrors = [err33];
              } else {
                vErrors.push(err33);
              }
              errors++;
            }
          }
        } else {
          const err34 = {
            instancePath: instancePath + "/restrictedTo",
            schemaPath: "#/properties/restrictedTo/anyOf/1/type",
            keyword: "type",
            params: {
              type: "object"
            },
            message: "must be object"
          };
          if (vErrors === null) {
            vErrors = [err34];
          } else {
            vErrors.push(err34);
          }
          errors++;
        }
        var _valid0 = _errs27 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err35 = {
          instancePath: instancePath + "/restrictedTo",
          schemaPath: "#/properties/restrictedTo/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err35];
        } else {
          vErrors.push(err35);
        }
        errors++;
      } else {
        errors = _errs22;
        if (vErrors !== null) {
          if (_errs22) {
            vErrors.length = _errs22;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.externalIds !== void 0) {
      let data14 = data.externalIds;
      if (Array.isArray(data14)) {
        const len2 = data14.length;
        for (let i2 = 0; i2 < len2; i2++) {
          if (typeof data14[i2] !== "string") {
            const err36 = {
              instancePath: instancePath + "/externalIds/" + i2,
              schemaPath: "#/properties/externalIds/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err36];
            } else {
              vErrors.push(err36);
            }
            errors++;
          }
        }
      } else {
        const err37 = {
          instancePath: instancePath + "/externalIds",
          schemaPath: "#/properties/externalIds/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err37];
        } else {
          vErrors.push(err37);
        }
        errors++;
      }
    }
    if (data.tags !== void 0) {
      let data16 = data.tags;
      if (Array.isArray(data16)) {
        const len3 = data16.length;
        for (let i3 = 0; i3 < len3; i3++) {
          if (typeof data16[i3] !== "string") {
            const err38 = {
              instancePath: instancePath + "/tags/" + i3,
              schemaPath: "#/properties/tags/items/type",
              keyword: "type",
              params: {
                type: "string"
              },
              message: "must be string"
            };
            if (vErrors === null) {
              vErrors = [err38];
            } else {
              vErrors.push(err38);
            }
            errors++;
          }
        }
      } else {
        const err39 = {
          instancePath: instancePath + "/tags",
          schemaPath: "#/properties/tags/type",
          keyword: "type",
          params: {
            type: "array"
          },
          message: "must be array"
        };
        if (vErrors === null) {
          vErrors = [err39];
        } else {
          vErrors.push(err39);
        }
        errors++;
      }
    }
    if (data.posterImage !== void 0) {
      if (typeof data.posterImage !== "string") {
        const err40 = {
          instancePath: instancePath + "/posterImage",
          schemaPath: "#/properties/posterImage/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err40];
        } else {
          vErrors.push(err40);
        }
        errors++;
      }
    }
    if (data.archived !== void 0) {
      if (typeof data.archived !== "boolean") {
        const err41 = {
          instancePath: instancePath + "/archived",
          schemaPath: "#/properties/archived/type",
          keyword: "type",
          params: {
            type: "boolean"
          },
          message: "must be boolean"
        };
        if (vErrors === null) {
          vErrors = [err41];
        } else {
          vErrors.push(err41);
        }
        errors++;
      }
    }
    if (data.type !== void 0) {
      let data20 = data.type;
      if (typeof data20 !== "string") {
        const err42 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err42];
        } else {
          vErrors.push(err42);
        }
        errors++;
      }
      if (!(data20 === "SHORT" || data20 === "UPLOAD" || data20 === "STREAM")) {
        const err43 = {
          instancePath: instancePath + "/type",
          schemaPath: "#/properties/type/enum",
          keyword: "enum",
          params: {
            allowedValues: schema230.properties.type.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err43];
        } else {
          vErrors.push(err43);
        }
        errors++;
      }
    }
    if (data.streamState !== void 0) {
      let data21 = data.streamState;
      if (typeof data21 !== "string" && data21 !== null) {
        const err44 = {
          instancePath: instancePath + "/streamState",
          schemaPath: "#/properties/streamState/type",
          keyword: "type",
          params: {
            type: schema230.properties.streamState.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err44];
        } else {
          vErrors.push(err44);
        }
        errors++;
      }
      if (!(data21 === "SCHEDULED" || data21 === "LIVE" || data21 === "FINISHED" || data21 === null)) {
        const err45 = {
          instancePath: instancePath + "/streamState",
          schemaPath: "#/properties/streamState/enum",
          keyword: "enum",
          params: {
            allowedValues: schema230.properties.streamState.enum
          },
          message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) {
          vErrors = [err45];
        } else {
          vErrors.push(err45);
        }
        errors++;
      }
    }
    if (data.startTime !== void 0) {
      let data22 = data.startTime;
      const _errs50 = errors;
      let valid11 = false;
      const _errs51 = errors;
      if (!(data22 && typeof data22 == "object" && !Array.isArray(data22))) {
        const err46 = {
          instancePath: instancePath + "/startTime",
          schemaPath: "#/properties/startTime/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err46];
        } else {
          vErrors.push(err46);
        }
        errors++;
      }
      if (typeof data22 === "string") {
        if (!formats0(data22)) {
          const err47 = {
            instancePath: instancePath + "/startTime",
            schemaPath: "#/properties/startTime/anyOf/0/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err47];
          } else {
            vErrors.push(err47);
          }
          errors++;
        }
      }
      var _valid1 = _errs51 === errors;
      valid11 = valid11 || _valid1;
      if (!valid11) {
        const _errs53 = errors;
        if (data22 !== null) {
          const err48 = {
            instancePath: instancePath + "/startTime",
            schemaPath: "#/properties/startTime/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err48];
          } else {
            vErrors.push(err48);
          }
          errors++;
        }
        var _valid1 = _errs53 === errors;
        valid11 = valid11 || _valid1;
      }
      if (!valid11) {
        const err49 = {
          instancePath: instancePath + "/startTime",
          schemaPath: "#/properties/startTime/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err49];
        } else {
          vErrors.push(err49);
        }
        errors++;
      } else {
        errors = _errs50;
        if (vErrors !== null) {
          if (_errs50) {
            vErrors.length = _errs50;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.endTime !== void 0) {
      let data23 = data.endTime;
      const _errs56 = errors;
      let valid12 = false;
      const _errs57 = errors;
      if (!(data23 && typeof data23 == "object" && !Array.isArray(data23))) {
        const err50 = {
          instancePath: instancePath + "/endTime",
          schemaPath: "#/properties/endTime/anyOf/0/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err50];
        } else {
          vErrors.push(err50);
        }
        errors++;
      }
      if (typeof data23 === "string") {
        if (!formats0(data23)) {
          const err51 = {
            instancePath: instancePath + "/endTime",
            schemaPath: "#/properties/endTime/anyOf/0/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err51];
          } else {
            vErrors.push(err51);
          }
          errors++;
        }
      }
      var _valid2 = _errs57 === errors;
      valid12 = valid12 || _valid2;
      if (!valid12) {
        const _errs59 = errors;
        if (data23 !== null) {
          const err52 = {
            instancePath: instancePath + "/endTime",
            schemaPath: "#/properties/endTime/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err52];
          } else {
            vErrors.push(err52);
          }
          errors++;
        }
        var _valid2 = _errs59 === errors;
        valid12 = valid12 || _valid2;
      }
      if (!valid12) {
        const err53 = {
          instancePath: instancePath + "/endTime",
          schemaPath: "#/properties/endTime/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err53];
        } else {
          vErrors.push(err53);
        }
        errors++;
      } else {
        errors = _errs56;
        if (vErrors !== null) {
          if (_errs56) {
            vErrors.length = _errs56;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.uploadTime !== void 0) {
      let data24 = data.uploadTime;
      if (!(data24 && typeof data24 == "object" && !Array.isArray(data24))) {
        const err54 = {
          instancePath: instancePath + "/uploadTime",
          schemaPath: "#/properties/uploadTime/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err54];
        } else {
          vErrors.push(err54);
        }
        errors++;
      }
      if (typeof data24 === "string") {
        if (!formats0(data24)) {
          const err55 = {
            instancePath: instancePath + "/uploadTime",
            schemaPath: "#/properties/uploadTime/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err55];
          } else {
            vErrors.push(err55);
          }
          errors++;
        }
      }
    }
    if (data.duration !== void 0) {
      let data25 = data.duration;
      if (!(typeof data25 == "number" && isFinite(data25)) && data25 !== null) {
        const err56 = {
          instancePath: instancePath + "/duration",
          schemaPath: "#/properties/duration/type",
          keyword: "type",
          params: {
            type: schema230.properties.duration.type
          },
          message: "must be number,null"
        };
        if (vErrors === null) {
          vErrors = [err56];
        } else {
          vErrors.push(err56);
        }
        errors++;
      }
    }
    if (data.videoLocation !== void 0) {
      if (typeof data.videoLocation !== "string") {
        const err57 = {
          instancePath: instancePath + "/videoLocation",
          schemaPath: "#/properties/videoLocation/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err57];
        } else {
          vErrors.push(err57);
        }
        errors++;
      }
    }
    if (data.views !== void 0) {
      let data27 = data.views;
      if (!(typeof data27 == "number" && isFinite(data27))) {
        const err58 = {
          instancePath: instancePath + "/views",
          schemaPath: "#/properties/views/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err58];
        } else {
          vErrors.push(err58);
        }
        errors++;
      }
    }
    if (data.popularity !== void 0) {
      let data28 = data.popularity;
      if (!(typeof data28 == "number" && isFinite(data28))) {
        const err59 = {
          instancePath: instancePath + "/popularity",
          schemaPath: "#/properties/popularity/type",
          keyword: "type",
          params: {
            type: "number"
          },
          message: "must be number"
        };
        if (vErrors === null) {
          vErrors = [err59];
        } else {
          vErrors.push(err59);
        }
        errors++;
      }
    }
    if (data.organizationId !== void 0) {
      let data29 = data.organizationId;
      if (typeof data29 !== "string" && data29 !== null) {
        const err60 = {
          instancePath: instancePath + "/organizationId",
          schemaPath: "#/properties/organizationId/type",
          keyword: "type",
          params: {
            type: schema230.properties.organizationId.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err60];
        } else {
          vErrors.push(err60);
        }
        errors++;
      }
    }
  } else {
    const err61 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err61];
    } else {
      vErrors.push(err61);
    }
    errors++;
  }
  validate208.errors = vErrors;
  return errors === 0;
}
const VideoAccessLogEntry = validate209;
const schema231 = {
  "$id": "VideoAccessLogEntry",
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "accessType": {
      "$ref": "GetAccessGrantType"
    },
    "userId": {
      "type": "string"
    },
    "videoId": {
      "type": "string"
    },
    "eventId": {
      "type": ["string", "null"]
    },
    "channelId": {
      "type": "string"
    },
    "location": {
      "anyOf": [{
        "$ref": "UserLocation"
      }, {
        "type": "null"
      }]
    },
    "ticketId": {
      "type": ["string", "null"]
    },
    "subscriptionId": {
      "type": ["string", "null"]
    },
    "timestamp": {
      "type": "object",
      "format": "date-time"
    },
    "videoUrl": {
      "type": "string"
    }
  },
  "required": ["accessType", "userId", "videoId", "eventId", "channelId", "location", "ticketId", "subscriptionId", "timestamp", "videoUrl"]
};
function validate209(data, {
  instancePath = "",
  parentData,
  parentDataProperty,
  rootData = data
} = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.accessType === void 0) {
      const err0 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "accessType"
        },
        message: "must have required property 'accessType'"
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.userId === void 0) {
      const err1 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "userId"
        },
        message: "must have required property 'userId'"
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.videoId === void 0) {
      const err2 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "videoId"
        },
        message: "must have required property 'videoId'"
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.eventId === void 0) {
      const err3 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "eventId"
        },
        message: "must have required property 'eventId'"
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.channelId === void 0) {
      const err4 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "channelId"
        },
        message: "must have required property 'channelId'"
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.location === void 0) {
      const err5 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "location"
        },
        message: "must have required property 'location'"
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.ticketId === void 0) {
      const err6 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "ticketId"
        },
        message: "must have required property 'ticketId'"
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.subscriptionId === void 0) {
      const err7 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "subscriptionId"
        },
        message: "must have required property 'subscriptionId'"
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.timestamp === void 0) {
      const err8 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "timestamp"
        },
        message: "must have required property 'timestamp'"
      };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    if (data.videoUrl === void 0) {
      const err9 = {
        instancePath,
        schemaPath: "#/required",
        keyword: "required",
        params: {
          missingProperty: "videoUrl"
        },
        message: "must have required property 'videoUrl'"
      };
      if (vErrors === null) {
        vErrors = [err9];
      } else {
        vErrors.push(err9);
      }
      errors++;
    }
    if (data.accessType !== void 0) {
      if (!validate162(data.accessType, {
        instancePath: instancePath + "/accessType",
        parentData: data,
        parentDataProperty: "accessType",
        rootData
      })) {
        vErrors = vErrors === null ? validate162.errors : vErrors.concat(validate162.errors);
        errors = vErrors.length;
      }
    }
    if (data.userId !== void 0) {
      if (typeof data.userId !== "string") {
        const err10 = {
          instancePath: instancePath + "/userId",
          schemaPath: "#/properties/userId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.videoId !== void 0) {
      if (typeof data.videoId !== "string") {
        const err11 = {
          instancePath: instancePath + "/videoId",
          schemaPath: "#/properties/videoId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.eventId !== void 0) {
      let data3 = data.eventId;
      if (typeof data3 !== "string" && data3 !== null) {
        const err12 = {
          instancePath: instancePath + "/eventId",
          schemaPath: "#/properties/eventId/type",
          keyword: "type",
          params: {
            type: schema231.properties.eventId.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.channelId !== void 0) {
      if (typeof data.channelId !== "string") {
        const err13 = {
          instancePath: instancePath + "/channelId",
          schemaPath: "#/properties/channelId/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.location !== void 0) {
      let data5 = data.location;
      const _errs11 = errors;
      let valid1 = false;
      const _errs12 = errors;
      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
        if (data5.IP === void 0) {
          const err14 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "IP"
            },
            message: "must have required property 'IP'"
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
        if (data5.latlng === void 0) {
          const err15 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "latlng"
            },
            message: "must have required property 'latlng'"
          };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if (data5.city === void 0) {
          const err16 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "city"
            },
            message: "must have required property 'city'"
          };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
        if (data5.country === void 0) {
          const err17 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "country"
            },
            message: "must have required property 'country'"
          };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
        if (data5.region === void 0) {
          const err18 = {
            instancePath: instancePath + "/location",
            schemaPath: "UserLocation/required",
            keyword: "required",
            params: {
              missingProperty: "region"
            },
            message: "must have required property 'region'"
          };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        if (data5.IP !== void 0) {
          let data6 = data5.IP;
          if (typeof data6 !== "string" && data6 !== null) {
            const err19 = {
              instancePath: instancePath + "/location/IP",
              schemaPath: "UserLocation/properties/IP/type",
              keyword: "type",
              params: {
                type: schema56.properties.IP.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err19];
            } else {
              vErrors.push(err19);
            }
            errors++;
          }
        }
        if (data5.latlng !== void 0) {
          let data7 = data5.latlng;
          if (typeof data7 !== "string" && data7 !== null) {
            const err20 = {
              instancePath: instancePath + "/location/latlng",
              schemaPath: "UserLocation/properties/latlng/type",
              keyword: "type",
              params: {
                type: schema56.properties.latlng.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err20];
            } else {
              vErrors.push(err20);
            }
            errors++;
          }
        }
        if (data5.city !== void 0) {
          let data8 = data5.city;
          if (typeof data8 !== "string" && data8 !== null) {
            const err21 = {
              instancePath: instancePath + "/location/city",
              schemaPath: "UserLocation/properties/city/type",
              keyword: "type",
              params: {
                type: schema56.properties.city.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
        }
        if (data5.country !== void 0) {
          let data9 = data5.country;
          if (typeof data9 !== "string" && data9 !== null) {
            const err22 = {
              instancePath: instancePath + "/location/country",
              schemaPath: "UserLocation/properties/country/type",
              keyword: "type",
              params: {
                type: schema56.properties.country.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err22];
            } else {
              vErrors.push(err22);
            }
            errors++;
          }
        }
        if (data5.region !== void 0) {
          let data10 = data5.region;
          if (typeof data10 !== "string" && data10 !== null) {
            const err23 = {
              instancePath: instancePath + "/location/region",
              schemaPath: "UserLocation/properties/region/type",
              keyword: "type",
              params: {
                type: schema56.properties.region.type
              },
              message: "must be string,null"
            };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
        }
      } else {
        const err24 = {
          instancePath: instancePath + "/location",
          schemaPath: "UserLocation/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err24];
        } else {
          vErrors.push(err24);
        }
        errors++;
      }
      var _valid0 = _errs12 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs25 = errors;
        if (data5 !== null) {
          const err25 = {
            instancePath: instancePath + "/location",
            schemaPath: "#/properties/location/anyOf/1/type",
            keyword: "type",
            params: {
              type: "null"
            },
            message: "must be null"
          };
          if (vErrors === null) {
            vErrors = [err25];
          } else {
            vErrors.push(err25);
          }
          errors++;
        }
        var _valid0 = _errs25 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err26 = {
          instancePath: instancePath + "/location",
          schemaPath: "#/properties/location/anyOf",
          keyword: "anyOf",
          params: {},
          message: "must match a schema in anyOf"
        };
        if (vErrors === null) {
          vErrors = [err26];
        } else {
          vErrors.push(err26);
        }
        errors++;
      } else {
        errors = _errs11;
        if (vErrors !== null) {
          if (_errs11) {
            vErrors.length = _errs11;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.ticketId !== void 0) {
      let data11 = data.ticketId;
      if (typeof data11 !== "string" && data11 !== null) {
        const err27 = {
          instancePath: instancePath + "/ticketId",
          schemaPath: "#/properties/ticketId/type",
          keyword: "type",
          params: {
            type: schema231.properties.ticketId.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err27];
        } else {
          vErrors.push(err27);
        }
        errors++;
      }
    }
    if (data.subscriptionId !== void 0) {
      let data12 = data.subscriptionId;
      if (typeof data12 !== "string" && data12 !== null) {
        const err28 = {
          instancePath: instancePath + "/subscriptionId",
          schemaPath: "#/properties/subscriptionId/type",
          keyword: "type",
          params: {
            type: schema231.properties.subscriptionId.type
          },
          message: "must be string,null"
        };
        if (vErrors === null) {
          vErrors = [err28];
        } else {
          vErrors.push(err28);
        }
        errors++;
      }
    }
    if (data.timestamp !== void 0) {
      let data13 = data.timestamp;
      if (!(data13 && typeof data13 == "object" && !Array.isArray(data13))) {
        const err29 = {
          instancePath: instancePath + "/timestamp",
          schemaPath: "#/properties/timestamp/type",
          keyword: "type",
          params: {
            type: "object"
          },
          message: "must be object"
        };
        if (vErrors === null) {
          vErrors = [err29];
        } else {
          vErrors.push(err29);
        }
        errors++;
      }
      if (typeof data13 === "string") {
        if (!formats0(data13)) {
          const err30 = {
            instancePath: instancePath + "/timestamp",
            schemaPath: "#/properties/timestamp/format",
            keyword: "format",
            params: {
              format: "date-time"
            },
            message: 'must match format "date-time"'
          };
          if (vErrors === null) {
            vErrors = [err30];
          } else {
            vErrors.push(err30);
          }
          errors++;
        }
      }
    }
    if (data.videoUrl !== void 0) {
      if (typeof data.videoUrl !== "string") {
        const err31 = {
          instancePath: instancePath + "/videoUrl",
          schemaPath: "#/properties/videoUrl/type",
          keyword: "type",
          params: {
            type: "string"
          },
          message: "must be string"
        };
        if (vErrors === null) {
          vErrors = [err31];
        } else {
          vErrors.push(err31);
        }
        errors++;
      }
    }
  } else {
    const err32 = {
      instancePath,
      schemaPath: "#/type",
      keyword: "type",
      params: {
        type: "object"
      },
      message: "must be object"
    };
    if (vErrors === null) {
      vErrors = [err32];
    } else {
      vErrors.push(err32);
    }
    errors++;
  }
  validate209.errors = vErrors;
  return errors === 0;
}
export { ACCOUNT_LINKING_RESULT, ACCOUNT_RELINK_RESULT, ACCOUNT_UNLINKING_RESULT, AbstractListModule, AbstractPageModule, AcceptUserInviteRequest, AcceptUserInviteResponse, AdCarouselModule, AdSpaceModule, ApplyCouponErrorResponse, ApplyCouponRequest, ApplyCouponResponse, ApplyCouponSuccessfulResponse, ArenaAuthRequest, AttributeKey, AttributeSource, AuthErrors, AuthRequest, AuthResponse, BillingPeriodConfiguration, BillingPeriodicity, Branding, ButtonPromotionalBlock, BuySubscriptionErrorResponse, BuySubscriptionRequest, BuySubscriptionResponse, BuySubscriptionSuccessfulResponse, BuyTicketErrorResponse, BuyTicketRequest, BuyTicketResponse, BuyTicketSuccessfulResponse, CancelSubscriptionCommand, CardPromotionalBlock, Channel, ChannelNavigation, ChannelPublicSettings, ChannelSubscriptions, ChannelTerms, ClassicHeaderModule, CreateSetupIntentRequest, CreateSetupIntentResponse, CreateSubscriptionErrorResponse, CreateSubscriptionRequest, CreateSubscriptionResponse, CreateSubscriptionSuccessfulResponse, CustomAttributes, DynamicNamedTagListSource, DynamicVideoListSource, Event, EventListModule, EventListSource, Feedback, FilteredVideoListModule, FiltersAttributeDefinition, GetAccessDeniedResponse, GetAccessDeniedResponseReason, GetAccessGrantType, GetAccessGrantedResponse, GetAccessRequest, GetAccessResponse, HeaderModule, Invite, InviteErrors, LinkExternalAccountErrorResponse, LinkExternalAccountRequest, LinkExternalAccountResponse, LinkExternalAccountSuccessfulResponse, LinkExternalSAMLAccountRequest, LinkNavigationResource, LiveAndUpcomingListModule, ManageSubscriptionRequest, ManageSubscriptionResponse, NamedTag, NamedTagListSource, NamedTagType, NamedTagsListModule, OptionsListLink, Page, PageModule, PageModuleList, PageTab, PauseBehaviour, PauseSubscriptionCommand, Plan, PlanInstallments, PlanPrice, PlanScope, PriceBlock, PromoButtonAction, PromotionalBlock, RootNavigationResource, SAML_LINK_OPERATION, SAML_PROVIDERS, SaveFeedbackErrorResponse, SaveFeedbackRequest, SaveFeedbackResponse, SaveFeedbackSuccessfulResponse, SingleOptionLink, SoldTicket, Sport80ExternalInfo, Sport80PlanProvider, StaticNamedTagListSource, StaticSlideSource, StaticVideoListSource, StripeCouponMetadata, StripePaymentOptionsForUser, StripePaymentSystemOpaque, StripeSavedPaymentMethods, StripeSubscriptionMetadata, StripeTicketMetaData, StudioAuthRequest, Subscription, SubscriptionCancellation, SubscriptionStatus, TabbedPageModules, TagsListModule, Testimonial, Ticket, TicketPrice, TicketScope, TvAuthRequest, UncancelSubscriptionCommand, UnpauseSubscriptionCommand, UpdateSubscriptionPaymentCommand, UpdateUserConsentRequest, UpdateUserConsentResponse, UserConsentEntry, UserConsentEntryResponse, UserConsentEntryTermsResponse, UserConsentRequest, UserConsentSettings, UserExternalIntegrationsData, UserGuidedOnboardingStatus, UserInfo, UserLocation, Video, VideoAccessLogEntry, VideoAttribute, VideoAttributeValue, VideoAttributesMapping, VideoCoreInfo, VideoListModule, VideoListModuleBase, VideoListSource, VideoModule, ViewerRetentionSettings };
